// Catálogo CIE-9 de procedimientos (fuente: "cie 9 nuevo.xlsx", Categoría / Subcategoría / Código).
// Generado automáticamente: no editar a mano.
export const procedimientos = [
 {
  "CATALOG_KEY": "00",
  "PRO_NOMBRE": "Procedimientos e intervenciones, no clasificados en otra parte"
 },
 {
  "CATALOG_KEY": "00.0",
  "PRO_NOMBRE": "Ultrasonido terapéutico"
 },
 {
  "CATALOG_KEY": "00.01",
  "PRO_NOMBRE": "Ultrasonido terapéutico de vasos de cabeza y cuello"
 },
 {
  "CATALOG_KEY": "00.02",
  "PRO_NOMBRE": "Ultrasonido terapéutico cardiaco"
 },
 {
  "CATALOG_KEY": "00.03",
  "PRO_NOMBRE": "Ultrasonido terapéutico de vasos periféricos"
 },
 {
  "CATALOG_KEY": "00.09",
  "PRO_NOMBRE": "Otro ultrasonido terapéutico"
 },
 {
  "CATALOG_KEY": "00.1",
  "PRO_NOMBRE": "Fármacos"
 },
 {
  "CATALOG_KEY": "00.10",
  "PRO_NOMBRE": "Implantación de agente quimioterapéutico"
 },
 {
  "CATALOG_KEY": "00.11",
  "PRO_NOMBRE": "Infusión de drotrecogin alfa (activada)"
 },
 {
  "CATALOG_KEY": "00.12",
  "PRO_NOMBRE": "Administración de óxido nítrico inhalado"
 },
 {
  "CATALOG_KEY": "00.13",
  "PRO_NOMBRE": "Inyección o infusión de nesiritide"
 },
 {
  "CATALOG_KEY": "00.14",
  "PRO_NOMBRE": "Inyección o infusión de antibióticos del grupo de la oxazolidinona"
 },
 {
  "CATALOG_KEY": "00.15",
  "PRO_NOMBRE": "Infusión de dosis alta de interleucina-2 [IL-2]"
 },
 {
  "CATALOG_KEY": "00.16",
  "PRO_NOMBRE": "Tratamiento presurizado de injerto de derivación venoso [conducto] con sustancia medicamentosa"
 },
 {
  "CATALOG_KEY": "00.17",
  "PRO_NOMBRE": "Infusión de agente vasopresor"
 },
 {
  "CATALOG_KEY": "00.18",
  "PRO_NOMBRE": "Terapia de infusión de anticuerpos inmunosupresores"
 },
 {
  "CATALOG_KEY": "00.19",
  "PRO_NOMBRE": "Irrupción de la barrera hematoencefálica vía infusión (IBH) [BBBD]"
 },
 {
  "CATALOG_KEY": "00.2",
  "PRO_NOMBRE": "Imagen intravascular de vasos sanguíneos"
 },
 {
  "CATALOG_KEY": "00.21",
  "PRO_NOMBRE": "Imagen intravascular de vasos cerebrales extracraneales"
 },
 {
  "CATALOG_KEY": "00.22",
  "PRO_NOMBRE": "Imagen intravascular de vasos intratorácicos"
 },
 {
  "CATALOG_KEY": "00.23",
  "PRO_NOMBRE": "Imagen intravascular de vasos periféricos"
 },
 {
  "CATALOG_KEY": "00.24",
  "PRO_NOMBRE": "Imagen intravascular de vasos coronarios"
 },
 {
  "CATALOG_KEY": "00.25",
  "PRO_NOMBRE": "Imagen intravascular de vasos renales"
 },
 {
  "CATALOG_KEY": "00.28",
  "PRO_NOMBRE": "Imagen intravascular de otro(s) vaso(s) especificado(s)"
 },
 {
  "CATALOG_KEY": "00.29",
  "PRO_NOMBRE": "Imagen intravascular de vaso(s) no especificado(s)"
 },
 {
  "CATALOG_KEY": "00.3",
  "PRO_NOMBRE": "Cirugía asistida por computadora (ordenador) [CAC] [CAS]"
 },
 {
  "CATALOG_KEY": "00.31",
  "PRO_NOMBRE": "Cirugía asistida por computadora (ordenador) con TAC"
 },
 {
  "CATALOG_KEY": "00.32",
  "PRO_NOMBRE": "Cirugía asistida por computadora (ordenador) con RMN"
 },
 {
  "CATALOG_KEY": "00.33",
  "PRO_NOMBRE": "Cirugía asistida por computadora (ordenador) con fluoroscopía"
 },
 {
  "CATALOG_KEY": "00.34",
  "PRO_NOMBRE": "Cirugía asistida por computadora (ordenador) sin imagen"
 },
 {
  "CATALOG_KEY": "00.35",
  "PRO_NOMBRE": "Cirugía asistida por computadora (ordenador) con múltiples fuentes de datos"
 },
 {
  "CATALOG_KEY": "00.39",
  "PRO_NOMBRE": "Otra cirugía asistida por computadora (ordenador)"
 },
 {
  "CATALOG_KEY": "00.4",
  "PRO_NOMBRE": "Procedimientos auxiliares sobre el sistema vascular"
 },
 {
  "CATALOG_KEY": "00.40",
  "PRO_NOMBRE": "Procedimiento sobre un solo vaso"
 },
 {
  "CATALOG_KEY": "00.41",
  "PRO_NOMBRE": "Procedimiento sobre dos vasos"
 },
 {
  "CATALOG_KEY": "00.42",
  "PRO_NOMBRE": "Procedimiento sobre tres vasos"
 },
 {
  "CATALOG_KEY": "00.43",
  "PRO_NOMBRE": "Procedimiento sobre cuatro o más vasos"
 },
 {
  "CATALOG_KEY": "00.44",
  "PRO_NOMBRE": "Procedimiento sobre bifurcación vascular"
 },
 {
  "CATALOG_KEY": "00.45",
  "PRO_NOMBRE": "Inserción de un stent vascular"
 },
 {
  "CATALOG_KEY": "00.46",
  "PRO_NOMBRE": "Inserción de dos stents vasculares"
 },
 {
  "CATALOG_KEY": "00.47",
  "PRO_NOMBRE": "Inserción de tres stents vasculares"
 },
 {
  "CATALOG_KEY": "00.48",
  "PRO_NOMBRE": "Inserción de cuatro o más stents vasculares"
 },
 {
  "CATALOG_KEY": "00.49",
  "PRO_NOMBRE": "Terapia con oxigeno supersaturado"
 },
 {
  "CATALOG_KEY": "00.5",
  "PRO_NOMBRE": "Otros procedimientos cardiovasculares"
 },
 {
  "CATALOG_KEY": "00.50",
  "PRO_NOMBRE": "Implantación de marcapasos de resincronización cardiaca sin mención de desfibrilación, sistema total [IMRC] [CRT-P]"
 },
 {
  "CATALOG_KEY": "00.51",
  "PRO_NOMBRE": "Implantación de desfibrilador de resincronización cardiaca, sistema total [DRCT] [CRT-D]"
 },
 {
  "CATALOG_KEY": "00.52",
  "PRO_NOMBRE": "Implantación o sustitución de electrodo dentro del sistema venoso coronario ventricular izquierdo"
 },
 {
  "CATALOG_KEY": "00.53",
  "PRO_NOMBRE": "Implantación o sustitución de marcapasos de resincronización cardiaca, sólo generador de pulso [IMRC] [CRT-P]"
 },
 {
  "CATALOG_KEY": "00.54",
  "PRO_NOMBRE": "Implantación o sustitución de desfibrilador de resincronización cardiaca, sólo dispositivo generador de pulso [DRC] [CRT-D]"
 },
 {
  "CATALOG_KEY": "00.55",
  "PRO_NOMBRE": "Inserción de stent(s) liberador de fármaco en vaso periférico"
 },
 {
  "CATALOG_KEY": "00.56",
  "PRO_NOMBRE": "Inserción o sustitución de sensor de presión implantable (electrodo) para monitorización hemodinámica intracardiaca"
 },
 {
  "CATALOG_KEY": "00.57",
  "PRO_NOMBRE": "Implantación o sustitución de dispositivo subcutáneo para monitorización hemodinámica intracardiaca"
 },
 {
  "CATALOG_KEY": "00.58",
  "PRO_NOMBRE": "Inserción de dispositivo para monitorización de presión en saco intra-aneurismático (intraoperatorio)"
 },
 {
  "CATALOG_KEY": "00.59",
  "PRO_NOMBRE": "Medición de presión intravascular de arterias coronarias"
 },
 {
  "CATALOG_KEY": "00.6",
  "PRO_NOMBRE": "Procedimientos sobre vasos sanguíneos"
 },
 {
  "CATALOG_KEY": "00.61",
  "PRO_NOMBRE": "Angioplastía o aterectomía percutánea de vaso(s) precerebral(es)"
 },
 {
  "CATALOG_KEY": "00.62",
  "PRO_NOMBRE": "Angioplastía o aterectomía percutánea de vaso(s) intracraneal(es)"
 },
 {
  "CATALOG_KEY": "00.63",
  "PRO_NOMBRE": "Inserción percutánea de stent(s) de arteria carótida"
 },
 {
  "CATALOG_KEY": "00.64",
  "PRO_NOMBRE": "Inserción percutánea de stent(s) de otra arteria precerebral"
 },
 {
  "CATALOG_KEY": "00.65",
  "PRO_NOMBRE": "Inserción percutánea de stent(s) vascular(es) intracraneal(es)"
 },
 {
  "CATALOG_KEY": "00.66",
  "PRO_NOMBRE": "Angioplastía coronaria transluminal percutánea (ACTP) [PTCA] o aterectomía coronaria"
 },
 {
  "CATALOG_KEY": "00.67",
  "PRO_NOMBRE": "Medición de presión intravascular de arterias intratorácicas"
 },
 {
  "CATALOG_KEY": "00.68",
  "PRO_NOMBRE": "Medición de presión intravascular de arterias periféricas"
 },
 {
  "CATALOG_KEY": "00.69",
  "PRO_NOMBRE": "Medición de presión intravascular de otros vasos especificados y los no especificados"
 },
 {
  "CATALOG_KEY": "00.7",
  "PRO_NOMBRE": "Otros procedimientos de cadera"
 },
 {
  "CATALOG_KEY": "00.70",
  "PRO_NOMBRE": "Revisión de sustitución de cadera, componentes acetabular y femoral"
 },
 {
  "CATALOG_KEY": "00.71",
  "PRO_NOMBRE": "Revisión de sustitución de cadera, componente acetabular"
 },
 {
  "CATALOG_KEY": "00.72",
  "PRO_NOMBRE": "Revisión de sustitución de cadera, componente femoral"
 },
 {
  "CATALOG_KEY": "00.73",
  "PRO_NOMBRE": "Revisión de sustitución de cadera, sólo alineador acetabular y/o cabeza femoral"
 },
 {
  "CATALOG_KEY": "00.74",
  "PRO_NOMBRE": "Superficie de apoyo en sustitución de cadera, metal sobre polietileno"
 },
 {
  "CATALOG_KEY": "00.75",
  "PRO_NOMBRE": "Superficie de apoyo en sustitución de cadera, metal sobre metal"
 },
 {
  "CATALOG_KEY": "00.76",
  "PRO_NOMBRE": "Superficie de apoyo en sustitución de cadera, cerámica sobre cerámica"
 },
 {
  "CATALOG_KEY": "00.77",
  "PRO_NOMBRE": "Superficie de apoyo en sustitución de cadera, cerámica sobre polietileno"
 },
 {
  "CATALOG_KEY": "00.8",
  "PRO_NOMBRE": "Otros procedimientos sobre rodilla y cadera"
 },
 {
  "CATALOG_KEY": "00.80",
  "PRO_NOMBRE": "Revisión de sustitución de rodilla, total (todos los componentes)"
 },
 {
  "CATALOG_KEY": "00.81",
  "PRO_NOMBRE": "Revisión de sustitución de rodilla, componente tibial"
 },
 {
  "CATALOG_KEY": "00.82",
  "PRO_NOMBRE": "Revisión de sustitución de rodilla, componente femoral"
 },
 {
  "CATALOG_KEY": "00.83",
  "PRO_NOMBRE": "Revisión de sustitución de rodilla, componente rotuliano"
 },
 {
  "CATALOG_KEY": "00.84",
  "PRO_NOMBRE": "Revisión de sustitución total de rodilla, inserción (alineador) tibial"
 },
 {
  "CATALOG_KEY": "00.85",
  "PRO_NOMBRE": "Recubrimiento total de cadera, acetábulo y cabeza femoral"
 },
 {
  "CATALOG_KEY": "00.86",
  "PRO_NOMBRE": "Recubrimiento parcial de cadera, cabeza femoral"
 },
 {
  "CATALOG_KEY": "00.87",
  "PRO_NOMBRE": "Recubrimiento parcial de cadera, acetábulo"
 },
 {
  "CATALOG_KEY": "00.9",
  "PRO_NOMBRE": "Otros procedimientos e intervenciones"
 },
 {
  "CATALOG_KEY": "00.91",
  "PRO_NOMBRE": "Trasplante procedente de donador vivo emparentado"
 },
 {
  "CATALOG_KEY": "00.92",
  "PRO_NOMBRE": "Trasplante procedente de donador vivo no emparentado"
 },
 {
  "CATALOG_KEY": "00.93",
  "PRO_NOMBRE": "Trasplante procedente de cadáver"
 },
 {
  "CATALOG_KEY": "00.94",
  "PRO_NOMBRE": "Monitorización neurofisiológica intraoperatoria"
 },
 {
  "CATALOG_KEY": "01",
  "PRO_NOMBRE": "Incisión y excisión de cráneo, cerebro y meninges cerebrales"
 },
 {
  "CATALOG_KEY": "01.0",
  "PRO_NOMBRE": "Punción craneal"
 },
 {
  "CATALOG_KEY": "01.01",
  "PRO_NOMBRE": "Punción cisternal"
 },
 {
  "CATALOG_KEY": "01.02",
  "PRO_NOMBRE": "Punción ventricular a través de catéter previamente implantado"
 },
 {
  "CATALOG_KEY": "01.09",
  "PRO_NOMBRE": "Otra punción craneal"
 },
 {
  "CATALOG_KEY": "01.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre cráneo, cerebro y meninges cerebrales"
 },
 {
  "CATALOG_KEY": "01.10",
  "PRO_NOMBRE": "Monitorización de la presión intracraneal"
 },
 {
  "CATALOG_KEY": "01.11",
  "PRO_NOMBRE": "Biopsia cerrada [aguja] [percutánea] de meninges cerebrales"
 },
 {
  "CATALOG_KEY": "01.12",
  "PRO_NOMBRE": "Biopsia abierta de meninges cerebrales"
 },
 {
  "CATALOG_KEY": "01.13",
  "PRO_NOMBRE": "Biopsia cerrada [aguja] [percutánea] de cerebro"
 },
 {
  "CATALOG_KEY": "01.14",
  "PRO_NOMBRE": "Biopsia abierta de cerebro"
 },
 {
  "CATALOG_KEY": "01.15",
  "PRO_NOMBRE": "Biopsia de cráneo"
 },
 {
  "CATALOG_KEY": "01.16",
  "PRO_NOMBRE": "Monitorización de la oxigenación intracraneal"
 },
 {
  "CATALOG_KEY": "01.17",
  "PRO_NOMBRE": "Monitorización de la temperatura del cerebro"
 },
 {
  "CATALOG_KEY": "01.18",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre cerebro y meninges cerebrales"
 },
 {
  "CATALOG_KEY": "01.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre el cráneo"
 },
 {
  "CATALOG_KEY": "01.2",
  "PRO_NOMBRE": "Craneotomía y craniectomía"
 },
 {
  "CATALOG_KEY": "01.20",
  "PRO_NOMBRE": "Craneotomía y craniectomía"
 },
 {
  "CATALOG_KEY": "01.21",
  "PRO_NOMBRE": "Incisión y drenaje de seno craneal"
 },
 {
  "CATALOG_KEY": "01.22",
  "PRO_NOMBRE": "Extracción de electrodo(s) de neuroestimulador intracraneal"
 },
 {
  "CATALOG_KEY": "01.23",
  "PRO_NOMBRE": "Reapertura de craneotomía"
 },
 {
  "CATALOG_KEY": "01.24",
  "PRO_NOMBRE": "Otras craneotomías"
 },
 {
  "CATALOG_KEY": "01.25",
  "PRO_NOMBRE": "Otras craniectomías"
 },
 {
  "CATALOG_KEY": "01.26",
  "PRO_NOMBRE": "Inserción de catéter(es) en cavidad o tejido craneal"
 },
 {
  "CATALOG_KEY": "01.27",
  "PRO_NOMBRE": "Retiro de catéter(es) de cavidad o tejido craneal"
 },
 {
  "CATALOG_KEY": "01.28",
  "PRO_NOMBRE": "Colocación de catéter(es) intracerebral(es) a través de agujero(s) de trépano"
 },
 {
  "CATALOG_KEY": "01.3",
  "PRO_NOMBRE": "Incisión de cerebro y meninges cerebrales"
 },
 {
  "CATALOG_KEY": "01.31",
  "PRO_NOMBRE": "Incisión de meninges cerebrales"
 },
 {
  "CATALOG_KEY": "01.32",
  "PRO_NOMBRE": "Lobotomía y tractomía"
 },
 {
  "CATALOG_KEY": "01.39",
  "PRO_NOMBRE": "Otras incisiones cerebrales"
 },
 {
  "CATALOG_KEY": "01.4",
  "PRO_NOMBRE": "Operaciones sobre tálamo y globo pálido"
 },
 {
  "CATALOG_KEY": "01.41",
  "PRO_NOMBRE": "Operaciones sobre tálamo"
 },
 {
  "CATALOG_KEY": "01.42",
  "PRO_NOMBRE": "Operaciones sobre globo pálido"
 },
 {
  "CATALOG_KEY": "01.5",
  "PRO_NOMBRE": "Otras excisiones o destrucciones de cerebro y meninges"
 },
 {
  "CATALOG_KEY": "01.51",
  "PRO_NOMBRE": "Excisión de lesión o tejido de meninges cerebrales"
 },
 {
  "CATALOG_KEY": "01.52",
  "PRO_NOMBRE": "Hemisferectomía"
 },
 {
  "CATALOG_KEY": "01.53",
  "PRO_NOMBRE": "Lobectomía cerebral"
 },
 {
  "CATALOG_KEY": "01.59",
  "PRO_NOMBRE": "Otras excisiones o destrucciones de lesión o tejido cerebral"
 },
 {
  "CATALOG_KEY": "01.6",
  "PRO_NOMBRE": "Excisión de lesión craneal"
 },
 {
  "CATALOG_KEY": "02",
  "PRO_NOMBRE": "Otras operaciones sobre cráneo, cerebro y meninges cerebrales"
 },
 {
  "CATALOG_KEY": "02.0",
  "PRO_NOMBRE": "Craneoplastía"
 },
 {
  "CATALOG_KEY": "02.01",
  "PRO_NOMBRE": "Apertura de sutura craneal"
 },
 {
  "CATALOG_KEY": "02.02",
  "PRO_NOMBRE": "Elevación de fragmentos de fractura de cráneo"
 },
 {
  "CATALOG_KEY": "02.03",
  "PRO_NOMBRE": "Formación de pliegue de hueso craneal"
 },
 {
  "CATALOG_KEY": "02.04",
  "PRO_NOMBRE": "Injerto óseo de cráneo"
 },
 {
  "CATALOG_KEY": "02.05",
  "PRO_NOMBRE": "Colocación de placa craneal (metálica, acrílica)"
 },
 {
  "CATALOG_KEY": "02.06",
  "PRO_NOMBRE": "Otras osteoplastías craneales"
 },
 {
  "CATALOG_KEY": "02.07",
  "PRO_NOMBRE": "Extracción de placa craneal"
 },
 {
  "CATALOG_KEY": "02.1",
  "PRO_NOMBRE": "Reparación de meninges cerebrales"
 },
 {
  "CATALOG_KEY": "02.11",
  "PRO_NOMBRE": "Sutura simple de duramadre cerebral"
 },
 {
  "CATALOG_KEY": "02.12",
  "PRO_NOMBRE": "Otras reparaciones de meninges cerebrales"
 },
 {
  "CATALOG_KEY": "02.13",
  "PRO_NOMBRE": "Ligadura de vaso meníngeo"
 },
 {
  "CATALOG_KEY": "02.14",
  "PRO_NOMBRE": "Plexectomía coroidea"
 },
 {
  "CATALOG_KEY": "02.2",
  "PRO_NOMBRE": "Ventriculostomía"
 },
 {
  "CATALOG_KEY": "02.3",
  "PRO_NOMBRE": "Derivación ventricular extracraneal"
 },
 {
  "CATALOG_KEY": "02.31",
  "PRO_NOMBRE": "Derivación ventricular a estructuras en cabeza y cuello"
 },
 {
  "CATALOG_KEY": "02.32",
  "PRO_NOMBRE": "Derivación ventricular al aparato circulatorio"
 },
 {
  "CATALOG_KEY": "02.33",
  "PRO_NOMBRE": "Derivación ventricular a la cavidad torácica"
 },
 {
  "CATALOG_KEY": "02.34",
  "PRO_NOMBRE": "Derivación ventricular a la cavidad y órganos abdominales"
 },
 {
  "CATALOG_KEY": "02.35",
  "PRO_NOMBRE": "Derivación ventricular al aparato urinario"
 },
 {
  "CATALOG_KEY": "02.39",
  "PRO_NOMBRE": "Otras operaciones para establecer drenajes de ventrículo"
 },
 {
  "CATALOG_KEY": "02.4",
  "PRO_NOMBRE": "Revisión, extracción e irrigación de derivación ventricular"
 },
 {
  "CATALOG_KEY": "02.41",
  "PRO_NOMBRE": "Irrigación y exploración de derivación ventricular"
 },
 {
  "CATALOG_KEY": "02.42",
  "PRO_NOMBRE": "Sustitución de derivación ventricular"
 },
 {
  "CATALOG_KEY": "02.43",
  "PRO_NOMBRE": "Extracción de derivación ventricular"
 },
 {
  "CATALOG_KEY": "02.9",
  "PRO_NOMBRE": "Otras operaciones sobre cráneo, cerebro y meninges cerebrales"
 },
 {
  "CATALOG_KEY": "02.91",
  "PRO_NOMBRE": "Lisis de adherencias corticales"
 },
 {
  "CATALOG_KEY": "02.92",
  "PRO_NOMBRE": "Reparación cerebral"
 },
 {
  "CATALOG_KEY": "02.93",
  "PRO_NOMBRE": "Implantación o sustitución de electrodo(s) de neuroestimulador intracraneal"
 },
 {
  "CATALOG_KEY": "02.94",
  "PRO_NOMBRE": "Colocación o sustitución de compás o de halo craneal"
 },
 {
  "CATALOG_KEY": "02.95",
  "PRO_NOMBRE": "Extracción de compás o de halo craneal"
 },
 {
  "CATALOG_KEY": "02.96",
  "PRO_NOMBRE": "Inserción de electrodo esfenoidal"
 },
 {
  "CATALOG_KEY": "02.99",
  "PRO_NOMBRE": "Otra operación sobre cráneo, cerebro y meninges cerebrales"
 },
 {
  "CATALOG_KEY": "03",
  "PRO_NOMBRE": "Operaciones sobre médula espinal y estructuras del conducto espinal"
 },
 {
  "CATALOG_KEY": "03.0",
  "PRO_NOMBRE": "Exploración y descompresión de estructuras del conducto espinal"
 },
 {
  "CATALOG_KEY": "03.01",
  "PRO_NOMBRE": "Extracción de cuerpo extraño del conducto espinal"
 },
 {
  "CATALOG_KEY": "03.02",
  "PRO_NOMBRE": "Reapertura de sitio de laminectomía"
 },
 {
  "CATALOG_KEY": "03.09",
  "PRO_NOMBRE": "Otra exploración y descompresión del conducto espinal"
 },
 {
  "CATALOG_KEY": "03.1",
  "PRO_NOMBRE": "División de raíz de nervio intraespinal"
 },
 {
  "CATALOG_KEY": "03.2",
  "PRO_NOMBRE": "Cordotomía"
 },
 {
  "CATALOG_KEY": "03.21",
  "PRO_NOMBRE": "Cordotomía percutánea"
 },
 {
  "CATALOG_KEY": "03.29",
  "PRO_NOMBRE": "Otra cordotomía"
 },
 {
  "CATALOG_KEY": "03.3",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre la médula espinal y estructuras del conducto espinal"
 },
 {
  "CATALOG_KEY": "03.31",
  "PRO_NOMBRE": "Punción espinal"
 },
 {
  "CATALOG_KEY": "03.32",
  "PRO_NOMBRE": "Biopsia de médula espinal o meninges espinales"
 },
 {
  "CATALOG_KEY": "03.39",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre la médula espinal y estructuras del conducto espinal"
 },
 {
  "CATALOG_KEY": "03.4",
  "PRO_NOMBRE": "Excisión o destrucción de lesión de la médula espinal o de meninges espinales"
 },
 {
  "CATALOG_KEY": "03.5",
  "PRO_NOMBRE": "Operaciones plásticas sobre estructuras de la médula espinal"
 },
 {
  "CATALOG_KEY": "03.51",
  "PRO_NOMBRE": "Reparación de meningocele espinal"
 },
 {
  "CATALOG_KEY": "03.52",
  "PRO_NOMBRE": "Reparación de mielomeningocele espinal"
 },
 {
  "CATALOG_KEY": "03.53",
  "PRO_NOMBRE": "Reparación de fractura vertebral"
 },
 {
  "CATALOG_KEY": "03.59",
  "PRO_NOMBRE": "Otras reparaciones de operaciones plásticas sobre estructuras del conducto espinal"
 },
 {
  "CATALOG_KEY": "03.6",
  "PRO_NOMBRE": "Lisis de adherencias de médula espinal y raíces de nervios espinales"
 },
 {
  "CATALOG_KEY": "03.7",
  "PRO_NOMBRE": "Derivación de teca espinal"
 },
 {
  "CATALOG_KEY": "03.71",
  "PRO_NOMBRE": "Derivación subaracnoide-peritoneal espinal"
 },
 {
  "CATALOG_KEY": "03.72",
  "PRO_NOMBRE": "Derivación subaracnoide-ureteral espinal"
 },
 {
  "CATALOG_KEY": "03.79",
  "PRO_NOMBRE": "Otra derivación de teca espinal"
 },
 {
  "CATALOG_KEY": "03.8",
  "PRO_NOMBRE": "Inyección de agente destructivo en el conducto espinal"
 },
 {
  "CATALOG_KEY": "03.9",
  "PRO_NOMBRE": "Otras operaciones sobre la médula espinal y estructuras del conducto espinal"
 },
 {
  "CATALOG_KEY": "03.90",
  "PRO_NOMBRE": "Inserción de catéter en conducto espinal para infusión de sustancias terapéuticas o paliativas"
 },
 {
  "CATALOG_KEY": "03.91",
  "PRO_NOMBRE": "Inyección de anestésico en el conducto espinal para analgesia"
 },
 {
  "CATALOG_KEY": "03.92",
  "PRO_NOMBRE": "Inyección de otro agente en canal espinal"
 },
 {
  "CATALOG_KEY": "03.93",
  "PRO_NOMBRE": "Implantación o sustitución de electrodo(s) de neuroestimulador medular"
 },
 {
  "CATALOG_KEY": "03.94",
  "PRO_NOMBRE": "Extracción de electrodo(s) de neuroestimulador espinal"
 },
 {
  "CATALOG_KEY": "03.95",
  "PRO_NOMBRE": "Parche hemático espinal"
 },
 {
  "CATALOG_KEY": "03.96",
  "PRO_NOMBRE": "Denervación percutánea de faceta"
 },
 {
  "CATALOG_KEY": "03.97",
  "PRO_NOMBRE": "Revisión de derivación de teca espinal"
 },
 {
  "CATALOG_KEY": "03.98",
  "PRO_NOMBRE": "Extracción de derivación de teca espinal"
 },
 {
  "CATALOG_KEY": "03.99",
  "PRO_NOMBRE": "Otra operación sobre la médula espinal y estructuras del conducto espinal"
 },
 {
  "CATALOG_KEY": "04",
  "PRO_NOMBRE": "Operaciones sobre nervios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "04.0",
  "PRO_NOMBRE": "Incisión, división y excisión de nervios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "04.01",
  "PRO_NOMBRE": "Excisión de neuroma acústico"
 },
 {
  "CATALOG_KEY": "04.02",
  "PRO_NOMBRE": "Sección de nervio trigémino"
 },
 {
  "CATALOG_KEY": "04.03",
  "PRO_NOMBRE": "Sección aplastamiento de otros nervios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "04.04",
  "PRO_NOMBRE": "Otras incisiones de nervios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "04.05",
  "PRO_NOMBRE": "Ganglionectomía de Gasser"
 },
 {
  "CATALOG_KEY": "04.06",
  "PRO_NOMBRE": "Otras ganglionectomías craneales o periféricas"
 },
 {
  "CATALOG_KEY": "04.07",
  "PRO_NOMBRE": "Otras excisiones o avulsiones de nervios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "04.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre el sistema nervioso periférico"
 },
 {
  "CATALOG_KEY": "04.11",
  "PRO_NOMBRE": "Biopsia cerrada [aguja] [percutánea] de nervio o ganglio craneal o simpático"
 },
 {
  "CATALOG_KEY": "04.12",
  "PRO_NOMBRE": "Biopsia abierta de nervio o ganglio craneal o periférico"
 },
 {
  "CATALOG_KEY": "04.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre nervios y ganglios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "04.2",
  "PRO_NOMBRE": "Destrucción de nervios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "04.3",
  "PRO_NOMBRE": "Sutura de nervios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "04.4",
  "PRO_NOMBRE": "Lisis de adherencias y descompresión de nervios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "04.41",
  "PRO_NOMBRE": "Descompresión de raíz de nervio trigémino"
 },
 {
  "CATALOG_KEY": "04.42",
  "PRO_NOMBRE": "Descompresión de otro nervio craneal"
 },
 {
  "CATALOG_KEY": "04.43",
  "PRO_NOMBRE": "Liberación de túnel carpiano"
 },
 {
  "CATALOG_KEY": "04.44",
  "PRO_NOMBRE": "Liberación de túnel tarsal"
 },
 {
  "CATALOG_KEY": "04.49",
  "PRO_NOMBRE": "Otra descompresión o lisis de adherencia de nervio o ganglio periférico"
 },
 {
  "CATALOG_KEY": "04.5",
  "PRO_NOMBRE": "Injerto de nervio craneal o periférico"
 },
 {
  "CATALOG_KEY": "04.6",
  "PRO_NOMBRE": "Transposición de nervios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "04.7",
  "PRO_NOMBRE": "Otra neuroplastía craneal o periférica"
 },
 {
  "CATALOG_KEY": "04.71",
  "PRO_NOMBRE": "Anastomosis hipogloso-facial"
 },
 {
  "CATALOG_KEY": "04.72",
  "PRO_NOMBRE": "Anastomosis accesorio-facial"
 },
 {
  "CATALOG_KEY": "04.73",
  "PRO_NOMBRE": "Anastomosis accesorio-hipoglosa"
 },
 {
  "CATALOG_KEY": "04.74",
  "PRO_NOMBRE": "Otra anastomosis de nervio craneal o periférico"
 },
 {
  "CATALOG_KEY": "04.75",
  "PRO_NOMBRE": "Revisión de reparación anterior de nervios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "04.76",
  "PRO_NOMBRE": "Reparación de herida traumática antigua de cráneo y nervios periféricos"
 },
 {
  "CATALOG_KEY": "04.79",
  "PRO_NOMBRE": "Otras neuroplastías"
 },
 {
  "CATALOG_KEY": "04.8",
  "PRO_NOMBRE": "Inyección dentro de nervio periférico"
 },
 {
  "CATALOG_KEY": "04.80",
  "PRO_NOMBRE": "Inyección de nervio craneal o periférico, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "04.81",
  "PRO_NOMBRE": "Inyección de anestesia dentro de nervio craneal o periférico con fines analgésicos"
 },
 {
  "CATALOG_KEY": "04.89",
  "PRO_NOMBRE": "Inyección de otro agente excepto neurolítico"
 },
 {
  "CATALOG_KEY": "04.9",
  "PRO_NOMBRE": "Otras operaciones sobre nervios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "04.91",
  "PRO_NOMBRE": "Neurectasia"
 },
 {
  "CATALOG_KEY": "04.92",
  "PRO_NOMBRE": "Implantación o sustitución de electrodo(s) de neuroestimulador periférico"
 },
 {
  "CATALOG_KEY": "04.93",
  "PRO_NOMBRE": "Extracción de electrodo(s) de neuroestimulador periférico"
 },
 {
  "CATALOG_KEY": "04.99",
  "PRO_NOMBRE": "Otra operación de nervios craneales y periféricos"
 },
 {
  "CATALOG_KEY": "05",
  "PRO_NOMBRE": "Operaciones sobre nervios o ganglios simpáticos"
 },
 {
  "CATALOG_KEY": "05.0",
  "PRO_NOMBRE": "División de nervio o ganglio simpático"
 },
 {
  "CATALOG_KEY": "05.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre nervios o ganglios simpáticos"
 },
 {
  "CATALOG_KEY": "05.11",
  "PRO_NOMBRE": "Biopsia de nervio o ganglio simpático"
 },
 {
  "CATALOG_KEY": "05.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre nervios o ganglios simpáticos"
 },
 {
  "CATALOG_KEY": "05.2",
  "PRO_NOMBRE": "Simpatectomía"
 },
 {
  "CATALOG_KEY": "05.21",
  "PRO_NOMBRE": "Ganglionectomía esfenopalatina"
 },
 {
  "CATALOG_KEY": "05.22",
  "PRO_NOMBRE": "Simpatectomía cervical"
 },
 {
  "CATALOG_KEY": "05.23",
  "PRO_NOMBRE": "Simpatectomía lumbar"
 },
 {
  "CATALOG_KEY": "05.24",
  "PRO_NOMBRE": "Simpatectomía presacral"
 },
 {
  "CATALOG_KEY": "05.25",
  "PRO_NOMBRE": "Simpatectomía periarterial"
 },
 {
  "CATALOG_KEY": "05.29",
  "PRO_NOMBRE": "Otras simpatectomías y ganglionectomías"
 },
 {
  "CATALOG_KEY": "05.3",
  "PRO_NOMBRE": "Inyección en nervio o ganglio simpático"
 },
 {
  "CATALOG_KEY": "05.31",
  "PRO_NOMBRE": "Inyección de anestésico en nervio simpático con fines analgésicos"
 },
 {
  "CATALOG_KEY": "05.32",
  "PRO_NOMBRE": "Inyección de agente neurolítico en nervio simpático"
 },
 {
  "CATALOG_KEY": "05.39",
  "PRO_NOMBRE": "Otra inyección en nervio o ganglio simpático"
 },
 {
  "CATALOG_KEY": "05.8",
  "PRO_NOMBRE": "Otras operaciones sobre nervios o ganglios simpáticos"
 },
 {
  "CATALOG_KEY": "05.81",
  "PRO_NOMBRE": "Reparación de nervios o ganglios simpáticos"
 },
 {
  "CATALOG_KEY": "05.89",
  "PRO_NOMBRE": "Otra operación sobre nervios o ganglios simpáticos"
 },
 {
  "CATALOG_KEY": "05.9",
  "PRO_NOMBRE": "Otras operaciones sobre el sistema nervioso"
 },
 {
  "CATALOG_KEY": "06",
  "PRO_NOMBRE": "Operaciones sobre las glándulas tiroides y paratiroides"
 },
 {
  "CATALOG_KEY": "06.0",
  "PRO_NOMBRE": "Incisión sobre el área tiroidea"
 },
 {
  "CATALOG_KEY": "06.01",
  "PRO_NOMBRE": "Aspiración del área tiroidea"
 },
 {
  "CATALOG_KEY": "06.02",
  "PRO_NOMBRE": "Reapertura de herida de área tiroidea"
 },
 {
  "CATALOG_KEY": "06.09",
  "PRO_NOMBRE": "Otra incisión del área tiroidea"
 },
 {
  "CATALOG_KEY": "06.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre glándulas paratiroides y tiroides"
 },
 {
  "CATALOG_KEY": "06.10",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre glándulas paratiroides y tiroides"
 },
 {
  "CATALOG_KEY": "06.11",
  "PRO_NOMBRE": "Biopsia cerrada [aguja] [percutánea] de glándula tiroides"
 },
 {
  "CATALOG_KEY": "06.12",
  "PRO_NOMBRE": "Otra biopsia de glándula tiroides"
 },
 {
  "CATALOG_KEY": "06.13",
  "PRO_NOMBRE": "Biopsia de glándula paratiroides"
 },
 {
  "CATALOG_KEY": "06.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre glándulas tiroides y paratiroides"
 },
 {
  "CATALOG_KEY": "06.2",
  "PRO_NOMBRE": "Lobectomía tiroidea unilateral"
 },
 {
  "CATALOG_KEY": "06.3",
  "PRO_NOMBRE": "Otra tiroidectomía parcial"
 },
 {
  "CATALOG_KEY": "06.31",
  "PRO_NOMBRE": "Extirpación de lesión de tiroides"
 },
 {
  "CATALOG_KEY": "06.39",
  "PRO_NOMBRE": "Otra tiroidectomía parcial"
 },
 {
  "CATALOG_KEY": "06.4",
  "PRO_NOMBRE": "Tiroidectomía total"
 },
 {
  "CATALOG_KEY": "06.5",
  "PRO_NOMBRE": "Tiroidectomía retroesternal"
 },
 {
  "CATALOG_KEY": "06.50",
  "PRO_NOMBRE": "Tiroidectomía retroesternal, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "06.51",
  "PRO_NOMBRE": "Tiroidectomía retroesternal parcial"
 },
 {
  "CATALOG_KEY": "06.52",
  "PRO_NOMBRE": "Tiroidectomía retroesternal total"
 },
 {
  "CATALOG_KEY": "06.6",
  "PRO_NOMBRE": "Extirpación de tiroides lingual"
 },
 {
  "CATALOG_KEY": "06.7",
  "PRO_NOMBRE": "Extirpación del conducto tirogloso"
 },
 {
  "CATALOG_KEY": "06.8",
  "PRO_NOMBRE": "Paratiroidectomía"
 },
 {
  "CATALOG_KEY": "06.81",
  "PRO_NOMBRE": "Paratiroidectomía total"
 },
 {
  "CATALOG_KEY": "06.89",
  "PRO_NOMBRE": "Otra paratiroidectomía"
 },
 {
  "CATALOG_KEY": "06.9",
  "PRO_NOMBRE": "Otras operaciones sobre tiroides (región) y paratiroides"
 },
 {
  "CATALOG_KEY": "06.91",
  "PRO_NOMBRE": "División del istmo tiroideo"
 },
 {
  "CATALOG_KEY": "06.92",
  "PRO_NOMBRE": "Ligadura de vasos tiroideos"
 },
 {
  "CATALOG_KEY": "06.93",
  "PRO_NOMBRE": "Sutura de glándula tiroides"
 },
 {
  "CATALOG_KEY": "06.94",
  "PRO_NOMBRE": "Reimplantación de tejidos tiroideos"
 },
 {
  "CATALOG_KEY": "06.95",
  "PRO_NOMBRE": "Reimplantación de tejido paratiroideo"
 },
 {
  "CATALOG_KEY": "06.98",
  "PRO_NOMBRE": "Otras operaciones sobre glándulas tiroides"
 },
 {
  "CATALOG_KEY": "06.99",
  "PRO_NOMBRE": "Otras operaciones sobre glándulas paratiroides"
 },
 {
  "CATALOG_KEY": "07",
  "PRO_NOMBRE": "Operaciones sobre otras glándulas endocrinas"
 },
 {
  "CATALOG_KEY": "07.0",
  "PRO_NOMBRE": "Exploración del área suprarrenal"
 },
 {
  "CATALOG_KEY": "07.00",
  "PRO_NOMBRE": "Exploración de área suprarrenal, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "07.01",
  "PRO_NOMBRE": "Exploración unilateral del área suprarrenal"
 },
 {
  "CATALOG_KEY": "07.02",
  "PRO_NOMBRE": "Exploración bilateral del área suprarrenal"
 },
 {
  "CATALOG_KEY": "07.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre glándulas suprarrenales, glándula pituitaria, glándula pineal y timo"
 },
 {
  "CATALOG_KEY": "07.11",
  "PRO_NOMBRE": "Biopsia cerrada [aguja] [percutánea] de glándula suprarrenal"
 },
 {
  "CATALOG_KEY": "07.12",
  "PRO_NOMBRE": "Otra biopsia de glándula suprarrenal"
 },
 {
  "CATALOG_KEY": "07.13",
  "PRO_NOMBRE": "Biopsia de glándula pituitaria, acceso transfrontal"
 },
 {
  "CATALOG_KEY": "07.14",
  "PRO_NOMBRE": "Biopsia de glándula pituitaria, acceso transesfenoidal"
 },
 {
  "CATALOG_KEY": "07.15",
  "PRO_NOMBRE": "Biopsia de glándula pituitaria, acceso no especificado"
 },
 {
  "CATALOG_KEY": "07.16",
  "PRO_NOMBRE": "Biopsia de timo"
 },
 {
  "CATALOG_KEY": "07.17",
  "PRO_NOMBRE": "Biopsia de glándula pineal"
 },
 {
  "CATALOG_KEY": "07.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre glándulas suprarrenales, glándula pituitaria, glándula pineal y timo"
 },
 {
  "CATALOG_KEY": "07.2",
  "PRO_NOMBRE": "Suprarrenalectomía parcial"
 },
 {
  "CATALOG_KEY": "07.21",
  "PRO_NOMBRE": "Excisión de lesión de glándula suprarrenal"
 },
 {
  "CATALOG_KEY": "07.22",
  "PRO_NOMBRE": "Suprarrenalectomía unilateral"
 },
 {
  "CATALOG_KEY": "07.29",
  "PRO_NOMBRE": "Otra suprarrenalectomía parcial"
 },
 {
  "CATALOG_KEY": "07.3",
  "PRO_NOMBRE": "Suprarrenalectomía bilateral"
 },
 {
  "CATALOG_KEY": "07.4",
  "PRO_NOMBRE": "Otras operaciones sobre glándulas, nervios, y vasos suprarrenales"
 },
 {
  "CATALOG_KEY": "07.41",
  "PRO_NOMBRE": "Incisión de glándula suprarrenal"
 },
 {
  "CATALOG_KEY": "07.42",
  "PRO_NOMBRE": "División de nervios aferentes con glándulas suprarrenales"
 },
 {
  "CATALOG_KEY": "07.43",
  "PRO_NOMBRE": "Ligadura de vasos suprarrenales"
 },
 {
  "CATALOG_KEY": "07.44",
  "PRO_NOMBRE": "Reparación de glándula suprarrenal"
 },
 {
  "CATALOG_KEY": "07.45",
  "PRO_NOMBRE": "Reimplantación de tejido suprarrenal"
 },
 {
  "CATALOG_KEY": "07.49",
  "PRO_NOMBRE": "Otra operación sobre glándulas, nervios y vasos suprarrenales"
 },
 {
  "CATALOG_KEY": "07.5",
  "PRO_NOMBRE": "Operaciones sobre glándula pineal"
 },
 {
  "CATALOG_KEY": "07.51",
  "PRO_NOMBRE": "Exploración del área pineal"
 },
 {
  "CATALOG_KEY": "07.52",
  "PRO_NOMBRE": "Incisión de glándula pineal"
 },
 {
  "CATALOG_KEY": "07.53",
  "PRO_NOMBRE": "Excisión parcial de glándula pineal"
 },
 {
  "CATALOG_KEY": "07.54",
  "PRO_NOMBRE": "Excisión total de glándula pineal"
 },
 {
  "CATALOG_KEY": "07.59",
  "PRO_NOMBRE": "Otras operaciones sobre glándula pineal"
 },
 {
  "CATALOG_KEY": "07.6",
  "PRO_NOMBRE": "Hipofisectomía"
 },
 {
  "CATALOG_KEY": "07.61",
  "PRO_NOMBRE": "Excisión parcial de glándula pituitaria, acceso transfrontal"
 },
 {
  "CATALOG_KEY": "07.62",
  "PRO_NOMBRE": "Excisión parcial de glándula pituitaria, acceso transesfenoidal"
 },
 {
  "CATALOG_KEY": "07.63",
  "PRO_NOMBRE": "Excisión parcial de glándula pituitaria, acceso no especificado"
 },
 {
  "CATALOG_KEY": "07.64",
  "PRO_NOMBRE": "Excisión total de glándula pituitaria, acceso transfrontal"
 },
 {
  "CATALOG_KEY": "07.65",
  "PRO_NOMBRE": "Excisión total de glándula pituitaria, acceso transesfenoidal"
 },
 {
  "CATALOG_KEY": "07.68",
  "PRO_NOMBRE": "Excisión total de glándula pituitaria, otro acceso especificado"
 },
 {
  "CATALOG_KEY": "07.69",
  "PRO_NOMBRE": "Excisión total de glándula pituitaria, acceso no especificado"
 },
 {
  "CATALOG_KEY": "07.7",
  "PRO_NOMBRE": "Otras operaciones sobre hipófisis"
 },
 {
  "CATALOG_KEY": "07.71",
  "PRO_NOMBRE": "Exploración de fosa pituitaria"
 },
 {
  "CATALOG_KEY": "07.72",
  "PRO_NOMBRE": "Incisión de glándula pituitaria"
 },
 {
  "CATALOG_KEY": "07.79",
  "PRO_NOMBRE": "Otra operación sobre hipófisis"
 },
 {
  "CATALOG_KEY": "07.8",
  "PRO_NOMBRE": "Timectomía"
 },
 {
  "CATALOG_KEY": "07.80",
  "PRO_NOMBRE": "Timectomía, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "07.81",
  "PRO_NOMBRE": "Otra extirpación parcial del timo"
 },
 {
  "CATALOG_KEY": "07.82",
  "PRO_NOMBRE": "Otra extirpación total del timo"
 },
 {
  "CATALOG_KEY": "07.83",
  "PRO_NOMBRE": "Extirpación parcial del timo por toracoscopía"
 },
 {
  "CATALOG_KEY": "07.84",
  "PRO_NOMBRE": "Extirpación total del timo por toracoscopía"
 },
 {
  "CATALOG_KEY": "07.9",
  "PRO_NOMBRE": "Otras operaciones sobre el timo"
 },
 {
  "CATALOG_KEY": "07.91",
  "PRO_NOMBRE": "Exploración del área tímica"
 },
 {
  "CATALOG_KEY": "07.92",
  "PRO_NOMBRE": "Otra incisión del timo"
 },
 {
  "CATALOG_KEY": "07.93",
  "PRO_NOMBRE": "Reparación de timo"
 },
 {
  "CATALOG_KEY": "07.94",
  "PRO_NOMBRE": "Trasplante de timo"
 },
 {
  "CATALOG_KEY": "07.95",
  "PRO_NOMBRE": "Incisión del timo por toracoscopía"
 },
 {
  "CATALOG_KEY": "07.98",
  "PRO_NOMBRE": "Otras operaciones y las no especificadas del timo por toracoscopía"
 },
 {
  "CATALOG_KEY": "07.99",
  "PRO_NOMBRE": "Otras operaciones y las no especificadas del timo"
 },
 {
  "CATALOG_KEY": "08",
  "PRO_NOMBRE": "Operaciones sobre párpados"
 },
 {
  "CATALOG_KEY": "08.0",
  "PRO_NOMBRE": "Incisión de párpado"
 },
 {
  "CATALOG_KEY": "08.01",
  "PRO_NOMBRE": "Incisión del margen del párpado"
 },
 {
  "CATALOG_KEY": "08.02",
  "PRO_NOMBRE": "Seccionado de blefarorrafia"
 },
 {
  "CATALOG_KEY": "08.09",
  "PRO_NOMBRE": "Otra incisión de párpado"
 },
 {
  "CATALOG_KEY": "08.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre párpado"
 },
 {
  "CATALOG_KEY": "08.11",
  "PRO_NOMBRE": "Biopsia de párpado"
 },
 {
  "CATALOG_KEY": "08.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre párpado"
 },
 {
  "CATALOG_KEY": "08.2",
  "PRO_NOMBRE": "Excisión o destrucción de lesión o tejido de párpado"
 },
 {
  "CATALOG_KEY": "08.20",
  "PRO_NOMBRE": "Eliminación de lesión de párpado, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "08.21",
  "PRO_NOMBRE": "Excisión de chalazión"
 },
 {
  "CATALOG_KEY": "08.22",
  "PRO_NOMBRE": "Excisión de otra lesión menor de párpado"
 },
 {
  "CATALOG_KEY": "08.23",
  "PRO_NOMBRE": "Excisión de lesión importante de párpado, espesor parcial"
 },
 {
  "CATALOG_KEY": "08.24",
  "PRO_NOMBRE": "Excisión de lesión importante de párpado, espesor total"
 },
 {
  "CATALOG_KEY": "08.25",
  "PRO_NOMBRE": "Destrucción de lesión de párpado"
 },
 {
  "CATALOG_KEY": "08.3",
  "PRO_NOMBRE": "Reparación de blefaroptosis y retracción del párpado"
 },
 {
  "CATALOG_KEY": "08.31",
  "PRO_NOMBRE": "Reparación de blefaroptosis por técnica de músculo frontal con sutura"
 },
 {
  "CATALOG_KEY": "08.32",
  "PRO_NOMBRE": "Reparación de blefaroptosis por técnica de músculo frontal con suspensión facial"
 },
 {
  "CATALOG_KEY": "08.33",
  "PRO_NOMBRE": "Reparación de blefaroptosis por resección o avance de músculo elevador o aponeurosis"
 },
 {
  "CATALOG_KEY": "08.34",
  "PRO_NOMBRE": "Reparación de blefaroptosis por otras técnicas del músculo elevador"
 },
 {
  "CATALOG_KEY": "08.35",
  "PRO_NOMBRE": "Reparación de blefaroptosis por otra técnica tarsiana"
 },
 {
  "CATALOG_KEY": "08.36",
  "PRO_NOMBRE": "Reparación de blefaroptosis por otras técnicas"
 },
 {
  "CATALOG_KEY": "08.37",
  "PRO_NOMBRE": "Reducción de corrección excesiva de ptosis"
 },
 {
  "CATALOG_KEY": "08.38",
  "PRO_NOMBRE": "Corrección de retracción del párpado"
 },
 {
  "CATALOG_KEY": "08.4",
  "PRO_NOMBRE": "Reparación de entropión o ectropión"
 },
 {
  "CATALOG_KEY": "08.41",
  "PRO_NOMBRE": "Reparación de entropión o ectropión por termocauterización"
 },
 {
  "CATALOG_KEY": "08.42",
  "PRO_NOMBRE": "Reparación de entropión o ectropión por técnica de sutura"
 },
 {
  "CATALOG_KEY": "08.43",
  "PRO_NOMBRE": "Reparación de entropión o ectropión con resección en cuña"
 },
 {
  "CATALOG_KEY": "08.44",
  "PRO_NOMBRE": "Reparación de entropión o ectropión con reconstrucción de párpado"
 },
 {
  "CATALOG_KEY": "08.49",
  "PRO_NOMBRE": "Otra reparación de entropión o ectropión"
 },
 {
  "CATALOG_KEY": "08.5",
  "PRO_NOMBRE": "Otro ajuste de posición de párpado"
 },
 {
  "CATALOG_KEY": "08.51",
  "PRO_NOMBRE": "Cantotomía"
 },
 {
  "CATALOG_KEY": "08.52",
  "PRO_NOMBRE": "Blefarorrafia"
 },
 {
  "CATALOG_KEY": "08.59",
  "PRO_NOMBRE": "Otro ajuste de posición de párpado"
 },
 {
  "CATALOG_KEY": "08.6",
  "PRO_NOMBRE": "Reconstrucción de párpado con colgajo o injerto"
 },
 {
  "CATALOG_KEY": "08.61",
  "PRO_NOMBRE": "Reconstrucción de párpado con colgajo o injerto de piel"
 },
 {
  "CATALOG_KEY": "08.62",
  "PRO_NOMBRE": "Reconstrucción de párpado con colgajo o injerto de membrana mucosa"
 },
 {
  "CATALOG_KEY": "08.63",
  "PRO_NOMBRE": "Reconstrucción de párpado con injerto de folículo piloso"
 },
 {
  "CATALOG_KEY": "08.64",
  "PRO_NOMBRE": "Reconstrucción de párpado con colgajo tarsoconjuntival"
 },
 {
  "CATALOG_KEY": "08.69",
  "PRO_NOMBRE": "Otra reconstrucción de párpado con colgajos o injertos"
 },
 {
  "CATALOG_KEY": "08.7",
  "PRO_NOMBRE": "Otra reconstrucción de párpado"
 },
 {
  "CATALOG_KEY": "08.70",
  "PRO_NOMBRE": "Reconstrucción de párpado, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "08.71",
  "PRO_NOMBRE": "Reconstrucción de párpado con implicación de margen de párpado, grosor parcial"
 },
 {
  "CATALOG_KEY": "08.72",
  "PRO_NOMBRE": "Otra reconstrucción de párpado, grosor parcial"
 },
 {
  "CATALOG_KEY": "08.73",
  "PRO_NOMBRE": "Reconstrucción de párpado con implicación de margen del párpado, grosor total"
 },
 {
  "CATALOG_KEY": "08.74",
  "PRO_NOMBRE": "Otra reconstrucción de párpado, grosor total"
 },
 {
  "CATALOG_KEY": "08.8",
  "PRO_NOMBRE": "Otra reparación del párpado"
 },
 {
  "CATALOG_KEY": "08.81",
  "PRO_NOMBRE": "Reparación lineal de laceración de párpado o ceja"
 },
 {
  "CATALOG_KEY": "08.82",
  "PRO_NOMBRE": "Reparación de laceración con afectación de margen de párpado, grosor parcial"
 },
 {
  "CATALOG_KEY": "08.83",
  "PRO_NOMBRE": "Otra reparación de laceración de párpado, grosor parcial"
 },
 {
  "CATALOG_KEY": "08.84",
  "PRO_NOMBRE": "Reparación de laceración con afectación de margen de párpado, grosor total"
 },
 {
  "CATALOG_KEY": "08.85",
  "PRO_NOMBRE": "Otra reparación de laceración de párpado, grosor total"
 },
 {
  "CATALOG_KEY": "08.86",
  "PRO_NOMBRE": "Ritidectomía de párpado inferior"
 },
 {
  "CATALOG_KEY": "08.87",
  "PRO_NOMBRE": "Ritidectomía de párpado superior"
 },
 {
  "CATALOG_KEY": "08.89",
  "PRO_NOMBRE": "Otra reparación de párpado"
 },
 {
  "CATALOG_KEY": "08.9",
  "PRO_NOMBRE": "Otras operaciones sobre párpados"
 },
 {
  "CATALOG_KEY": "08.91",
  "PRO_NOMBRE": "Epilación electroquirúrgica de párpado"
 },
 {
  "CATALOG_KEY": "08.92",
  "PRO_NOMBRE": "Epilación crioquirúrgica de párpado"
 },
 {
  "CATALOG_KEY": "08.93",
  "PRO_NOMBRE": "Otra epilación de párpado"
 },
 {
  "CATALOG_KEY": "08.99",
  "PRO_NOMBRE": "Otras operaciones de párpados"
 },
 {
  "CATALOG_KEY": "09",
  "PRO_NOMBRE": "Operaciones sobre aparato lagrimal"
 },
 {
  "CATALOG_KEY": "09.0",
  "PRO_NOMBRE": "Incisión de glándula lagrimal"
 },
 {
  "CATALOG_KEY": "09.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre aparato lagrimal"
 },
 {
  "CATALOG_KEY": "09.11",
  "PRO_NOMBRE": "Biopsia de glándula lagrimal"
 },
 {
  "CATALOG_KEY": "09.12",
  "PRO_NOMBRE": "Biopsia de saco lagrimal"
 },
 {
  "CATALOG_KEY": "09.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre aparato lagrimal"
 },
 {
  "CATALOG_KEY": "09.2",
  "PRO_NOMBRE": "Excisión de lesión o tejido de glándula lagrimal"
 },
 {
  "CATALOG_KEY": "09.20",
  "PRO_NOMBRE": "Excisión de glándula lagrimal, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "09.21",
  "PRO_NOMBRE": "Excisión de lesión de glándula lagrimal"
 },
 {
  "CATALOG_KEY": "09.22",
  "PRO_NOMBRE": "Otra dacrioadenectomía parcial"
 },
 {
  "CATALOG_KEY": "09.23",
  "PRO_NOMBRE": "Dacrioadenectomía total"
 },
 {
  "CATALOG_KEY": "09.3",
  "PRO_NOMBRE": "Otras operaciones sobre glándula lagrimal"
 },
 {
  "CATALOG_KEY": "09.4",
  "PRO_NOMBRE": "Manipulación del conducto lagrimal"
 },
 {
  "CATALOG_KEY": "09.41",
  "PRO_NOMBRE": "Sondaje del punto lagrimal"
 },
 {
  "CATALOG_KEY": "09.42",
  "PRO_NOMBRE": "Sondaje del canalículos lagrimales"
 },
 {
  "CATALOG_KEY": "09.43",
  "PRO_NOMBRE": "Exploración de conducto nasolagrimal"
 },
 {
  "CATALOG_KEY": "09.44",
  "PRO_NOMBRE": "Intubación de conducto nasolagrimal"
 },
 {
  "CATALOG_KEY": "09.49",
  "PRO_NOMBRE": "Otra manipulación de conducto lagrimal"
 },
 {
  "CATALOG_KEY": "09.5",
  "PRO_NOMBRE": "Incisión de saco y conductos lagrimales"
 },
 {
  "CATALOG_KEY": "09.51",
  "PRO_NOMBRE": "Incisión de punto lagrimal"
 },
 {
  "CATALOG_KEY": "09.52",
  "PRO_NOMBRE": "Incisión de canalículos lagrimales"
 },
 {
  "CATALOG_KEY": "09.53",
  "PRO_NOMBRE": "Incisión de saco lagrimal"
 },
 {
  "CATALOG_KEY": "09.59",
  "PRO_NOMBRE": "Otra incisión de conductos lagrimales"
 },
 {
  "CATALOG_KEY": "09.6",
  "PRO_NOMBRE": "Excisión de saco y conducto lagrimal"
 },
 {
  "CATALOG_KEY": "09.7",
  "PRO_NOMBRE": "Reparación de canalículo y punto"
 },
 {
  "CATALOG_KEY": "09.71",
  "PRO_NOMBRE": "Corrección de punto evertido"
 },
 {
  "CATALOG_KEY": "09.72",
  "PRO_NOMBRE": "Otra reparación de punto"
 },
 {
  "CATALOG_KEY": "09.73",
  "PRO_NOMBRE": "Reparación de canalículos"
 },
 {
  "CATALOG_KEY": "09.8",
  "PRO_NOMBRE": "Fistulización del tracto lagrimal hasta la cavidad nasal"
 },
 {
  "CATALOG_KEY": "09.81",
  "PRO_NOMBRE": "Dacriocistorrinostomía [DCR]"
 },
 {
  "CATALOG_KEY": "09.82",
  "PRO_NOMBRE": "Conjuntivocistorrinostomía"
 },
 {
  "CATALOG_KEY": "09.83",
  "PRO_NOMBRE": "Conjuntivorrinostomía con inserción de tubo o varilla"
 },
 {
  "CATALOG_KEY": "09.9",
  "PRO_NOMBRE": "Otras operaciones sobre el aparato lagrimal"
 },
 {
  "CATALOG_KEY": "09.91",
  "PRO_NOMBRE": "Obliteración del punto lagrimal"
 },
 {
  "CATALOG_KEY": "10",
  "PRO_NOMBRE": "Operaciones sobre la conjuntiva"
 },
 {
  "CATALOG_KEY": "10.0",
  "PRO_NOMBRE": "Extracción de la conjuntiva de un cuerpo extraño incrustado mediante incisión"
 },
 {
  "CATALOG_KEY": "10.1",
  "PRO_NOMBRE": "Otra incisión de conjuntiva"
 },
 {
  "CATALOG_KEY": "10.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos de la conjuntiva"
 },
 {
  "CATALOG_KEY": "10.21",
  "PRO_NOMBRE": "Biopsia de conjuntiva"
 },
 {
  "CATALOG_KEY": "10.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos de la conjuntiva"
 },
 {
  "CATALOG_KEY": "10.3",
  "PRO_NOMBRE": "Excisión o destrucción de lesión o tejido de conjuntiva"
 },
 {
  "CATALOG_KEY": "10.31",
  "PRO_NOMBRE": "Excisión de lesión o tejido de conjuntiva"
 },
 {
  "CATALOG_KEY": "10.32",
  "PRO_NOMBRE": "Destrucción de lesión de conjuntiva"
 },
 {
  "CATALOG_KEY": "10.33",
  "PRO_NOMBRE": "Otros procedimientos destructivos de la conjuntiva"
 },
 {
  "CATALOG_KEY": "10.4",
  "PRO_NOMBRE": "Conjuntivoplastía"
 },
 {
  "CATALOG_KEY": "10.41",
  "PRO_NOMBRE": "Reparación de simbléfaron con injerto libre"
 },
 {
  "CATALOG_KEY": "10.42",
  "PRO_NOMBRE": "Reconstrucción de fondo de saco conjuntival con injerto libre"
 },
 {
  "CATALOG_KEY": "10.43",
  "PRO_NOMBRE": "Otra reconstrucción de fondo de saco conjuntival"
 },
 {
  "CATALOG_KEY": "10.44",
  "PRO_NOMBRE": "Otro injerto libre a la conjuntiva"
 },
 {
  "CATALOG_KEY": "10.49",
  "PRO_NOMBRE": "Otra conjuntivoplastía"
 },
 {
  "CATALOG_KEY": "10.5",
  "PRO_NOMBRE": "Lisis de adherencia conjuntiva y párpado"
 },
 {
  "CATALOG_KEY": "10.6",
  "PRO_NOMBRE": "Reparación de laceración de conjuntiva"
 },
 {
  "CATALOG_KEY": "10.9",
  "PRO_NOMBRE": "Otras operaciones sobre conjuntiva"
 },
 {
  "CATALOG_KEY": "10.91",
  "PRO_NOMBRE": "Inyección subconjuntival"
 },
 {
  "CATALOG_KEY": "10.99",
  "PRO_NOMBRE": "Otras operaciones de la conjuntiva"
 },
 {
  "CATALOG_KEY": "11",
  "PRO_NOMBRE": "Operaciones de la córnea"
 },
 {
  "CATALOG_KEY": "11.0",
  "PRO_NOMBRE": "Extracción por imán de cuerpo extraño incrustado en córnea"
 },
 {
  "CATALOG_KEY": "11.1",
  "PRO_NOMBRE": "Incisión de córnea"
 },
 {
  "CATALOG_KEY": "11.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos de la córnea"
 },
 {
  "CATALOG_KEY": "11.21",
  "PRO_NOMBRE": "Raspado de córnea para frotis o cultivo"
 },
 {
  "CATALOG_KEY": "11.22",
  "PRO_NOMBRE": "Biopsia de córnea"
 },
 {
  "CATALOG_KEY": "11.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos de la córnea"
 },
 {
  "CATALOG_KEY": "11.3",
  "PRO_NOMBRE": "Excisión de pterigión"
 },
 {
  "CATALOG_KEY": "11.31",
  "PRO_NOMBRE": "Transposición de pterigión"
 },
 {
  "CATALOG_KEY": "11.32",
  "PRO_NOMBRE": "Excisión de pterigión con injerto corneal"
 },
 {
  "CATALOG_KEY": "11.39",
  "PRO_NOMBRE": "Otra excisión de pterigión"
 },
 {
  "CATALOG_KEY": "11.4",
  "PRO_NOMBRE": "Excisión o destrucción de tejido u otra lesión de córnea"
 },
 {
  "CATALOG_KEY": "11.41",
  "PRO_NOMBRE": "Extirpación mecánica del epitelio corneal"
 },
 {
  "CATALOG_KEY": "11.42",
  "PRO_NOMBRE": "Termocauterización de lesión corneal"
 },
 {
  "CATALOG_KEY": "11.43",
  "PRO_NOMBRE": "Crioterapia de lesión corneal"
 },
 {
  "CATALOG_KEY": "11.49",
  "PRO_NOMBRE": "Otra extirpación o destrucción de lesión corneal"
 },
 {
  "CATALOG_KEY": "11.5",
  "PRO_NOMBRE": "Reparación de córnea"
 },
 {
  "CATALOG_KEY": "11.51",
  "PRO_NOMBRE": "Sutura de laceración corneal"
 },
 {
  "CATALOG_KEY": "11.52",
  "PRO_NOMBRE": "Reparación de dehiscencia de herida postoperatoria de córnea"
 },
 {
  "CATALOG_KEY": "11.53",
  "PRO_NOMBRE": "Reparación de laceración o herida corneal con colgajo conjuntival"
 },
 {
  "CATALOG_KEY": "11.59",
  "PRO_NOMBRE": "Otra reparación de córnea"
 },
 {
  "CATALOG_KEY": "11.6",
  "PRO_NOMBRE": "Trasplante de córnea"
 },
 {
  "CATALOG_KEY": "11.60",
  "PRO_NOMBRE": "Trasplante de córnea, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "11.61",
  "PRO_NOMBRE": "Queratoplastía lamelar con autoinjerto"
 },
 {
  "CATALOG_KEY": "11.62",
  "PRO_NOMBRE": "Otra queratoplastía lamelar"
 },
 {
  "CATALOG_KEY": "11.63",
  "PRO_NOMBRE": "Queratoplastía penetrante con autoinjerto"
 },
 {
  "CATALOG_KEY": "11.64",
  "PRO_NOMBRE": "Otra queratoplastía penetrante"
 },
 {
  "CATALOG_KEY": "11.69",
  "PRO_NOMBRE": "Otro trasplante corneal"
 },
 {
  "CATALOG_KEY": "11.7",
  "PRO_NOMBRE": "Otra cirugía reconstructiva y refractiva de la córnea"
 },
 {
  "CATALOG_KEY": "11.71",
  "PRO_NOMBRE": "Queratomileusis"
 },
 {
  "CATALOG_KEY": "11.72",
  "PRO_NOMBRE": "Queratofaquia"
 },
 {
  "CATALOG_KEY": "11.73",
  "PRO_NOMBRE": "Queratoprótesis"
 },
 {
  "CATALOG_KEY": "11.74",
  "PRO_NOMBRE": "Termoqueratoplastía"
 },
 {
  "CATALOG_KEY": "11.75",
  "PRO_NOMBRE": "Queratotomía radial"
 },
 {
  "CATALOG_KEY": "11.76",
  "PRO_NOMBRE": "Epiqueratofaquia"
 },
 {
  "CATALOG_KEY": "11.79",
  "PRO_NOMBRE": "Otra cirugía reconstructiva y refractiva sobre córnea"
 },
 {
  "CATALOG_KEY": "11.9",
  "PRO_NOMBRE": "Otras operaciones de la córnea"
 },
 {
  "CATALOG_KEY": "11.91",
  "PRO_NOMBRE": "Tatuaje de córnea"
 },
 {
  "CATALOG_KEY": "11.92",
  "PRO_NOMBRE": "Eliminación de la córnea de implantación artificial"
 },
 {
  "CATALOG_KEY": "11.99",
  "PRO_NOMBRE": "Otras operaciones de la córnea"
 },
 {
  "CATALOG_KEY": "12",
  "PRO_NOMBRE": "Operaciones sobre iris, cuerpo ciliar, esclerótica, y cámara anterior del ojo"
 },
 {
  "CATALOG_KEY": "12.0",
  "PRO_NOMBRE": "Extracción de cuerpo extraño intraocular del segmento anterior del ojo"
 },
 {
  "CATALOG_KEY": "12.00",
  "PRO_NOMBRE": "Extracción de cuerpo extraño intraocular del segmento anterior del ojo, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "12.01",
  "PRO_NOMBRE": "Extracción de cuerpo extraño intraocular del segmento anterior del ojo, con empleo de imán"
 },
 {
  "CATALOG_KEY": "12.02",
  "PRO_NOMBRE": "Extracción de cuerpo extraño del segmento anterior del ojo sin empleo de imán"
 },
 {
  "CATALOG_KEY": "12.1",
  "PRO_NOMBRE": "Iridotomía e iridectomía simple"
 },
 {
  "CATALOG_KEY": "12.11",
  "PRO_NOMBRE": "Iridotomía con transfixión"
 },
 {
  "CATALOG_KEY": "12.12",
  "PRO_NOMBRE": "Otra iridotomía"
 },
 {
  "CATALOG_KEY": "12.13",
  "PRO_NOMBRE": "Excisión de iris prolapsado"
 },
 {
  "CATALOG_KEY": "12.14",
  "PRO_NOMBRE": "Otra iridectomía"
 },
 {
  "CATALOG_KEY": "12.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre iris, cuerpo ciliar, esclerótica, y cámara anterior del ojo"
 },
 {
  "CATALOG_KEY": "12.21",
  "PRO_NOMBRE": "Aspiración diagnóstica de la cámara anterior del ojo"
 },
 {
  "CATALOG_KEY": "12.22",
  "PRO_NOMBRE": "Biopsia de iris"
 },
 {
  "CATALOG_KEY": "12.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre el iris, cuerpo ciliar, esclerótica, y cámara anterior del ojo"
 },
 {
  "CATALOG_KEY": "12.3",
  "PRO_NOMBRE": "Iridoplastía y coroplastía"
 },
 {
  "CATALOG_KEY": "12.31",
  "PRO_NOMBRE": "Lisis de goniosinequias"
 },
 {
  "CATALOG_KEY": "12.32",
  "PRO_NOMBRE": "Lisis de otras sinequias anteriores"
 },
 {
  "CATALOG_KEY": "12.33",
  "PRO_NOMBRE": "Lisis de sinequias posteriores"
 },
 {
  "CATALOG_KEY": "12.34",
  "PRO_NOMBRE": "Lisis de adherencias corneovítreas"
 },
 {
  "CATALOG_KEY": "12.35",
  "PRO_NOMBRE": "Coreoplastía"
 },
 {
  "CATALOG_KEY": "12.39",
  "PRO_NOMBRE": "Otra iridoplastía"
 },
 {
  "CATALOG_KEY": "12.4",
  "PRO_NOMBRE": "Excisión o destrucción de lesión de iris y cuerpo ciliar"
 },
 {
  "CATALOG_KEY": "12.40",
  "PRO_NOMBRE": "Extirpación de lesión del segmento anterior del ojo, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "12.41",
  "PRO_NOMBRE": "Destrucción de lesión de iris, no por excisión"
 },
 {
  "CATALOG_KEY": "12.42",
  "PRO_NOMBRE": "Excisión de lesión de iris"
 },
 {
  "CATALOG_KEY": "12.43",
  "PRO_NOMBRE": "Destrucción de lesión del cuerpo ciliar, no por excisión"
 },
 {
  "CATALOG_KEY": "12.44",
  "PRO_NOMBRE": "Excisión de lesión de cuerpo ciliar"
 },
 {
  "CATALOG_KEY": "12.5",
  "PRO_NOMBRE": "Facilitación de la circulación intraocular"
 },
 {
  "CATALOG_KEY": "12.51",
  "PRO_NOMBRE": "Goniopuntura sin goniotomía"
 },
 {
  "CATALOG_KEY": "12.52",
  "PRO_NOMBRE": "Goniotomía sin goniopuntura"
 },
 {
  "CATALOG_KEY": "12.53",
  "PRO_NOMBRE": "Goniotomía con goniopuntura"
 },
 {
  "CATALOG_KEY": "12.54",
  "PRO_NOMBRE": "Trabeculotomía desde el exterior"
 },
 {
  "CATALOG_KEY": "12.55",
  "PRO_NOMBRE": "Ciclodiálisis"
 },
 {
  "CATALOG_KEY": "12.59",
  "PRO_NOMBRE": "Otra facilitación de la circulación intraocular"
 },
 {
  "CATALOG_KEY": "12.6",
  "PRO_NOMBRE": "Fistulización escleral"
 },
 {
  "CATALOG_KEY": "12.61",
  "PRO_NOMBRE": "Trepanación de esclerótica con iridectomía"
 },
 {
  "CATALOG_KEY": "12.62",
  "PRO_NOMBRE": "Termocauterización de esclerótica con iridectomía"
 },
 {
  "CATALOG_KEY": "12.63",
  "PRO_NOMBRE": "Iridencleisis e iridotasis"
 },
 {
  "CATALOG_KEY": "12.64",
  "PRO_NOMBRE": "Trabeculectomía desde el exterior"
 },
 {
  "CATALOG_KEY": "12.65",
  "PRO_NOMBRE": "Otra fistulización escleral con iridectomía"
 },
 {
  "CATALOG_KEY": "12.66",
  "PRO_NOMBRE": "Revisión postoperatoria de procedimiento de fistulización escleral"
 },
 {
  "CATALOG_KEY": "12.69",
  "PRO_NOMBRE": "Otro procedimiento de fistulización"
 },
 {
  "CATALOG_KEY": "12.7",
  "PRO_NOMBRE": "Otros procedimientos para el alivio de una presión intraocular elevada"
 },
 {
  "CATALOG_KEY": "12.71",
  "PRO_NOMBRE": "Ciclodiatermia"
 },
 {
  "CATALOG_KEY": "12.72",
  "PRO_NOMBRE": "Ciclocrioterapia"
 },
 {
  "CATALOG_KEY": "12.73",
  "PRO_NOMBRE": "Ciclofotocoagulación"
 },
 {
  "CATALOG_KEY": "12.74",
  "PRO_NOMBRE": "Disminución del cuerpo ciliar, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "12.79",
  "PRO_NOMBRE": "Otros procedimientos de glaucoma"
 },
 {
  "CATALOG_KEY": "12.8",
  "PRO_NOMBRE": "Operaciones sobre esclerótica"
 },
 {
  "CATALOG_KEY": "12.81",
  "PRO_NOMBRE": "Sutura de laceración de esclerótica"
 },
 {
  "CATALOG_KEY": "12.82",
  "PRO_NOMBRE": "Reparación de fístula escleral"
 },
 {
  "CATALOG_KEY": "12.83",
  "PRO_NOMBRE": "Revisión de herida operatoria de segmento anterior, no clasificada bajo otro concepto"
 },
 {
  "CATALOG_KEY": "12.84",
  "PRO_NOMBRE": "Excisión o destrucción de lesión de esclerótica"
 },
 {
  "CATALOG_KEY": "12.85",
  "PRO_NOMBRE": "Reparación de estafiloma escleral con injerto"
 },
 {
  "CATALOG_KEY": "12.86",
  "PRO_NOMBRE": "Otra reparación de estafiloma escleral"
 },
 {
  "CATALOG_KEY": "12.87",
  "PRO_NOMBRE": "Refuerzo escleral con injerto"
 },
 {
  "CATALOG_KEY": "12.88",
  "PRO_NOMBRE": "Otro refuerzo escleral"
 },
 {
  "CATALOG_KEY": "12.89",
  "PRO_NOMBRE": "Otras operaciones sobre esclerótica"
 },
 {
  "CATALOG_KEY": "12.9",
  "PRO_NOMBRE": "Otras operaciones sobre el iris, cuerpo ciliar y cámara anterior del ojo"
 },
 {
  "CATALOG_KEY": "12.91",
  "PRO_NOMBRE": "Evacuación terapéutica de la cámara anterior del ojo"
 },
 {
  "CATALOG_KEY": "12.92",
  "PRO_NOMBRE": "Inyección en cámara anterior del ojo"
 },
 {
  "CATALOG_KEY": "12.93",
  "PRO_NOMBRE": "Extirpación o destrucción de excrecencia descendiente epitelial de la cámara anterior del ojo"
 },
 {
  "CATALOG_KEY": "12.97",
  "PRO_NOMBRE": "Otras operaciones sobre iris"
 },
 {
  "CATALOG_KEY": "12.98",
  "PRO_NOMBRE": "Otras operaciones sobre el cuerpo ciliar"
 },
 {
  "CATALOG_KEY": "12.99",
  "PRO_NOMBRE": "Otras operaciones sobre la cámara anterior del ojo"
 },
 {
  "CATALOG_KEY": "13",
  "PRO_NOMBRE": "Operaciones sobre el cristalino"
 },
 {
  "CATALOG_KEY": "13.0",
  "PRO_NOMBRE": "Extracción de cuerpo extraño de cristalino"
 },
 {
  "CATALOG_KEY": "13.00",
  "PRO_NOMBRE": "Extracción de cuerpo extraño del cristalino, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "13.01",
  "PRO_NOMBRE": "Extracción de cuerpo extraño del cristalino con empleo de imán"
 },
 {
  "CATALOG_KEY": "13.02",
  "PRO_NOMBRE": "Extracción de cuerpo extraño sin empleo de imán"
 },
 {
  "CATALOG_KEY": "13.1",
  "PRO_NOMBRE": "Extracción intracapsular del cristalino"
 },
 {
  "CATALOG_KEY": "13.11",
  "PRO_NOMBRE": "Extracción intracapsular de cristalino por la ruta temporal inferior"
 },
 {
  "CATALOG_KEY": "13.19",
  "PRO_NOMBRE": "Otra extracción intracapsular de cristalino"
 },
 {
  "CATALOG_KEY": "13.2",
  "PRO_NOMBRE": "Extracción extracapsular de cristalino mediante técnica de extracción lineal"
 },
 {
  "CATALOG_KEY": "13.3",
  "PRO_NOMBRE": "Extracción extracapsular de cristalino mediante técnica simple sencilla de aspiración (e irrigación)"
 },
 {
  "CATALOG_KEY": "13.4",
  "PRO_NOMBRE": "Extracción extracapsular de cristalino mediante técnica de fragmentación y aspiración"
 },
 {
  "CATALOG_KEY": "13.41",
  "PRO_NOMBRE": "Facoemulsificación y aspiración de catarata"
 },
 {
  "CATALOG_KEY": "13.42",
  "PRO_NOMBRE": "Facofragmentación mecánica y aspiración de catarata por ruta posterior"
 },
 {
  "CATALOG_KEY": "13.43",
  "PRO_NOMBRE": "Facofragmentación mecánica y otra aspiración de catarata"
 },
 {
  "CATALOG_KEY": "13.5",
  "PRO_NOMBRE": "Otra extracción extracapsular de cristalino"
 },
 {
  "CATALOG_KEY": "13.51",
  "PRO_NOMBRE": "Extracción extracapsular de cristalino por la ruta temporal inferior"
 },
 {
  "CATALOG_KEY": "13.59",
  "PRO_NOMBRE": "Otra extracción extracapsular de cristalino"
 },
 {
  "CATALOG_KEY": "13.6",
  "PRO_NOMBRE": "Otra extracción de catarata"
 },
 {
  "CATALOG_KEY": "13.64",
  "PRO_NOMBRE": "Disección de membrana secundaria [después de catarata]"
 },
 {
  "CATALOG_KEY": "13.65",
  "PRO_NOMBRE": "Excisión de membrana secundaria [después de catarata]"
 },
 {
  "CATALOG_KEY": "13.66",
  "PRO_NOMBRE": "Fragmentación mecánica de membrana secundaria [después de catarata]"
 },
 {
  "CATALOG_KEY": "13.69",
  "PRO_NOMBRE": "Otra extracción de catarata"
 },
 {
  "CATALOG_KEY": "13.7",
  "PRO_NOMBRE": "Inserción de cristalino protésico [pseudocristalino]"
 },
 {
  "CATALOG_KEY": "13.70",
  "PRO_NOMBRE": "Inserción de pseudocristalino, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "13.71",
  "PRO_NOMBRE": "Inserción de prótesis de cristalino intraocular en el momento de la extracción de la catarata, una sola etapa"
 },
 {
  "CATALOG_KEY": "13.72",
  "PRO_NOMBRE": "Inserción secundaria de prótesis de cristalino intraocular"
 },
 {
  "CATALOG_KEY": "13.8",
  "PRO_NOMBRE": "Extracción de cristalino implantado"
 },
 {
  "CATALOG_KEY": "13.9",
  "PRO_NOMBRE": "Otras operaciones sobre cristalino"
 },
 {
  "CATALOG_KEY": "13.90",
  "PRO_NOMBRE": "Operación sobre cristalino, no clasificada bajo otro concepto"
 },
 {
  "CATALOG_KEY": "13.91",
  "PRO_NOMBRE": "Implantación de prótesis intraocular telescópica"
 },
 {
  "CATALOG_KEY": "14",
  "PRO_NOMBRE": "Operaciones sobre retina, coroides, cuerpo vítreo y cámara posterior del ojo"
 },
 {
  "CATALOG_KEY": "14.0",
  "PRO_NOMBRE": "Extracción de cuerpo extraño del segmento posterior del ojo"
 },
 {
  "CATALOG_KEY": "14.00",
  "PRO_NOMBRE": "Extracción de cuerpo extraño del segmento posterior del ojo, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "14.01",
  "PRO_NOMBRE": "Extracción de cuerpo extraño del segmento posterior del ojo con empleo de imán"
 },
 {
  "CATALOG_KEY": "14.02",
  "PRO_NOMBRE": "Extracción de cuerpo extraño del segmento posterior del ojo sin empleo de imán"
 },
 {
  "CATALOG_KEY": "14.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre retina, coroides, cuerpo vítreo, y la cámara posterior del ojo"
 },
 {
  "CATALOG_KEY": "14.11",
  "PRO_NOMBRE": "Aspiración diagnóstica de cuerpo vítreo"
 },
 {
  "CATALOG_KEY": "14.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre retina, coroides, cuerpo vítreo y cámara posterior del ojo"
 },
 {
  "CATALOG_KEY": "14.2",
  "PRO_NOMBRE": "Destrucción de lesión de retina y coroides"
 },
 {
  "CATALOG_KEY": "14.21",
  "PRO_NOMBRE": "Destrucción de lesión coriorretinal por diatermia"
 },
 {
  "CATALOG_KEY": "14.22",
  "PRO_NOMBRE": "Destrucción de lesión coriorretinal por crioterapia"
 },
 {
  "CATALOG_KEY": "14.23",
  "PRO_NOMBRE": "Destrucción de lesión coriorretinal por fotocoagulación por arco de xenón"
 },
 {
  "CATALOG_KEY": "14.24",
  "PRO_NOMBRE": "Destrucción de lesión coriorretinal por fotocoagulación por láser"
 },
 {
  "CATALOG_KEY": "14.25",
  "PRO_NOMBRE": "Destrucción de lesión coriorretinal por fotocoagulación de tipo no especificado"
 },
 {
  "CATALOG_KEY": "14.26",
  "PRO_NOMBRE": "Destrucción de lesión coriorretinal por terapia de radiación"
 },
 {
  "CATALOG_KEY": "14.27",
  "PRO_NOMBRE": "Destrucción de lesión coriorretinal por implantación de fuente de radiación"
 },
 {
  "CATALOG_KEY": "14.29",
  "PRO_NOMBRE": "Otra destrucción de lesión coriorretinal"
 },
 {
  "CATALOG_KEY": "14.3",
  "PRO_NOMBRE": "Reparación de desgarro retinal"
 },
 {
  "CATALOG_KEY": "14.31",
  "PRO_NOMBRE": "Reparación de desgarro retinal por diatermia"
 },
 {
  "CATALOG_KEY": "14.32",
  "PRO_NOMBRE": "Reparación de desgarro retinal por crioterapia"
 },
 {
  "CATALOG_KEY": "14.33",
  "PRO_NOMBRE": "Reparación de desgarro retinal por fotocoagulación por arco de xenón"
 },
 {
  "CATALOG_KEY": "14.34",
  "PRO_NOMBRE": "Reparación de desgarro retinal por fotocoagulación por láser"
 },
 {
  "CATALOG_KEY": "14.35",
  "PRO_NOMBRE": "Reparación de desgarro retinal por fotocoagulación de tipo no especificado"
 },
 {
  "CATALOG_KEY": "14.39",
  "PRO_NOMBRE": "Otra reparación de desgarro retinal"
 },
 {
  "CATALOG_KEY": "14.4",
  "PRO_NOMBRE": "Reparación de desprendimiento retinal con indentación escleral e implantación"
 },
 {
  "CATALOG_KEY": "14.41",
  "PRO_NOMBRE": "Indentación escleral con implantación"
 },
 {
  "CATALOG_KEY": "14.49",
  "PRO_NOMBRE": "Otra indentación escleral"
 },
 {
  "CATALOG_KEY": "14.5",
  "PRO_NOMBRE": "Otra reparación de desprendimiento retinal"
 },
 {
  "CATALOG_KEY": "14.51",
  "PRO_NOMBRE": "Reparación de desprendimiento retinal con diatermia"
 },
 {
  "CATALOG_KEY": "14.52",
  "PRO_NOMBRE": "Reparación de desprendimiento retinal con crioterapia"
 },
 {
  "CATALOG_KEY": "14.53",
  "PRO_NOMBRE": "Reparación de desprendimiento retinal con fotocoagulación por arco de xenón"
 },
 {
  "CATALOG_KEY": "14.54",
  "PRO_NOMBRE": "Reparación de desprendimiento retinal con fotocoagulación con láser"
 },
 {
  "CATALOG_KEY": "14.55",
  "PRO_NOMBRE": "Reparación de desprendimiento retinal con fotocoagulación de tipo no especificado"
 },
 {
  "CATALOG_KEY": "14.59",
  "PRO_NOMBRE": "Otra reparación de desprendimiento retinal"
 },
 {
  "CATALOG_KEY": "14.6",
  "PRO_NOMBRE": "Extracción de material quirúrgicamente implantado del segmento posterior del ojo"
 },
 {
  "CATALOG_KEY": "14.7",
  "PRO_NOMBRE": "Operaciones sobre el cuerpo vítreo"
 },
 {
  "CATALOG_KEY": "14.71",
  "PRO_NOMBRE": "Extracción de cuerpo vítreo, acceso anterior"
 },
 {
  "CATALOG_KEY": "14.72",
  "PRO_NOMBRE": "Otra extracción del cuerpo vítreo"
 },
 {
  "CATALOG_KEY": "14.73",
  "PRO_NOMBRE": "Vitrectomía mecánica por acceso anterior"
 },
 {
  "CATALOG_KEY": "14.74",
  "PRO_NOMBRE": "Otra vitrectomía mecánica"
 },
 {
  "CATALOG_KEY": "14.75",
  "PRO_NOMBRE": "Inyección de sustituto vítreo"
 },
 {
  "CATALOG_KEY": "14.79",
  "PRO_NOMBRE": "Otras operaciones sobre el cuerpo vítreo"
 },
 {
  "CATALOG_KEY": "14.9",
  "PRO_NOMBRE": "Otras operaciones sobre retina, coroides y cámara posterior del ojo"
 },
 {
  "CATALOG_KEY": "15",
  "PRO_NOMBRE": "Operaciones sobre músculos extraoculares"
 },
 {
  "CATALOG_KEY": "15.0",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre músculos o tendones extraoculares"
 },
 {
  "CATALOG_KEY": "15.01",
  "PRO_NOMBRE": "Biopsia de músculo o tendón extraocular"
 },
 {
  "CATALOG_KEY": "15.09",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre músculos y tendones extraoculares"
 },
 {
  "CATALOG_KEY": "15.1",
  "PRO_NOMBRE": "Operaciones sobre un músculo extraocular con desprendimiento temporal del globo ocular"
 },
 {
  "CATALOG_KEY": "15.11",
  "PRO_NOMBRE": "Recesión de un músculo extraocular"
 },
 {
  "CATALOG_KEY": "15.12",
  "PRO_NOMBRE": "Avance de músculo extraocular"
 },
 {
  "CATALOG_KEY": "15.13",
  "PRO_NOMBRE": "Resección de un músculo extraocular"
 },
 {
  "CATALOG_KEY": "15.19",
  "PRO_NOMBRE": "Otras operaciones sobre un músculo extraocular con desprendimiento temporal del globo ocular"
 },
 {
  "CATALOG_KEY": "15.2",
  "PRO_NOMBRE": "Otras operaciones sobre un músculo extraocular"
 },
 {
  "CATALOG_KEY": "15.21",
  "PRO_NOMBRE": "Procedimiento de alargamiento sobre un músculo extraocular"
 },
 {
  "CATALOG_KEY": "15.22",
  "PRO_NOMBRE": "Procedimiento de acortamiento sobre un músculo extraocular"
 },
 {
  "CATALOG_KEY": "15.29",
  "PRO_NOMBRE": "Otra operación sobre un músculo extraocular"
 },
 {
  "CATALOG_KEY": "15.3",
  "PRO_NOMBRE": "Operaciones sobre dos o más músculos extraoculares con desprendimiento temporal del globo ocular, uno o ambos ojos"
 },
 {
  "CATALOG_KEY": "15.4",
  "PRO_NOMBRE": "Otras operaciones sobre dos o más músculos extraoculares, uno o ambos ojos"
 },
 {
  "CATALOG_KEY": "15.5",
  "PRO_NOMBRE": "Transposición de músculos extraoculares"
 },
 {
  "CATALOG_KEY": "15.6",
  "PRO_NOMBRE": "Revisión de intervención quirúrgica sobre músculo extraocular"
 },
 {
  "CATALOG_KEY": "15.7",
  "PRO_NOMBRE": "Reparación de lesión de músculo extraocular"
 },
 {
  "CATALOG_KEY": "15.9",
  "PRO_NOMBRE": "Otras operaciones sobre músculos y tendones extraoculares"
 },
 {
  "CATALOG_KEY": "16",
  "PRO_NOMBRE": "Operaciones sobre órbita y globo ocular"
 },
 {
  "CATALOG_KEY": "16.0",
  "PRO_NOMBRE": "Orbitotomía"
 },
 {
  "CATALOG_KEY": "16.01",
  "PRO_NOMBRE": "Orbitotomía con colgajo óseo"
 },
 {
  "CATALOG_KEY": "16.02",
  "PRO_NOMBRE": "Orbitotomía con inserción de implantación orbital"
 },
 {
  "CATALOG_KEY": "16.09",
  "PRO_NOMBRE": "Otra orbitotomía"
 },
 {
  "CATALOG_KEY": "16.1",
  "PRO_NOMBRE": "Extracción del ojo de cuerpo extraño penetrante, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "16.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre órbita y globo ocular"
 },
 {
  "CATALOG_KEY": "16.21",
  "PRO_NOMBRE": "Oftalmoscopia"
 },
 {
  "CATALOG_KEY": "16.22",
  "PRO_NOMBRE": "Aspiración diagnóstica de órbita"
 },
 {
  "CATALOG_KEY": "16.23",
  "PRO_NOMBRE": "Biopsia de globo ocular y órbita"
 },
 {
  "CATALOG_KEY": "16.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre órbita y globo ocular"
 },
 {
  "CATALOG_KEY": "16.3",
  "PRO_NOMBRE": "Evisceración de globo ocular"
 },
 {
  "CATALOG_KEY": "16.31",
  "PRO_NOMBRE": "Extracción del contenido del ojo con implantación simultánea de la esclerótica"
 },
 {
  "CATALOG_KEY": "16.39",
  "PRO_NOMBRE": "Otra evisceración del globo ocular"
 },
 {
  "CATALOG_KEY": "16.4",
  "PRO_NOMBRE": "Enucleación del globo ocular"
 },
 {
  "CATALOG_KEY": "16.41",
  "PRO_NOMBRE": "Enucleación del globo ocular con implantación simultánea dentro de la cápsula de Tenon con adhesión de músculos"
 },
 {
  "CATALOG_KEY": "16.42",
  "PRO_NOMBRE": "Enucleación del globo ocular con otra implantación simultánea"
 },
 {
  "CATALOG_KEY": "16.49",
  "PRO_NOMBRE": "Otra enucleación del globo ocular"
 },
 {
  "CATALOG_KEY": "16.5",
  "PRO_NOMBRE": "Exanteración del contenido de la órbita"
 },
 {
  "CATALOG_KEY": "16.51",
  "PRO_NOMBRE": "Exanteración de la órbita con extirpación de estructuras adyacentes"
 },
 {
  "CATALOG_KEY": "16.52",
  "PRO_NOMBRE": "Exanteración de órbita con extracción terapéutica de hueso orbital"
 },
 {
  "CATALOG_KEY": "16.59",
  "PRO_NOMBRE": "Otra exanteración de la órbita"
 },
 {
  "CATALOG_KEY": "16.6",
  "PRO_NOMBRE": "Procedimientos secundarios después de extirpación de globo ocular"
 },
 {
  "CATALOG_KEY": "16.61",
  "PRO_NOMBRE": "Inserción secundaria de implantación ocular"
 },
 {
  "CATALOG_KEY": "16.62",
  "PRO_NOMBRE": "Revisión y reinserción de implantación ocular"
 },
 {
  "CATALOG_KEY": "16.63",
  "PRO_NOMBRE": "Revisión de cavidad de enucleación con injerto"
 },
 {
  "CATALOG_KEY": "16.64",
  "PRO_NOMBRE": "Otra revisión de cavidad de enucleación"
 },
 {
  "CATALOG_KEY": "16.65",
  "PRO_NOMBRE": "Injerto secundario a la cavidad de exanteración"
 },
 {
  "CATALOG_KEY": "16.66",
  "PRO_NOMBRE": "Otra revisión de la cavidad de exanteración"
 },
 {
  "CATALOG_KEY": "16.69",
  "PRO_NOMBRE": "Otros procedimientos secundarios después de extirpación de globo ocular"
 },
 {
  "CATALOG_KEY": "16.7",
  "PRO_NOMBRE": "Eliminación de implantación ocular u orbital"
 },
 {
  "CATALOG_KEY": "16.71",
  "PRO_NOMBRE": "Extracción de implantación ocular"
 },
 {
  "CATALOG_KEY": "16.72",
  "PRO_NOMBRE": "Extracción de implantación orbital"
 },
 {
  "CATALOG_KEY": "16.8",
  "PRO_NOMBRE": "Reparación de lesión de globo ocular y de órbita"
 },
 {
  "CATALOG_KEY": "16.81",
  "PRO_NOMBRE": "Reparación de herida de órbita"
 },
 {
  "CATALOG_KEY": "16.82",
  "PRO_NOMBRE": "Reparación de ruptura de globo ocular"
 },
 {
  "CATALOG_KEY": "16.89",
  "PRO_NOMBRE": "Otra reparación de lesión de globo ocular o de órbita"
 },
 {
  "CATALOG_KEY": "16.9",
  "PRO_NOMBRE": "Otras operaciones sobre órbita y globo ocular"
 },
 {
  "CATALOG_KEY": "16.91",
  "PRO_NOMBRE": "Inyección retrobulbar de agente terapéutico"
 },
 {
  "CATALOG_KEY": "16.92",
  "PRO_NOMBRE": "Excisión de lesión de órbita"
 },
 {
  "CATALOG_KEY": "16.93",
  "PRO_NOMBRE": "Excisión de lesión de ojo, estructura no especificada"
 },
 {
  "CATALOG_KEY": "16.98",
  "PRO_NOMBRE": "Otras operaciones sobre órbita"
 },
 {
  "CATALOG_KEY": "16.99",
  "PRO_NOMBRE": "Otras operaciones sobre globo ocular"
 },
 {
  "CATALOG_KEY": "18",
  "PRO_NOMBRE": "Operaciones sobre el oído externo"
 },
 {
  "CATALOG_KEY": "18.0",
  "PRO_NOMBRE": "Incisión del oído externo"
 },
 {
  "CATALOG_KEY": "18.01",
  "PRO_NOMBRE": "Perforación de lóbulo del oído externo"
 },
 {
  "CATALOG_KEY": "18.02",
  "PRO_NOMBRE": "Incisión del oído externo"
 },
 {
  "CATALOG_KEY": "18.09",
  "PRO_NOMBRE": "Otra incisión del oído externo"
 },
 {
  "CATALOG_KEY": "18.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre el oído externo"
 },
 {
  "CATALOG_KEY": "18.11",
  "PRO_NOMBRE": "Otoscopia"
 },
 {
  "CATALOG_KEY": "18.12",
  "PRO_NOMBRE": "Biopsia de oído externo"
 },
 {
  "CATALOG_KEY": "18.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre oído externo"
 },
 {
  "CATALOG_KEY": "18.2",
  "PRO_NOMBRE": "Excisión o resección de lesión de oído externo"
 },
 {
  "CATALOG_KEY": "18.21",
  "PRO_NOMBRE": "Excisión de fístula preauricular"
 },
 {
  "CATALOG_KEY": "18.29",
  "PRO_NOMBRE": "Excisión o resección de otra lesión del oído externo"
 },
 {
  "CATALOG_KEY": "18.3",
  "PRO_NOMBRE": "Otra excisión del oído externo"
 },
 {
  "CATALOG_KEY": "18.31",
  "PRO_NOMBRE": "Excisión radical de lesión del oído externo"
 },
 {
  "CATALOG_KEY": "18.39",
  "PRO_NOMBRE": "Otra excisión del oído externo"
 },
 {
  "CATALOG_KEY": "18.4",
  "PRO_NOMBRE": "Sutura de laceración de oído externo"
 },
 {
  "CATALOG_KEY": "18.5",
  "PRO_NOMBRE": "Corrección quirúrgica de pabellón auricular prominente"
 },
 {
  "CATALOG_KEY": "18.6",
  "PRO_NOMBRE": "Reconstrucción de conducto auditivo externo"
 },
 {
  "CATALOG_KEY": "18.7",
  "PRO_NOMBRE": "Otra reparación del oído externo"
 },
 {
  "CATALOG_KEY": "18.71",
  "PRO_NOMBRE": "Reconstrucción del pabellón del oído"
 },
 {
  "CATALOG_KEY": "18.72",
  "PRO_NOMBRE": "Reposición de oreja amputada"
 },
 {
  "CATALOG_KEY": "18.79",
  "PRO_NOMBRE": "Otra reparación plástica de oído externo"
 },
 {
  "CATALOG_KEY": "18.9",
  "PRO_NOMBRE": "Otras operaciones sobre el oído externo"
 },
 {
  "CATALOG_KEY": "19",
  "PRO_NOMBRE": "Operaciones reconstructivas sobre oído medio"
 },
 {
  "CATALOG_KEY": "19.0",
  "PRO_NOMBRE": "Movilización del estribo"
 },
 {
  "CATALOG_KEY": "19.1",
  "PRO_NOMBRE": "Estapedectomía"
 },
 {
  "CATALOG_KEY": "19.11",
  "PRO_NOMBRE": "Estapedectomía con sustitución de yunque"
 },
 {
  "CATALOG_KEY": "19.19",
  "PRO_NOMBRE": "Otra estapedectomía"
 },
 {
  "CATALOG_KEY": "19.2",
  "PRO_NOMBRE": "Revisión de estapedectomía"
 },
 {
  "CATALOG_KEY": "19.21",
  "PRO_NOMBRE": "Revisión de estapedectomía con sustitución de yunque"
 },
 {
  "CATALOG_KEY": "19.29",
  "PRO_NOMBRE": "Otra revisión de estapedectomía"
 },
 {
  "CATALOG_KEY": "19.3",
  "PRO_NOMBRE": "Otras operaciones sobre la cadena osicular"
 },
 {
  "CATALOG_KEY": "19.4",
  "PRO_NOMBRE": "Miringoplastía"
 },
 {
  "CATALOG_KEY": "19.5",
  "PRO_NOMBRE": "Otra timpanoplastía"
 },
 {
  "CATALOG_KEY": "19.52",
  "PRO_NOMBRE": "Timpanoplastía tipo II"
 },
 {
  "CATALOG_KEY": "19.53",
  "PRO_NOMBRE": "Timpanoplastía tipo III"
 },
 {
  "CATALOG_KEY": "19.54",
  "PRO_NOMBRE": "Timpanoplastía tipo IV"
 },
 {
  "CATALOG_KEY": "19.55",
  "PRO_NOMBRE": "Timpanoplastía tipo V"
 },
 {
  "CATALOG_KEY": "19.6",
  "PRO_NOMBRE": "Revisión de timpanoplastía"
 },
 {
  "CATALOG_KEY": "19.9",
  "PRO_NOMBRE": "Otra reparación del oído medio"
 },
 {
  "CATALOG_KEY": "20",
  "PRO_NOMBRE": "Otras operaciones sobre el oído medio y el oído interno"
 },
 {
  "CATALOG_KEY": "20.0",
  "PRO_NOMBRE": "Miringotomía"
 },
 {
  "CATALOG_KEY": "20.01",
  "PRO_NOMBRE": "Miringotomía con inserción de tubo"
 },
 {
  "CATALOG_KEY": "20.09",
  "PRO_NOMBRE": "Otra miringotomía"
 },
 {
  "CATALOG_KEY": "20.1",
  "PRO_NOMBRE": "Extracción de tubo de miringotomía"
 },
 {
  "CATALOG_KEY": "20.2",
  "PRO_NOMBRE": "Incisión de mastoides y oído medio"
 },
 {
  "CATALOG_KEY": "20.21",
  "PRO_NOMBRE": "Incisión de mastoides"
 },
 {
  "CATALOG_KEY": "20.22",
  "PRO_NOMBRE": "Incisión de células aéreas de la pirámide petrosa"
 },
 {
  "CATALOG_KEY": "20.23",
  "PRO_NOMBRE": "Incisión del oído medio"
 },
 {
  "CATALOG_KEY": "20.3",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre el oído medio y el oído interno"
 },
 {
  "CATALOG_KEY": "20.31",
  "PRO_NOMBRE": "Electrococleografía"
 },
 {
  "CATALOG_KEY": "20.32",
  "PRO_NOMBRE": "Biopsia de oído medio e interno"
 },
 {
  "CATALOG_KEY": "20.39",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre el oído medio y el oído interno"
 },
 {
  "CATALOG_KEY": "20.4",
  "PRO_NOMBRE": "Mastoidectomía"
 },
 {
  "CATALOG_KEY": "20.41",
  "PRO_NOMBRE": "Mastoidectomía simple"
 },
 {
  "CATALOG_KEY": "20.42",
  "PRO_NOMBRE": "Mastoidectomía radical"
 },
 {
  "CATALOG_KEY": "20.49",
  "PRO_NOMBRE": "Otra mastoidectomía"
 },
 {
  "CATALOG_KEY": "20.5",
  "PRO_NOMBRE": "Otra excisión del oído medio"
 },
 {
  "CATALOG_KEY": "20.51",
  "PRO_NOMBRE": "Excisión de lesión de oído medio"
 },
 {
  "CATALOG_KEY": "20.59",
  "PRO_NOMBRE": "Otra excisión del oído medio"
 },
 {
  "CATALOG_KEY": "20.6",
  "PRO_NOMBRE": "Fenestración del oído interno"
 },
 {
  "CATALOG_KEY": "20.61",
  "PRO_NOMBRE": "Fenestración del oído interno (inicial)"
 },
 {
  "CATALOG_KEY": "20.62",
  "PRO_NOMBRE": "Revisión de fenestración del oído interno"
 },
 {
  "CATALOG_KEY": "20.7",
  "PRO_NOMBRE": "Incisión, excisión y destrucción del oído interno"
 },
 {
  "CATALOG_KEY": "20.71",
  "PRO_NOMBRE": "Drenaje endolinfático"
 },
 {
  "CATALOG_KEY": "20.72",
  "PRO_NOMBRE": "Inyección en oído interno"
 },
 {
  "CATALOG_KEY": "20.79",
  "PRO_NOMBRE": "Otra incisión, excisión y destrucción del oído interno"
 },
 {
  "CATALOG_KEY": "20.8",
  "PRO_NOMBRE": "Operaciones sobre la trompa de Eustaquio"
 },
 {
  "CATALOG_KEY": "20.9",
  "PRO_NOMBRE": "Otras operaciones sobre el oído interno y el oído medio"
 },
 {
  "CATALOG_KEY": "20.91",
  "PRO_NOMBRE": "Timpanosimpatectomía"
 },
 {
  "CATALOG_KEY": "20.92",
  "PRO_NOMBRE": "Revisión de mastoidectomía"
 },
 {
  "CATALOG_KEY": "20.93",
  "PRO_NOMBRE": "Reparación de las ventanas oval y redonda"
 },
 {
  "CATALOG_KEY": "20.94",
  "PRO_NOMBRE": "Inyección de tímpano"
 },
 {
  "CATALOG_KEY": "20.95",
  "PRO_NOMBRE": "Implantación de prótesis auditiva electromagnética"
 },
 {
  "CATALOG_KEY": "20.96",
  "PRO_NOMBRE": "Implantación o sustitución de prótesis coclear, no especificada de otra forma (implante coclear)"
 },
 {
  "CATALOG_KEY": "20.97",
  "PRO_NOMBRE": "Implantación o sustitución prótesis coclear de canal único"
 },
 {
  "CATALOG_KEY": "20.98",
  "PRO_NOMBRE": "Implantación o sustitución de prótesis coclear de canal múltiple"
 },
 {
  "CATALOG_KEY": "20.99",
  "PRO_NOMBRE": "Otras operaciones sobre el oído medio y el oído interno"
 },
 {
  "CATALOG_KEY": "21",
  "PRO_NOMBRE": "Operaciones sobre la nariz"
 },
 {
  "CATALOG_KEY": "21.0",
  "PRO_NOMBRE": "Control de epistaxis"
 },
 {
  "CATALOG_KEY": "21.00",
  "PRO_NOMBRE": "Control de epistaxis, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "21.01",
  "PRO_NOMBRE": "Control de epistaxis por taponamiento nasal anterior"
 },
 {
  "CATALOG_KEY": "21.02",
  "PRO_NOMBRE": "Control de epistaxis por taponamiento posterior (y anterior)"
 },
 {
  "CATALOG_KEY": "21.03",
  "PRO_NOMBRE": "Control de epistaxis por cauterización (y taponamiento)"
 },
 {
  "CATALOG_KEY": "21.04",
  "PRO_NOMBRE": "Control de epistaxis por ligadura de las arterias etmoidales"
 },
 {
  "CATALOG_KEY": "21.05",
  "PRO_NOMBRE": "Control de epistaxis por ligadura de la arteria maxilar a través del seno maxilar"
 },
 {
  "CATALOG_KEY": "21.06",
  "PRO_NOMBRE": "Control de epistaxis por ligadura de la arteria carótida externa"
 },
 {
  "CATALOG_KEY": "21.07",
  "PRO_NOMBRE": "Control de epistaxis por excisión de las mucosas nasales e injertos de piel en el tabique y la pared nasal lateral"
 },
 {
  "CATALOG_KEY": "21.09",
  "PRO_NOMBRE": "Control de epistaxis por otros medios"
 },
 {
  "CATALOG_KEY": "21.1",
  "PRO_NOMBRE": "Incisión nasal"
 },
 {
  "CATALOG_KEY": "21.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre la región nasal"
 },
 {
  "CATALOG_KEY": "21.21",
  "PRO_NOMBRE": "Rinoscopía"
 },
 {
  "CATALOG_KEY": "21.22",
  "PRO_NOMBRE": "Biopsia de nariz"
 },
 {
  "CATALOG_KEY": "21.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre la región nasal"
 },
 {
  "CATALOG_KEY": "21.3",
  "PRO_NOMBRE": "Excisión local o extirpación de lesión de la pirámide nasal"
 },
 {
  "CATALOG_KEY": "21.30",
  "PRO_NOMBRE": "Excisión o extirpación de lesión de la pirámide nasal, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "21.31",
  "PRO_NOMBRE": "Excisión local o extirpación de lesión intranasal"
 },
 {
  "CATALOG_KEY": "21.32",
  "PRO_NOMBRE": "Excisión local o extirpación de otra lesión de nariz"
 },
 {
  "CATALOG_KEY": "21.4",
  "PRO_NOMBRE": "Resección de la pirámide nasal"
 },
 {
  "CATALOG_KEY": "21.5",
  "PRO_NOMBRE": "Resección submucosa del tabique nasal (septoplastías)"
 },
 {
  "CATALOG_KEY": "21.6",
  "PRO_NOMBRE": "Turbinectomía"
 },
 {
  "CATALOG_KEY": "21.61",
  "PRO_NOMBRE": "Turbinectomía por diatermia o criocirugía"
 },
 {
  "CATALOG_KEY": "21.62",
  "PRO_NOMBRE": "Fractura de los cornetes"
 },
 {
  "CATALOG_KEY": "21.69",
  "PRO_NOMBRE": "Otra turbinectomía"
 },
 {
  "CATALOG_KEY": "21.7",
  "PRO_NOMBRE": "Reducción de fractura nasal"
 },
 {
  "CATALOG_KEY": "21.71",
  "PRO_NOMBRE": "Reducción cerrada de fractura nasal"
 },
 {
  "CATALOG_KEY": "21.72",
  "PRO_NOMBRE": "Reducción abierta de fractura nasal"
 },
 {
  "CATALOG_KEY": "21.8",
  "PRO_NOMBRE": "Operaciones de reparación y cirugía plástica sobre la pirámide nasal"
 },
 {
  "CATALOG_KEY": "21.81",
  "PRO_NOMBRE": "Sutura de laceración de nariz"
 },
 {
  "CATALOG_KEY": "21.82",
  "PRO_NOMBRE": "Cierre de fístula nasal"
 },
 {
  "CATALOG_KEY": "21.83",
  "PRO_NOMBRE": "Reconstrucción nasal total"
 },
 {
  "CATALOG_KEY": "21.84",
  "PRO_NOMBRE": "Revisión de rinoplastía (rinoplastía secundaria)"
 },
 {
  "CATALOG_KEY": "21.85",
  "PRO_NOMBRE": "Rinoplastía de aumento"
 },
 {
  "CATALOG_KEY": "21.86",
  "PRO_NOMBRE": "Rinoplastía limitada"
 },
 {
  "CATALOG_KEY": "21.87",
  "PRO_NOMBRE": "Otra rinoplastía"
 },
 {
  "CATALOG_KEY": "21.88",
  "PRO_NOMBRE": "Otra septoplastía"
 },
 {
  "CATALOG_KEY": "21.89",
  "PRO_NOMBRE": "Otras operaciones de reparación y operaciones plásticas sobre la nariz"
 },
 {
  "CATALOG_KEY": "21.9",
  "PRO_NOMBRE": "Otras operaciones sobre la nariz"
 },
 {
  "CATALOG_KEY": "21.91",
  "PRO_NOMBRE": "Lisis de adherencias de nariz"
 },
 {
  "CATALOG_KEY": "21.99",
  "PRO_NOMBRE": "Otra operación sobre la nariz"
 },
 {
  "CATALOG_KEY": "22",
  "PRO_NOMBRE": "Operaciones sobre senos nasales (paranasales)"
 },
 {
  "CATALOG_KEY": "22.0",
  "PRO_NOMBRE": "Aspiración y lavado de seno maxilar"
 },
 {
  "CATALOG_KEY": "22.00",
  "PRO_NOMBRE": "Aspiración y lavado de seno nasal (maxilar), no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "22.01",
  "PRO_NOMBRE": "Punción de seno nasal (maxilar) para aspiración o lavado"
 },
 {
  "CATALOG_KEY": "22.02",
  "PRO_NOMBRE": "Aspiración o lavado de seno nasal (maxilar) a través de orificio natural"
 },
 {
  "CATALOG_KEY": "22.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre seno nasal"
 },
 {
  "CATALOG_KEY": "22.11",
  "PRO_NOMBRE": "Biopsia cerrada [endoscópica] [punción con aguja] del seno nasal"
 },
 {
  "CATALOG_KEY": "22.12",
  "PRO_NOMBRE": "Biopsia abierta de seno nasal"
 },
 {
  "CATALOG_KEY": "22.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre senos nasales (maxilares)"
 },
 {
  "CATALOG_KEY": "22.2",
  "PRO_NOMBRE": "Antrotomía intranasal"
 },
 {
  "CATALOG_KEY": "22.3",
  "PRO_NOMBRE": "Antrotomía maxilar externa"
 },
 {
  "CATALOG_KEY": "22.31",
  "PRO_NOMBRE": "Antrotomía maxilar radical"
 },
 {
  "CATALOG_KEY": "22.39",
  "PRO_NOMBRE": "Otra antrotomía maxilar externa"
 },
 {
  "CATALOG_KEY": "22.4",
  "PRO_NOMBRE": "Sinusotomía y sinusectomía frontales"
 },
 {
  "CATALOG_KEY": "22.41",
  "PRO_NOMBRE": "Sinusotomía frontal"
 },
 {
  "CATALOG_KEY": "22.42",
  "PRO_NOMBRE": "Sinusectomía frontal"
 },
 {
  "CATALOG_KEY": "22.5",
  "PRO_NOMBRE": "Otra sinusotomía nasal"
 },
 {
  "CATALOG_KEY": "22.50",
  "PRO_NOMBRE": "Sinusotomía, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "22.51",
  "PRO_NOMBRE": "Etmoidotomía"
 },
 {
  "CATALOG_KEY": "22.52",
  "PRO_NOMBRE": "Esfenoidotomía"
 },
 {
  "CATALOG_KEY": "22.53",
  "PRO_NOMBRE": "Incisión de múltiples senos nasales"
 },
 {
  "CATALOG_KEY": "22.6",
  "PRO_NOMBRE": "Otra sinusectomía nasal"
 },
 {
  "CATALOG_KEY": "22.60",
  "PRO_NOMBRE": "Sinusectomía, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "22.61",
  "PRO_NOMBRE": "Excisión de lesión de seno maxilar con abordaje Caldwell-Luc"
 },
 {
  "CATALOG_KEY": "22.62",
  "PRO_NOMBRE": "Excisión de lesión de seno maxilar con otro abordaje"
 },
 {
  "CATALOG_KEY": "22.63",
  "PRO_NOMBRE": "Etmoidectomía"
 },
 {
  "CATALOG_KEY": "22.64",
  "PRO_NOMBRE": "Esfenoidectomía"
 },
 {
  "CATALOG_KEY": "22.7",
  "PRO_NOMBRE": "Reparación de seno maxilar"
 },
 {
  "CATALOG_KEY": "22.71",
  "PRO_NOMBRE": "Cierre de fístula de seno maxilar"
 },
 {
  "CATALOG_KEY": "22.79",
  "PRO_NOMBRE": "Otra reparación de seno maxilar"
 },
 {
  "CATALOG_KEY": "22.9",
  "PRO_NOMBRE": "Otras operaciones sobre senos nasales (paranasales)"
 },
 {
  "CATALOG_KEY": "23",
  "PRO_NOMBRE": "Extracción y restauración de dientes"
 },
 {
  "CATALOG_KEY": "23.0",
  "PRO_NOMBRE": "Extracción de diente con fórceps"
 },
 {
  "CATALOG_KEY": "23.01",
  "PRO_NOMBRE": "Extracción de diente caduco"
 },
 {
  "CATALOG_KEY": "23.09",
  "PRO_NOMBRE": "Extracción de otro diente"
 },
 {
  "CATALOG_KEY": "23.1",
  "PRO_NOMBRE": "Extracción quirúrgica de diente"
 },
 {
  "CATALOG_KEY": "23.11",
  "PRO_NOMBRE": "Extracción de raíz residual"
 },
 {
  "CATALOG_KEY": "23.19",
  "PRO_NOMBRE": "Otra extracción quirúrgica de diente"
 },
 {
  "CATALOG_KEY": "23.5",
  "PRO_NOMBRE": "Implante de diente"
 },
 {
  "CATALOG_KEY": "23.6",
  "PRO_NOMBRE": "Implante dental protésico"
 },
 {
  "CATALOG_KEY": "23.7",
  "PRO_NOMBRE": "Apicectomía y tratamiento de conducto radicular"
 },
 {
  "CATALOG_KEY": "23.70",
  "PRO_NOMBRE": "Conducto radicular, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "23.71",
  "PRO_NOMBRE": "Tratamiento de conducto radicular con irrigación"
 },
 {
  "CATALOG_KEY": "23.72",
  "PRO_NOMBRE": "Tratamiento de conducto radicular con apicoectomía"
 },
 {
  "CATALOG_KEY": "23.73",
  "PRO_NOMBRE": "Apicectomía"
 },
 {
  "CATALOG_KEY": "24",
  "PRO_NOMBRE": "Otras operaciones sobre dientes, encías y alvéolos"
 },
 {
  "CATALOG_KEY": "24.0",
  "PRO_NOMBRE": "Incisión de encía o hueso alveolar"
 },
 {
  "CATALOG_KEY": "24.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre dientes, encías y alvéolos"
 },
 {
  "CATALOG_KEY": "24.11",
  "PRO_NOMBRE": "Biopsia de encía"
 },
 {
  "CATALOG_KEY": "24.12",
  "PRO_NOMBRE": "Biopsia de alvéolo"
 },
 {
  "CATALOG_KEY": "24.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre dientes, encías y alvéolos"
 },
 {
  "CATALOG_KEY": "24.2",
  "PRO_NOMBRE": "Gingivoplastía"
 },
 {
  "CATALOG_KEY": "24.3",
  "PRO_NOMBRE": "Otras operaciones sobre encía"
 },
 {
  "CATALOG_KEY": "24.31",
  "PRO_NOMBRE": "Excisión de lesión o de tejido de encía"
 },
 {
  "CATALOG_KEY": "24.32",
  "PRO_NOMBRE": "Sutura de laceración de encía"
 },
 {
  "CATALOG_KEY": "24.39",
  "PRO_NOMBRE": "Otras operaciones sobre encía"
 },
 {
  "CATALOG_KEY": "24.4",
  "PRO_NOMBRE": "Excisión de lesión maxilar de origen dentario"
 },
 {
  "CATALOG_KEY": "24.5",
  "PRO_NOMBRE": "Alveoloplastía"
 },
 {
  "CATALOG_KEY": "24.6",
  "PRO_NOMBRE": "Exposición de diente"
 },
 {
  "CATALOG_KEY": "24.7",
  "PRO_NOMBRE": "Aplicación de dispositivo ortodóntico"
 },
 {
  "CATALOG_KEY": "24.8",
  "PRO_NOMBRE": "Otra operación ortodóntica"
 },
 {
  "CATALOG_KEY": "24.9",
  "PRO_NOMBRE": "Otras operaciones dentales"
 },
 {
  "CATALOG_KEY": "24.91",
  "PRO_NOMBRE": "Extensión o profundización del surco bucolabial o lingual"
 },
 {
  "CATALOG_KEY": "24.99",
  "PRO_NOMBRE": "Otras operaciones dentales"
 },
 {
  "CATALOG_KEY": "25",
  "PRO_NOMBRE": "Operaciones sobre la lengua"
 },
 {
  "CATALOG_KEY": "25.0",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre la lengua"
 },
 {
  "CATALOG_KEY": "25.01",
  "PRO_NOMBRE": "Biopsia cerrada [punción-aspiración con aguja fina] [PAAF] de lengua"
 },
 {
  "CATALOG_KEY": "25.02",
  "PRO_NOMBRE": "Biopsia abierta de la lengua"
 },
 {
  "CATALOG_KEY": "25.09",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre la lengua"
 },
 {
  "CATALOG_KEY": "25.1",
  "PRO_NOMBRE": "Excisión, destrucción o lisis de lesión o tejido de la lengua"
 },
 {
  "CATALOG_KEY": "25.2",
  "PRO_NOMBRE": "Glosectomía parcial"
 },
 {
  "CATALOG_KEY": "25.3",
  "PRO_NOMBRE": "Glosectomía total"
 },
 {
  "CATALOG_KEY": "25.4",
  "PRO_NOMBRE": "Glosectomía radical"
 },
 {
  "CATALOG_KEY": "25.5",
  "PRO_NOMBRE": "Reparación de lengua y glosoplastía"
 },
 {
  "CATALOG_KEY": "25.51",
  "PRO_NOMBRE": "Sutura de laceración de lengua"
 },
 {
  "CATALOG_KEY": "25.59",
  "PRO_NOMBRE": "Otras operaciones de reparación y plástica sobre la lengua"
 },
 {
  "CATALOG_KEY": "25.9",
  "PRO_NOMBRE": "Otras operaciones sobre la lengua"
 },
 {
  "CATALOG_KEY": "25.91",
  "PRO_NOMBRE": "Frenotomía lingual"
 },
 {
  "CATALOG_KEY": "25.92",
  "PRO_NOMBRE": "Frenectomía lingual"
 },
 {
  "CATALOG_KEY": "25.93",
  "PRO_NOMBRE": "Lisis de adherencias de lengua"
 },
 {
  "CATALOG_KEY": "25.94",
  "PRO_NOMBRE": "Otra glosotomía"
 },
 {
  "CATALOG_KEY": "25.99",
  "PRO_NOMBRE": "Otras operaciones sobre la lengua"
 },
 {
  "CATALOG_KEY": "26",
  "PRO_NOMBRE": "Operaciones sobre glándulas y conductos salivales"
 },
 {
  "CATALOG_KEY": "26.0",
  "PRO_NOMBRE": "Incisión de glándula o conducto salival"
 },
 {
  "CATALOG_KEY": "26.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre glándulas y conductos salivales"
 },
 {
  "CATALOG_KEY": "26.11",
  "PRO_NOMBRE": "Biopsia cerrada [punción-aspiración con aguja fina] [PAAF] de glándula o conducto salival"
 },
 {
  "CATALOG_KEY": "26.12",
  "PRO_NOMBRE": "Biopsia abierta de glándula o conducto salival"
 },
 {
  "CATALOG_KEY": "26.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre glándulas y conductos salivales"
 },
 {
  "CATALOG_KEY": "26.2",
  "PRO_NOMBRE": "Excisión de lesión de glándula salival"
 },
 {
  "CATALOG_KEY": "26.21",
  "PRO_NOMBRE": "Marsupialización de quiste de glándula salival"
 },
 {
  "CATALOG_KEY": "26.29",
  "PRO_NOMBRE": "Otra excisión de lesión de glándula salival"
 },
 {
  "CATALOG_KEY": "26.3",
  "PRO_NOMBRE": "Sialoadenectomía"
 },
 {
  "CATALOG_KEY": "26.30",
  "PRO_NOMBRE": "Sialoadenectomía, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "26.31",
  "PRO_NOMBRE": "Sialoadenectomía parcial"
 },
 {
  "CATALOG_KEY": "26.32",
  "PRO_NOMBRE": "Sialoadenectomía total"
 },
 {
  "CATALOG_KEY": "26.4",
  "PRO_NOMBRE": "Reparación de glándula o conducto salival"
 },
 {
  "CATALOG_KEY": "26.41",
  "PRO_NOMBRE": "Sutura de laceración de glándula salival"
 },
 {
  "CATALOG_KEY": "26.42",
  "PRO_NOMBRE": "Cierre de fístula salival"
 },
 {
  "CATALOG_KEY": "26.49",
  "PRO_NOMBRE": "Otras operaciones de reparación y plásticas sobre glándula o conducto salival"
 },
 {
  "CATALOG_KEY": "26.9",
  "PRO_NOMBRE": "Otras operaciones sobre glándula o conducto salival"
 },
 {
  "CATALOG_KEY": "26.91",
  "PRO_NOMBRE": "Exploración de conducto salival"
 },
 {
  "CATALOG_KEY": "26.99",
  "PRO_NOMBRE": "Otras operaciones sobre glándula o conducto salival"
 },
 {
  "CATALOG_KEY": "27",
  "PRO_NOMBRE": "Otras operaciones sobre boca y cara"
 },
 {
  "CATALOG_KEY": "27.0",
  "PRO_NOMBRE": "Drenaje de cara y suelo de la boca"
 },
 {
  "CATALOG_KEY": "27.1",
  "PRO_NOMBRE": "Incisión del paladar"
 },
 {
  "CATALOG_KEY": "27.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre la cavidad oral"
 },
 {
  "CATALOG_KEY": "27.21",
  "PRO_NOMBRE": "Biopsia del paladar óseo"
 },
 {
  "CATALOG_KEY": "27.22",
  "PRO_NOMBRE": "Biopsia de úvula y paladar blando"
 },
 {
  "CATALOG_KEY": "27.23",
  "PRO_NOMBRE": "Biopsia de labio"
 },
 {
  "CATALOG_KEY": "27.24",
  "PRO_NOMBRE": "Biopsia de boca, estructura no especificada"
 },
 {
  "CATALOG_KEY": "27.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre cavidad oral"
 },
 {
  "CATALOG_KEY": "27.3",
  "PRO_NOMBRE": "Excisión de lesión o tejido del paladar óseo"
 },
 {
  "CATALOG_KEY": "27.31",
  "PRO_NOMBRE": "Excisión local o resección de lesión o de tejido del paladar óseo"
 },
 {
  "CATALOG_KEY": "27.32",
  "PRO_NOMBRE": "Excisión amplia o resección de lesión o tejido del paladar óseo"
 },
 {
  "CATALOG_KEY": "27.4",
  "PRO_NOMBRE": "Excisión de otras partes de la boca"
 },
 {
  "CATALOG_KEY": "27.41",
  "PRO_NOMBRE": "Frenectomía labial"
 },
 {
  "CATALOG_KEY": "27.42",
  "PRO_NOMBRE": "Excisión amplia de lesión de labio"
 },
 {
  "CATALOG_KEY": "27.43",
  "PRO_NOMBRE": "Otra excisión de lesión o tejido de labio"
 },
 {
  "CATALOG_KEY": "27.49",
  "PRO_NOMBRE": "Otra excisión de boca"
 },
 {
  "CATALOG_KEY": "27.5",
  "PRO_NOMBRE": "Reparación plástica de la boca"
 },
 {
  "CATALOG_KEY": "27.51",
  "PRO_NOMBRE": "Sutura de laceración de labio"
 },
 {
  "CATALOG_KEY": "27.52",
  "PRO_NOMBRE": "Sutura de laceración de otra parte de la boca"
 },
 {
  "CATALOG_KEY": "27.53",
  "PRO_NOMBRE": "Cierre de fístula de boca"
 },
 {
  "CATALOG_KEY": "27.54",
  "PRO_NOMBRE": "Reparación de labio fisurado"
 },
 {
  "CATALOG_KEY": "27.55",
  "PRO_NOMBRE": "Injerto de piel de grosor total aplicado al labio y cavidad bucal"
 },
 {
  "CATALOG_KEY": "27.56",
  "PRO_NOMBRE": "Otro injerto de piel aplicado a labio y cavidad bucal"
 },
 {
  "CATALOG_KEY": "27.57",
  "PRO_NOMBRE": "Unión de pedículo o injerto de colgajo al labio y cavidad bucal"
 },
 {
  "CATALOG_KEY": "27.59",
  "PRO_NOMBRE": "Otra reparación plástica de la boca"
 },
 {
  "CATALOG_KEY": "27.6",
  "PRO_NOMBRE": "Palatoplastía"
 },
 {
  "CATALOG_KEY": "27.61",
  "PRO_NOMBRE": "Sutura de laceración de paladar"
 },
 {
  "CATALOG_KEY": "27.62",
  "PRO_NOMBRE": "Corrección de paladar fisurado (estafilorrafia) (L)"
 },
 {
  "CATALOG_KEY": "27.63",
  "PRO_NOMBRE": "Revisión de reparación de paladar fisurado"
 },
 {
  "CATALOG_KEY": "27.64",
  "PRO_NOMBRE": "Inserción de implante de paladar"
 },
 {
  "CATALOG_KEY": "27.69",
  "PRO_NOMBRE": "Otra reparación plástica de paladar"
 },
 {
  "CATALOG_KEY": "27.7",
  "PRO_NOMBRE": "Operaciones sobre úvula"
 },
 {
  "CATALOG_KEY": "27.71",
  "PRO_NOMBRE": "Incisión de úvula"
 },
 {
  "CATALOG_KEY": "27.72",
  "PRO_NOMBRE": "Excisión de úvula"
 },
 {
  "CATALOG_KEY": "27.73",
  "PRO_NOMBRE": "Reparación de úvula"
 },
 {
  "CATALOG_KEY": "27.79",
  "PRO_NOMBRE": "Otras operaciones sobre úvula"
 },
 {
  "CATALOG_KEY": "27.9",
  "PRO_NOMBRE": "Otras operaciones sobre boca y cara"
 },
 {
  "CATALOG_KEY": "27.91",
  "PRO_NOMBRE": "Frenotomía labial"
 },
 {
  "CATALOG_KEY": "27.92",
  "PRO_NOMBRE": "Incisión de cavidad bucal, estructura no especificada"
 },
 {
  "CATALOG_KEY": "27.99",
  "PRO_NOMBRE": "Otras operaciones sobre la cavidad oral"
 },
 {
  "CATALOG_KEY": "28",
  "PRO_NOMBRE": "Operaciones sobre amígdalas y adenoides"
 },
 {
  "CATALOG_KEY": "28.0",
  "PRO_NOMBRE": "Incisión y drenaje de amígdala y estructuras periamigdalinas"
 },
 {
  "CATALOG_KEY": "28.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre amígdalas y adenoides"
 },
 {
  "CATALOG_KEY": "28.11",
  "PRO_NOMBRE": "Biopsia de amígdalas y adenoides"
 },
 {
  "CATALOG_KEY": "28.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre amígdalas y adenoides"
 },
 {
  "CATALOG_KEY": "28.2",
  "PRO_NOMBRE": "Amigdalectomía sin adenoidectomía"
 },
 {
  "CATALOG_KEY": "28.3",
  "PRO_NOMBRE": "Amigdalectomía con adenoidectomía"
 },
 {
  "CATALOG_KEY": "28.4",
  "PRO_NOMBRE": "Extirpación de resto amigdalino"
 },
 {
  "CATALOG_KEY": "28.5",
  "PRO_NOMBRE": "Extirpación de amígdala lingual"
 },
 {
  "CATALOG_KEY": "28.6",
  "PRO_NOMBRE": "Adenoidectomía sin amigdalectomía"
 },
 {
  "CATALOG_KEY": "28.7",
  "PRO_NOMBRE": "Control de hemorragia después de amigdalectomía y adenoidectomía"
 },
 {
  "CATALOG_KEY": "28.9",
  "PRO_NOMBRE": "Otras operaciones sobre amígdalas y adenoides"
 },
 {
  "CATALOG_KEY": "28.91",
  "PRO_NOMBRE": "Extracción de cuerpo extraño de la amígdala y adenoides por incisión"
 },
 {
  "CATALOG_KEY": "28.92",
  "PRO_NOMBRE": "Excisión de lesión de amígdala y adenoides"
 },
 {
  "CATALOG_KEY": "28.99",
  "PRO_NOMBRE": "Otras operaciones sobre amígdala y adenoides"
 },
 {
  "CATALOG_KEY": "29",
  "PRO_NOMBRE": "Operaciones sobre faringe"
 },
 {
  "CATALOG_KEY": "29.0",
  "PRO_NOMBRE": "Faringotomía"
 },
 {
  "CATALOG_KEY": "29.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre faringe"
 },
 {
  "CATALOG_KEY": "29.11",
  "PRO_NOMBRE": "Faringoscopia"
 },
 {
  "CATALOG_KEY": "29.12",
  "PRO_NOMBRE": "Biopsia faríngea"
 },
 {
  "CATALOG_KEY": "29.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre faringe"
 },
 {
  "CATALOG_KEY": "29.2",
  "PRO_NOMBRE": "Excisión de quiste o vestigio de hendidura branquial"
 },
 {
  "CATALOG_KEY": "29.3",
  "PRO_NOMBRE": "Excisión o resección de lesión o tejido de faringe"
 },
 {
  "CATALOG_KEY": "29.31",
  "PRO_NOMBRE": "Miotomía cricofaríngea"
 },
 {
  "CATALOG_KEY": "29.32",
  "PRO_NOMBRE": "Diverticulotomía faríngea"
 },
 {
  "CATALOG_KEY": "29.33",
  "PRO_NOMBRE": "Faringectomía (parcial)"
 },
 {
  "CATALOG_KEY": "29.39",
  "PRO_NOMBRE": "Otra excisión o resección de lesión o tejido de la faringe"
 },
 {
  "CATALOG_KEY": "29.4",
  "PRO_NOMBRE": "Operación plástica sobre faringe"
 },
 {
  "CATALOG_KEY": "29.5",
  "PRO_NOMBRE": "Otra reparación de faringe (reparación con colgajos libres o pediculados)"
 },
 {
  "CATALOG_KEY": "29.51",
  "PRO_NOMBRE": "Sutura de laceración de faringe"
 },
 {
  "CATALOG_KEY": "29.52",
  "PRO_NOMBRE": "Cierre de fístula de hendidura branquial"
 },
 {
  "CATALOG_KEY": "29.53",
  "PRO_NOMBRE": "Cierre de otra fístula de faringe"
 },
 {
  "CATALOG_KEY": "29.54",
  "PRO_NOMBRE": "Lisis de adherencias faríngeas"
 },
 {
  "CATALOG_KEY": "29.59",
  "PRO_NOMBRE": "Otra reparación de faringe"
 },
 {
  "CATALOG_KEY": "29.9",
  "PRO_NOMBRE": "Otras operaciones sobre faringe"
 },
 {
  "CATALOG_KEY": "29.91",
  "PRO_NOMBRE": "Dilatación de faringe"
 },
 {
  "CATALOG_KEY": "29.92",
  "PRO_NOMBRE": "Sección del nervio glosofaríngeo"
 },
 {
  "CATALOG_KEY": "29.99",
  "PRO_NOMBRE": "Otras operaciones sobre faringe"
 },
 {
  "CATALOG_KEY": "30",
  "PRO_NOMBRE": "Excisión de laringe"
 },
 {
  "CATALOG_KEY": "30.0",
  "PRO_NOMBRE": "Excisión o resección de lesión o tejido de laringe"
 },
 {
  "CATALOG_KEY": "30.01",
  "PRO_NOMBRE": "Marsupialización de quiste laríngeo"
 },
 {
  "CATALOG_KEY": "30.09",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión o tejido de la laringe"
 },
 {
  "CATALOG_KEY": "30.1",
  "PRO_NOMBRE": "Hemilaringectomía"
 },
 {
  "CATALOG_KEY": "30.2",
  "PRO_NOMBRE": "Otra laringectomía parcial"
 },
 {
  "CATALOG_KEY": "30.21",
  "PRO_NOMBRE": "Epiglotectomía"
 },
 {
  "CATALOG_KEY": "30.22",
  "PRO_NOMBRE": "Cordectomía"
 },
 {
  "CATALOG_KEY": "30.29",
  "PRO_NOMBRE": "Otra laringectomía parcial"
 },
 {
  "CATALOG_KEY": "30.3",
  "PRO_NOMBRE": "Laringectomía total"
 },
 {
  "CATALOG_KEY": "30.4",
  "PRO_NOMBRE": "Laringectomía radical"
 },
 {
  "CATALOG_KEY": "31",
  "PRO_NOMBRE": "Otras operaciones sobre laringe y tráquea"
 },
 {
  "CATALOG_KEY": "31.0",
  "PRO_NOMBRE": "Inyección en laringe"
 },
 {
  "CATALOG_KEY": "31.1",
  "PRO_NOMBRE": "Traqueostomía temporal"
 },
 {
  "CATALOG_KEY": "31.2",
  "PRO_NOMBRE": "Traqueostomía permanente"
 },
 {
  "CATALOG_KEY": "31.21",
  "PRO_NOMBRE": "Traqueostomía mediastínica"
 },
 {
  "CATALOG_KEY": "31.29",
  "PRO_NOMBRE": "Otra traqueostomía permanente"
 },
 {
  "CATALOG_KEY": "31.3",
  "PRO_NOMBRE": "Otra incisión de laringe o tráquea"
 },
 {
  "CATALOG_KEY": "31.4",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre laringe y tráquea"
 },
 {
  "CATALOG_KEY": "31.41",
  "PRO_NOMBRE": "Traqueoscopia a través de estoma artificial"
 },
 {
  "CATALOG_KEY": "31.42",
  "PRO_NOMBRE": "Laringoscopia y otra traqueoscopia"
 },
 {
  "CATALOG_KEY": "31.43",
  "PRO_NOMBRE": "Biopsia cerrada [endoscópica] de laringe"
 },
 {
  "CATALOG_KEY": "31.44",
  "PRO_NOMBRE": "Biopsia cerrada [endoscópica] de tráquea"
 },
 {
  "CATALOG_KEY": "31.45",
  "PRO_NOMBRE": "Biopsia abierta de laringe o tráquea"
 },
 {
  "CATALOG_KEY": "31.48",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre laringe"
 },
 {
  "CATALOG_KEY": "31.49",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre tráquea"
 },
 {
  "CATALOG_KEY": "31.5",
  "PRO_NOMBRE": "Excisión local o destrucción de lesión o tejido de tráquea"
 },
 {
  "CATALOG_KEY": "31.6",
  "PRO_NOMBRE": "Reparación de laringe"
 },
 {
  "CATALOG_KEY": "31.61",
  "PRO_NOMBRE": "Sutura de laceración de laringe"
 },
 {
  "CATALOG_KEY": "31.62",
  "PRO_NOMBRE": "Cierre de fístula de laringe"
 },
 {
  "CATALOG_KEY": "31.63",
  "PRO_NOMBRE": "Revisión de laringostomía"
 },
 {
  "CATALOG_KEY": "31.64",
  "PRO_NOMBRE": "Reparación de fractura laríngea"
 },
 {
  "CATALOG_KEY": "31.69",
  "PRO_NOMBRE": "Otra reparación de laringe"
 },
 {
  "CATALOG_KEY": "31.7",
  "PRO_NOMBRE": "Operaciones de reparación y plástica sobre tráquea"
 },
 {
  "CATALOG_KEY": "31.71",
  "PRO_NOMBRE": "Sutura de laceración de tráquea"
 },
 {
  "CATALOG_KEY": "31.72",
  "PRO_NOMBRE": "Cierre de fístula externa de tráquea"
 },
 {
  "CATALOG_KEY": "31.73",
  "PRO_NOMBRE": "Cierre de otra fístula de tráquea"
 },
 {
  "CATALOG_KEY": "31.74",
  "PRO_NOMBRE": "Revisión de traqueostomía"
 },
 {
  "CATALOG_KEY": "31.75",
  "PRO_NOMBRE": "Reconstrucción de tráquea y construcción de laringe artificial"
 },
 {
  "CATALOG_KEY": "31.79",
  "PRO_NOMBRE": "Otras operaciones de reconstrucción y plástica sobre tráquea"
 },
 {
  "CATALOG_KEY": "31.9",
  "PRO_NOMBRE": "Otras operaciones sobre laringe y tráquea"
 },
 {
  "CATALOG_KEY": "31.91",
  "PRO_NOMBRE": "Sección de nervio laríngeo"
 },
 {
  "CATALOG_KEY": "31.92",
  "PRO_NOMBRE": "Lisis de adherencias de tráquea o laringe"
 },
 {
  "CATALOG_KEY": "31.93",
  "PRO_NOMBRE": "Sustitución de tutor laríngeo o traqueal"
 },
 {
  "CATALOG_KEY": "31.94",
  "PRO_NOMBRE": "Inyección de sustancia terapéutica de acción local en la tráquea"
 },
 {
  "CATALOG_KEY": "31.95",
  "PRO_NOMBRE": "Fistulización traqueoesofágica"
 },
 {
  "CATALOG_KEY": "31.98",
  "PRO_NOMBRE": "Otras operaciones sobre laringe"
 },
 {
  "CATALOG_KEY": "31.99",
  "PRO_NOMBRE": "Otras operaciones sobre tráquea"
 },
 {
  "CATALOG_KEY": "32",
  "PRO_NOMBRE": "Excisión de pulmón y de bronquio"
 },
 {
  "CATALOG_KEY": "32.0",
  "PRO_NOMBRE": "Excisión local o destrucción de lesión o tejido bronquial"
 },
 {
  "CATALOG_KEY": "32.01",
  "PRO_NOMBRE": "Excisión o destrucción endoscópica de lesión o tejido bronquial"
 },
 {
  "CATALOG_KEY": "32.09",
  "PRO_NOMBRE": "Otra excisión o destrucción local de lesión o tejido bronquial"
 },
 {
  "CATALOG_KEY": "32.1",
  "PRO_NOMBRE": "Otra excisión de bronquio"
 },
 {
  "CATALOG_KEY": "32.2",
  "PRO_NOMBRE": "Excisión local o destrucción de lesión o tejido pulmonar"
 },
 {
  "CATALOG_KEY": "32.20",
  "PRO_NOMBRE": "Excisión de lesión o tejido pulmonar por toracoscopía"
 },
 {
  "CATALOG_KEY": "32.21",
  "PRO_NOMBRE": "Plicatura de bulla enfisematosa"
 },
 {
  "CATALOG_KEY": "32.22",
  "PRO_NOMBRE": "Reducción quirúrgica de volumen pulmonar"
 },
 {
  "CATALOG_KEY": "32.23",
  "PRO_NOMBRE": "Ablación abierta de lesión o tejido de pulmón"
 },
 {
  "CATALOG_KEY": "32.24",
  "PRO_NOMBRE": "Ablación percutánea de lesión o tejido de pulmón"
 },
 {
  "CATALOG_KEY": "32.25",
  "PRO_NOMBRE": "Ablación de lesión o tejido de pulmón por toracoscopía"
 },
 {
  "CATALOG_KEY": "32.26",
  "PRO_NOMBRE": "Otra ablación y la no especificada de lesión o tejido de pulmón"
 },
 {
  "CATALOG_KEY": "32.28",
  "PRO_NOMBRE": "Excisión o destrucción endoscópica de lesión o tejido de pulmón"
 },
 {
  "CATALOG_KEY": "32.29",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión o tejido de pulmón"
 },
 {
  "CATALOG_KEY": "32.3",
  "PRO_NOMBRE": "Resección segmentaria de pulmón"
 },
 {
  "CATALOG_KEY": "32.30",
  "PRO_NOMBRE": "Resección segmentaría de pulmón por toracoscopía"
 },
 {
  "CATALOG_KEY": "32.39",
  "PRO_NOMBRE": "Otra resección segmentaría y la no especificada de pulmón"
 },
 {
  "CATALOG_KEY": "32.4",
  "PRO_NOMBRE": "Lobectomía de pulmón"
 },
 {
  "CATALOG_KEY": "32.41",
  "PRO_NOMBRE": "Lobectomía de pulmón por toracoscopía"
 },
 {
  "CATALOG_KEY": "32.49",
  "PRO_NOMBRE": "Otra lobectomía de pulmón"
 },
 {
  "CATALOG_KEY": "32.5",
  "PRO_NOMBRE": "Neumonectomía [Pneumonectomía]"
 },
 {
  "CATALOG_KEY": "32.50",
  "PRO_NOMBRE": "Neumonectomía [Pneumonectomía] por toracoscopía"
 },
 {
  "CATALOG_KEY": "32.59",
  "PRO_NOMBRE": "Otra neumonectomía [pneumonectomía] y la no especificada"
 },
 {
  "CATALOG_KEY": "32.6",
  "PRO_NOMBRE": "Disección radical de estructuras torácicas"
 },
 {
  "CATALOG_KEY": "32.9",
  "PRO_NOMBRE": "Otra excisión de pulmón"
 },
 {
  "CATALOG_KEY": "33",
  "PRO_NOMBRE": "Otras operaciones sobre pulmón y bronquio"
 },
 {
  "CATALOG_KEY": "33.0",
  "PRO_NOMBRE": "Incisión de bronquio"
 },
 {
  "CATALOG_KEY": "33.1",
  "PRO_NOMBRE": "Incisión de pulmón"
 },
 {
  "CATALOG_KEY": "33.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre pulmón y bronquio"
 },
 {
  "CATALOG_KEY": "33.20",
  "PRO_NOMBRE": "Biopsia de pulmón por toracoscopía"
 },
 {
  "CATALOG_KEY": "33.21",
  "PRO_NOMBRE": "Broncoscopia a través de estoma artificial"
 },
 {
  "CATALOG_KEY": "33.22",
  "PRO_NOMBRE": "Broncoscopia fibroóptica"
 },
 {
  "CATALOG_KEY": "33.23",
  "PRO_NOMBRE": "Otra broncoscopia"
 },
 {
  "CATALOG_KEY": "33.24",
  "PRO_NOMBRE": "Biopsia cerrada [endoscópica] de bronquio"
 },
 {
  "CATALOG_KEY": "33.25",
  "PRO_NOMBRE": "Biopsia abierta de bronquio"
 },
 {
  "CATALOG_KEY": "33.26",
  "PRO_NOMBRE": "Biopsia cerrada [con aguja] [percútanea] de pulmón"
 },
 {
  "CATALOG_KEY": "33.27",
  "PRO_NOMBRE": "Biopsia cerrada del pulmón por endoscopía"
 },
 {
  "CATALOG_KEY": "33.28",
  "PRO_NOMBRE": "Biopsia abierta de pulmón"
 },
 {
  "CATALOG_KEY": "33.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre pulmón y bronquio"
 },
 {
  "CATALOG_KEY": "33.3",
  "PRO_NOMBRE": "Colapso quirúrgico de pulmón"
 },
 {
  "CATALOG_KEY": "33.31",
  "PRO_NOMBRE": "Destrucción de nervio frénico por colapso de pulmón"
 },
 {
  "CATALOG_KEY": "33.32",
  "PRO_NOMBRE": "Neumotórax artificial por colapso de pulmón"
 },
 {
  "CATALOG_KEY": "33.33",
  "PRO_NOMBRE": "Neumoperitoneo por colapso de pulmón"
 },
 {
  "CATALOG_KEY": "33.34",
  "PRO_NOMBRE": "Toracoplastía"
 },
 {
  "CATALOG_KEY": "33.39",
  "PRO_NOMBRE": "Otro colapso quirúrgico de pulmón"
 },
 {
  "CATALOG_KEY": "33.4",
  "PRO_NOMBRE": "Operaciones de reparación y plástica sobre pulmón y bronquio"
 },
 {
  "CATALOG_KEY": "33.41",
  "PRO_NOMBRE": "Sutura de laceración bronquial"
 },
 {
  "CATALOG_KEY": "33.42",
  "PRO_NOMBRE": "Cierre de fístula bronquial"
 },
 {
  "CATALOG_KEY": "33.43",
  "PRO_NOMBRE": "Cierre de laceración de pulmón"
 },
 {
  "CATALOG_KEY": "33.48",
  "PRO_NOMBRE": "Otras operaciones de reparación y plástica sobre bronquio"
 },
 {
  "CATALOG_KEY": "33.49",
  "PRO_NOMBRE": "Otras operaciones de reparación y plástica sobre pulmón"
 },
 {
  "CATALOG_KEY": "33.5",
  "PRO_NOMBRE": "Trasplante de pulmón"
 },
 {
  "CATALOG_KEY": "33.50",
  "PRO_NOMBRE": "Trasplante de pulmón, no especificado de otra manera."
 },
 {
  "CATALOG_KEY": "33.51",
  "PRO_NOMBRE": "Trasplante unilateral de pulmón"
 },
 {
  "CATALOG_KEY": "33.52",
  "PRO_NOMBRE": "Trasplante bilateral de pulmón"
 },
 {
  "CATALOG_KEY": "33.6",
  "PRO_NOMBRE": "Trasplante combinado de corazón-pulmón"
 },
 {
  "CATALOG_KEY": "33.7",
  "PRO_NOMBRE": "Otros procedimientos endoscópicos sobre pulmón y bronquio"
 },
 {
  "CATALOG_KEY": "33.71",
  "PRO_NOMBRE": "Inserción o sustitución endoscópica de válvula(s) bronquial(es)"
 },
 {
  "CATALOG_KEY": "33.72",
  "PRO_NOMBRE": "Medición endoscópica de flujo aéreo pulmonar"
 },
 {
  "CATALOG_KEY": "33.78",
  "PRO_NOMBRE": "Retiro endoscópico de dispositivo(s) o sustancias en bronquio"
 },
 {
  "CATALOG_KEY": "33.79",
  "PRO_NOMBRE": "Inserción endoscópica de otro dispositivo o sustancias en bronquio"
 },
 {
  "CATALOG_KEY": "33.9",
  "PRO_NOMBRE": "Otras operaciones sobre pulmón y bronquio"
 },
 {
  "CATALOG_KEY": "33.91",
  "PRO_NOMBRE": "Dilatación bronquial"
 },
 {
  "CATALOG_KEY": "33.92",
  "PRO_NOMBRE": "Ligadura de bronquio"
 },
 {
  "CATALOG_KEY": "33.93",
  "PRO_NOMBRE": "Punción de pulmón"
 },
 {
  "CATALOG_KEY": "33.98",
  "PRO_NOMBRE": "Otras operaciones sobre bronquio"
 },
 {
  "CATALOG_KEY": "33.99",
  "PRO_NOMBRE": "Otras operaciones sobre pulmón"
 },
 {
  "CATALOG_KEY": "34",
  "PRO_NOMBRE": "Operaciones sobre la pared torácica, pleura, mediastino y diafragma"
 },
 {
  "CATALOG_KEY": "34.0",
  "PRO_NOMBRE": "Incisión de pared torácica y pleural"
 },
 {
  "CATALOG_KEY": "34.01",
  "PRO_NOMBRE": "Incisión de pared torácica"
 },
 {
  "CATALOG_KEY": "34.02",
  "PRO_NOMBRE": "Toracotomía exploratoria"
 },
 {
  "CATALOG_KEY": "34.03",
  "PRO_NOMBRE": "Reapertura a través de toracotomía reciente"
 },
 {
  "CATALOG_KEY": "34.04",
  "PRO_NOMBRE": "Inserción de catéter intercostal para drenaje"
 },
 {
  "CATALOG_KEY": "34.05",
  "PRO_NOMBRE": "Creación de derivación pleuroperitoneal"
 },
 {
  "CATALOG_KEY": "34.06",
  "PRO_NOMBRE": "Drenaje de cavidad pleural por toracoscopía"
 },
 {
  "CATALOG_KEY": "34.09",
  "PRO_NOMBRE": "Otra incisión de pleura"
 },
 {
  "CATALOG_KEY": "34.0A",
  "PRO_NOMBRE": "Sello de agua"
 },
 {
  "CATALOG_KEY": "34.1",
  "PRO_NOMBRE": "Incisión de mediastino"
 },
 {
  "CATALOG_KEY": "34.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre pared torácica, pleura, mediastino y diafragma"
 },
 {
  "CATALOG_KEY": "34.20",
  "PRO_NOMBRE": "Biopsia pleural por toracoscopía"
 },
 {
  "CATALOG_KEY": "34.21",
  "PRO_NOMBRE": "Toracoscopia transpleural"
 },
 {
  "CATALOG_KEY": "34.22",
  "PRO_NOMBRE": "Mediastinoscopia"
 },
 {
  "CATALOG_KEY": "34.23",
  "PRO_NOMBRE": "Biopsia de pared torácica"
 },
 {
  "CATALOG_KEY": "34.24",
  "PRO_NOMBRE": "Otra biopsia pleural"
 },
 {
  "CATALOG_KEY": "34.25",
  "PRO_NOMBRE": "Biopsia cerrada [aguja] [percutánea] de mediastino"
 },
 {
  "CATALOG_KEY": "34.26",
  "PRO_NOMBRE": "Biopsia abierta de mediastino"
 },
 {
  "CATALOG_KEY": "34.27",
  "PRO_NOMBRE": "Biopsia de diafragma"
 },
 {
  "CATALOG_KEY": "34.28",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre la pared torácica, pleura y diafragma"
 },
 {
  "CATALOG_KEY": "34.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre mediastino"
 },
 {
  "CATALOG_KEY": "34.3",
  "PRO_NOMBRE": "Excisión o destrucción de lesión o tejido de mediastino"
 },
 {
  "CATALOG_KEY": "34.4",
  "PRO_NOMBRE": "Excisión o destrucción de lesión de pared torácica"
 },
 {
  "CATALOG_KEY": "34.5",
  "PRO_NOMBRE": "Pleurectomía"
 },
 {
  "CATALOG_KEY": "34.51",
  "PRO_NOMBRE": "Decorticación de pulmón"
 },
 {
  "CATALOG_KEY": "34.52",
  "PRO_NOMBRE": "Decorticación de pulmón por toracoscopía"
 },
 {
  "CATALOG_KEY": "34.59",
  "PRO_NOMBRE": "Otra excisión de pleura"
 },
 {
  "CATALOG_KEY": "34.6",
  "PRO_NOMBRE": "Escarificación de pleura"
 },
 {
  "CATALOG_KEY": "34.7",
  "PRO_NOMBRE": "Reparación de pared torácica"
 },
 {
  "CATALOG_KEY": "34.71",
  "PRO_NOMBRE": "Sutura de laceración de pared torácica"
 },
 {
  "CATALOG_KEY": "34.72",
  "PRO_NOMBRE": "Cierre de toracostomía"
 },
 {
  "CATALOG_KEY": "34.73",
  "PRO_NOMBRE": "Cierre de otra fístula de tórax"
 },
 {
  "CATALOG_KEY": "34.74",
  "PRO_NOMBRE": "Reparación de deformidad de pectus"
 },
 {
  "CATALOG_KEY": "34.79",
  "PRO_NOMBRE": "Otra reparación sobre de pared torácica"
 },
 {
  "CATALOG_KEY": "34.8",
  "PRO_NOMBRE": "Operaciones en diafragma"
 },
 {
  "CATALOG_KEY": "34.81",
  "PRO_NOMBRE": "Excisión de lesión o tejido de diafragma"
 },
 {
  "CATALOG_KEY": "34.82",
  "PRO_NOMBRE": "Sutura de laceración de diafragma"
 },
 {
  "CATALOG_KEY": "34.83",
  "PRO_NOMBRE": "Cierre de fístula de diafragma"
 },
 {
  "CATALOG_KEY": "34.84",
  "PRO_NOMBRE": "Otra reparación de diafragma"
 },
 {
  "CATALOG_KEY": "34.85",
  "PRO_NOMBRE": "Implantación de marcapasos diafragmático"
 },
 {
  "CATALOG_KEY": "34.89",
  "PRO_NOMBRE": "Otras operaciones sobre diafragma"
 },
 {
  "CATALOG_KEY": "34.9",
  "PRO_NOMBRE": "Otras operaciones sobre tórax"
 },
 {
  "CATALOG_KEY": "34.91",
  "PRO_NOMBRE": "Toracocentesis"
 },
 {
  "CATALOG_KEY": "34.92",
  "PRO_NOMBRE": "Inyección en la cavidad torácica"
 },
 {
  "CATALOG_KEY": "34.93",
  "PRO_NOMBRE": "Reparación de pleura"
 },
 {
  "CATALOG_KEY": "34.99",
  "PRO_NOMBRE": "Otra operación sobre tórax"
 },
 {
  "CATALOG_KEY": "35",
  "PRO_NOMBRE": "Operaciones sobre válvulas y tabiques del corazón"
 },
 {
  "CATALOG_KEY": "35.0",
  "PRO_NOMBRE": "Valvulotomía cardiaca cerrada"
 },
 {
  "CATALOG_KEY": "35.00",
  "PRO_NOMBRE": "Valvulotomía cardiaca cerrada, válvula no especificada"
 },
 {
  "CATALOG_KEY": "35.01",
  "PRO_NOMBRE": "Valvulotomía cardiaca cerrada, válvula aórtica"
 },
 {
  "CATALOG_KEY": "35.02",
  "PRO_NOMBRE": "Valvulotomía cardiaca cerrada, válvula mitral"
 },
 {
  "CATALOG_KEY": "35.03",
  "PRO_NOMBRE": "Valvulotomía cardiaca cerrada, válvula pulmonar"
 },
 {
  "CATALOG_KEY": "35.04",
  "PRO_NOMBRE": "Valvulotomía cardiaca cerrada, válvula tricúspide"
 },
 {
  "CATALOG_KEY": "35.1",
  "PRO_NOMBRE": "Valvuloplastía cardiaca abierta sin sustitución valvular"
 },
 {
  "CATALOG_KEY": "35.10",
  "PRO_NOMBRE": "Valvuloplastía cardiaca abierta sin sustitución, válvula no especificada"
 },
 {
  "CATALOG_KEY": "35.11",
  "PRO_NOMBRE": "Valvuloplastía cardiaca abierta de válvula aórtica sin sustitución"
 },
 {
  "CATALOG_KEY": "35.12",
  "PRO_NOMBRE": "Valvuloplastía cardiaca abierta de válvula mitral sin sustitución"
 },
 {
  "CATALOG_KEY": "35.13",
  "PRO_NOMBRE": "Valvuloplastía cardiaca abierta de válvula pulmonar sin sustitución"
 },
 {
  "CATALOG_KEY": "35.14",
  "PRO_NOMBRE": "Valvuloplastía cardiaca abierta de válvula tricúspide sin sustitución"
 },
 {
  "CATALOG_KEY": "35.2",
  "PRO_NOMBRE": "Sustitución de válvula cardiaca"
 },
 {
  "CATALOG_KEY": "35.20",
  "PRO_NOMBRE": "Sustitución de válvula cardiaca no especificada"
 },
 {
  "CATALOG_KEY": "35.21",
  "PRO_NOMBRE": "Sustitución de válvula aórtica con injerto de tejido"
 },
 {
  "CATALOG_KEY": "35.22",
  "PRO_NOMBRE": "Otra sustitución de válvula aórtica"
 },
 {
  "CATALOG_KEY": "35.23",
  "PRO_NOMBRE": "Sustitución de válvula mitral con injerto de tejido"
 },
 {
  "CATALOG_KEY": "35.24",
  "PRO_NOMBRE": "Otra sustitución de válvula mitral"
 },
 {
  "CATALOG_KEY": "35.25",
  "PRO_NOMBRE": "Sustitución de válvula pulmonar con injerto de tejido"
 },
 {
  "CATALOG_KEY": "35.26",
  "PRO_NOMBRE": "Otra sustitución de válvula pulmonar"
 },
 {
  "CATALOG_KEY": "35.27",
  "PRO_NOMBRE": "Sustitución de válvula tricúspide con injerto de tejido"
 },
 {
  "CATALOG_KEY": "35.28",
  "PRO_NOMBRE": "Otra sustitución de válvula tricúspide"
 },
 {
  "CATALOG_KEY": "35.3",
  "PRO_NOMBRE": "Operaciones sobre estructuras adyacentes a las válvulas cardiacas"
 },
 {
  "CATALOG_KEY": "35.31",
  "PRO_NOMBRE": "Operaciones sobre músculo papilar"
 },
 {
  "CATALOG_KEY": "35.32",
  "PRO_NOMBRE": "Operaciones sobre cuerdas tendinosas"
 },
 {
  "CATALOG_KEY": "35.33",
  "PRO_NOMBRE": "Anuloplastía"
 },
 {
  "CATALOG_KEY": "35.34",
  "PRO_NOMBRE": "Infundibulectomía"
 },
 {
  "CATALOG_KEY": "35.35",
  "PRO_NOMBRE": "Operaciones sobre trabéculas del corazón"
 },
 {
  "CATALOG_KEY": "35.39",
  "PRO_NOMBRE": "Operaciones sobre otras estructuras adyacentes a las válvulas cardiacas"
 },
 {
  "CATALOG_KEY": "35.4",
  "PRO_NOMBRE": "Producción de defecto de tabique en el corazón"
 },
 {
  "CATALOG_KEY": "35.41",
  "PRO_NOMBRE": "Ampliación de defecto existente en tabique interauricular"
 },
 {
  "CATALOG_KEY": "35.42",
  "PRO_NOMBRE": "Creación de defecto de tabique en el corazón"
 },
 {
  "CATALOG_KEY": "35.5",
  "PRO_NOMBRE": "Reparación de tabiques interauricular e interventricular con prótesis"
 },
 {
  "CATALOG_KEY": "35.50",
  "PRO_NOMBRE": "Reparación de defecto no especificado de tabiques cardiacos con prótesis"
 },
 {
  "CATALOG_KEY": "35.51",
  "PRO_NOMBRE": "Reparación de defecto de tabique interauricular con prótesis, técnica abierta"
 },
 {
  "CATALOG_KEY": "35.52",
  "PRO_NOMBRE": "Reparación de defecto de tabique interauricular con prótesis, técnica cerrada"
 },
 {
  "CATALOG_KEY": "35.53",
  "PRO_NOMBRE": "Reparación de defecto de tabique interventricular con prótesis, técnica abierta"
 },
 {
  "CATALOG_KEY": "35.54",
  "PRO_NOMBRE": "Reparación de defecto de cojines endocárdicos con prótesis"
 },
 {
  "CATALOG_KEY": "35.55",
  "PRO_NOMBRE": "Reparación de defecto de tabique interventricular con prótesis, técnica cerrada"
 },
 {
  "CATALOG_KEY": "35.6",
  "PRO_NOMBRE": "Reparación de tabiques interauricular e interventricular con injerto de tejido"
 },
 {
  "CATALOG_KEY": "35.60",
  "PRO_NOMBRE": "Reparación de defecto de tabique cardiaco no especificado con injerto de tejido"
 },
 {
  "CATALOG_KEY": "35.61",
  "PRO_NOMBRE": "Reparación de defecto de tabique interauricular con injerto de tejido"
 },
 {
  "CATALOG_KEY": "35.62",
  "PRO_NOMBRE": "Reparación de defecto de tabique interventricular con injerto de tejido"
 },
 {
  "CATALOG_KEY": "35.63",
  "PRO_NOMBRE": "Reparación de defecto de cojines endocárdicos con injerto de tejido"
 },
 {
  "CATALOG_KEY": "35.7",
  "PRO_NOMBRE": "Otra reparación no especificada del tabique interauricular e interventricular"
 },
 {
  "CATALOG_KEY": "35.70",
  "PRO_NOMBRE": "Otra reparación no especificada de defectos de tabiques cardiacos"
 },
 {
  "CATALOG_KEY": "35.71",
  "PRO_NOMBRE": "Otra reparación no especificada de tabique interauricular"
 },
 {
  "CATALOG_KEY": "35.72",
  "PRO_NOMBRE": "Otra reparación no especificada de tabique interventricular"
 },
 {
  "CATALOG_KEY": "35.73",
  "PRO_NOMBRE": "Otra reparación no especificada de defecto de cojines endocárdicos"
 },
 {
  "CATALOG_KEY": "35.8",
  "PRO_NOMBRE": "Reparación total de ciertas anomalías cardiacas congénitas"
 },
 {
  "CATALOG_KEY": "35.81",
  "PRO_NOMBRE": "Reparación total de tetralogía de Fallot"
 },
 {
  "CATALOG_KEY": "35.82",
  "PRO_NOMBRE": "Reparación completa de drenaje venoso pulmonar anómalo total"
 },
 {
  "CATALOG_KEY": "35.83",
  "PRO_NOMBRE": "Reparación total de tronco arterioso"
 },
 {
  "CATALOG_KEY": "35.84",
  "PRO_NOMBRE": "Corrección total o transposición de grandes vasos, no clasificada bajo otro concepto"
 },
 {
  "CATALOG_KEY": "35.9",
  "PRO_NOMBRE": "Otras operaciones sobre válvulas y tabiques cardiacos"
 },
 {
  "CATALOG_KEY": "35.91",
  "PRO_NOMBRE": "Transposición interauricular del retorno venoso"
 },
 {
  "CATALOG_KEY": "35.92",
  "PRO_NOMBRE": "Creación de conducto entre el ventrículo derecho y la arteria pulmonar"
 },
 {
  "CATALOG_KEY": "35.93",
  "PRO_NOMBRE": "Creación de conducto entre el ventrículo izquierdo y la aorta"
 },
 {
  "CATALOG_KEY": "35.94",
  "PRO_NOMBRE": "Creación de conducto entre aurícula y arteria pulmonar"
 },
 {
  "CATALOG_KEY": "35.95",
  "PRO_NOMBRE": "Revisión de procedimiento correctivo sobre el corazón"
 },
 {
  "CATALOG_KEY": "35.96",
  "PRO_NOMBRE": "Valvuloplastía percutánea"
 },
 {
  "CATALOG_KEY": "35.98",
  "PRO_NOMBRE": "Otras operaciones sobre tabiques cardiacos"
 },
 {
  "CATALOG_KEY": "35.99",
  "PRO_NOMBRE": "Otras operaciones sobre válvulas cardiacas"
 },
 {
  "CATALOG_KEY": "36",
  "PRO_NOMBRE": "Operaciones sobre vasos cardiacos"
 },
 {
  "CATALOG_KEY": "36.0",
  "PRO_NOMBRE": "Eliminación de estenosis arterial coronaria con o sin implante de prótesis intracoronaria(s) “stent”(s)"
 },
 {
  "CATALOG_KEY": "36.03",
  "PRO_NOMBRE": "Angioplastía de arteria coronaria a tórax abierto"
 },
 {
  "CATALOG_KEY": "36.04",
  "PRO_NOMBRE": "Infusión arterial intracoronaria de trombolítico"
 },
 {
  "CATALOG_KEY": "36.06",
  "PRO_NOMBRE": "Inserción de stent(s) no liberador de fármacos en arteria coronaria"
 },
 {
  "CATALOG_KEY": "36.07",
  "PRO_NOMBRE": "Inserción de stent(s) liberador(es) de fármaco en arteria coronaria"
 },
 {
  "CATALOG_KEY": "36.09",
  "PRO_NOMBRE": "Otra eliminación de obstrucción de arteria coronaria"
 },
 {
  "CATALOG_KEY": "36.1",
  "PRO_NOMBRE": "Anastomosis de derivación para revascularización miocárdica"
 },
 {
  "CATALOG_KEY": "36.10",
  "PRO_NOMBRE": "Derivación aortocoronaria para revascularización miocárdica, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "36.11",
  "PRO_NOMBRE": "Derivación (aorto) coronaria de una arteria coronaria"
 },
 {
  "CATALOG_KEY": "36.12",
  "PRO_NOMBRE": "Derivación (aorto) coronaria de dos arterias coronarias"
 },
 {
  "CATALOG_KEY": "36.13",
  "PRO_NOMBRE": "Derivación (aorto) coronaria de tres arterias coronarias"
 },
 {
  "CATALOG_KEY": "36.14",
  "PRO_NOMBRE": "Derivación (aorto) coronaria de cuatro o más arterias coronarias"
 },
 {
  "CATALOG_KEY": "36.15",
  "PRO_NOMBRE": "Anastomosis simple de arteria mamaria interna-arteria coronaria"
 },
 {
  "CATALOG_KEY": "36.16",
  "PRO_NOMBRE": "Anastomosis doble de arteria mamaria interna-arteria coronaria"
 },
 {
  "CATALOG_KEY": "36.17",
  "PRO_NOMBRE": "Anastomosis de la arteria coronaria abdominal"
 },
 {
  "CATALOG_KEY": "36.19",
  "PRO_NOMBRE": "Otras anastomosis de derivación para revascularización miocárdica"
 },
 {
  "CATALOG_KEY": "36.2",
  "PRO_NOMBRE": "Revascularización cardiaca por implantación arterial"
 },
 {
  "CATALOG_KEY": "36.3",
  "PRO_NOMBRE": "Otra revascularización cardíaca"
 },
 {
  "CATALOG_KEY": "36.31",
  "PRO_NOMBRE": "Revascularización transmiocárdica con tórax abierto"
 },
 {
  "CATALOG_KEY": "36.32",
  "PRO_NOMBRE": "Otra revascularización transmiocárdica"
 },
 {
  "CATALOG_KEY": "36.33",
  "PRO_NOMBRE": "Revascularización transmiocárdica endoscópica"
 },
 {
  "CATALOG_KEY": "36.34",
  "PRO_NOMBRE": "Revascularización transmiocárdica percutánea"
 },
 {
  "CATALOG_KEY": "36.39",
  "PRO_NOMBRE": "Otra revascularización del corazón"
 },
 {
  "CATALOG_KEY": "36.9",
  "PRO_NOMBRE": "Otras operaciones sobre vasos cardiacos"
 },
 {
  "CATALOG_KEY": "36.91",
  "PRO_NOMBRE": "Reparación de aneurisma de vaso coronario"
 },
 {
  "CATALOG_KEY": "36.99",
  "PRO_NOMBRE": "Otras operaciones sobre vasos cardiacos"
 },
 {
  "CATALOG_KEY": "37",
  "PRO_NOMBRE": "Otras operaciones sobre corazón y pericardio"
 },
 {
  "CATALOG_KEY": "37.0",
  "PRO_NOMBRE": "Pericardiocentesis"
 },
 {
  "CATALOG_KEY": "37.1",
  "PRO_NOMBRE": "Cardiotomía y pericardiotomía"
 },
 {
  "CATALOG_KEY": "37.10",
  "PRO_NOMBRE": "Incisión de corazón, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "37.11",
  "PRO_NOMBRE": "Cardiotomía"
 },
 {
  "CATALOG_KEY": "37.12",
  "PRO_NOMBRE": "Pericardiotomía"
 },
 {
  "CATALOG_KEY": "37.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre corazón y pericardio"
 },
 {
  "CATALOG_KEY": "37.20",
  "PRO_NOMBRE": "Estimulación eléctrica programada no invasiva [EEPNI] [NIPS]"
 },
 {
  "CATALOG_KEY": "37.21",
  "PRO_NOMBRE": "Cateterismo cardiaco del lado derecho del corazón"
 },
 {
  "CATALOG_KEY": "37.22",
  "PRO_NOMBRE": "Cateterismo cardiaco del lado izquierdo del corazón"
 },
 {
  "CATALOG_KEY": "37.23",
  "PRO_NOMBRE": "Cateterismo combinado de los lados derecho e izquierdo del corazón"
 },
 {
  "CATALOG_KEY": "37.24",
  "PRO_NOMBRE": "Biopsia de pericardio"
 },
 {
  "CATALOG_KEY": "37.26",
  "PRO_NOMBRE": "Estudio electrofisiológico invasivo por catéter (corazón y pericardio)"
 },
 {
  "CATALOG_KEY": "37.27",
  "PRO_NOMBRE": "Mapeo cardiaco"
 },
 {
  "CATALOG_KEY": "37.28",
  "PRO_NOMBRE": "Ecocardiografía intracardiaca"
 },
 {
  "CATALOG_KEY": "37.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre corazón y pericardio"
 },
 {
  "CATALOG_KEY": "37.3",
  "PRO_NOMBRE": "Pericardiectomía y excisión de lesión de corazón"
 },
 {
  "CATALOG_KEY": "37.31",
  "PRO_NOMBRE": "Pericardiectomía"
 },
 {
  "CATALOG_KEY": "37.32",
  "PRO_NOMBRE": "Excisión de aneurisma de corazón"
 },
 {
  "CATALOG_KEY": "37.33",
  "PRO_NOMBRE": "Excisión o destrucción de otra lesión o tejido cardíaco por vía abierta"
 },
 {
  "CATALOG_KEY": "37.34",
  "PRO_NOMBRE": "Excisión o destrucción de otra lesión o tejidos del corazón, otro acceso"
 },
 {
  "CATALOG_KEY": "37.35",
  "PRO_NOMBRE": "Ventriculectomía parcial"
 },
 {
  "CATALOG_KEY": "37.36",
  "PRO_NOMBRE": "Excisión o destrucción de apéndice de aurícula izquierda (AAI)"
 },
 {
  "CATALOG_KEY": "37.4",
  "PRO_NOMBRE": "Reparación de corazón y pericardio"
 },
 {
  "CATALOG_KEY": "37.41",
  "PRO_NOMBRE": "Implantación de dispositivo protésico de asistencia cardiaca alrededor del corazón"
 },
 {
  "CATALOG_KEY": "37.49",
  "PRO_NOMBRE": "Otra reparación de corazón y pericardio"
 },
 {
  "CATALOG_KEY": "37.5",
  "PRO_NOMBRE": "Procedimientos de sustitución cardíaca"
 },
 {
  "CATALOG_KEY": "37.51",
  "PRO_NOMBRE": "Trasplante cardíaco"
 },
 {
  "CATALOG_KEY": "37.52",
  "PRO_NOMBRE": "Implantación de sistema total de reemplazo cardíaco interno biventricular"
 },
 {
  "CATALOG_KEY": "37.53",
  "PRO_NOMBRE": "Reemplazo o reparación de la unidad torácica del sistema de reemplazo cardíaco (total)"
 },
 {
  "CATALOG_KEY": "37.54",
  "PRO_NOMBRE": "Reemplazo o reparación de otro componente implantable del sistema de reemplazo cardíaco (total)"
 },
 {
  "CATALOG_KEY": "37.55",
  "PRO_NOMBRE": "Retiro de sistema interno biventricular de reemplazo cardíaco"
 },
 {
  "CATALOG_KEY": "37.6",
  "PRO_NOMBRE": "Implante de sistema(s) de asistencia cardiaca y circulatoria"
 },
 {
  "CATALOG_KEY": "37.60",
  "PRO_NOMBRE": "Implantación o inserción de un sistema externo biventricular de asistencia cardíaca"
 },
 {
  "CATALOG_KEY": "37.61",
  "PRO_NOMBRE": "Implante de balón de contrapulsación"
 },
 {
  "CATALOG_KEY": "37.62",
  "PRO_NOMBRE": "Inserción de dispositivo de asistencia circulatoria extracorpóreo temporal no implantable"
 },
 {
  "CATALOG_KEY": "37.63",
  "PRO_NOMBRE": "Reparación de sistema de asistencia cardiaca"
 },
 {
  "CATALOG_KEY": "37.64",
  "PRO_NOMBRE": "Extracción de sistema(s) o dispositivo(s) externo de asistencia cardiaca"
 },
 {
  "CATALOG_KEY": "37.65",
  "PRO_NOMBRE": "Implantación de sistema de asistencia cardiaca externa de un solo ventrículo (extracorpóreo)"
 },
 {
  "CATALOG_KEY": "37.66",
  "PRO_NOMBRE": "Inserción de sistema implantable de asistencia cardiaca"
 },
 {
  "CATALOG_KEY": "37.67",
  "PRO_NOMBRE": "Implantación de sistema de cardiomioestimulación"
 },
 {
  "CATALOG_KEY": "37.68",
  "PRO_NOMBRE": "Inserción de dispositivo de asistencia cardíaca externo percutáneo"
 },
 {
  "CATALOG_KEY": "37.7",
  "PRO_NOMBRE": "Inserción, revisión, sustitución y eliminación de electrodos; inserción de sistema de marcapasos temporal o revisión de bolsa de dispositivo cardiaco"
 },
 {
  "CATALOG_KEY": "37.70",
  "PRO_NOMBRE": "Inserción inicial de electrodo, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "37.71",
  "PRO_NOMBRE": "Inserción inicial de electrodo transvenoso en ventrículo"
 },
 {
  "CATALOG_KEY": "37.72",
  "PRO_NOMBRE": "Inserción inicial de electrodo transvenoso en aurícula y ventrículo"
 },
 {
  "CATALOG_KEY": "37.73",
  "PRO_NOMBRE": "Inserción inicial de electrodo transvenoso en aurícula"
 },
 {
  "CATALOG_KEY": "37.74",
  "PRO_NOMBRE": "Inserción o sustitución de electrodo epicárdico"
 },
 {
  "CATALOG_KEY": "37.75",
  "PRO_NOMBRE": "Revisión de cable (electrodo)"
 },
 {
  "CATALOG_KEY": "37.76",
  "PRO_NOMBRE": "Sustitución de electrodo transvenoso en aurícula y ventrículo"
 },
 {
  "CATALOG_KEY": "37.77",
  "PRO_NOMBRE": "Extracción de electrodo sin sustitución"
 },
 {
  "CATALOG_KEY": "37.78",
  "PRO_NOMBRE": "Inserción de un sistema de marcapasos transvenoso temporal"
 },
 {
  "CATALOG_KEY": "37.79",
  "PRO_NOMBRE": "Revisión o reubicación de bolsa de dispositivo cardiaco"
 },
 {
  "CATALOG_KEY": "37.8",
  "PRO_NOMBRE": "Inserción, sustitución, extracción y revisión de dispositivo marcapasos"
 },
 {
  "CATALOG_KEY": "37.80",
  "PRO_NOMBRE": "Inserción de marcapasos permanente, inicial o sustituido, sin especificar tipo de aparato"
 },
 {
  "CATALOG_KEY": "37.81",
  "PRO_NOMBRE": "Inserción inicial de un dispositivo de cámara única, no especificado como respuesta en frecuencia"
 },
 {
  "CATALOG_KEY": "37.82",
  "PRO_NOMBRE": "Inserción inicial de un aparato de cámara única, con respuesta en frecuencia"
 },
 {
  "CATALOG_KEY": "37.83",
  "PRO_NOMBRE": "Inserción inicial de dispositivo de doble cámara"
 },
 {
  "CATALOG_KEY": "37.85",
  "PRO_NOMBRE": "Sustitución de cualquier tipo de marcapasos con aparato de cámara única, no especificado como con respuesta en frecuencia"
 },
 {
  "CATALOG_KEY": "37.86",
  "PRO_NOMBRE": "Sustitución de cualquier tipo de marcapasos con aparato de cámara única, con respuesta en frecuencia"
 },
 {
  "CATALOG_KEY": "37.87",
  "PRO_NOMBRE": "Sustitución de cualquier tipo de marcapasos con dispositivo de cámara doble"
 },
 {
  "CATALOG_KEY": "37.89",
  "PRO_NOMBRE": "Revisión o extracción de marcapasos cardiaco"
 },
 {
  "CATALOG_KEY": "37.9",
  "PRO_NOMBRE": "Otras operaciones sobre corazón y pericardio"
 },
 {
  "CATALOG_KEY": "37.90",
  "PRO_NOMBRE": "Inserción de dispositivo accesorio auricular izquierdo"
 },
 {
  "CATALOG_KEY": "37.91",
  "PRO_NOMBRE": "Masaje cardiaco a tórax abierto"
 },
 {
  "CATALOG_KEY": "37.92",
  "PRO_NOMBRE": "Inyección de sustancia terapéutica en corazón"
 },
 {
  "CATALOG_KEY": "37.93",
  "PRO_NOMBRE": "Inyección de sustancia terapéutica en pericardio"
 },
 {
  "CATALOG_KEY": "37.94",
  "PRO_NOMBRE": "Implantación o sustitución de cardioversor/desfibrilador automático"
 },
 {
  "CATALOG_KEY": "37.95",
  "PRO_NOMBRE": "Implantación de cardioversor/desfibrilador automático, sólo electrodos"
 },
 {
  "CATALOG_KEY": "37.96",
  "PRO_NOMBRE": "Implantación de cardioversor/desfibrilador automático, sólo generador del pulso"
 },
 {
  "CATALOG_KEY": "37.97",
  "PRO_NOMBRE": "Sustitución de cardioversor/desfibrilador automático, sólo cable(s)"
 },
 {
  "CATALOG_KEY": "37.98",
  "PRO_NOMBRE": "Sustitución de cardioversor/desfibrilador automático, sólo generador del pulso"
 },
 {
  "CATALOG_KEY": "37.99",
  "PRO_NOMBRE": "Otra operación sobre corazón y pericardio]"
 },
 {
  "CATALOG_KEY": "38",
  "PRO_NOMBRE": "Incisión, excisión y oclusión de vasos"
 },
 {
  "CATALOG_KEY": "38.0",
  "PRO_NOMBRE": "Incisión de vaso"
 },
 {
  "CATALOG_KEY": "38.00",
  "PRO_NOMBRE": "Incisión de vaso — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "38.01",
  "PRO_NOMBRE": "Incisión de vaso — Vasos Intracreneales"
 },
 {
  "CATALOG_KEY": "38.02",
  "PRO_NOMBRE": "Incisión de vaso — Otros vasos de cabeza y cuello"
 },
 {
  "CATALOG_KEY": "38.03",
  "PRO_NOMBRE": "Incisión de vaso — Vasos de miembros superiores"
 },
 {
  "CATALOG_KEY": "38.04",
  "PRO_NOMBRE": "Incisión de vaso — Aorta"
 },
 {
  "CATALOG_KEY": "38.05",
  "PRO_NOMBRE": "Incisión de vaso — Otros vasos torácicos"
 },
 {
  "CATALOG_KEY": "38.06",
  "PRO_NOMBRE": "Incisión de vaso — Arterias abdominales"
 },
 {
  "CATALOG_KEY": "38.07",
  "PRO_NOMBRE": "Incisión de vaso — Venas abdominales"
 },
 {
  "CATALOG_KEY": "38.08",
  "PRO_NOMBRE": "Incisión de vaso — Arterias de miembros inferiores"
 },
 {
  "CATALOG_KEY": "38.09",
  "PRO_NOMBRE": "Incisión de vaso — Venas de miembros inferiores"
 },
 {
  "CATALOG_KEY": "38.1",
  "PRO_NOMBRE": "Endarterectomía"
 },
 {
  "CATALOG_KEY": "38.10",
  "PRO_NOMBRE": "Endarterectomía — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "38.11",
  "PRO_NOMBRE": "Endarterectomía — Vasos Intracreneales"
 },
 {
  "CATALOG_KEY": "38.12",
  "PRO_NOMBRE": "Endarterectomía — Otros vasos de cabeza y cuello"
 },
 {
  "CATALOG_KEY": "38.13",
  "PRO_NOMBRE": "Endarterectomía — Vasos de miembros superiores"
 },
 {
  "CATALOG_KEY": "38.14",
  "PRO_NOMBRE": "Endarterectomía — Aorta"
 },
 {
  "CATALOG_KEY": "38.15",
  "PRO_NOMBRE": "Endarterectomía — Otros vasos torácicos"
 },
 {
  "CATALOG_KEY": "38.16",
  "PRO_NOMBRE": "Endarterectomía — Arterias abdominales"
 },
 {
  "CATALOG_KEY": "38.18",
  "PRO_NOMBRE": "Endarterectomía — Arterias de miembros inferiores"
 },
 {
  "CATALOG_KEY": "38.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre vasos sanguíneos"
 },
 {
  "CATALOG_KEY": "38.21",
  "PRO_NOMBRE": "Biopsia de vaso sanguíneo"
 },
 {
  "CATALOG_KEY": "38.22",
  "PRO_NOMBRE": "Angioscopia percutánea"
 },
 {
  "CATALOG_KEY": "38.23",
  "PRO_NOMBRE": "Espectroscopia intravascular"
 },
 {
  "CATALOG_KEY": "38.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre vasos sanguíneos"
 },
 {
  "CATALOG_KEY": "38.3",
  "PRO_NOMBRE": "Resección de vaso con anastomosis"
 },
 {
  "CATALOG_KEY": "38.30",
  "PRO_NOMBRE": "Resección de vaso con anastomosis — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "38.31",
  "PRO_NOMBRE": "Resección de vaso con anastomosis — Vasos Intracreneales"
 },
 {
  "CATALOG_KEY": "38.32",
  "PRO_NOMBRE": "Resección de vaso con anastomosis — Otros vasos de cabeza y cuello"
 },
 {
  "CATALOG_KEY": "38.33",
  "PRO_NOMBRE": "Resección de vaso con anastomosis — Vasos de miembros superiores"
 },
 {
  "CATALOG_KEY": "38.34",
  "PRO_NOMBRE": "Resección de vaso con anastomosis — Aorta"
 },
 {
  "CATALOG_KEY": "38.35",
  "PRO_NOMBRE": "Resección de vaso con anastomosis — Otros vasos torácicos"
 },
 {
  "CATALOG_KEY": "38.36",
  "PRO_NOMBRE": "Resección de vaso con anastomosis — Arterias abdominales"
 },
 {
  "CATALOG_KEY": "38.37",
  "PRO_NOMBRE": "Resección de vaso con anastomosis — Venas abdominales"
 },
 {
  "CATALOG_KEY": "38.38",
  "PRO_NOMBRE": "Resección de vaso con anastomosis — Arterias de miembros inferiores"
 },
 {
  "CATALOG_KEY": "38.39",
  "PRO_NOMBRE": "Resección de vaso con anastomosis — Venas de miembros inferiores"
 },
 {
  "CATALOG_KEY": "38.4",
  "PRO_NOMBRE": "Resección de vaso con sustitución"
 },
 {
  "CATALOG_KEY": "38.40",
  "PRO_NOMBRE": "Resección de vaso con sustitución — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "38.41",
  "PRO_NOMBRE": "Resección de vaso con sustitución — Vasos intracraneales"
 },
 {
  "CATALOG_KEY": "38.42",
  "PRO_NOMBRE": "Resección de vaso con sustitución — Otros vasos de cabeza y cuello"
 },
 {
  "CATALOG_KEY": "38.43",
  "PRO_NOMBRE": "Resección de vaso con sustitución — Vasos de miembros superiores"
 },
 {
  "CATALOG_KEY": "38.44",
  "PRO_NOMBRE": "Resección de vaso con sustitución — Aorta, abdominal"
 },
 {
  "CATALOG_KEY": "38.45",
  "PRO_NOMBRE": "Resección de vaso con sustitución — Vasos torácicos"
 },
 {
  "CATALOG_KEY": "38.46",
  "PRO_NOMBRE": "Resección de vaso con sustitución — Arterias abdominales"
 },
 {
  "CATALOG_KEY": "38.47",
  "PRO_NOMBRE": "Resección de vaso con sustitución — Venas abdominales"
 },
 {
  "CATALOG_KEY": "38.48",
  "PRO_NOMBRE": "Resección de vaso con sustitución — Arterias de miembros inferiores"
 },
 {
  "CATALOG_KEY": "38.49",
  "PRO_NOMBRE": "Resección de vaso con sustitución — Venas de miembros inferiores"
 },
 {
  "CATALOG_KEY": "38.5",
  "PRO_NOMBRE": "Ligadura y extirpación de venas varicosas"
 },
 {
  "CATALOG_KEY": "38.50",
  "PRO_NOMBRE": "Ligadura y extirpación de venas varicosas — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "38.51",
  "PRO_NOMBRE": "Ligadura y extirpación de venas varicosas — Vasos Intracreneales"
 },
 {
  "CATALOG_KEY": "38.52",
  "PRO_NOMBRE": "Ligadura y extirpación de venas varicosas — Otros vasos de cabeza y cuello"
 },
 {
  "CATALOG_KEY": "38.53",
  "PRO_NOMBRE": "Ligadura y extirpación de venas varicosas — Vasos de miembros superiores"
 },
 {
  "CATALOG_KEY": "38.55",
  "PRO_NOMBRE": "Ligadura y extirpación de venas varicosas — Otros vasos torácicos"
 },
 {
  "CATALOG_KEY": "38.57",
  "PRO_NOMBRE": "Ligadura y extirpación de venas varicosas — Venas abdominales"
 },
 {
  "CATALOG_KEY": "38.59",
  "PRO_NOMBRE": "Ligadura y extirpación de venas varicosas — Venas de miembros inferiores"
 },
 {
  "CATALOG_KEY": "38.6",
  "PRO_NOMBRE": "Otra excisión de vasos"
 },
 {
  "CATALOG_KEY": "38.60",
  "PRO_NOMBRE": "Otra excisión de vasos — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "38.61",
  "PRO_NOMBRE": "Otra excisión de vasos — Vasos Intracreneales"
 },
 {
  "CATALOG_KEY": "38.62",
  "PRO_NOMBRE": "Otra excisión de vasos — Otros vasos de cabeza y cuello"
 },
 {
  "CATALOG_KEY": "38.63",
  "PRO_NOMBRE": "Otra excisión de vasos — Vasos de miembros superiores"
 },
 {
  "CATALOG_KEY": "38.64",
  "PRO_NOMBRE": "Otra excisión de vasos — Aorta"
 },
 {
  "CATALOG_KEY": "38.65",
  "PRO_NOMBRE": "Otra excisión de vasos — Otros vasos torácicos"
 },
 {
  "CATALOG_KEY": "38.66",
  "PRO_NOMBRE": "Otra excisión de vasos — Arterias abdominales"
 },
 {
  "CATALOG_KEY": "38.67",
  "PRO_NOMBRE": "Otra excisión de vasos — Venas abdominales"
 },
 {
  "CATALOG_KEY": "38.68",
  "PRO_NOMBRE": "Otra excisión de vasos — Arterias de miembros inferiores"
 },
 {
  "CATALOG_KEY": "38.69",
  "PRO_NOMBRE": "Otra excisión de vasos — Venas de miembros inferiores"
 },
 {
  "CATALOG_KEY": "38.7",
  "PRO_NOMBRE": "Interrupción de vena cava"
 },
 {
  "CATALOG_KEY": "38.8",
  "PRO_NOMBRE": "Otra oclusión quirúrgica de vasos"
 },
 {
  "CATALOG_KEY": "38.80",
  "PRO_NOMBRE": "Otra oclusión quirúrgica de vasos — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "38.81",
  "PRO_NOMBRE": "Otra oclusión quirúrgica de vasos — Vasos Intracreneales"
 },
 {
  "CATALOG_KEY": "38.82",
  "PRO_NOMBRE": "Otra oclusión quirúrgica de vasos — Otros vasos de cabeza y cuello"
 },
 {
  "CATALOG_KEY": "38.83",
  "PRO_NOMBRE": "Otra oclusión quirúrgica de vasos — Vasos de miembros superiores"
 },
 {
  "CATALOG_KEY": "38.84",
  "PRO_NOMBRE": "Otra oclusión quirúrgica de vasos — Aorta"
 },
 {
  "CATALOG_KEY": "38.85",
  "PRO_NOMBRE": "Otra oclusión quirúrgica de vasos — Otros vasos torácicos"
 },
 {
  "CATALOG_KEY": "38.86",
  "PRO_NOMBRE": "Otra oclusión quirúrgica de vasos — Arterias abdominales"
 },
 {
  "CATALOG_KEY": "38.87",
  "PRO_NOMBRE": "Otra oclusión quirúrgica de vasos — Venas abdominales"
 },
 {
  "CATALOG_KEY": "38.88",
  "PRO_NOMBRE": "Otra oclusión quirúrgica de vasos — Arterias de miembros inferiores"
 },
 {
  "CATALOG_KEY": "38.89",
  "PRO_NOMBRE": "Otra oclusión quirúrgica de vasos — Venas de miembros inferiores"
 },
 {
  "CATALOG_KEY": "38.9",
  "PRO_NOMBRE": "Punción de vaso"
 },
 {
  "CATALOG_KEY": "38.91",
  "PRO_NOMBRE": "Cateterismo arterial"
 },
 {
  "CATALOG_KEY": "38.92",
  "PRO_NOMBRE": "Cateterismo de vena umbilical"
 },
 {
  "CATALOG_KEY": "38.93",
  "PRO_NOMBRE": "Cateterismo venoso, no clasificado bajo otro concepto"
 },
 {
  "CATALOG_KEY": "38.94",
  "PRO_NOMBRE": "Disección venosa"
 },
 {
  "CATALOG_KEY": "38.95",
  "PRO_NOMBRE": "Cateterismo venoso para diálisis renal"
 },
 {
  "CATALOG_KEY": "38.98",
  "PRO_NOMBRE": "Otra punción de arteria"
 },
 {
  "CATALOG_KEY": "38.99",
  "PRO_NOMBRE": "Otra punción de vena"
 },
 {
  "CATALOG_KEY": "39",
  "PRO_NOMBRE": "Otras operaciones sobre vasos"
 },
 {
  "CATALOG_KEY": "39.0",
  "PRO_NOMBRE": "Derivación sistémica a arteria pulmonar"
 },
 {
  "CATALOG_KEY": "39.1",
  "PRO_NOMBRE": "Derivación venosa intraabdominal"
 },
 {
  "CATALOG_KEY": "39.2",
  "PRO_NOMBRE": "Otra derivación o desviación vascular"
 },
 {
  "CATALOG_KEY": "39.21",
  "PRO_NOMBRE": "Anastomosis de vena cava-arteria pulmonar"
 },
 {
  "CATALOG_KEY": "39.22",
  "PRO_NOMBRE": "Desviación aorta-subclavia-carotídea"
 },
 {
  "CATALOG_KEY": "39.23",
  "PRO_NOMBRE": "Otra derivación o desviación vascular intratorácica"
 },
 {
  "CATALOG_KEY": "39.24",
  "PRO_NOMBRE": "Derivación aorta-renal"
 },
 {
  "CATALOG_KEY": "39.25",
  "PRO_NOMBRE": "Derivación aorta-iliaca-femoral"
 },
 {
  "CATALOG_KEY": "39.26",
  "PRO_NOMBRE": "Otras derivaciones o desviaciones vasculares intraabdominales"
 },
 {
  "CATALOG_KEY": "39.27",
  "PRO_NOMBRE": "Arteriovenostomía para diálisis renal"
 },
 {
  "CATALOG_KEY": "39.28",
  "PRO_NOMBRE": "Derivación vascular extracraneal-intracraneal (EC-IC)"
 },
 {
  "CATALOG_KEY": "39.29",
  "PRO_NOMBRE": "Otra derivación o desviación vascular (periférica)"
 },
 {
  "CATALOG_KEY": "39.3",
  "PRO_NOMBRE": "Sutura de vaso"
 },
 {
  "CATALOG_KEY": "39.30",
  "PRO_NOMBRE": "Sutura de vaso sanguíneo no especificado"
 },
 {
  "CATALOG_KEY": "39.31",
  "PRO_NOMBRE": "Sutura de arteria"
 },
 {
  "CATALOG_KEY": "39.32",
  "PRO_NOMBRE": "Sutura de vena"
 },
 {
  "CATALOG_KEY": "39.4",
  "PRO_NOMBRE": "Revisión de procedimiento vascular"
 },
 {
  "CATALOG_KEY": "39.41",
  "PRO_NOMBRE": "Control de hemorragia después de cirugía vascular"
 },
 {
  "CATALOG_KEY": "39.42",
  "PRO_NOMBRE": "Revisión de derivación arteriovenosa para diálisis renal"
 },
 {
  "CATALOG_KEY": "39.43",
  "PRO_NOMBRE": "Extracción de derivación arteriovenosa para diálisis renal"
 },
 {
  "CATALOG_KEY": "39.49",
  "PRO_NOMBRE": "Otra revisión de procedimiento vascular"
 },
 {
  "CATALOG_KEY": "39.5",
  "PRO_NOMBRE": "Otra reparación de vasos"
 },
 {
  "CATALOG_KEY": "39.50",
  "PRO_NOMBRE": "Angioplastía o aterectomía de otro(s) vaso(s) no coronario(s)"
 },
 {
  "CATALOG_KEY": "39.51",
  "PRO_NOMBRE": "Interrupción de aneurisma"
 },
 {
  "CATALOG_KEY": "39.52",
  "PRO_NOMBRE": "Otra reparación de aneurisma"
 },
 {
  "CATALOG_KEY": "39.53",
  "PRO_NOMBRE": "Reparación de fístula arteriovenosa"
 },
 {
  "CATALOG_KEY": "39.54",
  "PRO_NOMBRE": "Operación de re-entrada (aorta)"
 },
 {
  "CATALOG_KEY": "39.55",
  "PRO_NOMBRE": "Reimplantación de vaso renal aberrante"
 },
 {
  "CATALOG_KEY": "39.56",
  "PRO_NOMBRE": "Reparación de vaso sanguíneo con injerto de parche de tejido"
 },
 {
  "CATALOG_KEY": "39.57",
  "PRO_NOMBRE": "Reparación de vaso sanguíneo con injerto de parche sintético"
 },
 {
  "CATALOG_KEY": "39.58",
  "PRO_NOMBRE": "Reparación de vaso sanguíneo con tipo de injerto de parche no especificado"
 },
 {
  "CATALOG_KEY": "39.59",
  "PRO_NOMBRE": "Otras operaciones de vaso"
 },
 {
  "CATALOG_KEY": "39.6",
  "PRO_NOMBRE": "Circulación extracorpórea y procedimientos auxiliares de cirugía cardiaca"
 },
 {
  "CATALOG_KEY": "39.61",
  "PRO_NOMBRE": "Circulación extracorpórea auxiliar para cirugía cardiaca abierta"
 },
 {
  "CATALOG_KEY": "39.62",
  "PRO_NOMBRE": "Hipotermia (sistémica) accesoria de cirugía cardiaca abierta"
 },
 {
  "CATALOG_KEY": "39.63",
  "PRO_NOMBRE": "Cardioplejía"
 },
 {
  "CATALOG_KEY": "39.64",
  "PRO_NOMBRE": "Marcapasos cardiaco intraoperatorio"
 },
 {
  "CATALOG_KEY": "39.65",
  "PRO_NOMBRE": "Oxigenación extracorpórea de membrana (OECM)"
 },
 {
  "CATALOG_KEY": "39.66",
  "PRO_NOMBRE": "Derivación cardiopulmonar percutánea"
 },
 {
  "CATALOG_KEY": "39.7",
  "PRO_NOMBRE": "Reparación endovascular de vaso"
 },
 {
  "CATALOG_KEY": "39.71",
  "PRO_NOMBRE": "Implante endovascular de injerto en aorta abdominal"
 },
 {
  "CATALOG_KEY": "39.72",
  "PRO_NOMBRE": "Reparación u oclusión endovascular de vasos de cabeza y cuello"
 },
 {
  "CATALOG_KEY": "39.73",
  "PRO_NOMBRE": "Implantación endovascular de injerto en aorta torácica"
 },
 {
  "CATALOG_KEY": "39.74",
  "PRO_NOMBRE": "Eliminación endovascular de obstrucción de vaso(s) de cabeza y cuello"
 },
 {
  "CATALOG_KEY": "39.79",
  "PRO_NOMBRE": "Otra reparación endovascular (de aneurisma) de otros vasos"
 },
 {
  "CATALOG_KEY": "39.8",
  "PRO_NOMBRE": "Operaciones sobre el cuerpo carotídeo, seno carotídeo y otros cuerpos vasculares"
 },
 {
  "CATALOG_KEY": "39.9",
  "PRO_NOMBRE": "Otras operaciones sobre vasos"
 },
 {
  "CATALOG_KEY": "39.90",
  "PRO_NOMBRE": "Inserción de stent(s) no liberador de fármacos de vaso periférico"
 },
 {
  "CATALOG_KEY": "39.91",
  "PRO_NOMBRE": "Liberación de vaso"
 },
 {
  "CATALOG_KEY": "39.92",
  "PRO_NOMBRE": "Inyección de agente esclerosante en vena"
 },
 {
  "CATALOG_KEY": "39.93",
  "PRO_NOMBRE": "Inserción de cánula de vaso a vaso"
 },
 {
  "CATALOG_KEY": "39.94",
  "PRO_NOMBRE": "Sustitución de cánula de vaso a vaso"
 },
 {
  "CATALOG_KEY": "39.95",
  "PRO_NOMBRE": "Hemodiálisis"
 },
 {
  "CATALOG_KEY": "39.96",
  "PRO_NOMBRE": "Perfusión de cuerpo entero"
 },
 {
  "CATALOG_KEY": "39.97",
  "PRO_NOMBRE": "Otra perfusión"
 },
 {
  "CATALOG_KEY": "39.98",
  "PRO_NOMBRE": "Control de hemorragia, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "39.99",
  "PRO_NOMBRE": "Otras operaciones sobre vasos"
 },
 {
  "CATALOG_KEY": "40",
  "PRO_NOMBRE": "Operaciones sobre el sistema linfático"
 },
 {
  "CATALOG_KEY": "40.0",
  "PRO_NOMBRE": "Incisión de estructuras linfáticas"
 },
 {
  "CATALOG_KEY": "40.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre estructuras linfáticas"
 },
 {
  "CATALOG_KEY": "40.11",
  "PRO_NOMBRE": "Biopsia de estructura linfática"
 },
 {
  "CATALOG_KEY": "40.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre estructuras linfáticas"
 },
 {
  "CATALOG_KEY": "40.2",
  "PRO_NOMBRE": "Extirpación simple de estructura linfática"
 },
 {
  "CATALOG_KEY": "40.21",
  "PRO_NOMBRE": "Extirpación de ganglio linfático cervical profundo"
 },
 {
  "CATALOG_KEY": "40.22",
  "PRO_NOMBRE": "Extirpación de ganglio linfático mamario interno"
 },
 {
  "CATALOG_KEY": "40.23",
  "PRO_NOMBRE": "Extirpación de ganglio linfático axilar"
 },
 {
  "CATALOG_KEY": "40.24",
  "PRO_NOMBRE": "Extirpación de ganglio linfático inguinal"
 },
 {
  "CATALOG_KEY": "40.29",
  "PRO_NOMBRE": "Extirpación simple de otra estructura linfática"
 },
 {
  "CATALOG_KEY": "40.3",
  "PRO_NOMBRE": "Extirpación de ganglio linfático regional"
 },
 {
  "CATALOG_KEY": "40.4",
  "PRO_NOMBRE": "Extirpación radical de ganglios linfáticos cervicales"
 },
 {
  "CATALOG_KEY": "40.40",
  "PRO_NOMBRE": "Disección radical de cuello, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "40.41",
  "PRO_NOMBRE": "Disección radical de cuello, unilateral"
 },
 {
  "CATALOG_KEY": "40.42",
  "PRO_NOMBRE": "Disección radical de cuello, bilateral"
 },
 {
  "CATALOG_KEY": "40.5",
  "PRO_NOMBRE": "Extirpación radical de otros ganglios linfáticos"
 },
 {
  "CATALOG_KEY": "40.50",
  "PRO_NOMBRE": "Extirpación radical de ganglios linfáticos, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "40.51",
  "PRO_NOMBRE": "Extirpación radical de ganglios linfáticos axilares"
 },
 {
  "CATALOG_KEY": "40.52",
  "PRO_NOMBRE": "Extirpación radical de ganglios linfáticos periaórticos"
 },
 {
  "CATALOG_KEY": "40.53",
  "PRO_NOMBRE": "Extirpación radical de ganglios linfáticos iliacos"
 },
 {
  "CATALOG_KEY": "40.54",
  "PRO_NOMBRE": "Extirpación radical de ganglios linfáticos de la ingle"
 },
 {
  "CATALOG_KEY": "40.59",
  "PRO_NOMBRE": "Extirpación radical de otros ganglios linfáticos"
 },
 {
  "CATALOG_KEY": "40.6",
  "PRO_NOMBRE": "Operaciones sobre conducto torácico"
 },
 {
  "CATALOG_KEY": "40.61",
  "PRO_NOMBRE": "Canulación de conducto torácico"
 },
 {
  "CATALOG_KEY": "40.62",
  "PRO_NOMBRE": "Fistulización de conducto torácico"
 },
 {
  "CATALOG_KEY": "40.63",
  "PRO_NOMBRE": "Cierre de fístula de conducto torácico"
 },
 {
  "CATALOG_KEY": "40.64",
  "PRO_NOMBRE": "Ligadura de conducto torácico"
 },
 {
  "CATALOG_KEY": "40.69",
  "PRO_NOMBRE": "Otras operaciones sobre conducto torácico"
 },
 {
  "CATALOG_KEY": "40.9",
  "PRO_NOMBRE": "Otras operaciones sobre estructuras linfáticas"
 },
 {
  "CATALOG_KEY": "41",
  "PRO_NOMBRE": "Operaciones sobre médula ósea y bazo"
 },
 {
  "CATALOG_KEY": "41.0",
  "PRO_NOMBRE": "Trasplante de médula ósea o de células madre hematopoyéticas"
 },
 {
  "CATALOG_KEY": "41.00",
  "PRO_NOMBRE": "Trasplante de médula ósea, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "41.01",
  "PRO_NOMBRE": "Trasplante autólogo de médula ósea sin purgado"
 },
 {
  "CATALOG_KEY": "41.02",
  "PRO_NOMBRE": "Trasplante alogénico de médula ósea con purgado"
 },
 {
  "CATALOG_KEY": "41.03",
  "PRO_NOMBRE": "Trasplante alogénico de médula ósea sin purgado"
 },
 {
  "CATALOG_KEY": "41.04",
  "PRO_NOMBRE": "Trasplante autólogo de células madre hematopoyéticas sin purgado"
 },
 {
  "CATALOG_KEY": "41.05",
  "PRO_NOMBRE": "Trasplante alogénico de células madre hematopoyéticas sin purgado"
 },
 {
  "CATALOG_KEY": "41.06",
  "PRO_NOMBRE": "Trasplante de células progenitoras de sangre del cordón umbilical"
 },
 {
  "CATALOG_KEY": "41.07",
  "PRO_NOMBRE": "Trasplante autólogo de células madre hematopoyéticas con purgado"
 },
 {
  "CATALOG_KEY": "41.08",
  "PRO_NOMBRE": "Trasplante alogénico de células madre hematopoyéticas con purgado"
 },
 {
  "CATALOG_KEY": "41.09",
  "PRO_NOMBRE": "Trasplante autólogo de médula ósea con purgado"
 },
 {
  "CATALOG_KEY": "41.1",
  "PRO_NOMBRE": "Punción de bazo"
 },
 {
  "CATALOG_KEY": "41.2",
  "PRO_NOMBRE": "Esplenotomía"
 },
 {
  "CATALOG_KEY": "41.3",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre médula ósea y bazo"
 },
 {
  "CATALOG_KEY": "41.31",
  "PRO_NOMBRE": "Biopsia de médula ósea"
 },
 {
  "CATALOG_KEY": "41.32",
  "PRO_NOMBRE": "Biopsia cerrada [percutánea] [por aspiración] de bazo"
 },
 {
  "CATALOG_KEY": "41.33",
  "PRO_NOMBRE": "Biopsia abierta de bazo"
 },
 {
  "CATALOG_KEY": "41.38",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre médula ósea"
 },
 {
  "CATALOG_KEY": "41.39",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre bazo"
 },
 {
  "CATALOG_KEY": "41.4",
  "PRO_NOMBRE": "Extirpación o destrucción de lesión o tejido de bazo"
 },
 {
  "CATALOG_KEY": "41.41",
  "PRO_NOMBRE": "Marsupialización de quiste esplénico"
 },
 {
  "CATALOG_KEY": "41.42",
  "PRO_NOMBRE": "Extirpación de lesión o tejido de bazo"
 },
 {
  "CATALOG_KEY": "41.43",
  "PRO_NOMBRE": "Esplenectomía parcial"
 },
 {
  "CATALOG_KEY": "41.5",
  "PRO_NOMBRE": "Esplenectomía total"
 },
 {
  "CATALOG_KEY": "41.9",
  "PRO_NOMBRE": "Otras operaciones sobre bazo y médula ósea"
 },
 {
  "CATALOG_KEY": "41.91",
  "PRO_NOMBRE": "Aspiración de médula ósea de donante para trasplante"
 },
 {
  "CATALOG_KEY": "41.92",
  "PRO_NOMBRE": "Inyección de médula ósea"
 },
 {
  "CATALOG_KEY": "41.93",
  "PRO_NOMBRE": "Extirpación de bazo accesorio"
 },
 {
  "CATALOG_KEY": "41.94",
  "PRO_NOMBRE": "Trasplante de bazo"
 },
 {
  "CATALOG_KEY": "41.95",
  "PRO_NOMBRE": "Operaciones de reparación y plásticas sobre bazo"
 },
 {
  "CATALOG_KEY": "41.98",
  "PRO_NOMBRE": "Otras operaciones sobre médula ósea"
 },
 {
  "CATALOG_KEY": "41.99",
  "PRO_NOMBRE": "Otras operaciones sobre bazo"
 },
 {
  "CATALOG_KEY": "42",
  "PRO_NOMBRE": "Operaciones sobre esófago"
 },
 {
  "CATALOG_KEY": "42.0",
  "PRO_NOMBRE": "Esofagotomía"
 },
 {
  "CATALOG_KEY": "42.01",
  "PRO_NOMBRE": "Incisión de membrana esofágica"
 },
 {
  "CATALOG_KEY": "42.09",
  "PRO_NOMBRE": "Otra incisión de esófago"
 },
 {
  "CATALOG_KEY": "42.1",
  "PRO_NOMBRE": "Esofagostomía"
 },
 {
  "CATALOG_KEY": "42.10",
  "PRO_NOMBRE": "Esofagostomía, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "42.11",
  "PRO_NOMBRE": "Esofagostomía cervical"
 },
 {
  "CATALOG_KEY": "42.12",
  "PRO_NOMBRE": "Exteriorización de bolsa esofágica"
 },
 {
  "CATALOG_KEY": "42.19",
  "PRO_NOMBRE": "Otra fistulización externa de esófago"
 },
 {
  "CATALOG_KEY": "42.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre esófago"
 },
 {
  "CATALOG_KEY": "42.21",
  "PRO_NOMBRE": "Esofagoscopia operatoria por incisión"
 },
 {
  "CATALOG_KEY": "42.22",
  "PRO_NOMBRE": "Esofagoscopia a través de estoma artificial"
 },
 {
  "CATALOG_KEY": "42.23",
  "PRO_NOMBRE": "Otra esofagoscopia"
 },
 {
  "CATALOG_KEY": "42.24",
  "PRO_NOMBRE": "Biopsia de esófago cerrada [endoscópica]"
 },
 {
  "CATALOG_KEY": "42.25",
  "PRO_NOMBRE": "Biopsia abierta de esófago"
 },
 {
  "CATALOG_KEY": "42.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre esófago"
 },
 {
  "CATALOG_KEY": "42.3",
  "PRO_NOMBRE": "Extirpación local o eliminación (destrucción) de lesión o tejido de esófago"
 },
 {
  "CATALOG_KEY": "42.31",
  "PRO_NOMBRE": "Extirpación local de divertículo esofágico"
 },
 {
  "CATALOG_KEY": "42.32",
  "PRO_NOMBRE": "Extirpación local de otra lesión o tejido de esófago"
 },
 {
  "CATALOG_KEY": "42.33",
  "PRO_NOMBRE": "Extirpación o eliminación (destrucción) endoscópica de lesión o de tejido del esófago"
 },
 {
  "CATALOG_KEY": "42.39",
  "PRO_NOMBRE": "Otra extirpación de lesión o tejido de esófago"
 },
 {
  "CATALOG_KEY": "42.4",
  "PRO_NOMBRE": "Extirpación de esófago"
 },
 {
  "CATALOG_KEY": "42.40",
  "PRO_NOMBRE": "Esofaguectomía, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "42.41",
  "PRO_NOMBRE": "Esofaguectomía parcial"
 },
 {
  "CATALOG_KEY": "42.42",
  "PRO_NOMBRE": "Esofaguectomía total"
 },
 {
  "CATALOG_KEY": "42.5",
  "PRO_NOMBRE": "Anastomosis intratorácica (o cervical) de esófago"
 },
 {
  "CATALOG_KEY": "42.51",
  "PRO_NOMBRE": "Esofagoesofagostomía intratorácica (o cervical)"
 },
 {
  "CATALOG_KEY": "42.52",
  "PRO_NOMBRE": "Esofagogastrostomía intratorácica (o cervical)"
 },
 {
  "CATALOG_KEY": "42.53",
  "PRO_NOMBRE": "Anastomosis esofágica intratorácica (o cervical) con interposición del intestino delgado"
 },
 {
  "CATALOG_KEY": "42.54",
  "PRO_NOMBRE": "Otra esofagoenterostomía intratorácica (o cervical)"
 },
 {
  "CATALOG_KEY": "42.55",
  "PRO_NOMBRE": "Anastomosis esofágica intratorácica (o cervical) con interposición de colon"
 },
 {
  "CATALOG_KEY": "42.56",
  "PRO_NOMBRE": "Otra esofagocolostomía intratorácica (o cervical)"
 },
 {
  "CATALOG_KEY": "42.58",
  "PRO_NOMBRE": "Anastomosis esofágica intratorácica (o cervical) con otra interposición"
 },
 {
  "CATALOG_KEY": "42.59",
  "PRO_NOMBRE": "Otra anastomosis intratorácica de esófago"
 },
 {
  "CATALOG_KEY": "42.6",
  "PRO_NOMBRE": "Anastomosis pre o retroesternal de esófago"
 },
 {
  "CATALOG_KEY": "42.61",
  "PRO_NOMBRE": "Esofagoesofagostomía pre (o retroesternal)"
 },
 {
  "CATALOG_KEY": "42.62",
  "PRO_NOMBRE": "Esofagogastrostomía pre (o retroesternal)"
 },
 {
  "CATALOG_KEY": "42.63",
  "PRO_NOMBRE": "Anastomosis esofágica pre (o retroesternal) con interposición de intestino delgado"
 },
 {
  "CATALOG_KEY": "42.64",
  "PRO_NOMBRE": "Otra esofagoenterostomía pre (o retroesternal)"
 },
 {
  "CATALOG_KEY": "42.65",
  "PRO_NOMBRE": "Anastomosis esofágica pre (o retroesternal) con interposición de colon"
 },
 {
  "CATALOG_KEY": "42.66",
  "PRO_NOMBRE": "Otra esofagocolostomía pre (o retroesternal)"
 },
 {
  "CATALOG_KEY": "42.68",
  "PRO_NOMBRE": "Otra anastomosis esofágica pre (o retroesternal) con interposición"
 },
 {
  "CATALOG_KEY": "42.69",
  "PRO_NOMBRE": "Otra anastomosis pre (o retroesternal) de esófago"
 },
 {
  "CATALOG_KEY": "42.7",
  "PRO_NOMBRE": "Esofagomiotomía"
 },
 {
  "CATALOG_KEY": "42.8",
  "PRO_NOMBRE": "Otra reparación de esófago"
 },
 {
  "CATALOG_KEY": "42.81",
  "PRO_NOMBRE": "Inserción de tubo o prótesis permanente en esófago"
 },
 {
  "CATALOG_KEY": "42.82",
  "PRO_NOMBRE": "Sutura de laceración, desgarro o herida del esófago"
 },
 {
  "CATALOG_KEY": "42.83",
  "PRO_NOMBRE": "Cierre de esofagostomía"
 },
 {
  "CATALOG_KEY": "42.84",
  "PRO_NOMBRE": "Reparación de fístula esofágica, no especificada bajo otro concepto"
 },
 {
  "CATALOG_KEY": "42.85",
  "PRO_NOMBRE": "Reparación de estenosis esofágica"
 },
 {
  "CATALOG_KEY": "42.86",
  "PRO_NOMBRE": "Creación de túnel subcutáneo sin anastomosis esofágica"
 },
 {
  "CATALOG_KEY": "42.87",
  "PRO_NOMBRE": "Otro injerto de esófago"
 },
 {
  "CATALOG_KEY": "42.89",
  "PRO_NOMBRE": "Otra reparación de esófago"
 },
 {
  "CATALOG_KEY": "42.9",
  "PRO_NOMBRE": "Otras operaciones de esófago"
 },
 {
  "CATALOG_KEY": "42.91",
  "PRO_NOMBRE": "Ligadura de várices esofágicas"
 },
 {
  "CATALOG_KEY": "42.92",
  "PRO_NOMBRE": "Dilatación de esófago"
 },
 {
  "CATALOG_KEY": "42.99",
  "PRO_NOMBRE": "Otra operación de esófago"
 },
 {
  "CATALOG_KEY": "43",
  "PRO_NOMBRE": "Incisión y extirpación del estómago"
 },
 {
  "CATALOG_KEY": "43.0",
  "PRO_NOMBRE": "Gastrotomía"
 },
 {
  "CATALOG_KEY": "43.1",
  "PRO_NOMBRE": "Gastrostomía"
 },
 {
  "CATALOG_KEY": "43.11",
  "PRO_NOMBRE": "Gastrostomía percutánea [endoscópica] (PEG)"
 },
 {
  "CATALOG_KEY": "43.19",
  "PRO_NOMBRE": "Otra gastrostomía"
 },
 {
  "CATALOG_KEY": "43.3",
  "PRO_NOMBRE": "Piloromiotomía"
 },
 {
  "CATALOG_KEY": "43.4",
  "PRO_NOMBRE": "Extirpación local o eliminación (destrucción) endoscópica de lesión o de tejido de estómago"
 },
 {
  "CATALOG_KEY": "43.41",
  "PRO_NOMBRE": "Extirpación o eliminación (destrucción) endoscópica de lesión o de tejido del estómago"
 },
 {
  "CATALOG_KEY": "43.42",
  "PRO_NOMBRE": "Extirpación local de otra lesión o de tejido del estómago"
 },
 {
  "CATALOG_KEY": "43.49",
  "PRO_NOMBRE": "Otra eliminación (destrucción) de lesión o tejido de estómago"
 },
 {
  "CATALOG_KEY": "43.5",
  "PRO_NOMBRE": "Gastrectomía parcial con anastomosis al esófago"
 },
 {
  "CATALOG_KEY": "43.6",
  "PRO_NOMBRE": "Gastrectomía parcial con anastomosis al duodeno"
 },
 {
  "CATALOG_KEY": "43.7",
  "PRO_NOMBRE": "Gastrectomía parcial con anastomosis al yeyuno"
 },
 {
  "CATALOG_KEY": "43.8",
  "PRO_NOMBRE": "Otra gastrectomía parcial"
 },
 {
  "CATALOG_KEY": "43.81",
  "PRO_NOMBRE": "Gastrectomía parcial con transposición yeyunal"
 },
 {
  "CATALOG_KEY": "43.89",
  "PRO_NOMBRE": "Otra gastrectomía parcial"
 },
 {
  "CATALOG_KEY": "43.9",
  "PRO_NOMBRE": "Gastrectomía total"
 },
 {
  "CATALOG_KEY": "43.91",
  "PRO_NOMBRE": "Gastrectomía total con interposición intestinal"
 },
 {
  "CATALOG_KEY": "43.99",
  "PRO_NOMBRE": "Otra gastrectomía total"
 },
 {
  "CATALOG_KEY": "44",
  "PRO_NOMBRE": "Otras operaciones sobre el estómago"
 },
 {
  "CATALOG_KEY": "44.0",
  "PRO_NOMBRE": "Vagotomía"
 },
 {
  "CATALOG_KEY": "44.00",
  "PRO_NOMBRE": "Vagotomía, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "44.01",
  "PRO_NOMBRE": "Vagotomía troncular"
 },
 {
  "CATALOG_KEY": "44.02",
  "PRO_NOMBRE": "Vagotomía supraselectiva"
 },
 {
  "CATALOG_KEY": "44.03",
  "PRO_NOMBRE": "Otra vagotomía selectiva"
 },
 {
  "CATALOG_KEY": "44.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre estómago"
 },
 {
  "CATALOG_KEY": "44.11",
  "PRO_NOMBRE": "Gastroscopia transabdominal"
 },
 {
  "CATALOG_KEY": "44.12",
  "PRO_NOMBRE": "Gastroscopia a través de estoma artificial"
 },
 {
  "CATALOG_KEY": "44.13",
  "PRO_NOMBRE": "Otra gastroscopia"
 },
 {
  "CATALOG_KEY": "44.14",
  "PRO_NOMBRE": "Biopsia cerrada de estómago [endoscópica]"
 },
 {
  "CATALOG_KEY": "44.15",
  "PRO_NOMBRE": "Biopsia abierta del estómago"
 },
 {
  "CATALOG_KEY": "44.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre estómago"
 },
 {
  "CATALOG_KEY": "44.2",
  "PRO_NOMBRE": "Píloroplastía"
 },
 {
  "CATALOG_KEY": "44.21",
  "PRO_NOMBRE": "Dilatación de píloro mediante incisión"
 },
 {
  "CATALOG_KEY": "44.22",
  "PRO_NOMBRE": "Dilatación endoscópica de píloro"
 },
 {
  "CATALOG_KEY": "44.29",
  "PRO_NOMBRE": "Otra píloroplastía"
 },
 {
  "CATALOG_KEY": "44.3",
  "PRO_NOMBRE": "Gastroenterostomía sin gastrectomía"
 },
 {
  "CATALOG_KEY": "44.31",
  "PRO_NOMBRE": "Desviación gástrica proximal"
 },
 {
  "CATALOG_KEY": "44.32",
  "PRO_NOMBRE": "Gastroyeyunostomía percutánea [endoscópica]"
 },
 {
  "CATALOG_KEY": "44.38",
  "PRO_NOMBRE": "Gastroenterostomía laparoscópica"
 },
 {
  "CATALOG_KEY": "44.39",
  "PRO_NOMBRE": "Otra gastroenterostomía"
 },
 {
  "CATALOG_KEY": "44.4",
  "PRO_NOMBRE": "Control de hemorragia y sutura de úlcera gástrica o duodenal"
 },
 {
  "CATALOG_KEY": "44.40",
  "PRO_NOMBRE": "Sutura de úlcera péptica no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "44.41",
  "PRO_NOMBRE": "Sutura de úlcera gástrica"
 },
 {
  "CATALOG_KEY": "44.42",
  "PRO_NOMBRE": "Sutura de úlcera duodenal"
 },
 {
  "CATALOG_KEY": "44.43",
  "PRO_NOMBRE": "Control endoscópico de hemorragia gástrica o duodenal"
 },
 {
  "CATALOG_KEY": "44.44",
  "PRO_NOMBRE": "Embolización por catéter de una hemorragia gástrica o duodenal"
 },
 {
  "CATALOG_KEY": "44.49",
  "PRO_NOMBRE": "Otro control de hemorragia de estómago o duodeno"
 },
 {
  "CATALOG_KEY": "44.5",
  "PRO_NOMBRE": "Revisión de anastomosis gástrica"
 },
 {
  "CATALOG_KEY": "44.6",
  "PRO_NOMBRE": "Otra reparación de estómago"
 },
 {
  "CATALOG_KEY": "44.61",
  "PRO_NOMBRE": "Sutura de desgarro, lesión o herida del estómago"
 },
 {
  "CATALOG_KEY": "44.62",
  "PRO_NOMBRE": "Cierre de gastrostomía"
 },
 {
  "CATALOG_KEY": "44.63",
  "PRO_NOMBRE": "Cierre de otra fístula gástrica"
 },
 {
  "CATALOG_KEY": "44.64",
  "PRO_NOMBRE": "Gastropexia"
 },
 {
  "CATALOG_KEY": "44.65",
  "PRO_NOMBRE": "Esofagogastroplastía"
 },
 {
  "CATALOG_KEY": "44.66",
  "PRO_NOMBRE": "Otros procedimientos para la creación de competencia esfinteriana esofagogástrica"
 },
 {
  "CATALOG_KEY": "44.67",
  "PRO_NOMBRE": "Procedimientos laparoscópicos para creación de competencia del esfínter gastroesofágico"
 },
 {
  "CATALOG_KEY": "44.68",
  "PRO_NOMBRE": "Gastroplastía laparoscópica"
 },
 {
  "CATALOG_KEY": "44.69",
  "PRO_NOMBRE": "Otra reparación de estómago"
 },
 {
  "CATALOG_KEY": "44.9",
  "PRO_NOMBRE": "Otras operaciones sobre el estómago"
 },
 {
  "CATALOG_KEY": "44.91",
  "PRO_NOMBRE": "Ligadura de várices gástricas"
 },
 {
  "CATALOG_KEY": "44.92",
  "PRO_NOMBRE": "Manipulación intraoperatoria del estómago"
 },
 {
  "CATALOG_KEY": "44.93",
  "PRO_NOMBRE": "Inserción de burbuja gástrica (balón)"
 },
 {
  "CATALOG_KEY": "44.94",
  "PRO_NOMBRE": "Extracción de burbuja gástrica (balón)"
 },
 {
  "CATALOG_KEY": "44.95",
  "PRO_NOMBRE": "Procedimiento laparoscópico gástrico restrictivo"
 },
 {
  "CATALOG_KEY": "44.96",
  "PRO_NOMBRE": "Revisión laparoscópica de procedimiento gástrico restrictivo"
 },
 {
  "CATALOG_KEY": "44.97",
  "PRO_NOMBRE": "Retiro laparoscópico de dispositivo gástrico restrictivo"
 },
 {
  "CATALOG_KEY": "44.98",
  "PRO_NOMBRE": "Ajuste (laparoscópico) de tamaño de dispositivo gástrico restrictivo ajustable"
 },
 {
  "CATALOG_KEY": "44.99",
  "PRO_NOMBRE": "Otras operaciones sobre el estómago"
 },
 {
  "CATALOG_KEY": "45",
  "PRO_NOMBRE": "Incisión, extirpación y anastomosis de intestino"
 },
 {
  "CATALOG_KEY": "45.0",
  "PRO_NOMBRE": "Enterotomía"
 },
 {
  "CATALOG_KEY": "45.00",
  "PRO_NOMBRE": "Incisión de intestino, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "45.01",
  "PRO_NOMBRE": "Incisión de duodeno"
 },
 {
  "CATALOG_KEY": "45.02",
  "PRO_NOMBRE": "Otra incisión de intestino delgado"
 },
 {
  "CATALOG_KEY": "45.03",
  "PRO_NOMBRE": "Incisión de intestino grueso"
 },
 {
  "CATALOG_KEY": "45.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre el intestino delgado"
 },
 {
  "CATALOG_KEY": "45.11",
  "PRO_NOMBRE": "Endoscopia transabdominal de intestino delgado"
 },
 {
  "CATALOG_KEY": "45.12",
  "PRO_NOMBRE": "Endoscopia de intestino delgado a través de estoma artificial"
 },
 {
  "CATALOG_KEY": "45.13",
  "PRO_NOMBRE": "Otra endoscopia de intestino delgado"
 },
 {
  "CATALOG_KEY": "45.14",
  "PRO_NOMBRE": "Biopsia cerrada [endoscópica] de intestino delgado"
 },
 {
  "CATALOG_KEY": "45.15",
  "PRO_NOMBRE": "Biopsia abierta de intestino delgado"
 },
 {
  "CATALOG_KEY": "45.16",
  "PRO_NOMBRE": "Esofagogastroduodenoscopia [EGD] con biopsia cerrada"
 },
 {
  "CATALOG_KEY": "45.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre intestino delgado"
 },
 {
  "CATALOG_KEY": "45.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre intestino grueso"
 },
 {
  "CATALOG_KEY": "45.21",
  "PRO_NOMBRE": "Endoscopia transabdominal de intestino grueso"
 },
 {
  "CATALOG_KEY": "45.22",
  "PRO_NOMBRE": "Endoscopia de intestino grueso a través de estoma artificial"
 },
 {
  "CATALOG_KEY": "45.23",
  "PRO_NOMBRE": "Colonoscopia"
 },
 {
  "CATALOG_KEY": "45.24",
  "PRO_NOMBRE": "Sigmoidoscopia flexible"
 },
 {
  "CATALOG_KEY": "45.25",
  "PRO_NOMBRE": "Biopsia cerrada [endoscópica] del intestino grueso"
 },
 {
  "CATALOG_KEY": "45.26",
  "PRO_NOMBRE": "Biopsia abierta de intestino grueso"
 },
 {
  "CATALOG_KEY": "45.27",
  "PRO_NOMBRE": "Biopsia intestinal, sitio no especificado"
 },
 {
  "CATALOG_KEY": "45.28",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre intestino grueso"
 },
 {
  "CATALOG_KEY": "45.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre intestino, sitio no especificado"
 },
 {
  "CATALOG_KEY": "45.3",
  "PRO_NOMBRE": "Extirpación local o eliminación (destrucción) de lesión o tejido de intestino delgado"
 },
 {
  "CATALOG_KEY": "45.30",
  "PRO_NOMBRE": "Extirpación o eliminación (destrucción) endoscópica de lesión de duodeno"
 },
 {
  "CATALOG_KEY": "45.31",
  "PRO_NOMBRE": "Otra extirpación local de lesión de duodeno"
 },
 {
  "CATALOG_KEY": "45.32",
  "PRO_NOMBRE": "Otras destrucciones o extirpaciones de lesión de duodeno"
 },
 {
  "CATALOG_KEY": "45.33",
  "PRO_NOMBRE": "Extirpación local de lesión o tejido de intestino delgado, excepto duodeno"
 },
 {
  "CATALOG_KEY": "45.34",
  "PRO_NOMBRE": "Otra eliminación (destrucción o extirpación) de lesión de intestino delgado, excepto el duodeno"
 },
 {
  "CATALOG_KEY": "45.4",
  "PRO_NOMBRE": "Extirpación local o eliminación (destrucción) de lesión o tejido de intestino grueso"
 },
 {
  "CATALOG_KEY": "45.41",
  "PRO_NOMBRE": "Extirpación de lesión o tejido de intestino grueso"
 },
 {
  "CATALOG_KEY": "45.42",
  "PRO_NOMBRE": "Polipectomía endoscópica del intestino grueso"
 },
 {
  "CATALOG_KEY": "45.43",
  "PRO_NOMBRE": "Destrucción endoscópica de otra lesión del intestino grueso"
 },
 {
  "CATALOG_KEY": "45.49",
  "PRO_NOMBRE": "Otra eliminación de lesión de intestino grueso"
 },
 {
  "CATALOG_KEY": "45.5",
  "PRO_NOMBRE": "Aislamiento de segmento intestinal"
 },
 {
  "CATALOG_KEY": "45.50",
  "PRO_NOMBRE": "Aislamiento de segmento intestinal, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "45.51",
  "PRO_NOMBRE": "Aislamiento de segmento de intestino delgado"
 },
 {
  "CATALOG_KEY": "45.52",
  "PRO_NOMBRE": "Aislamiento de segmento de intestino grueso"
 },
 {
  "CATALOG_KEY": "45.6",
  "PRO_NOMBRE": "Otra excisión de intestino delgado"
 },
 {
  "CATALOG_KEY": "45.61",
  "PRO_NOMBRE": "Resección segmentaria múltiple de intestino delgado"
 },
 {
  "CATALOG_KEY": "45.62",
  "PRO_NOMBRE": "Otra resección parcial de intestino delgado"
 },
 {
  "CATALOG_KEY": "45.63",
  "PRO_NOMBRE": "Resección total de intestino delgado"
 },
 {
  "CATALOG_KEY": "45.7",
  "PRO_NOMBRE": "Extirpación parcial abierta y otra extirpación parcial de intestino grueso"
 },
 {
  "CATALOG_KEY": "45.71",
  "PRO_NOMBRE": "Resección segmentaria múltiple abierta y otra resección segmentaria múltiple de intestino grueso"
 },
 {
  "CATALOG_KEY": "45.72",
  "PRO_NOMBRE": "Cecectomía abierta y otra cecectomía"
 },
 {
  "CATALOG_KEY": "45.73",
  "PRO_NOMBRE": "Hemicolectomía derecha abierta y otra hemicolectomía derecha"
 },
 {
  "CATALOG_KEY": "45.74",
  "PRO_NOMBRE": "Resección abierta de colon transverso y otra resección de colon transverso"
 },
 {
  "CATALOG_KEY": "45.75",
  "PRO_NOMBRE": "Hemicolectomía izquierda abierta y otra hemicolectomía izquierda"
 },
 {
  "CATALOG_KEY": "45.76",
  "PRO_NOMBRE": "Sigmoidectomía abierta y otra sigmoidectomía"
 },
 {
  "CATALOG_KEY": "45.79",
  "PRO_NOMBRE": "Otra excisión parcial y la no especificada de intestino grueso"
 },
 {
  "CATALOG_KEY": "45.7A",
  "PRO_NOMBRE": "Resección segmental múltiple de intestino grueso por laparoscopia"
 },
 {
  "CATALOG_KEY": "45.7B",
  "PRO_NOMBRE": "Ciegotomía laparoscópica"
 },
 {
  "CATALOG_KEY": "45.7C",
  "PRO_NOMBRE": "Hemicolectomía derecha por laparoscopía"
 },
 {
  "CATALOG_KEY": "45.7D",
  "PRO_NOMBRE": "Resección de colon transverso por laparoscopía"
 },
 {
  "CATALOG_KEY": "45.7E",
  "PRO_NOMBRE": "Hemicolectomía izquierda por laparoscopía"
 },
 {
  "CATALOG_KEY": "45.7F",
  "PRO_NOMBRE": "Sigmoidectomía por laparoscopía"
 },
 {
  "CATALOG_KEY": "45.7G",
  "PRO_NOMBRE": "Otra excisión parcial de intestino grueso por laparoscopía"
 },
 {
  "CATALOG_KEY": "45.8",
  "PRO_NOMBRE": "Colectomía intraabdominal total"
 },
 {
  "CATALOG_KEY": "45.81",
  "PRO_NOMBRE": "Colectomía intraabdominal total laparoscópica"
 },
 {
  "CATALOG_KEY": "45.82",
  "PRO_NOMBRE": "Colectomía intraabdominal total abierta"
 },
 {
  "CATALOG_KEY": "45.83",
  "PRO_NOMBRE": "Otra colectomía intraabdominal total y la no especificada"
 },
 {
  "CATALOG_KEY": "45.9",
  "PRO_NOMBRE": "Anastomosis intestinal"
 },
 {
  "CATALOG_KEY": "45.90",
  "PRO_NOMBRE": "Anastomosis intestinal, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "45.91",
  "PRO_NOMBRE": "Anastomosis de intestino delgado a intestino delgado"
 },
 {
  "CATALOG_KEY": "45.92",
  "PRO_NOMBRE": "Anastomosis de intestino delgado al muñón rectal"
 },
 {
  "CATALOG_KEY": "45.93",
  "PRO_NOMBRE": "Otra anastomosis de intestino delgado a intestino grueso"
 },
 {
  "CATALOG_KEY": "45.94",
  "PRO_NOMBRE": "Anastomosis de intestino grueso a intestino grueso"
 },
 {
  "CATALOG_KEY": "45.95",
  "PRO_NOMBRE": "Anastomosis al ano"
 },
 {
  "CATALOG_KEY": "46",
  "PRO_NOMBRE": "Otras operaciones sobre intestino"
 },
 {
  "CATALOG_KEY": "46.0",
  "PRO_NOMBRE": "Exteriorización de intestino"
 },
 {
  "CATALOG_KEY": "46.01",
  "PRO_NOMBRE": "Exteriorización de intestino delgado"
 },
 {
  "CATALOG_KEY": "46.02",
  "PRO_NOMBRE": "Resección de segmento exteriorizado de intestino delgado"
 },
 {
  "CATALOG_KEY": "46.03",
  "PRO_NOMBRE": "Exteriorización de intestino grueso"
 },
 {
  "CATALOG_KEY": "46.04",
  "PRO_NOMBRE": "Resección de segmento exteriorizado de intestino grueso"
 },
 {
  "CATALOG_KEY": "46.1",
  "PRO_NOMBRE": "Colostomía"
 },
 {
  "CATALOG_KEY": "46.10",
  "PRO_NOMBRE": "Colostomía, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "46.11",
  "PRO_NOMBRE": "Colostomía temporal"
 },
 {
  "CATALOG_KEY": "46.13",
  "PRO_NOMBRE": "Colostomía permanente"
 },
 {
  "CATALOG_KEY": "46.14",
  "PRO_NOMBRE": "Apertura retardada de colostomía"
 },
 {
  "CATALOG_KEY": "46.2",
  "PRO_NOMBRE": "lleostomía"
 },
 {
  "CATALOG_KEY": "46.20",
  "PRO_NOMBRE": "lleostomía, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "46.21",
  "PRO_NOMBRE": "lleostomía temporal"
 },
 {
  "CATALOG_KEY": "46.22",
  "PRO_NOMBRE": "lleostomía continente"
 },
 {
  "CATALOG_KEY": "46.23",
  "PRO_NOMBRE": "Otra ileostomía permanente"
 },
 {
  "CATALOG_KEY": "46.24",
  "PRO_NOMBRE": "Apertura retardada de ileostomía"
 },
 {
  "CATALOG_KEY": "46.3",
  "PRO_NOMBRE": "Otra enterostomía"
 },
 {
  "CATALOG_KEY": "46.31",
  "PRO_NOMBRE": "Apertura retardada de otra enterostomía"
 },
 {
  "CATALOG_KEY": "46.32",
  "PRO_NOMBRE": "Yeyunostomía percutánea [endoscópica] para alimentación [YPE]"
 },
 {
  "CATALOG_KEY": "46.39",
  "PRO_NOMBRE": "Otra enterostomía"
 },
 {
  "CATALOG_KEY": "46.4",
  "PRO_NOMBRE": "Revisión de estoma intestinal"
 },
 {
  "CATALOG_KEY": "46.40",
  "PRO_NOMBRE": "Revisión de estoma intestinal, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "46.41",
  "PRO_NOMBRE": "Revisión de estoma de intestino delgado"
 },
 {
  "CATALOG_KEY": "46.42",
  "PRO_NOMBRE": "Reparación de hernia pericolostomia"
 },
 {
  "CATALOG_KEY": "46.43",
  "PRO_NOMBRE": "Otra revisión de estoma de intestino grueso"
 },
 {
  "CATALOG_KEY": "46.5",
  "PRO_NOMBRE": "Cierre de estoma intestinal"
 },
 {
  "CATALOG_KEY": "46.50",
  "PRO_NOMBRE": "Cierre de estoma intestinal no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "46.51",
  "PRO_NOMBRE": "Cierre de estoma de intestino delgado"
 },
 {
  "CATALOG_KEY": "46.52",
  "PRO_NOMBRE": "Cierre de estoma de intestino grueso"
 },
 {
  "CATALOG_KEY": "46.6",
  "PRO_NOMBRE": "Fijación de intestino"
 },
 {
  "CATALOG_KEY": "46.60",
  "PRO_NOMBRE": "Fijación de intestino, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "46.61",
  "PRO_NOMBRE": "Fijación de intestino delgado a pared abdominal lleopexia"
 },
 {
  "CATALOG_KEY": "46.62",
  "PRO_NOMBRE": "Otra fijación de intestino delgado"
 },
 {
  "CATALOG_KEY": "46.63",
  "PRO_NOMBRE": "Fijación de intestino grueso a pared abdominal"
 },
 {
  "CATALOG_KEY": "46.64",
  "PRO_NOMBRE": "Otra fijación de intestino grueso"
 },
 {
  "CATALOG_KEY": "46.7",
  "PRO_NOMBRE": "Otra reparación de intestino"
 },
 {
  "CATALOG_KEY": "46.71",
  "PRO_NOMBRE": "Sutura de herida de duodeno"
 },
 {
  "CATALOG_KEY": "46.72",
  "PRO_NOMBRE": "Cierre de fístula de duodeno"
 },
 {
  "CATALOG_KEY": "46.73",
  "PRO_NOMBRE": "Sutura de herida de intestino delgado, excepto duodeno"
 },
 {
  "CATALOG_KEY": "46.74",
  "PRO_NOMBRE": "Cierre de fístula de intestino delgado, excepto duodeno"
 },
 {
  "CATALOG_KEY": "46.75",
  "PRO_NOMBRE": "Sutura de herida de intestino grueso"
 },
 {
  "CATALOG_KEY": "46.76",
  "PRO_NOMBRE": "Cierre de fístula de intestino grueso"
 },
 {
  "CATALOG_KEY": "46.79",
  "PRO_NOMBRE": "Otra reparación de intestino"
 },
 {
  "CATALOG_KEY": "46.8",
  "PRO_NOMBRE": "Dilatación y manipulación de intestino"
 },
 {
  "CATALOG_KEY": "46.80",
  "PRO_NOMBRE": "Manipulación intraabdominal de intestino, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "46.81",
  "PRO_NOMBRE": "Manipulación intraabdominal de intestino delgado"
 },
 {
  "CATALOG_KEY": "46.82",
  "PRO_NOMBRE": "Manipulación intraabdominal de intestino grueso"
 },
 {
  "CATALOG_KEY": "46.85",
  "PRO_NOMBRE": "Dilatación del intestino"
 },
 {
  "CATALOG_KEY": "46.9",
  "PRO_NOMBRE": "Otras operaciones sobre intestinos"
 },
 {
  "CATALOG_KEY": "46.91",
  "PRO_NOMBRE": "Miotomía del colon sigmoideo"
 },
 {
  "CATALOG_KEY": "46.92",
  "PRO_NOMBRE": "Miotomía de otras partes del colon"
 },
 {
  "CATALOG_KEY": "46.93",
  "PRO_NOMBRE": "Revisión de anastomosis de intestino delgado"
 },
 {
  "CATALOG_KEY": "46.94",
  "PRO_NOMBRE": "Revisión de anastomosis de intestino grueso"
 },
 {
  "CATALOG_KEY": "46.95",
  "PRO_NOMBRE": "Perfusión local de intestino delgado"
 },
 {
  "CATALOG_KEY": "46.96",
  "PRO_NOMBRE": "Perfusión local del intestino grueso"
 },
 {
  "CATALOG_KEY": "46.97",
  "PRO_NOMBRE": "Trasplante de intestino"
 },
 {
  "CATALOG_KEY": "46.99",
  "PRO_NOMBRE": "Otras operaciones sobre intestinos lleoentectropia"
 },
 {
  "CATALOG_KEY": "47",
  "PRO_NOMBRE": "Operaciones sobre apéndice"
 },
 {
  "CATALOG_KEY": "47.0",
  "PRO_NOMBRE": "Apendicectomía"
 },
 {
  "CATALOG_KEY": "47.01",
  "PRO_NOMBRE": "Apendicectomía laparoscópica"
 },
 {
  "CATALOG_KEY": "47.09",
  "PRO_NOMBRE": "Otra apendicectomía"
 },
 {
  "CATALOG_KEY": "47.1",
  "PRO_NOMBRE": "Apendicectomía incidental"
 },
 {
  "CATALOG_KEY": "47.11",
  "PRO_NOMBRE": "Apendicectomía incidental laparoscópica"
 },
 {
  "CATALOG_KEY": "47.19",
  "PRO_NOMBRE": "Otra apendicectomía incidental"
 },
 {
  "CATALOG_KEY": "47.2",
  "PRO_NOMBRE": "Drenaje de absceso apendicular"
 },
 {
  "CATALOG_KEY": "47.9",
  "PRO_NOMBRE": "Otras operaciones sobre apéndice"
 },
 {
  "CATALOG_KEY": "47.91",
  "PRO_NOMBRE": "Apendicostomía"
 },
 {
  "CATALOG_KEY": "47.92",
  "PRO_NOMBRE": "Cierre de fístula de apéndice"
 },
 {
  "CATALOG_KEY": "47.99",
  "PRO_NOMBRE": "Otra operación de apéndice"
 },
 {
  "CATALOG_KEY": "48",
  "PRO_NOMBRE": "Operaciones sobre recto, rectosigmoide y tejido perirrectal"
 },
 {
  "CATALOG_KEY": "48.0",
  "PRO_NOMBRE": "Proctotomía"
 },
 {
  "CATALOG_KEY": "48.1",
  "PRO_NOMBRE": "Proctostomía"
 },
 {
  "CATALOG_KEY": "48.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre recto, rectosigmoide y tejido perirrectal"
 },
 {
  "CATALOG_KEY": "48.21",
  "PRO_NOMBRE": "Proctosigmoidoscopia transabdominal"
 },
 {
  "CATALOG_KEY": "48.22",
  "PRO_NOMBRE": "Proctosigmoidoscopia a través de estoma artificial"
 },
 {
  "CATALOG_KEY": "48.23",
  "PRO_NOMBRE": "Proctosigmoidoscopia rígida"
 },
 {
  "CATALOG_KEY": "48.24",
  "PRO_NOMBRE": "Biopsia cerrada [endoscópica] de recto"
 },
 {
  "CATALOG_KEY": "48.25",
  "PRO_NOMBRE": "Otra biopsia de recto"
 },
 {
  "CATALOG_KEY": "48.26",
  "PRO_NOMBRE": "Biopsia de tejido perirrectal"
 },
 {
  "CATALOG_KEY": "48.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre recto, rectosigmolde y tejido perirrectal"
 },
 {
  "CATALOG_KEY": "48.3",
  "PRO_NOMBRE": "Extirpación local o eliminación de lesión o tejido rectal"
 },
 {
  "CATALOG_KEY": "48.31",
  "PRO_NOMBRE": "Electrocoagulación radical de lesión o tejido rectal"
 },
 {
  "CATALOG_KEY": "48.32",
  "PRO_NOMBRE": "Otra electrocoagulación de lesión o tejido rectal"
 },
 {
  "CATALOG_KEY": "48.33",
  "PRO_NOMBRE": "Eliminación de lesión o tejido rectal por láser"
 },
 {
  "CATALOG_KEY": "48.34",
  "PRO_NOMBRE": "Eliminación de lesión o tejido rectal por criocirugía"
 },
 {
  "CATALOG_KEY": "48.35",
  "PRO_NOMBRE": "Extirpación local de lesión o tejido rectal"
 },
 {
  "CATALOG_KEY": "48.36",
  "PRO_NOMBRE": "Polipectomía endoscópica del recto"
 },
 {
  "CATALOG_KEY": "48.4",
  "PRO_NOMBRE": "Resección de recto con reconstrucción haciendo pasar el cebo colónico proximal a través de la luz del distal (pull-through)"
 },
 {
  "CATALOG_KEY": "48.40",
  "PRO_NOMBRE": "Resección tipo pull-through de recto, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "48.41",
  "PRO_NOMBRE": "Resección de submucosa de recto de Soave"
 },
 {
  "CATALOG_KEY": "48.42",
  "PRO_NOMBRE": "Resección tipo pull-through de recto laparoscópica"
 },
 {
  "CATALOG_KEY": "48.43",
  "PRO_NOMBRE": "Resección tipo pull-through de recto abierta"
 },
 {
  "CATALOG_KEY": "48.49",
  "PRO_NOMBRE": "Otra resección de recto con reconstrucción tipo pull-through"
 },
 {
  "CATALOG_KEY": "48.5",
  "PRO_NOMBRE": "Resección abdominoperineal de recto"
 },
 {
  "CATALOG_KEY": "48.50",
  "PRO_NOMBRE": "Resección abdominoperineal de recto, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "48.51",
  "PRO_NOMBRE": "Resección abdominoperineal de recto laparoscópica"
 },
 {
  "CATALOG_KEY": "48.52",
  "PRO_NOMBRE": "Resección abdominoperineal de recto abierta"
 },
 {
  "CATALOG_KEY": "48.59",
  "PRO_NOMBRE": "Otra resección abdominoperineal de recto"
 },
 {
  "CATALOG_KEY": "48.6",
  "PRO_NOMBRE": "Otra resección de recto"
 },
 {
  "CATALOG_KEY": "48.61",
  "PRO_NOMBRE": "Rectosigmoidectomía transacra"
 },
 {
  "CATALOG_KEY": "48.62",
  "PRO_NOMBRE": "Resección anterior de recto con colostomía simultánea"
 },
 {
  "CATALOG_KEY": "48.63",
  "PRO_NOMBRE": "Otra resección anterior de recto"
 },
 {
  "CATALOG_KEY": "48.64",
  "PRO_NOMBRE": "Resección posterior de recto"
 },
 {
  "CATALOG_KEY": "48.65",
  "PRO_NOMBRE": "Resección de recto de Duhamel"
 },
 {
  "CATALOG_KEY": "48.69",
  "PRO_NOMBRE": "Otra resección de recto"
 },
 {
  "CATALOG_KEY": "48.7",
  "PRO_NOMBRE": "Reparación de recto"
 },
 {
  "CATALOG_KEY": "48.71",
  "PRO_NOMBRE": "Sutura de lesión de recto"
 },
 {
  "CATALOG_KEY": "48.72",
  "PRO_NOMBRE": "Cierre de proctostomía"
 },
 {
  "CATALOG_KEY": "48.73",
  "PRO_NOMBRE": "Cierre de otra fístula rectal"
 },
 {
  "CATALOG_KEY": "48.74",
  "PRO_NOMBRE": "Rectorrectostomía"
 },
 {
  "CATALOG_KEY": "48.75",
  "PRO_NOMBRE": "Proctopexia abdominal"
 },
 {
  "CATALOG_KEY": "48.76",
  "PRO_NOMBRE": "Otra proctopexia"
 },
 {
  "CATALOG_KEY": "48.79",
  "PRO_NOMBRE": "Otra reparación de recto"
 },
 {
  "CATALOG_KEY": "48.8",
  "PRO_NOMBRE": "Incisión o extirpación de tejido o lesión perirrectal"
 },
 {
  "CATALOG_KEY": "48.81",
  "PRO_NOMBRE": "Incisión de tejido perirrectal"
 },
 {
  "CATALOG_KEY": "48.82",
  "PRO_NOMBRE": "Excisión de tejido perirrectal"
 },
 {
  "CATALOG_KEY": "48.9",
  "PRO_NOMBRE": "Otras operaciones sobre recto y tejido perirrectal"
 },
 {
  "CATALOG_KEY": "48.91",
  "PRO_NOMBRE": "Incisión de estenosis rectal"
 },
 {
  "CATALOG_KEY": "48.92",
  "PRO_NOMBRE": "Miectomía anorrectal"
 },
 {
  "CATALOG_KEY": "48.93",
  "PRO_NOMBRE": "Reparación de fístula perirrectal"
 },
 {
  "CATALOG_KEY": "48.99",
  "PRO_NOMBRE": "Otra operación sobre recto y tejido perirrectal"
 },
 {
  "CATALOG_KEY": "49",
  "PRO_NOMBRE": "Operaciones sobre ano"
 },
 {
  "CATALOG_KEY": "49.0",
  "PRO_NOMBRE": "Incisión o extirpación de tejido perianal"
 },
 {
  "CATALOG_KEY": "49.01",
  "PRO_NOMBRE": "Incisión de absceso perianal"
 },
 {
  "CATALOG_KEY": "49.02",
  "PRO_NOMBRE": "Otra incisión de tejido perianal"
 },
 {
  "CATALOG_KEY": "49.03",
  "PRO_NOMBRE": "Extirpación de colgajos cutáneos perianales"
 },
 {
  "CATALOG_KEY": "49.04",
  "PRO_NOMBRE": "Otra extirpación de tejido perianal"
 },
 {
  "CATALOG_KEY": "49.1",
  "PRO_NOMBRE": "Incisión o extirpación de fístula anal"
 },
 {
  "CATALOG_KEY": "49.11",
  "PRO_NOMBRE": "Fistulotomía anal"
 },
 {
  "CATALOG_KEY": "49.12",
  "PRO_NOMBRE": "Fistulectomía anal"
 },
 {
  "CATALOG_KEY": "49.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre ano y tejido perianal"
 },
 {
  "CATALOG_KEY": "49.21",
  "PRO_NOMBRE": "Anoscopia"
 },
 {
  "CATALOG_KEY": "49.22",
  "PRO_NOMBRE": "Biopsia de tejido perianal"
 },
 {
  "CATALOG_KEY": "49.23",
  "PRO_NOMBRE": "Biopsia de ano"
 },
 {
  "CATALOG_KEY": "49.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre ano y tejido perianal"
 },
 {
  "CATALOG_KEY": "49.3",
  "PRO_NOMBRE": "Extirpación local o eliminación (destrucción) de otra lesión o tejido del ano"
 },
 {
  "CATALOG_KEY": "49.31",
  "PRO_NOMBRE": "Extirpación o eliminación (destrucción) endoscópica de lesión o de tejido del ano"
 },
 {
  "CATALOG_KEY": "49.39",
  "PRO_NOMBRE": "Otra extirpación local o eliminación (destrucción) de lesión o de tejido del ano"
 },
 {
  "CATALOG_KEY": "49.4",
  "PRO_NOMBRE": "Procedimientos sobre hemorroides"
 },
 {
  "CATALOG_KEY": "49.41",
  "PRO_NOMBRE": "Reducción de hemorroides"
 },
 {
  "CATALOG_KEY": "49.42",
  "PRO_NOMBRE": "Inyección (esclerosis) de hemorroides"
 },
 {
  "CATALOG_KEY": "49.43",
  "PRO_NOMBRE": "Cauterización de hemorroides"
 },
 {
  "CATALOG_KEY": "49.44",
  "PRO_NOMBRE": "Destrucción de hemorroides por crioterapia"
 },
 {
  "CATALOG_KEY": "49.45",
  "PRO_NOMBRE": "Ligamento de hemorroides"
 },
 {
  "CATALOG_KEY": "49.46",
  "PRO_NOMBRE": "Extirpación de hemorroides"
 },
 {
  "CATALOG_KEY": "49.47",
  "PRO_NOMBRE": "Evacuación de hemorroides trombosadas"
 },
 {
  "CATALOG_KEY": "49.49",
  "PRO_NOMBRE": "Otros procedimientos sobre hemorroides"
 },
 {
  "CATALOG_KEY": "49.5",
  "PRO_NOMBRE": "División (sección) de esfínter anal"
 },
 {
  "CATALOG_KEY": "49.51",
  "PRO_NOMBRE": "Esfinterotomía anal lateral izquierda"
 },
 {
  "CATALOG_KEY": "49.52",
  "PRO_NOMBRE": "Esfinterotomía anal posterior"
 },
 {
  "CATALOG_KEY": "49.59",
  "PRO_NOMBRE": "Otra esfinterotomía anal"
 },
 {
  "CATALOG_KEY": "49.6",
  "PRO_NOMBRE": "Excisión (extirpación) de ano"
 },
 {
  "CATALOG_KEY": "49.7",
  "PRO_NOMBRE": "Reparación de ano"
 },
 {
  "CATALOG_KEY": "49.71",
  "PRO_NOMBRE": "Sutura de laceración o desgarro de ano"
 },
 {
  "CATALOG_KEY": "49.72",
  "PRO_NOMBRE": "Implantación de un anillo en la circunferencia anal (cerclaje)"
 },
 {
  "CATALOG_KEY": "49.73",
  "PRO_NOMBRE": "Cierre de fístula anal"
 },
 {
  "CATALOG_KEY": "49.74",
  "PRO_NOMBRE": "Transposición del músculo recto interno para incontinencia anal"
 },
 {
  "CATALOG_KEY": "49.75",
  "PRO_NOMBRE": "Implantación o revisión de esfínter anal artificial"
 },
 {
  "CATALOG_KEY": "49.76",
  "PRO_NOMBRE": "Extracción de esfínter anal artificial"
 },
 {
  "CATALOG_KEY": "49.79",
  "PRO_NOMBRE": "Otra reparación de esfínter anal"
 },
 {
  "CATALOG_KEY": "49.9",
  "PRO_NOMBRE": "Otras operaciones sobre ano"
 },
 {
  "CATALOG_KEY": "49.91",
  "PRO_NOMBRE": "Incisión de tabique anal"
 },
 {
  "CATALOG_KEY": "49.92",
  "PRO_NOMBRE": "Inserción o implante de estimulador anal eléctrico subcutáneo"
 },
 {
  "CATALOG_KEY": "49.93",
  "PRO_NOMBRE": "Otra incisión de ano"
 },
 {
  "CATALOG_KEY": "49.94",
  "PRO_NOMBRE": "Reducción de prolapso anal"
 },
 {
  "CATALOG_KEY": "49.95",
  "PRO_NOMBRE": "Control de hemorragia (postoperatoria) de ano"
 },
 {
  "CATALOG_KEY": "49.99",
  "PRO_NOMBRE": "Otra operación sobre ano"
 },
 {
  "CATALOG_KEY": "50",
  "PRO_NOMBRE": "Operaciones sobre hígado"
 },
 {
  "CATALOG_KEY": "50.0",
  "PRO_NOMBRE": "Hepatotomía"
 },
 {
  "CATALOG_KEY": "50.1",
  "PRO_NOMBRE": "Procedimiento diagnóstico sobre hígado"
 },
 {
  "CATALOG_KEY": "50.11",
  "PRO_NOMBRE": "Biopsia cerrada [con aguja] (percutánea) de hígado"
 },
 {
  "CATALOG_KEY": "50.12",
  "PRO_NOMBRE": "Biopsia abierta de hígado"
 },
 {
  "CATALOG_KEY": "50.13",
  "PRO_NOMBRE": "Biopsia transyugular de hígado"
 },
 {
  "CATALOG_KEY": "50.14",
  "PRO_NOMBRE": "Biopsia de hígado por laparoscopía"
 },
 {
  "CATALOG_KEY": "50.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre hígado"
 },
 {
  "CATALOG_KEY": "50.2",
  "PRO_NOMBRE": "Extirpación local o eliminación (destrucción) de tejido o lesión de hígado"
 },
 {
  "CATALOG_KEY": "50.21",
  "PRO_NOMBRE": "Marsupialización de lesión de hígado"
 },
 {
  "CATALOG_KEY": "50.22",
  "PRO_NOMBRE": "Hepatectomía parcial (subtotal)"
 },
 {
  "CATALOG_KEY": "50.23",
  "PRO_NOMBRE": "Ablación abierta de lesión o tejido de hígado"
 },
 {
  "CATALOG_KEY": "50.24",
  "PRO_NOMBRE": "Ablación percutánea de lesión o tejido de hígado"
 },
 {
  "CATALOG_KEY": "50.25",
  "PRO_NOMBRE": "Ablación laparoscópica de lesión o tejido de hígado"
 },
 {
  "CATALOG_KEY": "50.26",
  "PRO_NOMBRE": "Otra ablación y la no especificada de lesión o tejido de hígado"
 },
 {
  "CATALOG_KEY": "50.29",
  "PRO_NOMBRE": "Otra destrucción de lesión de hígado"
 },
 {
  "CATALOG_KEY": "50.3",
  "PRO_NOMBRE": "Lobectomía hepática"
 },
 {
  "CATALOG_KEY": "50.4",
  "PRO_NOMBRE": "Hepatectomía total"
 },
 {
  "CATALOG_KEY": "50.5",
  "PRO_NOMBRE": "Trasplante de hígado"
 },
 {
  "CATALOG_KEY": "50.51",
  "PRO_NOMBRE": "Trasplante auxiliar de hígado"
 },
 {
  "CATALOG_KEY": "50.59",
  "PRO_NOMBRE": "Otro trasplante de hígado"
 },
 {
  "CATALOG_KEY": "50.6",
  "PRO_NOMBRE": "Reparación de hígado"
 },
 {
  "CATALOG_KEY": "50.61",
  "PRO_NOMBRE": "Sutura de lesión hepática"
 },
 {
  "CATALOG_KEY": "50.69",
  "PRO_NOMBRE": "Otra reparación de hígado"
 },
 {
  "CATALOG_KEY": "50.9",
  "PRO_NOMBRE": "Otras operaciones sobre hígado"
 },
 {
  "CATALOG_KEY": "50.91",
  "PRO_NOMBRE": "Aspiración percutánea de hígado"
 },
 {
  "CATALOG_KEY": "50.92",
  "PRO_NOMBRE": "Asistencia hepática extracorpórea"
 },
 {
  "CATALOG_KEY": "50.93",
  "PRO_NOMBRE": "Perfusión localizada de hígado"
 },
 {
  "CATALOG_KEY": "50.94",
  "PRO_NOMBRE": "Otra inyección de sustancia terapéutica en hígado"
 },
 {
  "CATALOG_KEY": "50.99",
  "PRO_NOMBRE": "Otra operación sobre hígado"
 },
 {
  "CATALOG_KEY": "51",
  "PRO_NOMBRE": "Operaciones sobre vesícula biliar y tracto biliar"
 },
 {
  "CATALOG_KEY": "51.0",
  "PRO_NOMBRE": "Colecistotomía y colecistostomía"
 },
 {
  "CATALOG_KEY": "51.01",
  "PRO_NOMBRE": "Aspiración percutánea de vesícula biliar"
 },
 {
  "CATALOG_KEY": "51.02",
  "PRO_NOMBRE": "Colecistostomía por trócar"
 },
 {
  "CATALOG_KEY": "51.03",
  "PRO_NOMBRE": "Otra colecistostomía"
 },
 {
  "CATALOG_KEY": "51.04",
  "PRO_NOMBRE": "Otra colecistotomía"
 },
 {
  "CATALOG_KEY": "51.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre la vía biliar principal"
 },
 {
  "CATALOG_KEY": "51.10",
  "PRO_NOMBRE": "Colangiopancreatografia retrógada endoscópica [CPRE]"
 },
 {
  "CATALOG_KEY": "51.11",
  "PRO_NOMBRE": "Colangiografía retrógrada endoscópica [CRE]"
 },
 {
  "CATALOG_KEY": "51.12",
  "PRO_NOMBRE": "Biopsia percutánea de vesícula biliar o vías biliares"
 },
 {
  "CATALOG_KEY": "51.13",
  "PRO_NOMBRE": "Biopsia abierta de vesícula biliar o conductos biliares"
 },
 {
  "CATALOG_KEY": "51.14",
  "PRO_NOMBRE": "Otra biopsia cerrada [endoscópica] de vías biliares o esfínter de Oddi"
 },
 {
  "CATALOG_KEY": "51.15",
  "PRO_NOMBRE": "Medición de la presión del esfínter de Oddi"
 },
 {
  "CATALOG_KEY": "51.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre los conductos biliares"
 },
 {
  "CATALOG_KEY": "51.2",
  "PRO_NOMBRE": "Colecistectomía"
 },
 {
  "CATALOG_KEY": "51.21",
  "PRO_NOMBRE": "Otra colecistectomía parcial"
 },
 {
  "CATALOG_KEY": "51.22",
  "PRO_NOMBRE": "Colecistectomía"
 },
 {
  "CATALOG_KEY": "51.23",
  "PRO_NOMBRE": "Colecistectomía laparoscópica"
 },
 {
  "CATALOG_KEY": "51.24",
  "PRO_NOMBRE": "Colecistectomía parcial laparoscópica"
 },
 {
  "CATALOG_KEY": "51.3",
  "PRO_NOMBRE": "Anastomosis de vesícula biliar o conducto biliar"
 },
 {
  "CATALOG_KEY": "51.31",
  "PRO_NOMBRE": "Anastomosis de vesícula biliar a conductos hepáticos"
 },
 {
  "CATALOG_KEY": "51.32",
  "PRO_NOMBRE": "Anastomosis de vesícula biliar a intestino"
 },
 {
  "CATALOG_KEY": "51.33",
  "PRO_NOMBRE": "Anastomosis de vesícula biliar a páncreas"
 },
 {
  "CATALOG_KEY": "51.34",
  "PRO_NOMBRE": "Anastomosis de vesícula biliar a estómago"
 },
 {
  "CATALOG_KEY": "51.35",
  "PRO_NOMBRE": "Otra anastomosis de vesícula biliar"
 },
 {
  "CATALOG_KEY": "51.36",
  "PRO_NOMBRE": "Coledocoenterostomía"
 },
 {
  "CATALOG_KEY": "51.37",
  "PRO_NOMBRE": "Anastomosis de conducto hepático a tracto gastrointestinal"
 },
 {
  "CATALOG_KEY": "51.39",
  "PRO_NOMBRE": "Otra anastomosis del conducto biliar"
 },
 {
  "CATALOG_KEY": "51.4",
  "PRO_NOMBRE": "Incisión del conducto biliar para alivio de obstrucción"
 },
 {
  "CATALOG_KEY": "51.41",
  "PRO_NOMBRE": "Exploración del conducto biliar principal para extracción de cálculo"
 },
 {
  "CATALOG_KEY": "51.42",
  "PRO_NOMBRE": "Exploración del conducto biliar principal para alivio de otra obstrucción"
 },
 {
  "CATALOG_KEY": "51.43",
  "PRO_NOMBRE": "Inserción de tubo coledocohepático para descompresión"
 },
 {
  "CATALOG_KEY": "51.49",
  "PRO_NOMBRE": "Incisión de otros conductos biliares para alivio de obstrucción"
 },
 {
  "CATALOG_KEY": "51.5",
  "PRO_NOMBRE": "Otra incisión del conducto biliar"
 },
 {
  "CATALOG_KEY": "51.51",
  "PRO_NOMBRE": "Exploración de colédoco"
 },
 {
  "CATALOG_KEY": "51.59",
  "PRO_NOMBRE": "Incisión de otro conducto biliar"
 },
 {
  "CATALOG_KEY": "51.6",
  "PRO_NOMBRE": "Extirpación local o eliminación (destrucción) de lesión o tejido de conductos biliares y esfínter de Oddi"
 },
 {
  "CATALOG_KEY": "51.61",
  "PRO_NOMBRE": "Extirpación de conducto cístico remanente (muñón cístico)"
 },
 {
  "CATALOG_KEY": "51.62",
  "PRO_NOMBRE": "Extirpación de ampolla de Vater (con reimplantación de colédoco)"
 },
 {
  "CATALOG_KEY": "51.63",
  "PRO_NOMBRE": "Otra extirpación de colédoco"
 },
 {
  "CATALOG_KEY": "51.64",
  "PRO_NOMBRE": "Extirpación o eliminación (destrucción) endoscópica de lesión de conductos biliares o de esfínter de Oddi"
 },
 {
  "CATALOG_KEY": "51.69",
  "PRO_NOMBRE": "Extirpación de otro conducto biliar"
 },
 {
  "CATALOG_KEY": "51.7",
  "PRO_NOMBRE": "Reparación de vías biliares"
 },
 {
  "CATALOG_KEY": "51.71",
  "PRO_NOMBRE": "Sutura simple de colédoco"
 },
 {
  "CATALOG_KEY": "51.72",
  "PRO_NOMBRE": "Coledocoplastía"
 },
 {
  "CATALOG_KEY": "51.79",
  "PRO_NOMBRE": "Reparación de otros conductos biliares"
 },
 {
  "CATALOG_KEY": "51.8",
  "PRO_NOMBRE": "Otras operaciones sobre conductos biliares y esfínter de Oddi"
 },
 {
  "CATALOG_KEY": "51.81",
  "PRO_NOMBRE": "Dilatación de esfínter de Oddi"
 },
 {
  "CATALOG_KEY": "51.82",
  "PRO_NOMBRE": "Esfinterotomía pancreática (y biliar)"
 },
 {
  "CATALOG_KEY": "51.83",
  "PRO_NOMBRE": "Esfinteroplastía pancreática (y biliar)"
 },
 {
  "CATALOG_KEY": "51.84",
  "PRO_NOMBRE": "Dilatación endoscópica de ampolla y conducto biliar"
 },
 {
  "CATALOG_KEY": "51.85",
  "PRO_NOMBRE": "Esfinterotomía y papilotomía endoscópicas"
 },
 {
  "CATALOG_KEY": "51.86",
  "PRO_NOMBRE": "Inserción endoscópica de tubo de drenaje nasobiliar"
 },
 {
  "CATALOG_KEY": "51.87",
  "PRO_NOMBRE": "Inserción endoscópica de tubo tutor (stent) en conducto biliar"
 },
 {
  "CATALOG_KEY": "51.88",
  "PRO_NOMBRE": "Extracción endoscópica de cálculo(s) del tracto biliar"
 },
 {
  "CATALOG_KEY": "51.89",
  "PRO_NOMBRE": "Otras operaciones sobre esfínter de Oddi"
 },
 {
  "CATALOG_KEY": "51.9",
  "PRO_NOMBRE": "Otras operaciones sobre el tracto biliar"
 },
 {
  "CATALOG_KEY": "51.91",
  "PRO_NOMBRE": "Reparación de lesión de vesícula biliar"
 },
 {
  "CATALOG_KEY": "51.92",
  "PRO_NOMBRE": "Cierre de colecistostomía"
 },
 {
  "CATALOG_KEY": "51.93",
  "PRO_NOMBRE": "Cierre de otra fístula biliar"
 },
 {
  "CATALOG_KEY": "51.94",
  "PRO_NOMBRE": "Revisión de anastomosis de las vías biliares"
 },
 {
  "CATALOG_KEY": "51.95",
  "PRO_NOMBRE": "Extracción de dispositivo protésico de vía biliar"
 },
 {
  "CATALOG_KEY": "51.96",
  "PRO_NOMBRE": "Extracción percutánea de cálculo en colédoco"
 },
 {
  "CATALOG_KEY": "51.98",
  "PRO_NOMBRE": "Otros procedimientos percutáneos sobre tracto biliar"
 },
 {
  "CATALOG_KEY": "51.99",
  "PRO_NOMBRE": "Otra operación sobre el tracto biliar"
 },
 {
  "CATALOG_KEY": "52",
  "PRO_NOMBRE": "Operaciones sobre páncreas"
 },
 {
  "CATALOG_KEY": "52.0",
  "PRO_NOMBRE": "Pancreatotomía"
 },
 {
  "CATALOG_KEY": "52.01",
  "PRO_NOMBRE": "Drenaje de quiste, pseudoquiste y absceso pancreático por catéter"
 },
 {
  "CATALOG_KEY": "52.09",
  "PRO_NOMBRE": "Otra pancreatotomía"
 },
 {
  "CATALOG_KEY": "52.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre páncreas"
 },
 {
  "CATALOG_KEY": "52.11",
  "PRO_NOMBRE": "Biopsia cerrada [aguja] [por aspiración] de páncreas"
 },
 {
  "CATALOG_KEY": "52.12",
  "PRO_NOMBRE": "Biopsia abierta de páncreas"
 },
 {
  "CATALOG_KEY": "52.13",
  "PRO_NOMBRE": "Pancreatografía retrógrada endoscópica [PRE]"
 },
 {
  "CATALOG_KEY": "52.14",
  "PRO_NOMBRE": "Biopsia cerrada [endoscópica] del conducto pancreático"
 },
 {
  "CATALOG_KEY": "52.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre páncreas"
 },
 {
  "CATALOG_KEY": "52.2",
  "PRO_NOMBRE": "Extirpación local o eliminación de páncreas y conducto pancreático"
 },
 {
  "CATALOG_KEY": "52.21",
  "PRO_NOMBRE": "Extirpación o eliminación (destrucción) endoscópica de lesión o de tejido del conducto pancreático"
 },
 {
  "CATALOG_KEY": "52.22",
  "PRO_NOMBRE": "Otra extirpación o eliminación (destrucción) de lesión o de tejido del páncreas o del conducto pancreático"
 },
 {
  "CATALOG_KEY": "52.3",
  "PRO_NOMBRE": "Marsupialización de quiste pancreático"
 },
 {
  "CATALOG_KEY": "52.4",
  "PRO_NOMBRE": "Drenaje interno de quiste y pseudoquiste pancreático"
 },
 {
  "CATALOG_KEY": "52.5",
  "PRO_NOMBRE": "Pancreatectomía parcial"
 },
 {
  "CATALOG_KEY": "52.51",
  "PRO_NOMBRE": "Pancreatectomía proximal"
 },
 {
  "CATALOG_KEY": "52.52",
  "PRO_NOMBRE": "Pancreatectomía distal"
 },
 {
  "CATALOG_KEY": "52.53",
  "PRO_NOMBRE": "Pancreatectomía subtotal radical"
 },
 {
  "CATALOG_KEY": "52.59",
  "PRO_NOMBRE": "Otra pancreatectomía parcial"
 },
 {
  "CATALOG_KEY": "52.6",
  "PRO_NOMBRE": "Pancreatectomía total"
 },
 {
  "CATALOG_KEY": "52.7",
  "PRO_NOMBRE": "Pancreaticoduodenectomía radical"
 },
 {
  "CATALOG_KEY": "52.8",
  "PRO_NOMBRE": "Trasplante de páncreas"
 },
 {
  "CATALOG_KEY": "52.80",
  "PRO_NOMBRE": "Trasplante de páncreas, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "52.81",
  "PRO_NOMBRE": "Reimplante de tejido pancreático"
 },
 {
  "CATALOG_KEY": "52.82",
  "PRO_NOMBRE": "Homotrasplante de páncreas"
 },
 {
  "CATALOG_KEY": "52.83",
  "PRO_NOMBRE": "Heterotrasplante de páncreas"
 },
 {
  "CATALOG_KEY": "52.84",
  "PRO_NOMBRE": "Autotrasplante de células de los islotes de Langerhans"
 },
 {
  "CATALOG_KEY": "52.85",
  "PRO_NOMBRE": "Alotrasplante de células de los islotes de Langerhans"
 },
 {
  "CATALOG_KEY": "52.86",
  "PRO_NOMBRE": "Trasplante de células de los islotes de Langerhans, no especificado"
 },
 {
  "CATALOG_KEY": "52.9",
  "PRO_NOMBRE": "Otras operaciones de páncreas"
 },
 {
  "CATALOG_KEY": "52.92",
  "PRO_NOMBRE": "Canulación del conducto pancreático"
 },
 {
  "CATALOG_KEY": "52.93",
  "PRO_NOMBRE": "Inserción de tubo tutor (stent) en el conducto pancreático"
 },
 {
  "CATALOG_KEY": "52.94",
  "PRO_NOMBRE": "Extracción endoscópica de cálculos del conducto pancreático"
 },
 {
  "CATALOG_KEY": "52.95",
  "PRO_NOMBRE": "Otra reparación de páncreas"
 },
 {
  "CATALOG_KEY": "52.96",
  "PRO_NOMBRE": "Anastomosis de páncreas"
 },
 {
  "CATALOG_KEY": "52.97",
  "PRO_NOMBRE": "Inserción endoscópica de tubo de drenaje nasopancreático"
 },
 {
  "CATALOG_KEY": "52.98",
  "PRO_NOMBRE": "Dilatación endoscópica del conducto pancreático"
 },
 {
  "CATALOG_KEY": "52.99",
  "PRO_NOMBRE": "Otra operación de páncreas"
 },
 {
  "CATALOG_KEY": "53",
  "PRO_NOMBRE": "Reparación de hernia"
 },
 {
  "CATALOG_KEY": "53.0",
  "PRO_NOMBRE": "Reparación unilateral de hernia inguinal"
 },
 {
  "CATALOG_KEY": "53.00",
  "PRO_NOMBRE": "Reparación unilateral de hernia inguinal, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "53.01",
  "PRO_NOMBRE": "Reparación abierta y otra reparación de hernia inguinal directa"
 },
 {
  "CATALOG_KEY": "53.02",
  "PRO_NOMBRE": "Reparación abierta y otra reparación de hernia inguinal indirecta"
 },
 {
  "CATALOG_KEY": "53.03",
  "PRO_NOMBRE": "Reparación abierta y otra reparación de hernia inguinal directa con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.04",
  "PRO_NOMBRE": "Reparación abierta y otra reparación de hernia inguinal indirecta con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.05",
  "PRO_NOMBRE": "Reparación de hernia inguinal con injerto o prótesis no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "53.0A",
  "PRO_NOMBRE": "Reparación laparoscópica de hernia inguinal directa con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.0B",
  "PRO_NOMBRE": "Reparación laparoscópica de hernia inguinal indirecta con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.0C",
  "PRO_NOMBRE": "Reparación laparoscópica de hernia inguinal con injerto o prótesis, sin otra especificación"
 },
 {
  "CATALOG_KEY": "53.1",
  "PRO_NOMBRE": "Reparación bilateral de hernia inguinal"
 },
 {
  "CATALOG_KEY": "53.10",
  "PRO_NOMBRE": "Reparación bilateral de hernia inguinal, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "53.11",
  "PRO_NOMBRE": "Reparación abierta y otra reparación bilateral de hernia inguinal directa"
 },
 {
  "CATALOG_KEY": "53.12",
  "PRO_NOMBRE": "Reparación abierta y otra reparación bilateral de hernia inguinal indirecta"
 },
 {
  "CATALOG_KEY": "53.13",
  "PRO_NOMBRE": "Reparación abierta y otra reparación bilateral de hernia inguinal, una directa y otra indirecta"
 },
 {
  "CATALOG_KEY": "53.14",
  "PRO_NOMBRE": "Reparación abierta y otra reparación bilateral de hernia inguinal directa con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.15",
  "PRO_NOMBRE": "Reparación abierta y otra reparación bilateral de hernia inguinal indirecta con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.16",
  "PRO_NOMBRE": "Reparación abierta y otra reparación bilateral de hernia inguinal, una directa y una indirecta, con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.17",
  "PRO_NOMBRE": "Reparación bilateral de hernia inguinal con injerto o prótesis, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "53.1A",
  "PRO_NOMBRE": "Reparación laparoscópica bilateral de hernia inguinal directa con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.1B",
  "PRO_NOMBRE": "Reparación laparoscópica bilateral de hernia inguinal indirecta con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.1C",
  "PRO_NOMBRE": "Reparación laparoscópica bilateral de hernia inguinal, una directa y una indirecta, con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.1D",
  "PRO_NOMBRE": "Reparación laparoscópica bilateral de hernia inguinal con injerto o prótesis, sin otra especificación"
 },
 {
  "CATALOG_KEY": "53.2",
  "PRO_NOMBRE": "Reparación unilateral de hernia crural (femoral)"
 },
 {
  "CATALOG_KEY": "53.21",
  "PRO_NOMBRE": "Reparación unilateral de hernia crural con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.29",
  "PRO_NOMBRE": "Otra herniorrafia de hernia crural unilateral"
 },
 {
  "CATALOG_KEY": "53.3",
  "PRO_NOMBRE": "Reparación bilateral de hernia crural"
 },
 {
  "CATALOG_KEY": "53.31",
  "PRO_NOMBRE": "Reparación bilateral de hernia crural con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.39",
  "PRO_NOMBRE": "Otra herniorrafia crural bilateral"
 },
 {
  "CATALOG_KEY": "53.4",
  "PRO_NOMBRE": "Reparación de hernia umbilical"
 },
 {
  "CATALOG_KEY": "53.41",
  "PRO_NOMBRE": "Reparación abierta y otra reparación de hernia umbilical con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.42",
  "PRO_NOMBRE": "Reparación laparoscópica de hernia umbilical con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.43",
  "PRO_NOMBRE": "Otra reparación laparoscópica de hernia umbilical"
 },
 {
  "CATALOG_KEY": "53.49",
  "PRO_NOMBRE": "Otra herniorrafia umbilical abierta"
 },
 {
  "CATALOG_KEY": "53.5",
  "PRO_NOMBRE": "Reparación de otra hernia de la pared abdominal anterior (sin injerto ni prótesis)"
 },
 {
  "CATALOG_KEY": "53.51",
  "PRO_NOMBRE": "Reparación de hernia incisional (eventración)"
 },
 {
  "CATALOG_KEY": "53.59",
  "PRO_NOMBRE": "Reparación de otra hernia de la pared abdominal anterior"
 },
 {
  "CATALOG_KEY": "53.6",
  "PRO_NOMBRE": "Reparación de otra hernia de la pared abdominal anterior con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.61",
  "PRO_NOMBRE": "Otra reparación abierta de hernia incisional (eventración) con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.62",
  "PRO_NOMBRE": "Reparación laparoscópica de hernia incisional con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.63",
  "PRO_NOMBRE": "Otra reparación laparoscópica de otra hernia de pared abdominal anterior con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.69",
  "PRO_NOMBRE": "Reparación abierta y otra reparación de otra hernia de la pared abdominal anterior con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "53.7",
  "PRO_NOMBRE": "Reparación de hernia diafragmática, abordaje abdominal"
 },
 {
  "CATALOG_KEY": "53.71",
  "PRO_NOMBRE": "Reparación laparoscópica de hernia diafragmática, abordaje abdominal"
 },
 {
  "CATALOG_KEY": "53.72",
  "PRO_NOMBRE": "Reparación abierta y otra reparación de hernia diafragmática, abordaje abdominal"
 },
 {
  "CATALOG_KEY": "53.75",
  "PRO_NOMBRE": "Reparación de hernia diafragmática, abordaje abdominal, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "53.8",
  "PRO_NOMBRE": "Reparación de hernia diafragmática, acceso torácico"
 },
 {
  "CATALOG_KEY": "53.80",
  "PRO_NOMBRE": "Reparación de hernia diafragmática con acceso torácico, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "53.81",
  "PRO_NOMBRE": "Plicatura de diafragma"
 },
 {
  "CATALOG_KEY": "53.82",
  "PRO_NOMBRE": "Reparación de hernia parasternal (Morgagni)"
 },
 {
  "CATALOG_KEY": "53.83",
  "PRO_NOMBRE": "Reparación laparoscópica de hernia diafragmática, con abordaje torácico"
 },
 {
  "CATALOG_KEY": "53.84",
  "PRO_NOMBRE": "Reparación abierta y otra reparación de hernia diafragmática, abordaje torácico"
 },
 {
  "CATALOG_KEY": "53.9",
  "PRO_NOMBRE": "Otra reparación de hernia"
 },
 {
  "CATALOG_KEY": "54",
  "PRO_NOMBRE": "Otras operaciones sobre la región abdominal"
 },
 {
  "CATALOG_KEY": "54.0",
  "PRO_NOMBRE": "Incisión de pared abdominal"
 },
 {
  "CATALOG_KEY": "54.1",
  "PRO_NOMBRE": "Laparotomía"
 },
 {
  "CATALOG_KEY": "54.11",
  "PRO_NOMBRE": "Laparotomía exploradora"
 },
 {
  "CATALOG_KEY": "54.12",
  "PRO_NOMBRE": "Reapertura de laparotomía reciente"
 },
 {
  "CATALOG_KEY": "54.19",
  "PRO_NOMBRE": "Otra laparotomía"
 },
 {
  "CATALOG_KEY": "54.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos de la región abdominal"
 },
 {
  "CATALOG_KEY": "54.21",
  "PRO_NOMBRE": "Laparoscopia"
 },
 {
  "CATALOG_KEY": "54.22",
  "PRO_NOMBRE": "Biopsia de pared abdominal u ombligo"
 },
 {
  "CATALOG_KEY": "54.23",
  "PRO_NOMBRE": "Biopsia de peritoneo"
 },
 {
  "CATALOG_KEY": "54.24",
  "PRO_NOMBRE": "Biopsia cerrada [con aguja] [percutánea] de masa intraabdominal"
 },
 {
  "CATALOG_KEY": "54.25",
  "PRO_NOMBRE": "Lavado peritoneal"
 },
 {
  "CATALOG_KEY": "54.29",
  "PRO_NOMBRE": "Endoscopia diagnostica"
 },
 {
  "CATALOG_KEY": "54.3",
  "PRO_NOMBRE": "Excisión o eliminación de lesión o tejido de pared abdominal u ombligo"
 },
 {
  "CATALOG_KEY": "54.4",
  "PRO_NOMBRE": "Excisión o eliminación de tejido peritoneal"
 },
 {
  "CATALOG_KEY": "54.5",
  "PRO_NOMBRE": "Lisis de adherencias peritoneales"
 },
 {
  "CATALOG_KEY": "54.51",
  "PRO_NOMBRE": "Lisis laparoscópica de adherencias peritoneales"
 },
 {
  "CATALOG_KEY": "54.59",
  "PRO_NOMBRE": "Otras lisis de adherencias peritoneales"
 },
 {
  "CATALOG_KEY": "54.6",
  "PRO_NOMBRE": "Sutura de pared abdominal y peritoneo"
 },
 {
  "CATALOG_KEY": "54.61",
  "PRO_NOMBRE": "Nuevo cierre de disrupción postoperatoria de pared abdominal"
 },
 {
  "CATALOG_KEY": "54.62",
  "PRO_NOMBRE": "Cierre retardado de herida abdominal en fase de granulación"
 },
 {
  "CATALOG_KEY": "54.63",
  "PRO_NOMBRE": "Otra sutura de pared abdominal"
 },
 {
  "CATALOG_KEY": "54.64",
  "PRO_NOMBRE": "Sutura de peritoneo"
 },
 {
  "CATALOG_KEY": "54.7",
  "PRO_NOMBRE": "Otra reparación de pared abdominal y peritoneo"
 },
 {
  "CATALOG_KEY": "54.71",
  "PRO_NOMBRE": "Reparación de gastrosquisis"
 },
 {
  "CATALOG_KEY": "54.72",
  "PRO_NOMBRE": "Otra reparación de pared abdominal"
 },
 {
  "CATALOG_KEY": "54.73",
  "PRO_NOMBRE": "Otra reparación de peritoneo"
 },
 {
  "CATALOG_KEY": "54.74",
  "PRO_NOMBRE": "Otra reparación de epiplón"
 },
 {
  "CATALOG_KEY": "54.75",
  "PRO_NOMBRE": "Otra reparación de mesenterio"
 },
 {
  "CATALOG_KEY": "54.9",
  "PRO_NOMBRE": "Otras operaciones de la región abdominal"
 },
 {
  "CATALOG_KEY": "54.91",
  "PRO_NOMBRE": "Drenaje abdominal percutáneo"
 },
 {
  "CATALOG_KEY": "54.92",
  "PRO_NOMBRE": "Extracción de cuerpo extraño de la cavidad peritoneal"
 },
 {
  "CATALOG_KEY": "54.93",
  "PRO_NOMBRE": "Creación de fístula cutáneoperitoneal"
 },
 {
  "CATALOG_KEY": "54.94",
  "PRO_NOMBRE": "Creación de derivación peritoneo-vascular (shunt)"
 },
 {
  "CATALOG_KEY": "54.95",
  "PRO_NOMBRE": "Incisión de peritoneo"
 },
 {
  "CATALOG_KEY": "54.96",
  "PRO_NOMBRE": "Inyección de aire en cavidad peritoneal"
 },
 {
  "CATALOG_KEY": "54.97",
  "PRO_NOMBRE": "Inyección de sustancia terapéutica de acción local en cavidad peritoneal"
 },
 {
  "CATALOG_KEY": "54.98",
  "PRO_NOMBRE": "Diálisis peritoneal"
 },
 {
  "CATALOG_KEY": "54.99",
  "PRO_NOMBRE": "Otra operación de la región abdominal"
 },
 {
  "CATALOG_KEY": "55",
  "PRO_NOMBRE": "Operaciones sobre el riñón"
 },
 {
  "CATALOG_KEY": "55.0",
  "PRO_NOMBRE": "Nefrotomía y nefrostomía"
 },
 {
  "CATALOG_KEY": "55.01",
  "PRO_NOMBRE": "Nefrotomía"
 },
 {
  "CATALOG_KEY": "55.02",
  "PRO_NOMBRE": "Nefrostomía"
 },
 {
  "CATALOG_KEY": "55.03",
  "PRO_NOMBRE": "Nefrostomía percutánea sin fragmentación"
 },
 {
  "CATALOG_KEY": "55.04",
  "PRO_NOMBRE": "Nefrostomía percutánea con fragmentación"
 },
 {
  "CATALOG_KEY": "55.1",
  "PRO_NOMBRE": "Pielotomía y pielostomía"
 },
 {
  "CATALOG_KEY": "55.11",
  "PRO_NOMBRE": "Pielotomía"
 },
 {
  "CATALOG_KEY": "55.12",
  "PRO_NOMBRE": "Pielostomía"
 },
 {
  "CATALOG_KEY": "55.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre riñón"
 },
 {
  "CATALOG_KEY": "55.21",
  "PRO_NOMBRE": "Nefroscopia"
 },
 {
  "CATALOG_KEY": "55.22",
  "PRO_NOMBRE": "Pieloscopia"
 },
 {
  "CATALOG_KEY": "55.23",
  "PRO_NOMBRE": "Biopsia cerrada [aguja] [percutánea] de riñón"
 },
 {
  "CATALOG_KEY": "55.24",
  "PRO_NOMBRE": "Biopsia abierta de riñón"
 },
 {
  "CATALOG_KEY": "55.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre el riñón"
 },
 {
  "CATALOG_KEY": "55.3",
  "PRO_NOMBRE": "Excisión local o destrucción de lesión renal"
 },
 {
  "CATALOG_KEY": "55.31",
  "PRO_NOMBRE": "Marsupialización de lesión renal"
 },
 {
  "CATALOG_KEY": "55.32",
  "PRO_NOMBRE": "Ablación abierta de lesión o tejido renal"
 },
 {
  "CATALOG_KEY": "55.33",
  "PRO_NOMBRE": "Ablación percutánea de lesión o tejido renal"
 },
 {
  "CATALOG_KEY": "55.34",
  "PRO_NOMBRE": "Ablación laparoscópica de lesión o tejido renal"
 },
 {
  "CATALOG_KEY": "55.35",
  "PRO_NOMBRE": "Otra ablación y la no especificada de lesión o tejido renal"
 },
 {
  "CATALOG_KEY": "55.39",
  "PRO_NOMBRE": "Otra destrucción local o excisión de lesión o tejido renal"
 },
 {
  "CATALOG_KEY": "55.4",
  "PRO_NOMBRE": "Nefrectomía parcial"
 },
 {
  "CATALOG_KEY": "55.5",
  "PRO_NOMBRE": "Nefrectomía total"
 },
 {
  "CATALOG_KEY": "55.51",
  "PRO_NOMBRE": "Nefroureterectomía"
 },
 {
  "CATALOG_KEY": "55.52",
  "PRO_NOMBRE": "Nefrectomía de riñón restante"
 },
 {
  "CATALOG_KEY": "55.53",
  "PRO_NOMBRE": "Extracción de riñón trasplantado o rechazado"
 },
 {
  "CATALOG_KEY": "55.54",
  "PRO_NOMBRE": "Nefrectomía bilateral"
 },
 {
  "CATALOG_KEY": "55.6",
  "PRO_NOMBRE": "Trasplante de riñón"
 },
 {
  "CATALOG_KEY": "55.61",
  "PRO_NOMBRE": "Autotrasplante renal"
 },
 {
  "CATALOG_KEY": "55.69",
  "PRO_NOMBRE": "Otro trasplante de riñón"
 },
 {
  "CATALOG_KEY": "55.7",
  "PRO_NOMBRE": "Nefropexia"
 },
 {
  "CATALOG_KEY": "55.8",
  "PRO_NOMBRE": "Otra reparación de riñón"
 },
 {
  "CATALOG_KEY": "55.81",
  "PRO_NOMBRE": "Sutura de laceración de riñón"
 },
 {
  "CATALOG_KEY": "55.82",
  "PRO_NOMBRE": "Cierre de nefrostomía y pielostomía"
 },
 {
  "CATALOG_KEY": "55.83",
  "PRO_NOMBRE": "Cierre de otra fístula de riñón"
 },
 {
  "CATALOG_KEY": "55.84",
  "PRO_NOMBRE": "Reducción de torsión de pedículo renal"
 },
 {
  "CATALOG_KEY": "55.85",
  "PRO_NOMBRE": "Sinfisiotomía para riñón (anular) en herradura"
 },
 {
  "CATALOG_KEY": "55.86",
  "PRO_NOMBRE": "Anastomosis de riñón"
 },
 {
  "CATALOG_KEY": "55.87",
  "PRO_NOMBRE": "Corrección de unión ureteropélvica"
 },
 {
  "CATALOG_KEY": "55.89",
  "PRO_NOMBRE": "Otra reparación de riñón"
 },
 {
  "CATALOG_KEY": "55.9",
  "PRO_NOMBRE": "Otras operaciones sobre el riñón"
 },
 {
  "CATALOG_KEY": "55.91",
  "PRO_NOMBRE": "Decapsulación de riñón"
 },
 {
  "CATALOG_KEY": "55.92",
  "PRO_NOMBRE": "Aspiración percutánea de riñón (pelvis)"
 },
 {
  "CATALOG_KEY": "55.93",
  "PRO_NOMBRE": "Sustitución de tubo de nefrostomía"
 },
 {
  "CATALOG_KEY": "55.94",
  "PRO_NOMBRE": "Sustitución de tubo de pielostomía"
 },
 {
  "CATALOG_KEY": "55.95",
  "PRO_NOMBRE": "Perfusión local de riñón"
 },
 {
  "CATALOG_KEY": "55.96",
  "PRO_NOMBRE": "Otra inyección de sustancia terapéutica en riñón"
 },
 {
  "CATALOG_KEY": "55.97",
  "PRO_NOMBRE": "Implantación o sustitución de riñón mecánico"
 },
 {
  "CATALOG_KEY": "55.98",
  "PRO_NOMBRE": "Extracción de riñón mecánico"
 },
 {
  "CATALOG_KEY": "55.99",
  "PRO_NOMBRE": "Otras operaciones sobre el riñón"
 },
 {
  "CATALOG_KEY": "56",
  "PRO_NOMBRE": "Operaciones sobre uréter"
 },
 {
  "CATALOG_KEY": "56.0",
  "PRO_NOMBRE": "Extracción transuretral de obstáculo de uréter y pelvis renal"
 },
 {
  "CATALOG_KEY": "56.1",
  "PRO_NOMBRE": "Meatotomía ureteral"
 },
 {
  "CATALOG_KEY": "56.2",
  "PRO_NOMBRE": "Ureterotomía"
 },
 {
  "CATALOG_KEY": "56.3",
  "PRO_NOMBRE": "Procedimientos de diagnóstico en uréter"
 },
 {
  "CATALOG_KEY": "56.31",
  "PRO_NOMBRE": "Ureteroscopia"
 },
 {
  "CATALOG_KEY": "56.32",
  "PRO_NOMBRE": "Biopsia percutánea cerrada de uréter"
 },
 {
  "CATALOG_KEY": "56.33",
  "PRO_NOMBRE": "Biopsia endoscópica cerrada de uréter"
 },
 {
  "CATALOG_KEY": "56.34",
  "PRO_NOMBRE": "Biopsia abierta de uréter"
 },
 {
  "CATALOG_KEY": "56.35",
  "PRO_NOMBRE": "Cistoscopia"
 },
 {
  "CATALOG_KEY": "56.39",
  "PRO_NOMBRE": "Otros procedimientos de diagnóstico en uréter"
 },
 {
  "CATALOG_KEY": "56.4",
  "PRO_NOMBRE": "Ureterectomía"
 },
 {
  "CATALOG_KEY": "56.40",
  "PRO_NOMBRE": "Ureterectomía no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "56.41",
  "PRO_NOMBRE": "Ureterectomía parcial"
 },
 {
  "CATALOG_KEY": "56.42",
  "PRO_NOMBRE": "Ureterectomía total"
 },
 {
  "CATALOG_KEY": "56.5",
  "PRO_NOMBRE": "Ureteroileostomía cutánea"
 },
 {
  "CATALOG_KEY": "56.51",
  "PRO_NOMBRE": "Formación de ureteroileostomía cutánea"
 },
 {
  "CATALOG_KEY": "56.52",
  "PRO_NOMBRE": "Revisión de ureteroileostomía cutánea"
 },
 {
  "CATALOG_KEY": "56.6",
  "PRO_NOMBRE": "Otra derivación urinaria externa"
 },
 {
  "CATALOG_KEY": "56.61",
  "PRO_NOMBRE": "Formación de otra ureterostomía cutánea"
 },
 {
  "CATALOG_KEY": "56.62",
  "PRO_NOMBRE": "Revisión de otra ureterostomía cutánea"
 },
 {
  "CATALOG_KEY": "56.7",
  "PRO_NOMBRE": "Otra anastomosis o desviación de uréter"
 },
 {
  "CATALOG_KEY": "56.71",
  "PRO_NOMBRE": "Derivación urinaria a intestino"
 },
 {
  "CATALOG_KEY": "56.72",
  "PRO_NOMBRE": "Revisión de anastomosis ureterointestinal"
 },
 {
  "CATALOG_KEY": "56.73",
  "PRO_NOMBRE": "Nefrocistoanastomosis no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "56.74",
  "PRO_NOMBRE": "Ureteroneocistostomía"
 },
 {
  "CATALOG_KEY": "56.75",
  "PRO_NOMBRE": "Transureteroureterostomía"
 },
 {
  "CATALOG_KEY": "56.79",
  "PRO_NOMBRE": "Otra anastomosis o desviación de uréter"
 },
 {
  "CATALOG_KEY": "56.8",
  "PRO_NOMBRE": "Reparación de uréter"
 },
 {
  "CATALOG_KEY": "56.81",
  "PRO_NOMBRE": "Liberación de adherencias intraluminales de uréter"
 },
 {
  "CATALOG_KEY": "56.82",
  "PRO_NOMBRE": "Sutura de laceración de uréter"
 },
 {
  "CATALOG_KEY": "56.83",
  "PRO_NOMBRE": "Cierre de ureterostomía"
 },
 {
  "CATALOG_KEY": "56.84",
  "PRO_NOMBRE": "Cierre de otra fístula de uréter"
 },
 {
  "CATALOG_KEY": "56.85",
  "PRO_NOMBRE": "Ureteropexia"
 },
 {
  "CATALOG_KEY": "56.86",
  "PRO_NOMBRE": "Extracción de ligadura de uréter"
 },
 {
  "CATALOG_KEY": "56.89",
  "PRO_NOMBRE": "Otra reparación de uréter"
 },
 {
  "CATALOG_KEY": "56.9",
  "PRO_NOMBRE": "Otras operaciones sobre uréter"
 },
 {
  "CATALOG_KEY": "56.91",
  "PRO_NOMBRE": "Dilatación del meato ureteral"
 },
 {
  "CATALOG_KEY": "56.92",
  "PRO_NOMBRE": "Implantación de estimulador ureteral electrónico"
 },
 {
  "CATALOG_KEY": "56.93",
  "PRO_NOMBRE": "Sustitución de estimulador ureteral electrónico"
 },
 {
  "CATALOG_KEY": "56.94",
  "PRO_NOMBRE": "Extracción de estimulador ureteral electrónico"
 },
 {
  "CATALOG_KEY": "56.95",
  "PRO_NOMBRE": "Ligadura de uréter"
 },
 {
  "CATALOG_KEY": "56.99",
  "PRO_NOMBRE": "Otras operaciones sobre uréter"
 },
 {
  "CATALOG_KEY": "57",
  "PRO_NOMBRE": "Operaciones sobre vejiga urinaria"
 },
 {
  "CATALOG_KEY": "57.0",
  "PRO_NOMBRE": "Drenaje transuretral vesical"
 },
 {
  "CATALOG_KEY": "57.1",
  "PRO_NOMBRE": "Cistotomía y cistostomía"
 },
 {
  "CATALOG_KEY": "57.11",
  "PRO_NOMBRE": "Aspiración percutánea de vejiga"
 },
 {
  "CATALOG_KEY": "57.12",
  "PRO_NOMBRE": "Liberación de adherencias intraluminales con incisión de vejiga"
 },
 {
  "CATALOG_KEY": "57.17",
  "PRO_NOMBRE": "Cistostomía percutánea"
 },
 {
  "CATALOG_KEY": "57.18",
  "PRO_NOMBRE": "Otra cistostomía suprapúbica"
 },
 {
  "CATALOG_KEY": "57.19",
  "PRO_NOMBRE": "Otra cistotomía"
 },
 {
  "CATALOG_KEY": "57.2",
  "PRO_NOMBRE": "Vesicostomía"
 },
 {
  "CATALOG_KEY": "57.21",
  "PRO_NOMBRE": "Vesicostomía"
 },
 {
  "CATALOG_KEY": "57.22",
  "PRO_NOMBRE": "Revisión o sutura de vesicostomía"
 },
 {
  "CATALOG_KEY": "57.3",
  "PRO_NOMBRE": "Procedimientos diagnósticos en vejiga"
 },
 {
  "CATALOG_KEY": "57.31",
  "PRO_NOMBRE": "Cistoscopia a través de estoma artificial"
 },
 {
  "CATALOG_KEY": "57.32",
  "PRO_NOMBRE": "Otra cistoscopia"
 },
 {
  "CATALOG_KEY": "57.33",
  "PRO_NOMBRE": "Biopsia cerrada [transuretral] de vejiga"
 },
 {
  "CATALOG_KEY": "57.34",
  "PRO_NOMBRE": "Biopsia abierta de vejiga"
 },
 {
  "CATALOG_KEY": "57.39",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre vejiga"
 },
 {
  "CATALOG_KEY": "57.4",
  "PRO_NOMBRE": "Excisión o destrucción transuretral de tejido de vejiga"
 },
 {
  "CATALOG_KEY": "57.41",
  "PRO_NOMBRE": "Liberación transuretral de adherencias intraluminales"
 },
 {
  "CATALOG_KEY": "57.49",
  "PRO_NOMBRE": "Otra excisión o destrucción transuretral de lesión o tejido vesical"
 },
 {
  "CATALOG_KEY": "57.5",
  "PRO_NOMBRE": "Otra excisión o destrucción de tejido de vejiga"
 },
 {
  "CATALOG_KEY": "57.51",
  "PRO_NOMBRE": "Excisión de uraco"
 },
 {
  "CATALOG_KEY": "57.59",
  "PRO_NOMBRE": "Excisión o destrucción abierta de otra lesión o tejido de vejiga"
 },
 {
  "CATALOG_KEY": "57.6",
  "PRO_NOMBRE": "Cistectomía parcial"
 },
 {
  "CATALOG_KEY": "57.7",
  "PRO_NOMBRE": "Cistectomía total"
 },
 {
  "CATALOG_KEY": "57.71",
  "PRO_NOMBRE": "Cistectomía radical"
 },
 {
  "CATALOG_KEY": "57.79",
  "PRO_NOMBRE": "Otra cistectomía total"
 },
 {
  "CATALOG_KEY": "57.8",
  "PRO_NOMBRE": "Otra reparación de vejiga urinaria"
 },
 {
  "CATALOG_KEY": "57.81",
  "PRO_NOMBRE": "Sutura de laceración de vejiga"
 },
 {
  "CATALOG_KEY": "57.82",
  "PRO_NOMBRE": "Cierre de cistostomía"
 },
 {
  "CATALOG_KEY": "57.83",
  "PRO_NOMBRE": "Reparación de fístula con afectación de vejiga e intestino"
 },
 {
  "CATALOG_KEY": "57.84",
  "PRO_NOMBRE": "Reparación de otra fístula de vejiga"
 },
 {
  "CATALOG_KEY": "57.85",
  "PRO_NOMBRE": "Cistouretroplastía y reparación plástica de cuello de vejiga"
 },
 {
  "CATALOG_KEY": "57.86",
  "PRO_NOMBRE": "Reparación de extrofia vesical"
 },
 {
  "CATALOG_KEY": "57.87",
  "PRO_NOMBRE": "Reconstrucción de vejiga urinaria"
 },
 {
  "CATALOG_KEY": "57.88",
  "PRO_NOMBRE": "Otra anastomosis de vejiga"
 },
 {
  "CATALOG_KEY": "57.89",
  "PRO_NOMBRE": "Otra reparación de vejiga"
 },
 {
  "CATALOG_KEY": "57.9",
  "PRO_NOMBRE": "Otras operaciones sobre vejiga"
 },
 {
  "CATALOG_KEY": "57.91",
  "PRO_NOMBRE": "Esfinterotomía de vejiga"
 },
 {
  "CATALOG_KEY": "57.92",
  "PRO_NOMBRE": "Dilatación de cuello de vejiga"
 },
 {
  "CATALOG_KEY": "57.93",
  "PRO_NOMBRE": "Control de hemorragia (postoperatoria) de vejiga"
 },
 {
  "CATALOG_KEY": "57.94",
  "PRO_NOMBRE": "Inserción de catéter urinario permanente"
 },
 {
  "CATALOG_KEY": "57.95",
  "PRO_NOMBRE": "Sustitución de catéter urinario permanente"
 },
 {
  "CATALOG_KEY": "57.96",
  "PRO_NOMBRE": "Implantación de estimulador de vejiga electrónico"
 },
 {
  "CATALOG_KEY": "57.97",
  "PRO_NOMBRE": "Sustitución de estimulador de vejiga electrónico"
 },
 {
  "CATALOG_KEY": "57.98",
  "PRO_NOMBRE": "Extracción de estimulador de vejiga electrónico"
 },
 {
  "CATALOG_KEY": "57.99",
  "PRO_NOMBRE": "Otras operaciones sobre vejiga"
 },
 {
  "CATALOG_KEY": "58",
  "PRO_NOMBRE": "Operaciones sobre uretra"
 },
 {
  "CATALOG_KEY": "58.0",
  "PRO_NOMBRE": "Uretrotomía"
 },
 {
  "CATALOG_KEY": "58.1",
  "PRO_NOMBRE": "Meatotomía uretral"
 },
 {
  "CATALOG_KEY": "58.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos en uretra"
 },
 {
  "CATALOG_KEY": "58.21",
  "PRO_NOMBRE": "Uretroscopia perineal"
 },
 {
  "CATALOG_KEY": "58.22",
  "PRO_NOMBRE": "Otra uretroscopia"
 },
 {
  "CATALOG_KEY": "58.23",
  "PRO_NOMBRE": "Biopsia de uretra"
 },
 {
  "CATALOG_KEY": "58.24",
  "PRO_NOMBRE": "Biopsia de tejido periuretral"
 },
 {
  "CATALOG_KEY": "58.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre uretra y tejido periuretral"
 },
 {
  "CATALOG_KEY": "58.3",
  "PRO_NOMBRE": "Excisión o destrucción de tejido o de lesión uretral"
 },
 {
  "CATALOG_KEY": "58.31",
  "PRO_NOMBRE": "Excisión endoscópica o destrucción de lesión o de tejido de la uretra"
 },
 {
  "CATALOG_KEY": "58.39",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión o de tejido de la uretra"
 },
 {
  "CATALOG_KEY": "58.4",
  "PRO_NOMBRE": "Reparación de uretra"
 },
 {
  "CATALOG_KEY": "58.41",
  "PRO_NOMBRE": "Sutura de laceración de uretra"
 },
 {
  "CATALOG_KEY": "58.42",
  "PRO_NOMBRE": "Cierre de uretrostomía"
 },
 {
  "CATALOG_KEY": "58.43",
  "PRO_NOMBRE": "Cierre de otra fístula de uretra"
 },
 {
  "CATALOG_KEY": "58.44",
  "PRO_NOMBRE": "Reanastomosis de uretra"
 },
 {
  "CATALOG_KEY": "58.45",
  "PRO_NOMBRE": "Reparación de hipospadias o epispadias"
 },
 {
  "CATALOG_KEY": "58.46",
  "PRO_NOMBRE": "Otra reconstrucción de uretra"
 },
 {
  "CATALOG_KEY": "58.47",
  "PRO_NOMBRE": "Meatoplastía uretral"
 },
 {
  "CATALOG_KEY": "58.49",
  "PRO_NOMBRE": "Otra reparación de uretra"
 },
 {
  "CATALOG_KEY": "58.5",
  "PRO_NOMBRE": "Liberación de estenosis uretral"
 },
 {
  "CATALOG_KEY": "58.6",
  "PRO_NOMBRE": "Dilatación de uretra"
 },
 {
  "CATALOG_KEY": "58.9",
  "PRO_NOMBRE": "Otras operaciones sobre uretra y tejido periuretral"
 },
 {
  "CATALOG_KEY": "58.91",
  "PRO_NOMBRE": "Incisión de tejido periuretral"
 },
 {
  "CATALOG_KEY": "58.92",
  "PRO_NOMBRE": "Excisión de tejido periuretral"
 },
 {
  "CATALOG_KEY": "58.93",
  "PRO_NOMBRE": "Implantación de esfínter urinario artificial [EUA]"
 },
 {
  "CATALOG_KEY": "58.99",
  "PRO_NOMBRE": "Otras operaciones sobre uretra y tejido periuretral"
 },
 {
  "CATALOG_KEY": "59",
  "PRO_NOMBRE": "Otras operaciones sobre el tracto urinario"
 },
 {
  "CATALOG_KEY": "59.0",
  "PRO_NOMBRE": "Disección de tejido retroperitoneal"
 },
 {
  "CATALOG_KEY": "59.00",
  "PRO_NOMBRE": "Disección retroperitoneal no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "59.02",
  "PRO_NOMBRE": "Otra lisis de adherencias perirrenales o periureterales"
 },
 {
  "CATALOG_KEY": "59.03",
  "PRO_NOMBRE": "Lisis laparoscópica de adherencias perirrenales o periureterales"
 },
 {
  "CATALOG_KEY": "59.09",
  "PRO_NOMBRE": "Otra incisión de tejido perirrenal o periureteral"
 },
 {
  "CATALOG_KEY": "59.1",
  "PRO_NOMBRE": "Incisión de tejido perivesical"
 },
 {
  "CATALOG_KEY": "59.11",
  "PRO_NOMBRE": "Otra lisis de adherencias perivesicales"
 },
 {
  "CATALOG_KEY": "59.12",
  "PRO_NOMBRE": "Lisis laparoscópica de adherencias perivesicales"
 },
 {
  "CATALOG_KEY": "59.19",
  "PRO_NOMBRE": "Otra incisión de tejido perivesical"
 },
 {
  "CATALOG_KEY": "59.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos en tejido perirrenal y perivesical"
 },
 {
  "CATALOG_KEY": "59.21",
  "PRO_NOMBRE": "Biopsia de tejido perirrenal o perivesical"
 },
 {
  "CATALOG_KEY": "59.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre tejido perirrenal, tejido perivesical y retroperitoneo"
 },
 {
  "CATALOG_KEY": "59.3",
  "PRO_NOMBRE": "Plicatura de unión uretrovesical"
 },
 {
  "CATALOG_KEY": "59.4",
  "PRO_NOMBRE": "Operación suprapúbica de suspensión (Sling)"
 },
 {
  "CATALOG_KEY": "59.5",
  "PRO_NOMBRE": "Suspensión uretral retropúbica"
 },
 {
  "CATALOG_KEY": "59.6",
  "PRO_NOMBRE": "Suspensión parauretral"
 },
 {
  "CATALOG_KEY": "59.7",
  "PRO_NOMBRE": "Otra reparación de incontinencia urinaria de esfuerzo"
 },
 {
  "CATALOG_KEY": "59.71",
  "PRO_NOMBRE": "Operación de músculo elevador para suspensión uretrovesical"
 },
 {
  "CATALOG_KEY": "59.72",
  "PRO_NOMBRE": "Inyección de implante en cuello vesical o intrauretral"
 },
 {
  "CATALOG_KEY": "59.79",
  "PRO_NOMBRE": "Otra reparación de incontinencia urinaria de esfuerzo"
 },
 {
  "CATALOG_KEY": "59.8",
  "PRO_NOMBRE": "Cateterismo ureteral"
 },
 {
  "CATALOG_KEY": "59.9",
  "PRO_NOMBRE": "Otras operaciones sobre el aparato urinario"
 },
 {
  "CATALOG_KEY": "59.91",
  "PRO_NOMBRE": "Excisión de tejido perirrenal o perivesical"
 },
 {
  "CATALOG_KEY": "59.92",
  "PRO_NOMBRE": "Otras operaciones sobre tejido perirrenal o perivesical"
 },
 {
  "CATALOG_KEY": "59.93",
  "PRO_NOMBRE": "Sustitución de tubo de ureterostomía"
 },
 {
  "CATALOG_KEY": "59.94",
  "PRO_NOMBRE": "Sustitución de tubo de cistostomía"
 },
 {
  "CATALOG_KEY": "59.95",
  "PRO_NOMBRE": "Fragmentación por ultrasonidos de cálculos urinarios"
 },
 {
  "CATALOG_KEY": "59.99",
  "PRO_NOMBRE": "Otras operaciones sobre el aparato urinario"
 },
 {
  "CATALOG_KEY": "60",
  "PRO_NOMBRE": "Operaciones sobre próstata y vesículas seminales"
 },
 {
  "CATALOG_KEY": "60.0",
  "PRO_NOMBRE": "Incisión de próstata"
 },
 {
  "CATALOG_KEY": "60.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos en próstata y vesículas seminales"
 },
 {
  "CATALOG_KEY": "60.11",
  "PRO_NOMBRE": "Biopsia cerrada [por aguja] [percutánea] de próstata"
 },
 {
  "CATALOG_KEY": "60.12",
  "PRO_NOMBRE": "Biopsia abierta de próstata"
 },
 {
  "CATALOG_KEY": "60.13",
  "PRO_NOMBRE": "Biopsia cerrada [percutánea] de vesículas seminales"
 },
 {
  "CATALOG_KEY": "60.14",
  "PRO_NOMBRE": "Biopsia abierta de vesículas seminales"
 },
 {
  "CATALOG_KEY": "60.15",
  "PRO_NOMBRE": "Biopsia de tejido periprostático"
 },
 {
  "CATALOG_KEY": "60.18",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre próstata y tejido periprostático"
 },
 {
  "CATALOG_KEY": "60.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre vesículas seminales"
 },
 {
  "CATALOG_KEY": "60.2",
  "PRO_NOMBRE": "Resección transuretral de próstata"
 },
 {
  "CATALOG_KEY": "60.21",
  "PRO_NOMBRE": "Prostatectomía transuretral (ultrasonido) guiado por láser inducido"
 },
 {
  "CATALOG_KEY": "60.29",
  "PRO_NOMBRE": "Otra prostatectomía transuretral"
 },
 {
  "CATALOG_KEY": "60.3",
  "PRO_NOMBRE": "Adenomectomía suprapúbica"
 },
 {
  "CATALOG_KEY": "60.4",
  "PRO_NOMBRE": "Adenomectomía retropúbica"
 },
 {
  "CATALOG_KEY": "60.5",
  "PRO_NOMBRE": "Prostatectomía radical"
 },
 {
  "CATALOG_KEY": "60.6",
  "PRO_NOMBRE": "Otra prostatectomía"
 },
 {
  "CATALOG_KEY": "60.61",
  "PRO_NOMBRE": "Excisión local de lesión de próstata"
 },
 {
  "CATALOG_KEY": "60.62",
  "PRO_NOMBRE": "Prostatectomía perineal"
 },
 {
  "CATALOG_KEY": "60.69",
  "PRO_NOMBRE": "Otra prostatectomía"
 },
 {
  "CATALOG_KEY": "60.7",
  "PRO_NOMBRE": "Operaciones sobre vesículas seminales"
 },
 {
  "CATALOG_KEY": "60.71",
  "PRO_NOMBRE": "Aspiración percutánea de vesículas seminales"
 },
 {
  "CATALOG_KEY": "60.72",
  "PRO_NOMBRE": "Incisión de vesícula seminal"
 },
 {
  "CATALOG_KEY": "60.73",
  "PRO_NOMBRE": "Excisión de vesícula seminal"
 },
 {
  "CATALOG_KEY": "60.79",
  "PRO_NOMBRE": "Otras operaciones sobre vesículas seminales"
 },
 {
  "CATALOG_KEY": "60.8",
  "PRO_NOMBRE": "Incisión o excisión de tejido periprostático"
 },
 {
  "CATALOG_KEY": "60.81",
  "PRO_NOMBRE": "Incisión de tejido periprostático"
 },
 {
  "CATALOG_KEY": "60.82",
  "PRO_NOMBRE": "Excisión de tejido periprostático"
 },
 {
  "CATALOG_KEY": "60.9",
  "PRO_NOMBRE": "Otras operaciones sobre próstata"
 },
 {
  "CATALOG_KEY": "60.91",
  "PRO_NOMBRE": "Aspiración percutánea de próstata"
 },
 {
  "CATALOG_KEY": "60.92",
  "PRO_NOMBRE": "Inyección en próstata"
 },
 {
  "CATALOG_KEY": "60.93",
  "PRO_NOMBRE": "Reparación de próstata"
 },
 {
  "CATALOG_KEY": "60.94",
  "PRO_NOMBRE": "Control de hemorragia (postoperatoria) de próstata"
 },
 {
  "CATALOG_KEY": "60.95",
  "PRO_NOMBRE": "Dilatación transuretral con balón de uretra prostática"
 },
 {
  "CATALOG_KEY": "60.96",
  "PRO_NOMBRE": "Destrucción transuretral de tejido prostático por termoterapia con microondas"
 },
 {
  "CATALOG_KEY": "60.97",
  "PRO_NOMBRE": "Otra destrucción transuretral de tejido prostático con otra termoterapia"
 },
 {
  "CATALOG_KEY": "60.99",
  "PRO_NOMBRE": "Otras operaciones sobre próstata"
 },
 {
  "CATALOG_KEY": "61",
  "PRO_NOMBRE": "Operaciones sobre escroto y túnica vaginal"
 },
 {
  "CATALOG_KEY": "61.0",
  "PRO_NOMBRE": "Incisión y drenaje de escroto y túnica vaginal"
 },
 {
  "CATALOG_KEY": "61.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre escroto y túnica vaginal"
 },
 {
  "CATALOG_KEY": "61.11",
  "PRO_NOMBRE": "Biopsia de escroto o túnica vaginal"
 },
 {
  "CATALOG_KEY": "61.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre escroto y túnica vaginal"
 },
 {
  "CATALOG_KEY": "61.2",
  "PRO_NOMBRE": "Excisión de hidrocele (de túnica vaginal)"
 },
 {
  "CATALOG_KEY": "61.3",
  "PRO_NOMBRE": "Excisión o destrucción de lesión o tejido de escroto"
 },
 {
  "CATALOG_KEY": "61.4",
  "PRO_NOMBRE": "Reparación de escroto y túnica vaginal"
 },
 {
  "CATALOG_KEY": "61.41",
  "PRO_NOMBRE": "Sutura de laceración de escroto y túnica vaginal"
 },
 {
  "CATALOG_KEY": "61.42",
  "PRO_NOMBRE": "Reparación de fístula escrotal"
 },
 {
  "CATALOG_KEY": "61.49",
  "PRO_NOMBRE": "Otra reparación de escroto y túnica vaginal"
 },
 {
  "CATALOG_KEY": "61.9",
  "PRO_NOMBRE": "Otras operaciones sobre escroto y túnica vaginal"
 },
 {
  "CATALOG_KEY": "61.91",
  "PRO_NOMBRE": "Aspiración percutánea de túnica vaginal"
 },
 {
  "CATALOG_KEY": "61.92",
  "PRO_NOMBRE": "Excisión de lesión de túnica vaginal salvo hidrocele"
 },
 {
  "CATALOG_KEY": "61.99",
  "PRO_NOMBRE": "Otras operaciones sobre escroto y túnica vaginal"
 },
 {
  "CATALOG_KEY": "62",
  "PRO_NOMBRE": "Operaciones sobre testículos"
 },
 {
  "CATALOG_KEY": "62.0",
  "PRO_NOMBRE": "Incisión de testículo"
 },
 {
  "CATALOG_KEY": "62.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre testículos"
 },
 {
  "CATALOG_KEY": "62.11",
  "PRO_NOMBRE": "Biopsia cerrada [percutánea] [por aguja] de testículo"
 },
 {
  "CATALOG_KEY": "62.12",
  "PRO_NOMBRE": "Biopsia abierta de testículo"
 },
 {
  "CATALOG_KEY": "62.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre testículos"
 },
 {
  "CATALOG_KEY": "62.2",
  "PRO_NOMBRE": "Excisión o destrucción de lesión testicular"
 },
 {
  "CATALOG_KEY": "62.3",
  "PRO_NOMBRE": "Orquiectomía unilateral"
 },
 {
  "CATALOG_KEY": "62.4",
  "PRO_NOMBRE": "Orquiectomía bilateral"
 },
 {
  "CATALOG_KEY": "62.41",
  "PRO_NOMBRE": "Extirpación de ambos testículos en el mismo episodio operatorio"
 },
 {
  "CATALOG_KEY": "62.42",
  "PRO_NOMBRE": "Extirpación de testículo restante"
 },
 {
  "CATALOG_KEY": "62.5",
  "PRO_NOMBRE": "Orquiopexia"
 },
 {
  "CATALOG_KEY": "62.6",
  "PRO_NOMBRE": "Reparación de testículos"
 },
 {
  "CATALOG_KEY": "62.61",
  "PRO_NOMBRE": "Sutura de laceración de testículo"
 },
 {
  "CATALOG_KEY": "62.69",
  "PRO_NOMBRE": "Otra reparación de testículo"
 },
 {
  "CATALOG_KEY": "62.7",
  "PRO_NOMBRE": "Inserción de prótesis testicular"
 },
 {
  "CATALOG_KEY": "62.9",
  "PRO_NOMBRE": "Otras operaciones sobre testículo"
 },
 {
  "CATALOG_KEY": "62.91",
  "PRO_NOMBRE": "Aspiración de testículo"
 },
 {
  "CATALOG_KEY": "62.92",
  "PRO_NOMBRE": "Inyección de sustancia terapéutica en testículo"
 },
 {
  "CATALOG_KEY": "62.99",
  "PRO_NOMBRE": "Otras operaciones sobre testículo"
 },
 {
  "CATALOG_KEY": "63",
  "PRO_NOMBRE": "Operaciones sobre cordón espermático, epidídimo y conducto deferente"
 },
 {
  "CATALOG_KEY": "63.0",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre cordón espermático, epidídimo y conducto deferente"
 },
 {
  "CATALOG_KEY": "63.01",
  "PRO_NOMBRE": "Biopsia de cordón espermático, epidídimo o conducto deferente"
 },
 {
  "CATALOG_KEY": "63.09",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre cordón espermático, epidídimo y conducto deferente"
 },
 {
  "CATALOG_KEY": "63.1",
  "PRO_NOMBRE": "Excisión de varicocele e hidrocele de cordón espermático"
 },
 {
  "CATALOG_KEY": "63.2",
  "PRO_NOMBRE": "Excisión de quiste de epidídimo"
 },
 {
  "CATALOG_KEY": "63.3",
  "PRO_NOMBRE": "Excisión de otra lesión o tejido de cordón espermático y epidídimo"
 },
 {
  "CATALOG_KEY": "63.4",
  "PRO_NOMBRE": "Epididimectomía"
 },
 {
  "CATALOG_KEY": "63.5",
  "PRO_NOMBRE": "Reparación de cordón espermático y epidídimo"
 },
 {
  "CATALOG_KEY": "63.51",
  "PRO_NOMBRE": "Sutura de laceración de cordón espermático y epidídimo"
 },
 {
  "CATALOG_KEY": "63.52",
  "PRO_NOMBRE": "Reducción de torsión de testículo o cordón espermático"
 },
 {
  "CATALOG_KEY": "63.53",
  "PRO_NOMBRE": "Trasplante de cordón espermático"
 },
 {
  "CATALOG_KEY": "63.59",
  "PRO_NOMBRE": "Otra reparación de cordón espermático y epidídimo"
 },
 {
  "CATALOG_KEY": "63.6",
  "PRO_NOMBRE": "Vasotomía"
 },
 {
  "CATALOG_KEY": "63.7",
  "PRO_NOMBRE": "Vasectomía y ligadura de conducto deferente"
 },
 {
  "CATALOG_KEY": "63.70",
  "PRO_NOMBRE": "Procedimiento de esterilización masculina, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "63.71",
  "PRO_NOMBRE": "Ligadura de conducto deferente"
 },
 {
  "CATALOG_KEY": "63.72",
  "PRO_NOMBRE": "Ligadura de cordón espermático"
 },
 {
  "CATALOG_KEY": "63.73",
  "PRO_NOMBRE": "Vasectomía sin bisturí"
 },
 {
  "CATALOG_KEY": "63.8",
  "PRO_NOMBRE": "Reparación de conducto deferente y epidídimo"
 },
 {
  "CATALOG_KEY": "63.81",
  "PRO_NOMBRE": "Sutura de laceración de conducto deferente y epidídimo"
 },
 {
  "CATALOG_KEY": "63.82",
  "PRO_NOMBRE": "Reconstrucción de conducto deferente dividido quirúrgicamente"
 },
 {
  "CATALOG_KEY": "63.83",
  "PRO_NOMBRE": "Epididimovasostomía"
 },
 {
  "CATALOG_KEY": "63.84",
  "PRO_NOMBRE": "Retiro de ligadura de conducto deferente"
 },
 {
  "CATALOG_KEY": "63.85",
  "PRO_NOMBRE": "Extracción de válvula de conducto deferente"
 },
 {
  "CATALOG_KEY": "63.89",
  "PRO_NOMBRE": "Otra reparación de conducto deferente y epidídimo"
 },
 {
  "CATALOG_KEY": "63.9",
  "PRO_NOMBRE": "Otras operaciones sobre cordón espermático, epidídimo y conducto deferente"
 },
 {
  "CATALOG_KEY": "63.91",
  "PRO_NOMBRE": "Aspiración de espermatocele"
 },
 {
  "CATALOG_KEY": "63.92",
  "PRO_NOMBRE": "Epididimotomía"
 },
 {
  "CATALOG_KEY": "63.93",
  "PRO_NOMBRE": "Incisión de cordón espermático"
 },
 {
  "CATALOG_KEY": "63.94",
  "PRO_NOMBRE": "Lisis de adherencias de cordón espermático"
 },
 {
  "CATALOG_KEY": "63.95",
  "PRO_NOMBRE": "Inserción de válvula en vaso deferente"
 },
 {
  "CATALOG_KEY": "63.99",
  "PRO_NOMBRE": "Otras operaciones sobre cordón espermático, epidídimo y conducto deferente"
 },
 {
  "CATALOG_KEY": "64",
  "PRO_NOMBRE": "Operaciones sobre el pene"
 },
 {
  "CATALOG_KEY": "64.0",
  "PRO_NOMBRE": "Circuncisión"
 },
 {
  "CATALOG_KEY": "64.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos en el pene"
 },
 {
  "CATALOG_KEY": "64.11",
  "PRO_NOMBRE": "Biopsia de pene"
 },
 {
  "CATALOG_KEY": "64.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre pene"
 },
 {
  "CATALOG_KEY": "64.2",
  "PRO_NOMBRE": "Excisión local o destrucción de lesión de pene"
 },
 {
  "CATALOG_KEY": "64.3",
  "PRO_NOMBRE": "Amputación de pene"
 },
 {
  "CATALOG_KEY": "64.4",
  "PRO_NOMBRE": "Operación de reparación y plástica sobre pene"
 },
 {
  "CATALOG_KEY": "64.41",
  "PRO_NOMBRE": "Sutura de laceración de pene"
 },
 {
  "CATALOG_KEY": "64.42",
  "PRO_NOMBRE": "Liberación de corda [chordée]"
 },
 {
  "CATALOG_KEY": "64.43",
  "PRO_NOMBRE": "Construcción de pene"
 },
 {
  "CATALOG_KEY": "64.44",
  "PRO_NOMBRE": "Reconstrucción de pene"
 },
 {
  "CATALOG_KEY": "64.45",
  "PRO_NOMBRE": "Reimplantación de pene"
 },
 {
  "CATALOG_KEY": "64.49",
  "PRO_NOMBRE": "Otra reparación de pene"
 },
 {
  "CATALOG_KEY": "64.5",
  "PRO_NOMBRE": "Operaciones para transformación de sexo, no clasificadas bajo otros conceptos"
 },
 {
  "CATALOG_KEY": "64.9",
  "PRO_NOMBRE": "Otras operaciones sobre órganos genitales masculinos"
 },
 {
  "CATALOG_KEY": "64.91",
  "PRO_NOMBRE": "Corte dorsal o lateral de prepucio"
 },
 {
  "CATALOG_KEY": "64.92",
  "PRO_NOMBRE": "Incisión de pene"
 },
 {
  "CATALOG_KEY": "64.93",
  "PRO_NOMBRE": "Liberación de adherencias de pene"
 },
 {
  "CATALOG_KEY": "64.94",
  "PRO_NOMBRE": "Colocación de prótesis externa de pene"
 },
 {
  "CATALOG_KEY": "64.95",
  "PRO_NOMBRE": "Inserción o sustitución de prótesis de pene no inflable"
 },
 {
  "CATALOG_KEY": "64.96",
  "PRO_NOMBRE": "Extracción de prótesis interna de pene"
 },
 {
  "CATALOG_KEY": "64.97",
  "PRO_NOMBRE": "Inserción o sustitución de prótesis de pene inflable"
 },
 {
  "CATALOG_KEY": "64.98",
  "PRO_NOMBRE": "Otras operaciones sobre el pene"
 },
 {
  "CATALOG_KEY": "64.99",
  "PRO_NOMBRE": "Otras operaciones sobre órganos genitales masculinos"
 },
 {
  "CATALOG_KEY": "65",
  "PRO_NOMBRE": "Operaciones sobre los ovarios"
 },
 {
  "CATALOG_KEY": "65.0",
  "PRO_NOMBRE": "Ooforotomía"
 },
 {
  "CATALOG_KEY": "65.01",
  "PRO_NOMBRE": "Ooforotomía laparoscópica"
 },
 {
  "CATALOG_KEY": "65.09",
  "PRO_NOMBRE": "Otra ooforotomía"
 },
 {
  "CATALOG_KEY": "65.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre los ovarios"
 },
 {
  "CATALOG_KEY": "65.11",
  "PRO_NOMBRE": "Biopsia por aspiración de ovario"
 },
 {
  "CATALOG_KEY": "65.12",
  "PRO_NOMBRE": "Otra biopsia de ovario"
 },
 {
  "CATALOG_KEY": "65.13",
  "PRO_NOMBRE": "Biopsia laparoscópica de ovario"
 },
 {
  "CATALOG_KEY": "65.14",
  "PRO_NOMBRE": "Otro procedimiento diagnóstico laparoscópico de ovario"
 },
 {
  "CATALOG_KEY": "65.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre los ovarios"
 },
 {
  "CATALOG_KEY": "65.2",
  "PRO_NOMBRE": "Excisión local o destrucción de lesión o tejido de ovario"
 },
 {
  "CATALOG_KEY": "65.21",
  "PRO_NOMBRE": "Marsupialización de quiste ovárico"
 },
 {
  "CATALOG_KEY": "65.22",
  "PRO_NOMBRE": "Resección en cuña de ovario"
 },
 {
  "CATALOG_KEY": "65.23",
  "PRO_NOMBRE": "Marsupialización laparoscópica de quiste ovárico"
 },
 {
  "CATALOG_KEY": "65.24",
  "PRO_NOMBRE": "Resección en cuña laparoscópica de ovario"
 },
 {
  "CATALOG_KEY": "65.25",
  "PRO_NOMBRE": "Otra excisión local o destrucción laparoscópica de ovario"
 },
 {
  "CATALOG_KEY": "65.29",
  "PRO_NOMBRE": "Otra excisión local o destrucción local de ovario"
 },
 {
  "CATALOG_KEY": "65.3",
  "PRO_NOMBRE": "Ooforectomía unilateral"
 },
 {
  "CATALOG_KEY": "65.31",
  "PRO_NOMBRE": "Ooforectomía unilateral laparoscópica"
 },
 {
  "CATALOG_KEY": "65.39",
  "PRO_NOMBRE": "Otra ooforectomía unilateral"
 },
 {
  "CATALOG_KEY": "65.4",
  "PRO_NOMBRE": "Salpingooforectomía unilateral"
 },
 {
  "CATALOG_KEY": "65.41",
  "PRO_NOMBRE": "Salpingooforectomía unilateral laparoscópica"
 },
 {
  "CATALOG_KEY": "65.49",
  "PRO_NOMBRE": "Otra salpingooforectomía unilateral"
 },
 {
  "CATALOG_KEY": "65.5",
  "PRO_NOMBRE": "Ooforectomía bilateral"
 },
 {
  "CATALOG_KEY": "65.51",
  "PRO_NOMBRE": "Otra extirpación de ambos ovarios en un mismo acto operatorio"
 },
 {
  "CATALOG_KEY": "65.52",
  "PRO_NOMBRE": "Otra extirpación de ovario restante"
 },
 {
  "CATALOG_KEY": "65.53",
  "PRO_NOMBRE": "Extirpación laparoscópica de ambos ovarios en un mismo acto operatorio"
 },
 {
  "CATALOG_KEY": "65.54",
  "PRO_NOMBRE": "Extirpación laparoscópica de ovario restante"
 },
 {
  "CATALOG_KEY": "65.6",
  "PRO_NOMBRE": "Salpingooforectomía bilateral"
 },
 {
  "CATALOG_KEY": "65.61",
  "PRO_NOMBRE": "Otra extirpación de ambos ovarios y trompas en un mismo acto operatorio"
 },
 {
  "CATALOG_KEY": "65.62",
  "PRO_NOMBRE": "Otra extirpación de ovario y trompa restantes"
 },
 {
  "CATALOG_KEY": "65.63",
  "PRO_NOMBRE": "Extirpación laparoscópica de ambos ovarios y trompas en un mismo acto operatorio"
 },
 {
  "CATALOG_KEY": "65.64",
  "PRO_NOMBRE": "Extirpación laparoscópica de ovario y trompa restantes"
 },
 {
  "CATALOG_KEY": "65.7",
  "PRO_NOMBRE": "Reparación de ovario"
 },
 {
  "CATALOG_KEY": "65.71",
  "PRO_NOMBRE": "Otra sutura simple de ovario"
 },
 {
  "CATALOG_KEY": "65.72",
  "PRO_NOMBRE": "Otra reimplantación de ovario"
 },
 {
  "CATALOG_KEY": "65.73",
  "PRO_NOMBRE": "Otra salpingooforoplastía"
 },
 {
  "CATALOG_KEY": "65.74",
  "PRO_NOMBRE": "Sutura simple laparoscópica de ovario"
 },
 {
  "CATALOG_KEY": "65.75",
  "PRO_NOMBRE": "Reimplantación laparoscópica de ovario"
 },
 {
  "CATALOG_KEY": "65.76",
  "PRO_NOMBRE": "Salpingooforoplastía laparoscópica"
 },
 {
  "CATALOG_KEY": "65.79",
  "PRO_NOMBRE": "Otra reparación de ovario"
 },
 {
  "CATALOG_KEY": "65.8",
  "PRO_NOMBRE": "Liberación de adherencias de ovario y trompa de Falopio"
 },
 {
  "CATALOG_KEY": "65.81",
  "PRO_NOMBRE": "Liberación laparoscópica de adherencias de ovario y trompa de Falopio"
 },
 {
  "CATALOG_KEY": "65.89",
  "PRO_NOMBRE": "Otra liberación de adherencias de ovario y trompa de Falopio"
 },
 {
  "CATALOG_KEY": "65.9",
  "PRO_NOMBRE": "Otras operaciones sobre el ovario"
 },
 {
  "CATALOG_KEY": "65.91",
  "PRO_NOMBRE": "Aspiración de ovario"
 },
 {
  "CATALOG_KEY": "65.92",
  "PRO_NOMBRE": "Trasplante de ovario"
 },
 {
  "CATALOG_KEY": "65.93",
  "PRO_NOMBRE": "Ruptura manual de quiste ovárico"
 },
 {
  "CATALOG_KEY": "65.94",
  "PRO_NOMBRE": "Denervación ovárica"
 },
 {
  "CATALOG_KEY": "65.95",
  "PRO_NOMBRE": "Liberación de torsión de ovario"
 },
 {
  "CATALOG_KEY": "65.99",
  "PRO_NOMBRE": "Otras operaciones sobre el ovario"
 },
 {
  "CATALOG_KEY": "66",
  "PRO_NOMBRE": "Operaciones sobre las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.0",
  "PRO_NOMBRE": "Salpingotomía y salpingostomia"
 },
 {
  "CATALOG_KEY": "66.01",
  "PRO_NOMBRE": "Salpingotomía"
 },
 {
  "CATALOG_KEY": "66.02",
  "PRO_NOMBRE": "Salpingostomía"
 },
 {
  "CATALOG_KEY": "66.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.11",
  "PRO_NOMBRE": "Biopsia de trompa de Falopio"
 },
 {
  "CATALOG_KEY": "66.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.2",
  "PRO_NOMBRE": "Destrucción u oclusión endoscópica bilateral de las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.21",
  "PRO_NOMBRE": "Ligadura y aplastamiento endoscópico bilateral de las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.22",
  "PRO_NOMBRE": "Ligadura y sección endoscópica bilateral de las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.29",
  "PRO_NOMBRE": "Otra destrucción u oclusión endoscópica bilateral de las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.3",
  "PRO_NOMBRE": "Otra destrucción u oclusión bilateral de las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.31",
  "PRO_NOMBRE": "Otra ligadura y aplastamiento bilateral de las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.32",
  "PRO_NOMBRE": "Otra ligadura y sección bilateral de las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.39",
  "PRO_NOMBRE": "Otra destrucción u oclusión bilateral de las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.4",
  "PRO_NOMBRE": "Salpingectomía unilateral total"
 },
 {
  "CATALOG_KEY": "66.5",
  "PRO_NOMBRE": "Salpingectomía bilateral total"
 },
 {
  "CATALOG_KEY": "66.51",
  "PRO_NOMBRE": "Extirpación de ambas trompas de Falopio en un mismo acto quirúrgico"
 },
 {
  "CATALOG_KEY": "66.52",
  "PRO_NOMBRE": "Extirpación de trompa de Falopio restante"
 },
 {
  "CATALOG_KEY": "66.6",
  "PRO_NOMBRE": "Otra salpingectomía"
 },
 {
  "CATALOG_KEY": "66.61",
  "PRO_NOMBRE": "Excisión o destrucción de lesión de trompa de Falopio"
 },
 {
  "CATALOG_KEY": "66.62",
  "PRO_NOMBRE": "Salpingectomía con extracción de embarazo tubárico"
 },
 {
  "CATALOG_KEY": "66.63",
  "PRO_NOMBRE": "Salpingectomía parcial bilateral, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "66.69",
  "PRO_NOMBRE": "Otra salpingectomia parcial"
 },
 {
  "CATALOG_KEY": "66.7",
  "PRO_NOMBRE": "Reparación de trompa de Falopio"
 },
 {
  "CATALOG_KEY": "66.71",
  "PRO_NOMBRE": "Sutura simple de trompa de Falopio"
 },
 {
  "CATALOG_KEY": "66.72",
  "PRO_NOMBRE": "Salpingooforostomía"
 },
 {
  "CATALOG_KEY": "66.73",
  "PRO_NOMBRE": "Salpingosalpingostomía"
 },
 {
  "CATALOG_KEY": "66.74",
  "PRO_NOMBRE": "Salpingouterostomía"
 },
 {
  "CATALOG_KEY": "66.79",
  "PRO_NOMBRE": "Otra reparación de trompa de Falopio"
 },
 {
  "CATALOG_KEY": "66.8",
  "PRO_NOMBRE": "Insuflación de trompa de Falopio"
 },
 {
  "CATALOG_KEY": "66.9",
  "PRO_NOMBRE": "Otras operaciones sobre trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.91",
  "PRO_NOMBRE": "Aspiración de trompa de Falopio"
 },
 {
  "CATALOG_KEY": "66.92",
  "PRO_NOMBRE": "Destrucción u oclusión unilateral de trompa de Falopio"
 },
 {
  "CATALOG_KEY": "66.93",
  "PRO_NOMBRE": "Implantación o sustitución de prótesis de trompa de Falopio"
 },
 {
  "CATALOG_KEY": "66.94",
  "PRO_NOMBRE": "Extracción de prótesis de trompa de Falopio"
 },
 {
  "CATALOG_KEY": "66.95",
  "PRO_NOMBRE": "Insuflación de agente terapéutico en las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.96",
  "PRO_NOMBRE": "Dilatación de las trompas de Falopio"
 },
 {
  "CATALOG_KEY": "66.97",
  "PRO_NOMBRE": "Enterramiento de fimbrias en la pared uterina"
 },
 {
  "CATALOG_KEY": "66.99",
  "PRO_NOMBRE": "Otras operaciones sobre trompas de Falopio"
 },
 {
  "CATALOG_KEY": "67",
  "PRO_NOMBRE": "Operaciones sobre el cuello uterino"
 },
 {
  "CATALOG_KEY": "67.0",
  "PRO_NOMBRE": "Dilatación del canal cervical"
 },
 {
  "CATALOG_KEY": "67.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre el cuello uterino"
 },
 {
  "CATALOG_KEY": "67.11",
  "PRO_NOMBRE": "Biopsia endocervical"
 },
 {
  "CATALOG_KEY": "67.12",
  "PRO_NOMBRE": "Otra biopsia cervical"
 },
 {
  "CATALOG_KEY": "67.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre el cuello uterino"
 },
 {
  "CATALOG_KEY": "67.2",
  "PRO_NOMBRE": "Conización"
 },
 {
  "CATALOG_KEY": "67.3",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión o tejido del cuello uterino"
 },
 {
  "CATALOG_KEY": "67.31",
  "PRO_NOMBRE": "Marsupialización de quiste cervical"
 },
 {
  "CATALOG_KEY": "67.32",
  "PRO_NOMBRE": "Destrucción de lesión del cuello uterino por cauterización"
 },
 {
  "CATALOG_KEY": "67.33",
  "PRO_NOMBRE": "Destrucción de lesión del cuello uterino por criocirugía"
 },
 {
  "CATALOG_KEY": "67.39",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión o tejido del cuello uterino"
 },
 {
  "CATALOG_KEY": "67.4",
  "PRO_NOMBRE": "Amputación del cuello uterino"
 },
 {
  "CATALOG_KEY": "67.5",
  "PRO_NOMBRE": "Reparación de orificio cervical interno"
 },
 {
  "CATALOG_KEY": "67.51",
  "PRO_NOMBRE": "Cerclaje transabdominal de cervix"
 },
 {
  "CATALOG_KEY": "67.59",
  "PRO_NOMBRE": "Otra reparación de orificio cervical interno"
 },
 {
  "CATALOG_KEY": "67.6",
  "PRO_NOMBRE": "Otra reparación del cuello uterino"
 },
 {
  "CATALOG_KEY": "67.61",
  "PRO_NOMBRE": "Sutura de desgarro de cuello uterino"
 },
 {
  "CATALOG_KEY": "67.62",
  "PRO_NOMBRE": "Reparación de fístula de cuello uterino"
 },
 {
  "CATALOG_KEY": "67.69",
  "PRO_NOMBRE": "Otra reparación del cuello uterino"
 },
 {
  "CATALOG_KEY": "68",
  "PRO_NOMBRE": "Otra incisión y excisión del útero"
 },
 {
  "CATALOG_KEY": "68.0",
  "PRO_NOMBRE": "Histerotomía"
 },
 {
  "CATALOG_KEY": "68.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre el útero y sus estructuras de soporte"
 },
 {
  "CATALOG_KEY": "68.11",
  "PRO_NOMBRE": "Examen digital del útero"
 },
 {
  "CATALOG_KEY": "68.12",
  "PRO_NOMBRE": "Histeroscopia"
 },
 {
  "CATALOG_KEY": "68.13",
  "PRO_NOMBRE": "Biopsia abierta de útero"
 },
 {
  "CATALOG_KEY": "68.14",
  "PRO_NOMBRE": "Biopsia abierta de ligamentos uterinos"
 },
 {
  "CATALOG_KEY": "68.15",
  "PRO_NOMBRE": "Biopsia cerrada de ligamentos uterinos"
 },
 {
  "CATALOG_KEY": "68.16",
  "PRO_NOMBRE": "Biopsia cerrada de útero"
 },
 {
  "CATALOG_KEY": "68.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre útero y estructuras de soporte"
 },
 {
  "CATALOG_KEY": "68.2",
  "PRO_NOMBRE": "Excisión o destrucción de lesión o tejido del útero"
 },
 {
  "CATALOG_KEY": "68.21",
  "PRO_NOMBRE": "División de sinequias endometriales"
 },
 {
  "CATALOG_KEY": "68.22",
  "PRO_NOMBRE": "Incisión o excisión de tabique congénito del útero"
 },
 {
  "CATALOG_KEY": "68.23",
  "PRO_NOMBRE": "Ablación endometrial"
 },
 {
  "CATALOG_KEY": "68.29",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión del útero"
 },
 {
  "CATALOG_KEY": "68.3",
  "PRO_NOMBRE": "Histerectomía subtotal abdominal"
 },
 {
  "CATALOG_KEY": "68.31",
  "PRO_NOMBRE": "Histerectomía supracervical laparoscópica [HSL]"
 },
 {
  "CATALOG_KEY": "68.39",
  "PRO_NOMBRE": "Otra histerectomía subtotal abdominal y la no especificada"
 },
 {
  "CATALOG_KEY": "68.4",
  "PRO_NOMBRE": "Histerectomía total abdominal"
 },
 {
  "CATALOG_KEY": "68.41",
  "PRO_NOMBRE": "Histerectomía total abdominal laparoscópica"
 },
 {
  "CATALOG_KEY": "68.49",
  "PRO_NOMBRE": "Otra histerectomía total abdominal y la no especificada"
 },
 {
  "CATALOG_KEY": "68.5",
  "PRO_NOMBRE": "Histerectomía vaginal"
 },
 {
  "CATALOG_KEY": "68.51",
  "PRO_NOMBRE": "Histerectomía vaginal asistida por laparoscopia (HVAL)"
 },
 {
  "CATALOG_KEY": "68.59",
  "PRO_NOMBRE": "Otra histerectomía vaginal y la no especificada"
 },
 {
  "CATALOG_KEY": "68.6",
  "PRO_NOMBRE": "Histerectomía radical abdominal"
 },
 {
  "CATALOG_KEY": "68.61",
  "PRO_NOMBRE": "Histerectomía radical abdominal laparoscópica"
 },
 {
  "CATALOG_KEY": "68.69",
  "PRO_NOMBRE": "Otra histerectomía radical abdominal y la no especificada"
 },
 {
  "CATALOG_KEY": "68.7",
  "PRO_NOMBRE": "Histerectomía radical vaginal"
 },
 {
  "CATALOG_KEY": "68.71",
  "PRO_NOMBRE": "Histerectomía radical vaginal laparoscópica [HRVL]"
 },
 {
  "CATALOG_KEY": "68.79",
  "PRO_NOMBRE": "Otra histerectomía radical vaginal y la no especificada"
 },
 {
  "CATALOG_KEY": "68.8",
  "PRO_NOMBRE": "Exenteración pélvica"
 },
 {
  "CATALOG_KEY": "68.9",
  "PRO_NOMBRE": "Otras histerectomías y las no especificadas"
 },
 {
  "CATALOG_KEY": "69",
  "PRO_NOMBRE": "Otras operaciones sobre el útero y sus estructuras de soporte"
 },
 {
  "CATALOG_KEY": "69.0",
  "PRO_NOMBRE": "Dilatación y legrado del útero"
 },
 {
  "CATALOG_KEY": "69.01",
  "PRO_NOMBRE": "Dilatación y legrado para terminación del embarazo"
 },
 {
  "CATALOG_KEY": "69.02",
  "PRO_NOMBRE": "Dilatación y legrado después de parto o aborto"
 },
 {
  "CATALOG_KEY": "69.09",
  "PRO_NOMBRE": "Otra dilatación y legrado"
 },
 {
  "CATALOG_KEY": "69.1",
  "PRO_NOMBRE": "Excisión o destrucción de lesión o tejido del útero y sus estructuras de soporte"
 },
 {
  "CATALOG_KEY": "69.19",
  "PRO_NOMBRE": "Otra excisión o destrucción del útero y sus estructuras de soporte"
 },
 {
  "CATALOG_KEY": "69.2",
  "PRO_NOMBRE": "Reparación de estructuras de soporte de útero"
 },
 {
  "CATALOG_KEY": "69.21",
  "PRO_NOMBRE": "Operación de interposición"
 },
 {
  "CATALOG_KEY": "69.22",
  "PRO_NOMBRE": "Otra suspensión uterina"
 },
 {
  "CATALOG_KEY": "69.23",
  "PRO_NOMBRE": "Reparación vaginal de inversión crónica del útero"
 },
 {
  "CATALOG_KEY": "69.29",
  "PRO_NOMBRE": "Otra reparación del útero y sus estructuras de soporte"
 },
 {
  "CATALOG_KEY": "69.3",
  "PRO_NOMBRE": "Denervación uterina paracervical"
 },
 {
  "CATALOG_KEY": "69.4",
  "PRO_NOMBRE": "Reparación uterina"
 },
 {
  "CATALOG_KEY": "69.41",
  "PRO_NOMBRE": "Sutura de desgarro de útero"
 },
 {
  "CATALOG_KEY": "69.42",
  "PRO_NOMBRE": "Cierre de fístula de útero"
 },
 {
  "CATALOG_KEY": "69.49",
  "PRO_NOMBRE": "Otra reparación de útero"
 },
 {
  "CATALOG_KEY": "69.5",
  "PRO_NOMBRE": "Legrado por aspiración de útero"
 },
 {
  "CATALOG_KEY": "69.51",
  "PRO_NOMBRE": "Legrado por aspiración del útero para terminación de embarazo"
 },
 {
  "CATALOG_KEY": "69.52",
  "PRO_NOMBRE": "Legrado por aspiración del útero después de parto o aborto"
 },
 {
  "CATALOG_KEY": "69.59",
  "PRO_NOMBRE": "Otro legrado por aspiración del útero"
 },
 {
  "CATALOG_KEY": "69.6",
  "PRO_NOMBRE": "Extracción o regulación menstrual"
 },
 {
  "CATALOG_KEY": "69.7",
  "PRO_NOMBRE": "Inserción de dispositivo anticonceptivo intrauterino"
 },
 {
  "CATALOG_KEY": "69.9",
  "PRO_NOMBRE": "Otras operaciones sobre útero, cuello y estructuras de apoyo"
 },
 {
  "CATALOG_KEY": "69.91",
  "PRO_NOMBRE": "Inserción de dispositivo terapéutico en útero"
 },
 {
  "CATALOG_KEY": "69.92",
  "PRO_NOMBRE": "Inseminación artificial"
 },
 {
  "CATALOG_KEY": "69.93",
  "PRO_NOMBRE": "Inserción de laminaria"
 },
 {
  "CATALOG_KEY": "69.94",
  "PRO_NOMBRE": "Reposición manual de útero invertido"
 },
 {
  "CATALOG_KEY": "69.95",
  "PRO_NOMBRE": "Incisión de cuello"
 },
 {
  "CATALOG_KEY": "69.96",
  "PRO_NOMBRE": "Extracción de material de cerclaje del cuello uterino"
 },
 {
  "CATALOG_KEY": "69.97",
  "PRO_NOMBRE": "Extracción de otro cuerpo extraño penetrante del cuello uterino"
 },
 {
  "CATALOG_KEY": "69.98",
  "PRO_NOMBRE": "Otras operaciones sobre las estructuras de soporte de útero"
 },
 {
  "CATALOG_KEY": "69.99",
  "PRO_NOMBRE": "Otras operaciones sobre cuello uterino y útero"
 },
 {
  "CATALOG_KEY": "70",
  "PRO_NOMBRE": "Operaciones sobre la vagina y fondo de saco"
 },
 {
  "CATALOG_KEY": "70.0",
  "PRO_NOMBRE": "Culdocentesis"
 },
 {
  "CATALOG_KEY": "70.1",
  "PRO_NOMBRE": "Incisión de vagina y de fondo de saco"
 },
 {
  "CATALOG_KEY": "70.11",
  "PRO_NOMBRE": "Himenotomía"
 },
 {
  "CATALOG_KEY": "70.12",
  "PRO_NOMBRE": "Culdotomía"
 },
 {
  "CATALOG_KEY": "70.13",
  "PRO_NOMBRE": "Liberación de adherencias vaginales intraluminales"
 },
 {
  "CATALOG_KEY": "70.14",
  "PRO_NOMBRE": "Otra vaginotomía"
 },
 {
  "CATALOG_KEY": "70.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre vagina y fondo de saco"
 },
 {
  "CATALOG_KEY": "70.21",
  "PRO_NOMBRE": "Vaginoscopia"
 },
 {
  "CATALOG_KEY": "70.22",
  "PRO_NOMBRE": "Culdoscopia"
 },
 {
  "CATALOG_KEY": "70.23",
  "PRO_NOMBRE": "Biopsia de fondo de saco"
 },
 {
  "CATALOG_KEY": "70.24",
  "PRO_NOMBRE": "Biopsia vaginal"
 },
 {
  "CATALOG_KEY": "70.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre vagina y fondo de saco"
 },
 {
  "CATALOG_KEY": "70.3",
  "PRO_NOMBRE": "Escisión local o destrucción de vagina y fondo de saco"
 },
 {
  "CATALOG_KEY": "70.31",
  "PRO_NOMBRE": "Himenectomía"
 },
 {
  "CATALOG_KEY": "70.32",
  "PRO_NOMBRE": "Excisión o destrucción de lesión de fondo de saco"
 },
 {
  "CATALOG_KEY": "70.33",
  "PRO_NOMBRE": "Excisión o destrucción de lesión de vagina"
 },
 {
  "CATALOG_KEY": "70.4",
  "PRO_NOMBRE": "Obliteración y excisión total de vagina"
 },
 {
  "CATALOG_KEY": "70.5",
  "PRO_NOMBRE": "Reparación de cistocele y rectocele"
 },
 {
  "CATALOG_KEY": "70.50",
  "PRO_NOMBRE": "Reparación de cistocele y rectocele"
 },
 {
  "CATALOG_KEY": "70.51",
  "PRO_NOMBRE": "Reparación de cistocele"
 },
 {
  "CATALOG_KEY": "70.52",
  "PRO_NOMBRE": "Reparación de rectocele"
 },
 {
  "CATALOG_KEY": "70.53",
  "PRO_NOMBRE": "Reparación de cistocele y rectocele con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "70.54",
  "PRO_NOMBRE": "Reparación de cistocele con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "70.55",
  "PRO_NOMBRE": "Reparación de rectocele con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "70.6",
  "PRO_NOMBRE": "Construcción y reconstrucción vaginales"
 },
 {
  "CATALOG_KEY": "70.61",
  "PRO_NOMBRE": "Construcción vaginal (creación de una neovagina)"
 },
 {
  "CATALOG_KEY": "70.62",
  "PRO_NOMBRE": "Reconstrucción vaginal"
 },
 {
  "CATALOG_KEY": "70.63",
  "PRO_NOMBRE": "Construcción vaginal con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "70.64",
  "PRO_NOMBRE": "Reconstrucción vaginal con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "70.7",
  "PRO_NOMBRE": "Otra reparación de vagina"
 },
 {
  "CATALOG_KEY": "70.71",
  "PRO_NOMBRE": "Sutura de desgarro de vagina"
 },
 {
  "CATALOG_KEY": "70.72",
  "PRO_NOMBRE": "Reparación de fístula colovaginal"
 },
 {
  "CATALOG_KEY": "70.73",
  "PRO_NOMBRE": "Reparación de fístula rectovaginal"
 },
 {
  "CATALOG_KEY": "70.74",
  "PRO_NOMBRE": "Reparación de otra fístula vaginoentérica"
 },
 {
  "CATALOG_KEY": "70.75",
  "PRO_NOMBRE": "Reparación de otra fístula de vagina"
 },
 {
  "CATALOG_KEY": "70.76",
  "PRO_NOMBRE": "Himenorrafia"
 },
 {
  "CATALOG_KEY": "70.77",
  "PRO_NOMBRE": "Suspensión y fijación de vagina"
 },
 {
  "CATALOG_KEY": "70.78",
  "PRO_NOMBRE": "Suspensión y fijación vaginal con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "70.79",
  "PRO_NOMBRE": "Otra reparación de vagina"
 },
 {
  "CATALOG_KEY": "70.8",
  "PRO_NOMBRE": "Obliteración de la cúpula vaginal"
 },
 {
  "CATALOG_KEY": "70.9",
  "PRO_NOMBRE": "Otras operaciones sobre la vagina y fondo de saco"
 },
 {
  "CATALOG_KEY": "70.91",
  "PRO_NOMBRE": "Otras operaciones sobre la vagina"
 },
 {
  "CATALOG_KEY": "70.92",
  "PRO_NOMBRE": "Otras operaciones sobre fondo de saco"
 },
 {
  "CATALOG_KEY": "70.93",
  "PRO_NOMBRE": "Otras operaciones sobre fondo de saco con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "70.94",
  "PRO_NOMBRE": "Inserción de injerto biológico"
 },
 {
  "CATALOG_KEY": "70.95",
  "PRO_NOMBRE": "Inserción de injerto sintético o prótesis de tejido artificial"
 },
 {
  "CATALOG_KEY": "71",
  "PRO_NOMBRE": "Operaciones sobre la vulva y el perineo"
 },
 {
  "CATALOG_KEY": "71.0",
  "PRO_NOMBRE": "Incisión de vulva y perineo"
 },
 {
  "CATALOG_KEY": "71.01",
  "PRO_NOMBRE": "Liberación de adherencias vulvares"
 },
 {
  "CATALOG_KEY": "71.09",
  "PRO_NOMBRE": "Otra incisión de vulva y perineo"
 },
 {
  "CATALOG_KEY": "71.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre la vulva"
 },
 {
  "CATALOG_KEY": "71.11",
  "PRO_NOMBRE": "Biopsia de vulva"
 },
 {
  "CATALOG_KEY": "71.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre la vulva"
 },
 {
  "CATALOG_KEY": "71.2",
  "PRO_NOMBRE": "Operaciones sobre la glándula de Bartholin"
 },
 {
  "CATALOG_KEY": "71.21",
  "PRO_NOMBRE": "Aspiración percutánea de glándula de Bartholin (quiste)"
 },
 {
  "CATALOG_KEY": "71.22",
  "PRO_NOMBRE": "Incisión de glándula de Bartholin (quiste)"
 },
 {
  "CATALOG_KEY": "71.23",
  "PRO_NOMBRE": "Marsupialización de glándula de Bartholin (quiste)"
 },
 {
  "CATALOG_KEY": "71.24",
  "PRO_NOMBRE": "Excisión u otra destrucción de glándula de Bartholin (quiste)"
 },
 {
  "CATALOG_KEY": "71.29",
  "PRO_NOMBRE": "Otras operaciones sobre las glándulas de Bartholin"
 },
 {
  "CATALOG_KEY": "71.3",
  "PRO_NOMBRE": "Otra excisión local o destrucción de la vulva y el perineo"
 },
 {
  "CATALOG_KEY": "71.4",
  "PRO_NOMBRE": "Operaciones sobre el clítoris"
 },
 {
  "CATALOG_KEY": "71.5",
  "PRO_NOMBRE": "Vulvectomía radical"
 },
 {
  "CATALOG_KEY": "71.6",
  "PRO_NOMBRE": "Otra vulvectomía"
 },
 {
  "CATALOG_KEY": "71.61",
  "PRO_NOMBRE": "Vulvectomía unilateral"
 },
 {
  "CATALOG_KEY": "71.62",
  "PRO_NOMBRE": "Vulvectomía bilateral"
 },
 {
  "CATALOG_KEY": "71.7",
  "PRO_NOMBRE": "Reparación de la vulva o el perineo"
 },
 {
  "CATALOG_KEY": "71.71",
  "PRO_NOMBRE": "Sutura de desgarro de la vulva o el perineo actual"
 },
 {
  "CATALOG_KEY": "71.72",
  "PRO_NOMBRE": "Reparación de fístula de vulva o perineo"
 },
 {
  "CATALOG_KEY": "71.79",
  "PRO_NOMBRE": "Otra reparación de la vulva y el perineo"
 },
 {
  "CATALOG_KEY": "71.8",
  "PRO_NOMBRE": "Otras reparaciones sobre vulva"
 },
 {
  "CATALOG_KEY": "71.9",
  "PRO_NOMBRE": "Otras operaciones sobre los órganos genitales femeninos"
 },
 {
  "CATALOG_KEY": "72",
  "PRO_NOMBRE": "Fórceps, ventosa y parto de nalgas"
 },
 {
  "CATALOG_KEY": "72.0",
  "PRO_NOMBRE": "Aplicación de fórceps bajo"
 },
 {
  "CATALOG_KEY": "72.1",
  "PRO_NOMBRE": "Aplicación de fórceps bajo con episiotomía"
 },
 {
  "CATALOG_KEY": "72.2",
  "PRO_NOMBRE": "Aplicación de fórceps medio"
 },
 {
  "CATALOG_KEY": "72.21",
  "PRO_NOMBRE": "Aplicación de fórceps medio con episiotomía"
 },
 {
  "CATALOG_KEY": "72.29",
  "PRO_NOMBRE": "Otra aplicación de fórceps medio"
 },
 {
  "CATALOG_KEY": "72.3",
  "PRO_NOMBRE": "Aplicación de fórceps alto"
 },
 {
  "CATALOG_KEY": "72.31",
  "PRO_NOMBRE": "Aplicación de fórceps alto con episiotomía"
 },
 {
  "CATALOG_KEY": "72.39",
  "PRO_NOMBRE": "Otra aplicación de fórceps alto"
 },
 {
  "CATALOG_KEY": "72.4",
  "PRO_NOMBRE": "Rotación mediante fórceps de la cabeza del feto"
 },
 {
  "CATALOG_KEY": "72.5",
  "PRO_NOMBRE": "Extracción con presentación de nalgas"
 },
 {
  "CATALOG_KEY": "72.51",
  "PRO_NOMBRE": "Extracción parcial con presentación de nalgas mediante aplicación de fórceps en cabeza última"
 },
 {
  "CATALOG_KEY": "72.52",
  "PRO_NOMBRE": "Otra extracción parcial en presentación de nalgas"
 },
 {
  "CATALOG_KEY": "72.53",
  "PRO_NOMBRE": "Extracción total en presentación de nalgas con aplicación de fórceps en cabeza última"
 },
 {
  "CATALOG_KEY": "72.54",
  "PRO_NOMBRE": "Otra extracción total con presentación de nalgas"
 },
 {
  "CATALOG_KEY": "72.6",
  "PRO_NOMBRE": "Aplicación de fórceps a cabeza última"
 },
 {
  "CATALOG_KEY": "72.7",
  "PRO_NOMBRE": "Extracción con ventosa obstétrica"
 },
 {
  "CATALOG_KEY": "72.71",
  "PRO_NOMBRE": "Extracción mediante ventosa con episiotomía"
 },
 {
  "CATALOG_KEY": "72.79",
  "PRO_NOMBRE": "Otra extracción mediante ventosa"
 },
 {
  "CATALOG_KEY": "72.8",
  "PRO_NOMBRE": "Otro parto instrumentado especificado"
 },
 {
  "CATALOG_KEY": "72.9",
  "PRO_NOMBRE": "Parto instrumentado no especificado"
 },
 {
  "CATALOG_KEY": "73",
  "PRO_NOMBRE": "Otros procedimientos para la inducción o asistencia al parto"
 },
 {
  "CATALOG_KEY": "73.0",
  "PRO_NOMBRE": "Ruptura artificial de las membranas"
 },
 {
  "CATALOG_KEY": "73.01",
  "PRO_NOMBRE": "Inducción del parto por ruptura artificial de las membranas"
 },
 {
  "CATALOG_KEY": "73.09",
  "PRO_NOMBRE": "Otra ruptura artificial de las membranas"
 },
 {
  "CATALOG_KEY": "73.1",
  "PRO_NOMBRE": "Otra inducción quirúrgica del parto"
 },
 {
  "CATALOG_KEY": "73.2",
  "PRO_NOMBRE": "Versión interna y combinada y extracción"
 },
 {
  "CATALOG_KEY": "73.21",
  "PRO_NOMBRE": "Versión interna y combinada sin extracción"
 },
 {
  "CATALOG_KEY": "73.22",
  "PRO_NOMBRE": "Versión interna y combinada con extracción"
 },
 {
  "CATALOG_KEY": "73.3",
  "PRO_NOMBRE": "Operación de fórceps fallida"
 },
 {
  "CATALOG_KEY": "73.4",
  "PRO_NOMBRE": "Inducción médica de parto"
 },
 {
  "CATALOG_KEY": "73.5",
  "PRO_NOMBRE": "Parto asistido manualmente"
 },
 {
  "CATALOG_KEY": "73.51",
  "PRO_NOMBRE": "Rotación manual de la cabeza de feto"
 },
 {
  "CATALOG_KEY": "73.59",
  "PRO_NOMBRE": "Otro parto asistido manualmente"
 },
 {
  "CATALOG_KEY": "73.6",
  "PRO_NOMBRE": "Episiotomía"
 },
 {
  "CATALOG_KEY": "73.8",
  "PRO_NOMBRE": "Operaciones sobre el feto para facilitar el período expulsivo"
 },
 {
  "CATALOG_KEY": "73.9",
  "PRO_NOMBRE": "Otras operaciones de asistencia al período expulsivo"
 },
 {
  "CATALOG_KEY": "73.91",
  "PRO_NOMBRE": "Versión externa"
 },
 {
  "CATALOG_KEY": "73.92",
  "PRO_NOMBRE": "Sustitución del cordón umbilical prolapsado"
 },
 {
  "CATALOG_KEY": "73.93",
  "PRO_NOMBRE": "Incisión del cuello uterino para ayudar al período expulsivo"
 },
 {
  "CATALOG_KEY": "73.94",
  "PRO_NOMBRE": "Pubiotomía para asistir al parto"
 },
 {
  "CATALOG_KEY": "73.99",
  "PRO_NOMBRE": "Otra operación de asistencia al período expulsivo"
 },
 {
  "CATALOG_KEY": "74",
  "PRO_NOMBRE": "Cesárea y extracción de feto"
 },
 {
  "CATALOG_KEY": "74.0",
  "PRO_NOMBRE": "Cesárea clásica"
 },
 {
  "CATALOG_KEY": "74.1",
  "PRO_NOMBRE": "Cesárea clásica baja"
 },
 {
  "CATALOG_KEY": "74.2",
  "PRO_NOMBRE": "Cesárea extraperitoneal"
 },
 {
  "CATALOG_KEY": "74.4",
  "PRO_NOMBRE": "Cesárea de otro tipo especificado"
 },
 {
  "CATALOG_KEY": "74.9",
  "PRO_NOMBRE": "Cesárea de tipo no especificado"
 },
 {
  "CATALOG_KEY": "74.91",
  "PRO_NOMBRE": "Histerotomía para terminar el embarazo"
 },
 {
  "CATALOG_KEY": "74.99",
  "PRO_NOMBRE": "Otra cesárea de tipo no especificado"
 },
 {
  "CATALOG_KEY": "75",
  "PRO_NOMBRE": "Otras operaciones obstétricas"
 },
 {
  "CATALOG_KEY": "75.0",
  "PRO_NOMBRE": "Inyección intra-amniótica para inducir el aborto"
 },
 {
  "CATALOG_KEY": "75.1",
  "PRO_NOMBRE": "Amniocentesis diagnóstica"
 },
 {
  "CATALOG_KEY": "75.2",
  "PRO_NOMBRE": "Transfusión intrauterina"
 },
 {
  "CATALOG_KEY": "75.3",
  "PRO_NOMBRE": "Otras operaciones intrauterinas sobre el feto y el amnios"
 },
 {
  "CATALOG_KEY": "75.31",
  "PRO_NOMBRE": "Amnioscopia"
 },
 {
  "CATALOG_KEY": "75.32",
  "PRO_NOMBRE": "Electrocardiograma fetal (cuero cabelludo)"
 },
 {
  "CATALOG_KEY": "75.33",
  "PRO_NOMBRE": "Biopsia y toma de sangre fetal"
 },
 {
  "CATALOG_KEY": "75.34",
  "PRO_NOMBRE": "Otra monitorización fetal"
 },
 {
  "CATALOG_KEY": "75.35",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre el feto y amnios"
 },
 {
  "CATALOG_KEY": "75.36",
  "PRO_NOMBRE": "Corrección de defecto fetal"
 },
 {
  "CATALOG_KEY": "75.37",
  "PRO_NOMBRE": "Amnioinfusión"
 },
 {
  "CATALOG_KEY": "75.38",
  "PRO_NOMBRE": "Pulsioximetría fetal"
 },
 {
  "CATALOG_KEY": "75.4",
  "PRO_NOMBRE": "Extracción manual de placenta retenida"
 },
 {
  "CATALOG_KEY": "75.5",
  "PRO_NOMBRE": "Reparación de desgarro obstétrico actual del útero"
 },
 {
  "CATALOG_KEY": "75.50",
  "PRO_NOMBRE": "Reparación de desgarro obstétrico actual del útero, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "75.51",
  "PRO_NOMBRE": "Reparación de desgarro obstétrico actual del cuello uterino"
 },
 {
  "CATALOG_KEY": "75.52",
  "PRO_NOMBRE": "Reparación de desgarro obstétrico actual del cuerpo uterino"
 },
 {
  "CATALOG_KEY": "75.6",
  "PRO_NOMBRE": "Reparación de otro desgarro obstétrico actual"
 },
 {
  "CATALOG_KEY": "75.61",
  "PRO_NOMBRE": "Reparación de desgarro obstétrico actual de vejiga y uretra"
 },
 {
  "CATALOG_KEY": "75.62",
  "PRO_NOMBRE": "Reparación de desgarro obstétrico actual de recto y esfínter anal"
 },
 {
  "CATALOG_KEY": "75.69",
  "PRO_NOMBRE": "Reparación de otro desgarro obstétrico actual"
 },
 {
  "CATALOG_KEY": "75.7",
  "PRO_NOMBRE": "Exploración manual de la cavidad uterina, después del parto"
 },
 {
  "CATALOG_KEY": "75.8",
  "PRO_NOMBRE": "Taponamiento obstétrico de útero o vagina"
 },
 {
  "CATALOG_KEY": "75.9",
  "PRO_NOMBRE": "Otras operaciones obstétricas"
 },
 {
  "CATALOG_KEY": "75.91",
  "PRO_NOMBRE": "Evacuación de hematoma por incisión obstétrica de perineo"
 },
 {
  "CATALOG_KEY": "75.92",
  "PRO_NOMBRE": "Evacuación de otro hematoma de vulva o vagina"
 },
 {
  "CATALOG_KEY": "75.93",
  "PRO_NOMBRE": "Corrección quirúrgica de útero invertido"
 },
 {
  "CATALOG_KEY": "75.94",
  "PRO_NOMBRE": "Reposición manual de útero invertido"
 },
 {
  "CATALOG_KEY": "75.99",
  "PRO_NOMBRE": "Otras operaciones obstétricas"
 },
 {
  "CATALOG_KEY": "76",
  "PRO_NOMBRE": "Operaciones sobre huesos y articulaciones faciales"
 },
 {
  "CATALOG_KEY": "76.0",
  "PRO_NOMBRE": "Incisión de hueso facial sin división"
 },
 {
  "CATALOG_KEY": "76.01",
  "PRO_NOMBRE": "Secuestrectomía de hueso facial"
 },
 {
  "CATALOG_KEY": "76.09",
  "PRO_NOMBRE": "Otra incisión de hueso facial"
 },
 {
  "CATALOG_KEY": "76.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre huesos y articulaciones faciales"
 },
 {
  "CATALOG_KEY": "76.11",
  "PRO_NOMBRE": "Biopsia de hueso facial"
 },
 {
  "CATALOG_KEY": "76.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos en hueso y articulaciones faciales"
 },
 {
  "CATALOG_KEY": "76.2",
  "PRO_NOMBRE": "Excisión local o destrucción de lesiones de hueso facial"
 },
 {
  "CATALOG_KEY": "76.3",
  "PRO_NOMBRE": "Ostectomía parcial de hueso facial"
 },
 {
  "CATALOG_KEY": "76.31",
  "PRO_NOMBRE": "Mandibulectomía parcial"
 },
 {
  "CATALOG_KEY": "76.39",
  "PRO_NOMBRE": "Ostectomía, exéresis o excisión parcial de otro hueso facial"
 },
 {
  "CATALOG_KEY": "76.4",
  "PRO_NOMBRE": "Excisión y reconstrucción de huesos faciales"
 },
 {
  "CATALOG_KEY": "76.41",
  "PRO_NOMBRE": "Mandibulectomía total con reconstrucción simultánea"
 },
 {
  "CATALOG_KEY": "76.42",
  "PRO_NOMBRE": "Otra mandibulectomía total"
 },
 {
  "CATALOG_KEY": "76.43",
  "PRO_NOMBRE": "Otra reconstrucción de mandíbula"
 },
 {
  "CATALOG_KEY": "76.44",
  "PRO_NOMBRE": "Ostectomía total de otro hueso facial con reconstrucción simultánea"
 },
 {
  "CATALOG_KEY": "76.45",
  "PRO_NOMBRE": "Otra ostectomía total de otro hueso facial"
 },
 {
  "CATALOG_KEY": "76.46",
  "PRO_NOMBRE": "Otra reconstrucción de otro hueso facial"
 },
 {
  "CATALOG_KEY": "76.5",
  "PRO_NOMBRE": "Artroplastía temporomandibular"
 },
 {
  "CATALOG_KEY": "76.6",
  "PRO_NOMBRE": "Otra reparación de hueso facial y cirugía ortognática"
 },
 {
  "CATALOG_KEY": "76.61",
  "PRO_NOMBRE": "Osteoplastía cerrada [osteotomía] de rama mandibular"
 },
 {
  "CATALOG_KEY": "76.62",
  "PRO_NOMBRE": "Osteoplastía abierta [osteotomía] de rama mandibular"
 },
 {
  "CATALOG_KEY": "76.63",
  "PRO_NOMBRE": "Osteoplastía [osteotomía] de cuerpo de mandíbula"
 },
 {
  "CATALOG_KEY": "76.64",
  "PRO_NOMBRE": "Otra cirugía ortognática sobre mandíbula"
 },
 {
  "CATALOG_KEY": "76.65",
  "PRO_NOMBRE": "Osteoplastía [osteotomía] segmentaria de maxilar"
 },
 {
  "CATALOG_KEY": "76.66",
  "PRO_NOMBRE": "Osteoplastía total [osteotomía] de maxilar"
 },
 {
  "CATALOG_KEY": "76.67",
  "PRO_NOMBRE": "Genioplastía de reducción"
 },
 {
  "CATALOG_KEY": "76.68",
  "PRO_NOMBRE": "Genioplastía de aumento"
 },
 {
  "CATALOG_KEY": "76.69",
  "PRO_NOMBRE": "Otra reparación de hueso facial"
 },
 {
  "CATALOG_KEY": "76.7",
  "PRO_NOMBRE": "Reducción de fractura facial"
 },
 {
  "CATALOG_KEY": "76.70",
  "PRO_NOMBRE": "Reducción de fractura facial, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "76.71",
  "PRO_NOMBRE": "Reducción cerrada de fractura malar y cigomática"
 },
 {
  "CATALOG_KEY": "76.72",
  "PRO_NOMBRE": "Reducción abierta de fractura malar y cigomática"
 },
 {
  "CATALOG_KEY": "76.73",
  "PRO_NOMBRE": "Reducción cerrada de fractura maxilar"
 },
 {
  "CATALOG_KEY": "76.74",
  "PRO_NOMBRE": "Reducción abierta de fractura maxilar"
 },
 {
  "CATALOG_KEY": "76.75",
  "PRO_NOMBRE": "Reducción cerrada de fractura mandibular"
 },
 {
  "CATALOG_KEY": "76.76",
  "PRO_NOMBRE": "Reducción abierta de fractura mandibular"
 },
 {
  "CATALOG_KEY": "76.77",
  "PRO_NOMBRE": "Reducción abierta de fractura alveolar"
 },
 {
  "CATALOG_KEY": "76.78",
  "PRO_NOMBRE": "Otra reducción cerrada de fractura facial"
 },
 {
  "CATALOG_KEY": "76.79",
  "PRO_NOMBRE": "Otra reducción abierta de fractura facial"
 },
 {
  "CATALOG_KEY": "76.9",
  "PRO_NOMBRE": "Otras operaciones sobre hueso y articulaciones faciales"
 },
 {
  "CATALOG_KEY": "76.91",
  "PRO_NOMBRE": "Injerto óseo a hueso facial"
 },
 {
  "CATALOG_KEY": "76.92",
  "PRO_NOMBRE": "Inserción de implante sintético en hueso facial"
 },
 {
  "CATALOG_KEY": "76.93",
  "PRO_NOMBRE": "Reducción cerrada de luxación temporomandibular"
 },
 {
  "CATALOG_KEY": "76.94",
  "PRO_NOMBRE": "Reducción abierta de dislocación temporomandibular"
 },
 {
  "CATALOG_KEY": "76.95",
  "PRO_NOMBRE": "Otra manipulación de articulación temporomandibular"
 },
 {
  "CATALOG_KEY": "76.96",
  "PRO_NOMBRE": "Inyección de sustancia terapéutica en articulación temporomandibular"
 },
 {
  "CATALOG_KEY": "76.97",
  "PRO_NOMBRE": "Extracción de dispositivo de fijación interna de hueso facial"
 },
 {
  "CATALOG_KEY": "76.99",
  "PRO_NOMBRE": "Otras operaciones sobre huesos y articulaciones faciales"
 },
 {
  "CATALOG_KEY": "77",
  "PRO_NOMBRE": "Incisión, excisión y división de otros huesos"
 },
 {
  "CATALOG_KEY": "77.0",
  "PRO_NOMBRE": "Secuestrectomía"
 },
 {
  "CATALOG_KEY": "77.00",
  "PRO_NOMBRE": "Secuestrectomía — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "77.01",
  "PRO_NOMBRE": "Secuestrectomía — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "77.02",
  "PRO_NOMBRE": "Secuestrectomía — Húmero"
 },
 {
  "CATALOG_KEY": "77.03",
  "PRO_NOMBRE": "Secuestrectomía — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "77.04",
  "PRO_NOMBRE": "Secuestrectomía — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "77.05",
  "PRO_NOMBRE": "Secuestrectomía — Fémur"
 },
 {
  "CATALOG_KEY": "77.06",
  "PRO_NOMBRE": "Secuestrectomía — Rótula"
 },
 {
  "CATALOG_KEY": "77.07",
  "PRO_NOMBRE": "Secuestrectomía — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "77.08",
  "PRO_NOMBRE": "Secuestrectomía — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "77.09",
  "PRO_NOMBRE": "Secuestrectomía — Otro"
 },
 {
  "CATALOG_KEY": "77.1",
  "PRO_NOMBRE": "Otra incisión de hueso sin división"
 },
 {
  "CATALOG_KEY": "77.10",
  "PRO_NOMBRE": "Otra incisión de hueso sin división — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "77.11",
  "PRO_NOMBRE": "Otra incisión de hueso sin división — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "77.12",
  "PRO_NOMBRE": "Otra incisión de hueso sin división — Húmero"
 },
 {
  "CATALOG_KEY": "77.13",
  "PRO_NOMBRE": "Otra incisión de hueso sin división — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "77.14",
  "PRO_NOMBRE": "Otra incisión de hueso sin división — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "77.15",
  "PRO_NOMBRE": "Otra incisión de hueso sin división — Fémur"
 },
 {
  "CATALOG_KEY": "77.16",
  "PRO_NOMBRE": "Otra incisión de hueso sin división — Rótula"
 },
 {
  "CATALOG_KEY": "77.17",
  "PRO_NOMBRE": "Otra incisión de hueso sin división — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "77.18",
  "PRO_NOMBRE": "Otra incisión de hueso sin división — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "77.19",
  "PRO_NOMBRE": "Otra incisión de hueso sin división — Otro"
 },
 {
  "CATALOG_KEY": "77.2",
  "PRO_NOMBRE": "Osteotomía en cuña"
 },
 {
  "CATALOG_KEY": "77.20",
  "PRO_NOMBRE": "Osteotomía en cuña — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "77.21",
  "PRO_NOMBRE": "Osteotomía en cuña — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "77.22",
  "PRO_NOMBRE": "Osteotomía en cuña — Húmero"
 },
 {
  "CATALOG_KEY": "77.23",
  "PRO_NOMBRE": "Osteotomía en cuña — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "77.24",
  "PRO_NOMBRE": "Osteotomía en cuña — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "77.25",
  "PRO_NOMBRE": "Osteotomía en cuña — Fémur"
 },
 {
  "CATALOG_KEY": "77.26",
  "PRO_NOMBRE": "Osteotomía en cuña — Rótula"
 },
 {
  "CATALOG_KEY": "77.27",
  "PRO_NOMBRE": "Osteotomía en cuña — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "77.28",
  "PRO_NOMBRE": "Osteotomía en cuña — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "77.29",
  "PRO_NOMBRE": "Osteotomía en cuña — Otro"
 },
 {
  "CATALOG_KEY": "77.3",
  "PRO_NOMBRE": "Otra división de hueso"
 },
 {
  "CATALOG_KEY": "77.30",
  "PRO_NOMBRE": "Otra división de hueso — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "77.31",
  "PRO_NOMBRE": "Otra división de hueso — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "77.32",
  "PRO_NOMBRE": "Otra división de hueso — Húmero"
 },
 {
  "CATALOG_KEY": "77.33",
  "PRO_NOMBRE": "Otra división de hueso — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "77.34",
  "PRO_NOMBRE": "Otra división de hueso — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "77.35",
  "PRO_NOMBRE": "Otra división de hueso — Fémur"
 },
 {
  "CATALOG_KEY": "77.36",
  "PRO_NOMBRE": "Otra división de hueso — Rótula"
 },
 {
  "CATALOG_KEY": "77.37",
  "PRO_NOMBRE": "Otra división de hueso — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "77.38",
  "PRO_NOMBRE": "Otra división de hueso — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "77.39",
  "PRO_NOMBRE": "Otra división de hueso — Otro"
 },
 {
  "CATALOG_KEY": "77.4",
  "PRO_NOMBRE": "Biopsia de hueso"
 },
 {
  "CATALOG_KEY": "77.40",
  "PRO_NOMBRE": "Biopsia de hueso — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "77.41",
  "PRO_NOMBRE": "Biopsia de hueso — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "77.42",
  "PRO_NOMBRE": "Biopsia de hueso — Húmero"
 },
 {
  "CATALOG_KEY": "77.43",
  "PRO_NOMBRE": "Biopsia de hueso — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "77.44",
  "PRO_NOMBRE": "Biopsia de hueso — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "77.45",
  "PRO_NOMBRE": "Biopsia de hueso — Fémur"
 },
 {
  "CATALOG_KEY": "77.46",
  "PRO_NOMBRE": "Biopsia de hueso — Rótula"
 },
 {
  "CATALOG_KEY": "77.47",
  "PRO_NOMBRE": "Biopsia de hueso — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "77.48",
  "PRO_NOMBRE": "Biopsia de hueso — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "77.49",
  "PRO_NOMBRE": "Biopsia de hueso — Otro"
 },
 {
  "CATALOG_KEY": "77.5",
  "PRO_NOMBRE": "Excisión y reparación de hallux valgus (juanete) y de otras deformaciones de los dedos del pie"
 },
 {
  "CATALOG_KEY": "77.51",
  "PRO_NOMBRE": "Bunionectomía con corrección de tejido blando y osteotomía del primer metatarsiano"
 },
 {
  "CATALOG_KEY": "77.52",
  "PRO_NOMBRE": "Bunionectomía con corrección de tejido blando y artrodesis"
 },
 {
  "CATALOG_KEY": "77.53",
  "PRO_NOMBRE": "Otra bunionectomía con corrección de tejido blando"
 },
 {
  "CATALOG_KEY": "77.54",
  "PRO_NOMBRE": "Excisión o corrección de hallux valgus"
 },
 {
  "CATALOG_KEY": "77.56",
  "PRO_NOMBRE": "Reparación de dedo de pie en martillo"
 },
 {
  "CATALOG_KEY": "77.57",
  "PRO_NOMBRE": "Reparación de dedo de pie en garra"
 },
 {
  "CATALOG_KEY": "77.58",
  "PRO_NOMBRE": "Otra excisión, fusión y reparación de dedos del pie"
 },
 {
  "CATALOG_KEY": "77.59",
  "PRO_NOMBRE": "Otra bunionectomía"
 },
 {
  "CATALOG_KEY": "77.6",
  "PRO_NOMBRE": "Excisión local de lesión o tejido de hueso"
 },
 {
  "CATALOG_KEY": "77.60",
  "PRO_NOMBRE": "Excisión local de lesión o tejido de hueso — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "77.61",
  "PRO_NOMBRE": "Excisión local de lesión o tejido de hueso — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "77.62",
  "PRO_NOMBRE": "Excisión local de lesión o tejido de hueso — Húmero"
 },
 {
  "CATALOG_KEY": "77.63",
  "PRO_NOMBRE": "Excisión local de lesión o tejido de hueso — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "77.64",
  "PRO_NOMBRE": "Excisión local de lesión o tejido de hueso — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "77.65",
  "PRO_NOMBRE": "Excisión local de lesión o tejido de hueso — Fémur"
 },
 {
  "CATALOG_KEY": "77.66",
  "PRO_NOMBRE": "Excisión local de lesión o tejido de hueso — Rótula"
 },
 {
  "CATALOG_KEY": "77.67",
  "PRO_NOMBRE": "Excisión local de lesión o tejido de hueso — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "77.68",
  "PRO_NOMBRE": "Excisión local de lesión o tejido de hueso — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "77.69",
  "PRO_NOMBRE": "Excisión local de lesión o tejido de hueso — Otro"
 },
 {
  "CATALOG_KEY": "77.7",
  "PRO_NOMBRE": "Excisión de hueso para injerto"
 },
 {
  "CATALOG_KEY": "77.70",
  "PRO_NOMBRE": "Excisión de hueso para injerto — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "77.71",
  "PRO_NOMBRE": "Excisión de hueso para injerto — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "77.72",
  "PRO_NOMBRE": "Excisión de hueso para injerto — Húmero"
 },
 {
  "CATALOG_KEY": "77.73",
  "PRO_NOMBRE": "Excisión de hueso para injerto — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "77.74",
  "PRO_NOMBRE": "Excisión de hueso para injerto — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "77.75",
  "PRO_NOMBRE": "Excisión de hueso para injerto — Fémur"
 },
 {
  "CATALOG_KEY": "77.76",
  "PRO_NOMBRE": "Excisión de hueso para injerto — Rótula"
 },
 {
  "CATALOG_KEY": "77.77",
  "PRO_NOMBRE": "Excisión de hueso para injerto — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "77.78",
  "PRO_NOMBRE": "Excisión de hueso para injerto — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "77.79",
  "PRO_NOMBRE": "Excisión de hueso para injerto — Otro"
 },
 {
  "CATALOG_KEY": "77.8",
  "PRO_NOMBRE": "Otra ostectomía parcial"
 },
 {
  "CATALOG_KEY": "77.80",
  "PRO_NOMBRE": "Otra ostectomía parcial — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "77.81",
  "PRO_NOMBRE": "Otra ostectomía parcial — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "77.82",
  "PRO_NOMBRE": "Otra ostectomía parcial — Húmero"
 },
 {
  "CATALOG_KEY": "77.83",
  "PRO_NOMBRE": "Otra ostectomía parcial — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "77.84",
  "PRO_NOMBRE": "Otra ostectomía parcial — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "77.85",
  "PRO_NOMBRE": "Otra ostectomía parcial — Fémur"
 },
 {
  "CATALOG_KEY": "77.86",
  "PRO_NOMBRE": "Otra ostectomía parcial — Rótula"
 },
 {
  "CATALOG_KEY": "77.87",
  "PRO_NOMBRE": "Otra ostectomía parcial — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "77.88",
  "PRO_NOMBRE": "Otra ostectomía parcial — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "77.89",
  "PRO_NOMBRE": "Otra ostectomía parcial — Otro"
 },
 {
  "CATALOG_KEY": "77.9",
  "PRO_NOMBRE": "Exéresis o excisión ósea total"
 },
 {
  "CATALOG_KEY": "77.90",
  "PRO_NOMBRE": "Exéresis o excisión ósea total — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "77.91",
  "PRO_NOMBRE": "Exéresis o excisión ósea total — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "77.92",
  "PRO_NOMBRE": "Exéresis o excisión ósea total — Húmero"
 },
 {
  "CATALOG_KEY": "77.93",
  "PRO_NOMBRE": "Exéresis o excisión ósea total — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "77.94",
  "PRO_NOMBRE": "Exéresis o excisión ósea total — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "77.95",
  "PRO_NOMBRE": "Exéresis o excisión ósea total — Fémur"
 },
 {
  "CATALOG_KEY": "77.96",
  "PRO_NOMBRE": "Exéresis o excisión ósea total — Rótula"
 },
 {
  "CATALOG_KEY": "77.97",
  "PRO_NOMBRE": "Exéresis o excisión ósea total — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "77.98",
  "PRO_NOMBRE": "Exéresis o excisión ósea total — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "77.99",
  "PRO_NOMBRE": "Exéresis o excisión ósea total — Otro"
 },
 {
  "CATALOG_KEY": "78",
  "PRO_NOMBRE": "Otras operaciones de huesos, salvo huesos faciales"
 },
 {
  "CATALOG_KEY": "78.0",
  "PRO_NOMBRE": "Injerto de hueso"
 },
 {
  "CATALOG_KEY": "78.00",
  "PRO_NOMBRE": "Injerto de hueso — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "78.01",
  "PRO_NOMBRE": "Injerto de hueso — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "78.02",
  "PRO_NOMBRE": "Injerto de hueso — Húmero"
 },
 {
  "CATALOG_KEY": "78.03",
  "PRO_NOMBRE": "Injerto de hueso — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "78.04",
  "PRO_NOMBRE": "Injerto de hueso — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "78.05",
  "PRO_NOMBRE": "Injerto de hueso — Fémur"
 },
 {
  "CATALOG_KEY": "78.06",
  "PRO_NOMBRE": "Injerto de hueso — Rótula"
 },
 {
  "CATALOG_KEY": "78.07",
  "PRO_NOMBRE": "Injerto de hueso — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "78.08",
  "PRO_NOMBRE": "Injerto de hueso — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "78.09",
  "PRO_NOMBRE": "Injerto de hueso — Otros"
 },
 {
  "CATALOG_KEY": "78.1",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo"
 },
 {
  "CATALOG_KEY": "78.10",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "78.11",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "78.12",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo — Húmero"
 },
 {
  "CATALOG_KEY": "78.13",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "78.14",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "78.15",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo — Fémur"
 },
 {
  "CATALOG_KEY": "78.16",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo — Rótula"
 },
 {
  "CATALOG_KEY": "78.17",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "78.18",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "78.19",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo — Otros"
 },
 {
  "CATALOG_KEY": "78.2",
  "PRO_NOMBRE": "Procedimientos de acortamiento de extremidades"
 },
 {
  "CATALOG_KEY": "78.20",
  "PRO_NOMBRE": "Procedimientos de acortamiento de extremidades — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "78.22",
  "PRO_NOMBRE": "Procedimientos de acortamiento de extremidades — Húmero"
 },
 {
  "CATALOG_KEY": "78.23",
  "PRO_NOMBRE": "Procedimientos de acortamiento de extremidades — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "78.24",
  "PRO_NOMBRE": "Procedimientos de acortamiento de extremidades — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "78.25",
  "PRO_NOMBRE": "Procedimientos de acortamiento de extremidades — Fémur"
 },
 {
  "CATALOG_KEY": "78.27",
  "PRO_NOMBRE": "Procedimientos de acortamiento de extremidades — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "78.28",
  "PRO_NOMBRE": "Procedimientos de acortamiento de extremidades — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "78.29",
  "PRO_NOMBRE": "Procedimientos de acortamiento de extremidades — Otros"
 },
 {
  "CATALOG_KEY": "78.3",
  "PRO_NOMBRE": "Procedimiento de alargamiento de extremidades"
 },
 {
  "CATALOG_KEY": "78.30",
  "PRO_NOMBRE": "Procedimiento de alargamiento de extremidades — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "78.32",
  "PRO_NOMBRE": "Procedimiento de alargamiento de extremidades — Húmero"
 },
 {
  "CATALOG_KEY": "78.33",
  "PRO_NOMBRE": "Procedimiento de alargamiento de extremidades — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "78.34",
  "PRO_NOMBRE": "Procedimiento de alargamiento de extremidades — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "78.35",
  "PRO_NOMBRE": "Procedimiento de alargamiento de extremidades — Fémur"
 },
 {
  "CATALOG_KEY": "78.37",
  "PRO_NOMBRE": "Procedimiento de alargamiento de extremidades — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "78.38",
  "PRO_NOMBRE": "Procedimiento de alargamiento de extremidades — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "78.39",
  "PRO_NOMBRE": "Procedimiento de alargamiento de extremidades — Otros"
 },
 {
  "CATALOG_KEY": "78.4",
  "PRO_NOMBRE": "Otra reparación u operaciones plásticas en el hueso"
 },
 {
  "CATALOG_KEY": "78.40",
  "PRO_NOMBRE": "Otra reparación u operaciones plásticas en el hueso — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "78.41",
  "PRO_NOMBRE": "Otra reparación u operaciones plásticas en el hueso — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "78.42",
  "PRO_NOMBRE": "Otra reparación u operaciones plásticas en el hueso — Húmero"
 },
 {
  "CATALOG_KEY": "78.43",
  "PRO_NOMBRE": "Otra reparación u operaciones plásticas en el hueso — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "78.44",
  "PRO_NOMBRE": "Otra reparación u operaciones plásticas en el hueso — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "78.45",
  "PRO_NOMBRE": "Otra reparación u operaciones plásticas en el hueso — Fémur"
 },
 {
  "CATALOG_KEY": "78.46",
  "PRO_NOMBRE": "Otra reparación u operaciones plásticas en el hueso — Rótula"
 },
 {
  "CATALOG_KEY": "78.47",
  "PRO_NOMBRE": "Otra reparación u operaciones plásticas en el hueso — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "78.48",
  "PRO_NOMBRE": "Otra reparación u operaciones plásticas en el hueso — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "78.49",
  "PRO_NOMBRE": "Otra reparación u operaciones plásticas en el hueso — Otros"
 },
 {
  "CATALOG_KEY": "78.5",
  "PRO_NOMBRE": "Fijación interna de hueso sin reducción de fractura"
 },
 {
  "CATALOG_KEY": "78.50",
  "PRO_NOMBRE": "Fijación interna de hueso sin reducción de fractura — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "78.51",
  "PRO_NOMBRE": "Fijación interna de hueso sin reducción de fractura — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "78.52",
  "PRO_NOMBRE": "Fijación interna de hueso sin reducción de fractura — Húmero"
 },
 {
  "CATALOG_KEY": "78.53",
  "PRO_NOMBRE": "Fijación interna de hueso sin reducción de fractura — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "78.54",
  "PRO_NOMBRE": "Fijación interna de hueso sin reducción de fractura — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "78.55",
  "PRO_NOMBRE": "Fijación interna de hueso sin reducción de fractura — Fémur"
 },
 {
  "CATALOG_KEY": "78.56",
  "PRO_NOMBRE": "Fijación interna de hueso sin reducción de fractura — Rótula"
 },
 {
  "CATALOG_KEY": "78.57",
  "PRO_NOMBRE": "Fijación interna de hueso sin reducción de fractura — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "78.58",
  "PRO_NOMBRE": "Fijación interna de hueso sin reducción de fractura — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "78.59",
  "PRO_NOMBRE": "Fijación interna de hueso sin reducción de fractura — Otros"
 },
 {
  "CATALOG_KEY": "78.6",
  "PRO_NOMBRE": "Extracción de dispositivos implantados en el hueso"
 },
 {
  "CATALOG_KEY": "78.60",
  "PRO_NOMBRE": "Extracción de dispositivos implantados en el hueso — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "78.61",
  "PRO_NOMBRE": "Extracción de dispositivos implantados en el hueso — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "78.62",
  "PRO_NOMBRE": "Extracción de dispositivos implantados en el hueso — Húmero"
 },
 {
  "CATALOG_KEY": "78.63",
  "PRO_NOMBRE": "Extracción de dispositivos implantados en el hueso — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "78.64",
  "PRO_NOMBRE": "Extracción de dispositivos implantados en el hueso — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "78.65",
  "PRO_NOMBRE": "Extracción de dispositivos implantados en el hueso — Fémur"
 },
 {
  "CATALOG_KEY": "78.66",
  "PRO_NOMBRE": "Extracción de dispositivos implantados en el hueso — Rótula"
 },
 {
  "CATALOG_KEY": "78.67",
  "PRO_NOMBRE": "Extracción de dispositivos implantados en el hueso — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "78.68",
  "PRO_NOMBRE": "Extracción de dispositivos implantados en el hueso — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "78.69",
  "PRO_NOMBRE": "Extracción de dispositivos implantados en el hueso — Otros"
 },
 {
  "CATALOG_KEY": "78.7",
  "PRO_NOMBRE": "Osteoclasia"
 },
 {
  "CATALOG_KEY": "78.70",
  "PRO_NOMBRE": "Osteoclasia — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "78.71",
  "PRO_NOMBRE": "Osteoclasia — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "78.72",
  "PRO_NOMBRE": "Osteoclasia — Húmero"
 },
 {
  "CATALOG_KEY": "78.73",
  "PRO_NOMBRE": "Osteoclasia — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "78.74",
  "PRO_NOMBRE": "Osteoclasia — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "78.75",
  "PRO_NOMBRE": "Osteoclasia — Fémur"
 },
 {
  "CATALOG_KEY": "78.76",
  "PRO_NOMBRE": "Osteoclasia — Rótula"
 },
 {
  "CATALOG_KEY": "78.77",
  "PRO_NOMBRE": "Osteoclasia — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "78.78",
  "PRO_NOMBRE": "Osteoclasia — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "78.79",
  "PRO_NOMBRE": "Osteoclasia — Otros"
 },
 {
  "CATALOG_KEY": "78.8",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre hueso, no clasificados en otra parte"
 },
 {
  "CATALOG_KEY": "78.80",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre hueso, no clasificados en otra parte — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "78.81",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre hueso, no clasificados en otra parte — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "78.82",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre hueso, no clasificados en otra parte — Húmero"
 },
 {
  "CATALOG_KEY": "78.83",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre hueso, no clasificados en otra parte — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "78.84",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre hueso, no clasificados en otra parte — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "78.85",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre hueso, no clasificados en otra parte — Fémur"
 },
 {
  "CATALOG_KEY": "78.86",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre hueso, no clasificados en otra parte — Rótula"
 },
 {
  "CATALOG_KEY": "78.87",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre hueso, no clasificados en otra parte — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "78.88",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre hueso, no clasificados en otra parte — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "78.89",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre hueso, no clasificados en otra parte — Otros"
 },
 {
  "CATALOG_KEY": "78.9",
  "PRO_NOMBRE": "Inserción de estimulador del crecimiento óseo"
 },
 {
  "CATALOG_KEY": "78.90",
  "PRO_NOMBRE": "Inserción de estimulador del crecimiento óseo — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "78.91",
  "PRO_NOMBRE": "Inserción de estimulador del crecimiento óseo — Escápula, clavícula y tórax [costillas y esternón]"
 },
 {
  "CATALOG_KEY": "78.92",
  "PRO_NOMBRE": "Inserción de estimulador del crecimiento óseo — Húmero"
 },
 {
  "CATALOG_KEY": "78.93",
  "PRO_NOMBRE": "Inserción de estimulador del crecimiento óseo — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "78.94",
  "PRO_NOMBRE": "Inserción de estimulador del crecimiento óseo — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "78.95",
  "PRO_NOMBRE": "Inserción de estimulador del crecimiento óseo — Fémur"
 },
 {
  "CATALOG_KEY": "78.96",
  "PRO_NOMBRE": "Inserción de estimulador del crecimiento óseo — Rótula"
 },
 {
  "CATALOG_KEY": "78.97",
  "PRO_NOMBRE": "Inserción de estimulador del crecimiento óseo — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "78.98",
  "PRO_NOMBRE": "Inserción de estimulador del crecimiento óseo — Tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "78.99",
  "PRO_NOMBRE": "Inserción de estimulador del crecimiento óseo — Otros"
 },
 {
  "CATALOG_KEY": "79",
  "PRO_NOMBRE": "Reducción de fractura y luxación"
 },
 {
  "CATALOG_KEY": "79.0",
  "PRO_NOMBRE": "Reducción cerrada de fractura sin fijación interna"
 },
 {
  "CATALOG_KEY": "79.00",
  "PRO_NOMBRE": "Reducción cerrada de fractura sin fijación interna — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "79.01",
  "PRO_NOMBRE": "Reducción cerrada de fractura sin fijación interna — Húmero"
 },
 {
  "CATALOG_KEY": "79.02",
  "PRO_NOMBRE": "Reducción cerrada de fractura sin fijación interna — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "79.03",
  "PRO_NOMBRE": "Reducción cerrada de fractura sin fijación interna — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "79.04",
  "PRO_NOMBRE": "Reducción cerrada de fractura sin fijación interna — Falanges y mano"
 },
 {
  "CATALOG_KEY": "79.05",
  "PRO_NOMBRE": "Reducción cerrada de fractura sin fijación interna — Fémur"
 },
 {
  "CATALOG_KEY": "79.06",
  "PRO_NOMBRE": "Reducción cerrada de fractura sin fijación interna — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "79.07",
  "PRO_NOMBRE": "Reducción cerrada de fractura sin fijación interna — tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "79.08",
  "PRO_NOMBRE": "Reducción cerrada de fractura sin fijación interna — Falanges y pie"
 },
 {
  "CATALOG_KEY": "79.09",
  "PRO_NOMBRE": "Reducción cerrada de fractura sin fijación interna — Otros huesos específicos"
 },
 {
  "CATALOG_KEY": "79.1",
  "PRO_NOMBRE": "Reducción cerrada de fractura con fijación interna"
 },
 {
  "CATALOG_KEY": "79.10",
  "PRO_NOMBRE": "Reducción cerrada de fractura con fijación interna — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "79.11",
  "PRO_NOMBRE": "Reducción cerrada de fractura con fijación interna — Húmero"
 },
 {
  "CATALOG_KEY": "79.12",
  "PRO_NOMBRE": "Reducción cerrada de fractura con fijación interna — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "79.13",
  "PRO_NOMBRE": "Reducción cerrada de fractura con fijación interna — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "79.14",
  "PRO_NOMBRE": "Reducción cerrada de fractura con fijación interna — Falanges y mano"
 },
 {
  "CATALOG_KEY": "79.15",
  "PRO_NOMBRE": "Reducción cerrada de fractura con fijación interna — Fémur"
 },
 {
  "CATALOG_KEY": "79.16",
  "PRO_NOMBRE": "Reducción cerrada de fractura con fijación interna — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "79.17",
  "PRO_NOMBRE": "Reducción cerrada de fractura con fijación interna — tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "79.18",
  "PRO_NOMBRE": "Reducción cerrada de fractura con fijación interna — Falanges y pie"
 },
 {
  "CATALOG_KEY": "79.19",
  "PRO_NOMBRE": "Reducción cerrada de fractura con fijación interna — Otros huesos específicos"
 },
 {
  "CATALOG_KEY": "79.2",
  "PRO_NOMBRE": "Reducción abierta de fractura sin fijación interna"
 },
 {
  "CATALOG_KEY": "79.20",
  "PRO_NOMBRE": "Reducción abierta de fractura sin fijación interna — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "79.21",
  "PRO_NOMBRE": "Reducción abierta de fractura sin fijación interna — Húmero"
 },
 {
  "CATALOG_KEY": "79.22",
  "PRO_NOMBRE": "Reducción abierta de fractura sin fijación interna — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "79.23",
  "PRO_NOMBRE": "Reducción abierta de fractura sin fijación interna — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "79.24",
  "PRO_NOMBRE": "Reducción abierta de fractura sin fijación interna — Falanges y mano"
 },
 {
  "CATALOG_KEY": "79.25",
  "PRO_NOMBRE": "Reducción abierta de fractura sin fijación interna — Fémur"
 },
 {
  "CATALOG_KEY": "79.26",
  "PRO_NOMBRE": "Reducción abierta de fractura sin fijación interna — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "79.27",
  "PRO_NOMBRE": "Reducción abierta de fractura sin fijación interna — tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "79.28",
  "PRO_NOMBRE": "Reducción abierta de fractura sin fijación interna — Falanges y pie"
 },
 {
  "CATALOG_KEY": "79.29",
  "PRO_NOMBRE": "Reducción abierta de fractura sin fijación interna — Otros huesos específicos"
 },
 {
  "CATALOG_KEY": "79.3",
  "PRO_NOMBRE": "Reducción abierta de fractura con fijación interna"
 },
 {
  "CATALOG_KEY": "79.30",
  "PRO_NOMBRE": "Reducción abierta de fractura con fijación interna — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "79.31",
  "PRO_NOMBRE": "Reducción abierta de fractura con fijación interna — Húmero"
 },
 {
  "CATALOG_KEY": "79.32",
  "PRO_NOMBRE": "Reducción abierta de fractura con fijación interna — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "79.33",
  "PRO_NOMBRE": "Reducción abierta de fractura con fijación interna — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "79.34",
  "PRO_NOMBRE": "Reducción abierta de fractura con fijación interna — Falanges y mano"
 },
 {
  "CATALOG_KEY": "79.35",
  "PRO_NOMBRE": "Reducción abierta de fractura con fijación interna — Fémur"
 },
 {
  "CATALOG_KEY": "79.36",
  "PRO_NOMBRE": "Reducción abierta de fractura con fijación interna — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "79.37",
  "PRO_NOMBRE": "Reducción abierta de fractura con fijación interna — tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "79.38",
  "PRO_NOMBRE": "Reducción abierta de fractura con fijación interna — Falanges y pie"
 },
 {
  "CATALOG_KEY": "79.39",
  "PRO_NOMBRE": "Reducción abierta de fractura con fijación interna — Otros huesos específicos"
 },
 {
  "CATALOG_KEY": "79.4",
  "PRO_NOMBRE": "Reducción cerrada de epífisis separada"
 },
 {
  "CATALOG_KEY": "79.40",
  "PRO_NOMBRE": "Reducción cerrada de epífisis separada — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "79.41",
  "PRO_NOMBRE": "Reducción cerrada de epífisis separada — Húmero"
 },
 {
  "CATALOG_KEY": "79.42",
  "PRO_NOMBRE": "Reducción cerrada de epífisis separada — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "79.45",
  "PRO_NOMBRE": "Reducción cerrada de epífisis separada — Fémur"
 },
 {
  "CATALOG_KEY": "79.46",
  "PRO_NOMBRE": "Reducción cerrada de epífisis separada — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "79.49",
  "PRO_NOMBRE": "Reducción cerrada de epífisis separada — Otros huesos específicos"
 },
 {
  "CATALOG_KEY": "79.5",
  "PRO_NOMBRE": "Reducción abierta de epífisis separada"
 },
 {
  "CATALOG_KEY": "79.50",
  "PRO_NOMBRE": "Reducción abierta de epífisis separada — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "79.51",
  "PRO_NOMBRE": "Reducción abierta de epífisis separada — Húmero"
 },
 {
  "CATALOG_KEY": "79.52",
  "PRO_NOMBRE": "Reducción abierta de epífisis separada — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "79.55",
  "PRO_NOMBRE": "Reducción abierta de epífisis separada — Fémur"
 },
 {
  "CATALOG_KEY": "79.56",
  "PRO_NOMBRE": "Reducción abierta de epífisis separada — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "79.59",
  "PRO_NOMBRE": "Reducción abierta de epífisis separada — Otros huesos específicos"
 },
 {
  "CATALOG_KEY": "79.6",
  "PRO_NOMBRE": "Desbridamiento de sitio de fractura abierta"
 },
 {
  "CATALOG_KEY": "79.60",
  "PRO_NOMBRE": "Desbridamiento de sitio de fractura abierta — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "79.61",
  "PRO_NOMBRE": "Desbridamiento de sitio de fractura abierta — Húmero"
 },
 {
  "CATALOG_KEY": "79.62",
  "PRO_NOMBRE": "Desbridamiento de sitio de fractura abierta — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "79.63",
  "PRO_NOMBRE": "Desbridamiento de sitio de fractura abierta — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "79.64",
  "PRO_NOMBRE": "Desbridamiento de sitio de fractura abierta — Falanges y mano"
 },
 {
  "CATALOG_KEY": "79.65",
  "PRO_NOMBRE": "Desbridamiento de sitio de fractura abierta — Fémur"
 },
 {
  "CATALOG_KEY": "79.66",
  "PRO_NOMBRE": "Desbridamiento de sitio de fractura abierta — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "79.67",
  "PRO_NOMBRE": "Desbridamiento de sitio de fractura abierta — tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "79.68",
  "PRO_NOMBRE": "Desbridamiento de sitio de fractura abierta — Falanges y pie"
 },
 {
  "CATALOG_KEY": "79.69",
  "PRO_NOMBRE": "Desbridamiento de sitio de fractura abierta — Otros huesos específicos"
 },
 {
  "CATALOG_KEY": "79.7",
  "PRO_NOMBRE": "Reducción cerrada de luxación"
 },
 {
  "CATALOG_KEY": "79.70",
  "PRO_NOMBRE": "Reducción cerrada de luxación de sitio no especificado"
 },
 {
  "CATALOG_KEY": "79.71",
  "PRO_NOMBRE": "Reducción cerrada de luxación de hombro"
 },
 {
  "CATALOG_KEY": "79.72",
  "PRO_NOMBRE": "Reducción cerrada de luxación de codo"
 },
 {
  "CATALOG_KEY": "79.73",
  "PRO_NOMBRE": "Reducción cerrada de luxación de muñeca"
 },
 {
  "CATALOG_KEY": "79.74",
  "PRO_NOMBRE": "Reducción cerrada de luxación de mano y dedo de mano"
 },
 {
  "CATALOG_KEY": "79.75",
  "PRO_NOMBRE": "Reducción cerrada de luxación de cadera"
 },
 {
  "CATALOG_KEY": "79.76",
  "PRO_NOMBRE": "Reducción cerrada de luxación de rodilla"
 },
 {
  "CATALOG_KEY": "79.77",
  "PRO_NOMBRE": "Reducción cerrada de luxación de tobillo"
 },
 {
  "CATALOG_KEY": "79.78",
  "PRO_NOMBRE": "Reducción cerrada de luxación de pie y dedo de pie"
 },
 {
  "CATALOG_KEY": "79.79",
  "PRO_NOMBRE": "Reducción cerrada de luxación de otros sitios especificados"
 },
 {
  "CATALOG_KEY": "79.8",
  "PRO_NOMBRE": "Reducción abierta de luxación"
 },
 {
  "CATALOG_KEY": "79.80",
  "PRO_NOMBRE": "Reducción abierta de luxación de sitio no especificado"
 },
 {
  "CATALOG_KEY": "79.81",
  "PRO_NOMBRE": "Reducción abierta de luxación de hombro"
 },
 {
  "CATALOG_KEY": "79.82",
  "PRO_NOMBRE": "Reducción abierta de luxación de codo"
 },
 {
  "CATALOG_KEY": "79.83",
  "PRO_NOMBRE": "Reducción abierta de luxación de muñeca"
 },
 {
  "CATALOG_KEY": "79.84",
  "PRO_NOMBRE": "Reducción abierta de luxación de mano y dedo de mano"
 },
 {
  "CATALOG_KEY": "79.85",
  "PRO_NOMBRE": "Reducción abierta de luxación de cadera"
 },
 {
  "CATALOG_KEY": "79.86",
  "PRO_NOMBRE": "Reducción abierta de luxación de rodilla"
 },
 {
  "CATALOG_KEY": "79.87",
  "PRO_NOMBRE": "Reducción abierta de luxación de tobillo"
 },
 {
  "CATALOG_KEY": "79.88",
  "PRO_NOMBRE": "Reducción abierta de luxación de pie y dedo de pie"
 },
 {
  "CATALOG_KEY": "79.89",
  "PRO_NOMBRE": "Reducción abierta de luxación de otros sitios especificados"
 },
 {
  "CATALOG_KEY": "79.9",
  "PRO_NOMBRE": "Operación no especificada sobre lesión de hueso"
 },
 {
  "CATALOG_KEY": "79.90",
  "PRO_NOMBRE": "Operación no especificada sobre lesión de hueso — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "79.91",
  "PRO_NOMBRE": "Operación no especificada sobre lesión de hueso — Húmero"
 },
 {
  "CATALOG_KEY": "79.92",
  "PRO_NOMBRE": "Operación no especificada sobre lesión de hueso — Radio y cúbito"
 },
 {
  "CATALOG_KEY": "79.93",
  "PRO_NOMBRE": "Operación no especificada sobre lesión de hueso — Carpianos y metacarpianos"
 },
 {
  "CATALOG_KEY": "79.94",
  "PRO_NOMBRE": "Operación no especificada sobre lesión de hueso — Falanges y mano"
 },
 {
  "CATALOG_KEY": "79.95",
  "PRO_NOMBRE": "Operación no especificada sobre lesión de hueso — Fémur"
 },
 {
  "CATALOG_KEY": "79.96",
  "PRO_NOMBRE": "Operación no especificada sobre lesión de hueso — Tibia y peroné"
 },
 {
  "CATALOG_KEY": "79.97",
  "PRO_NOMBRE": "Operación no especificada sobre lesión de hueso — tarsianos y metatarsianos"
 },
 {
  "CATALOG_KEY": "79.98",
  "PRO_NOMBRE": "Operación no especificada sobre lesión de hueso — Falanges y pie"
 },
 {
  "CATALOG_KEY": "79.99",
  "PRO_NOMBRE": "Operación no especificada sobre lesión de hueso — Otros huesos específicos"
 },
 {
  "CATALOG_KEY": "80",
  "PRO_NOMBRE": "Incisión y excisión de estructuras de la articulación"
 },
 {
  "CATALOG_KEY": "80.0",
  "PRO_NOMBRE": "Artrotomía para extracción de prótesis"
 },
 {
  "CATALOG_KEY": "80.00",
  "PRO_NOMBRE": "Artrotomía para extracción de prótesis — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "80.01",
  "PRO_NOMBRE": "Artrotomía para extracción de prótesis — Hombro"
 },
 {
  "CATALOG_KEY": "80.02",
  "PRO_NOMBRE": "Artrotomía para extracción de prótesis — Codo"
 },
 {
  "CATALOG_KEY": "80.03",
  "PRO_NOMBRE": "Artrotomía para extracción de prótesis — Muñeca"
 },
 {
  "CATALOG_KEY": "80.04",
  "PRO_NOMBRE": "Artrotomía para extracción de prótesis — Mano y dedos de la mano"
 },
 {
  "CATALOG_KEY": "80.05",
  "PRO_NOMBRE": "Artrotomía para extracción de prótesis — Cadera"
 },
 {
  "CATALOG_KEY": "80.06",
  "PRO_NOMBRE": "Artrotomía para extracción de prótesis — Rodilla"
 },
 {
  "CATALOG_KEY": "80.07",
  "PRO_NOMBRE": "Artrotomía para extracción de prótesis — Tobillo"
 },
 {
  "CATALOG_KEY": "80.08",
  "PRO_NOMBRE": "Artrotomía para extracción de prótesis — Pie y dedos del pie"
 },
 {
  "CATALOG_KEY": "80.09",
  "PRO_NOMBRE": "Artrotomía para extracción de prótesis — Otros sitios especificados"
 },
 {
  "CATALOG_KEY": "80.1",
  "PRO_NOMBRE": "Otra artrotomía"
 },
 {
  "CATALOG_KEY": "80.10",
  "PRO_NOMBRE": "Otra artrotomía — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "80.11",
  "PRO_NOMBRE": "Otra artrotomía — Hombro"
 },
 {
  "CATALOG_KEY": "80.12",
  "PRO_NOMBRE": "Otra artrotomía — Codo"
 },
 {
  "CATALOG_KEY": "80.13",
  "PRO_NOMBRE": "Otra artrotomía — Muñeca"
 },
 {
  "CATALOG_KEY": "80.14",
  "PRO_NOMBRE": "Otra artrotomía — Mano y dedos de la mano"
 },
 {
  "CATALOG_KEY": "80.15",
  "PRO_NOMBRE": "Otra artrotomía — Cadera"
 },
 {
  "CATALOG_KEY": "80.16",
  "PRO_NOMBRE": "Otra artrotomía — Rodilla"
 },
 {
  "CATALOG_KEY": "80.17",
  "PRO_NOMBRE": "Otra artrotomía — Tobillo"
 },
 {
  "CATALOG_KEY": "80.18",
  "PRO_NOMBRE": "Otra artrotomía — Pie y dedos del pie"
 },
 {
  "CATALOG_KEY": "80.19",
  "PRO_NOMBRE": "Otra artrotomía — Otros sitios especificados"
 },
 {
  "CATALOG_KEY": "80.2",
  "PRO_NOMBRE": "Artroscopia"
 },
 {
  "CATALOG_KEY": "80.20",
  "PRO_NOMBRE": "Artroscopia — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "80.21",
  "PRO_NOMBRE": "Artroscopia — Hombro"
 },
 {
  "CATALOG_KEY": "80.22",
  "PRO_NOMBRE": "Artroscopia — Codo"
 },
 {
  "CATALOG_KEY": "80.23",
  "PRO_NOMBRE": "Artroscopia — Muñeca"
 },
 {
  "CATALOG_KEY": "80.24",
  "PRO_NOMBRE": "Artroscopia — Mano y dedos de la mano"
 },
 {
  "CATALOG_KEY": "80.25",
  "PRO_NOMBRE": "Artroscopia — Cadera"
 },
 {
  "CATALOG_KEY": "80.26",
  "PRO_NOMBRE": "Artroscopia — Rodilla"
 },
 {
  "CATALOG_KEY": "80.27",
  "PRO_NOMBRE": "Artroscopia — Tobillo"
 },
 {
  "CATALOG_KEY": "80.28",
  "PRO_NOMBRE": "Artroscopia — Pie y dedos del pie"
 },
 {
  "CATALOG_KEY": "80.29",
  "PRO_NOMBRE": "Artroscopia — Otros sitios especificados"
 },
 {
  "CATALOG_KEY": "80.3",
  "PRO_NOMBRE": "Biopsia de estructura de la articulación"
 },
 {
  "CATALOG_KEY": "80.30",
  "PRO_NOMBRE": "Biopsia de estructura de la articulación — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "80.31",
  "PRO_NOMBRE": "Biopsia de estructura de la articulación — Hombro"
 },
 {
  "CATALOG_KEY": "80.32",
  "PRO_NOMBRE": "Biopsia de estructura de la articulación — Codo"
 },
 {
  "CATALOG_KEY": "80.33",
  "PRO_NOMBRE": "Biopsia de estructura de la articulación — Muñeca"
 },
 {
  "CATALOG_KEY": "80.34",
  "PRO_NOMBRE": "Biopsia de estructura de la articulación — Mano y dedos de la mano"
 },
 {
  "CATALOG_KEY": "80.35",
  "PRO_NOMBRE": "Biopsia de estructura de la articulación — Cadera"
 },
 {
  "CATALOG_KEY": "80.36",
  "PRO_NOMBRE": "Biopsia de estructura de la articulación — Rodilla"
 },
 {
  "CATALOG_KEY": "80.37",
  "PRO_NOMBRE": "Biopsia de estructura de la articulación — Tobillo"
 },
 {
  "CATALOG_KEY": "80.38",
  "PRO_NOMBRE": "Biopsia de estructura de la articulación — Pie y dedos del pie"
 },
 {
  "CATALOG_KEY": "80.39",
  "PRO_NOMBRE": "Biopsia de estructura de la articulación — Otros sitios especificados"
 },
 {
  "CATALOG_KEY": "80.4",
  "PRO_NOMBRE": "División de cápsula articular, ligamento o cartílago"
 },
 {
  "CATALOG_KEY": "80.40",
  "PRO_NOMBRE": "División de cápsula articular, ligamento o cartílago — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "80.41",
  "PRO_NOMBRE": "División de cápsula articular, ligamento o cartílago — Hombro"
 },
 {
  "CATALOG_KEY": "80.42",
  "PRO_NOMBRE": "División de cápsula articular, ligamento o cartílago — Codo"
 },
 {
  "CATALOG_KEY": "80.43",
  "PRO_NOMBRE": "División de cápsula articular, ligamento o cartílago — Muñeca"
 },
 {
  "CATALOG_KEY": "80.44",
  "PRO_NOMBRE": "División de cápsula articular, ligamento o cartílago — Mano y dedos de la mano"
 },
 {
  "CATALOG_KEY": "80.45",
  "PRO_NOMBRE": "División de cápsula articular, ligamento o cartílago — Cadera"
 },
 {
  "CATALOG_KEY": "80.46",
  "PRO_NOMBRE": "División de cápsula articular, ligamento o cartílago — Rodilla"
 },
 {
  "CATALOG_KEY": "80.47",
  "PRO_NOMBRE": "División de cápsula articular, ligamento o cartílago — Tobillo"
 },
 {
  "CATALOG_KEY": "80.48",
  "PRO_NOMBRE": "División de cápsula articular, ligamento o cartílago — Pie y dedos del pie"
 },
 {
  "CATALOG_KEY": "80.49",
  "PRO_NOMBRE": "División de cápsula articular, ligamento o cartílago — Otros sitios especificados"
 },
 {
  "CATALOG_KEY": "80.5",
  "PRO_NOMBRE": "Excisión, destrucción y otra reparación de disco intervertebral"
 },
 {
  "CATALOG_KEY": "80.50",
  "PRO_NOMBRE": "Excisión o destrucción de disco intervertebral, no especificada"
 },
 {
  "CATALOG_KEY": "80.51",
  "PRO_NOMBRE": "Excisión de disco intervertebral"
 },
 {
  "CATALOG_KEY": "80.52",
  "PRO_NOMBRE": "Quimionucleolisis intervertebral"
 },
 {
  "CATALOG_KEY": "80.53",
  "PRO_NOMBRE": "Reparación del anillo fibroso con injerto o prótesis"
 },
 {
  "CATALOG_KEY": "80.54",
  "PRO_NOMBRE": "Otra reparación y no especificada del anillo fibroso"
 },
 {
  "CATALOG_KEY": "80.59",
  "PRO_NOMBRE": "Otra destrucción de disco intervertebral"
 },
 {
  "CATALOG_KEY": "80.6",
  "PRO_NOMBRE": "Excisión de cartílago semilunar de la rodilla"
 },
 {
  "CATALOG_KEY": "80.7",
  "PRO_NOMBRE": "Sinovectomía"
 },
 {
  "CATALOG_KEY": "80.70",
  "PRO_NOMBRE": "Sinovectomía — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "80.71",
  "PRO_NOMBRE": "Sinovectomía — Hombro"
 },
 {
  "CATALOG_KEY": "80.72",
  "PRO_NOMBRE": "Sinovectomía — Codo"
 },
 {
  "CATALOG_KEY": "80.73",
  "PRO_NOMBRE": "Sinovectomía — Muñeca"
 },
 {
  "CATALOG_KEY": "80.74",
  "PRO_NOMBRE": "Sinovectomía — Mano y dedos de la mano"
 },
 {
  "CATALOG_KEY": "80.75",
  "PRO_NOMBRE": "Sinovectomía — Cadera"
 },
 {
  "CATALOG_KEY": "80.76",
  "PRO_NOMBRE": "Sinovectomía — Rodilla"
 },
 {
  "CATALOG_KEY": "80.77",
  "PRO_NOMBRE": "Sinovectomía — Tobillo"
 },
 {
  "CATALOG_KEY": "80.78",
  "PRO_NOMBRE": "Sinovectomía — Pie y dedos del pie"
 },
 {
  "CATALOG_KEY": "80.79",
  "PRO_NOMBRE": "Sinovectomía — Otros sitios especificados"
 },
 {
  "CATALOG_KEY": "80.8",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión de articulación"
 },
 {
  "CATALOG_KEY": "80.80",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión de articulación — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "80.81",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión de articulación — Hombro"
 },
 {
  "CATALOG_KEY": "80.82",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión de articulación — Codo"
 },
 {
  "CATALOG_KEY": "80.83",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión de articulación — Muñeca"
 },
 {
  "CATALOG_KEY": "80.84",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión de articulación — Mano y dedos de la mano"
 },
 {
  "CATALOG_KEY": "80.85",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión de articulación — Cadera"
 },
 {
  "CATALOG_KEY": "80.86",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión de articulación — Rodilla"
 },
 {
  "CATALOG_KEY": "80.87",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión de articulación — Tobillo"
 },
 {
  "CATALOG_KEY": "80.88",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión de articulación — Pie y dedos del pie"
 },
 {
  "CATALOG_KEY": "80.89",
  "PRO_NOMBRE": "Otra excisión local o destrucción de lesión de articulación — Otros sitios especificados"
 },
 {
  "CATALOG_KEY": "80.9",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión de la articulación"
 },
 {
  "CATALOG_KEY": "80.90",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión de la articulación — Sitio no especificado"
 },
 {
  "CATALOG_KEY": "80.91",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión de la articulación — Hombro"
 },
 {
  "CATALOG_KEY": "80.92",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión de la articulación — Codo"
 },
 {
  "CATALOG_KEY": "80.93",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión de la articulación — Muñeca"
 },
 {
  "CATALOG_KEY": "80.94",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión de la articulación — Mano y dedos de la mano"
 },
 {
  "CATALOG_KEY": "80.95",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión de la articulación — Cadera"
 },
 {
  "CATALOG_KEY": "80.96",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión de la articulación — Rodilla"
 },
 {
  "CATALOG_KEY": "80.97",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión de la articulación — Tobillo"
 },
 {
  "CATALOG_KEY": "80.98",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión de la articulación — Pie y dedos del pie"
 },
 {
  "CATALOG_KEY": "80.99",
  "PRO_NOMBRE": "Otra excisión o destrucción de lesión de la articulación — Otros sitios especificados"
 },
 {
  "CATALOG_KEY": "81",
  "PRO_NOMBRE": "Operaciones de reparación y plásticas sobre estructuras de la articulación"
 },
 {
  "CATALOG_KEY": "81.0",
  "PRO_NOMBRE": "Fusión vertebral"
 },
 {
  "CATALOG_KEY": "81.00",
  "PRO_NOMBRE": "Fusión vertebral, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "81.01",
  "PRO_NOMBRE": "Fusión vertebral atlas-axis"
 },
 {
  "CATALOG_KEY": "81.02",
  "PRO_NOMBRE": "Otra fusión cervical, técnica anterior"
 },
 {
  "CATALOG_KEY": "81.03",
  "PRO_NOMBRE": "Otra fusión cervical, técnica posterior"
 },
 {
  "CATALOG_KEY": "81.04",
  "PRO_NOMBRE": "Fusión dorsal y dorsolumbar, técnica anterior"
 },
 {
  "CATALOG_KEY": "81.05",
  "PRO_NOMBRE": "Fusión dorsal y dorsolumbar, técnica posterior"
 },
 {
  "CATALOG_KEY": "81.06",
  "PRO_NOMBRE": "Fusión lumbar y lumbosacra, técnica anterior"
 },
 {
  "CATALOG_KEY": "81.07",
  "PRO_NOMBRE": "Fusión lumbar y lumbosacra, técnica de procedimiento lateral transverso"
 },
 {
  "CATALOG_KEY": "81.08",
  "PRO_NOMBRE": "Fusión lumbar y lumbosacra, técnica posterior"
 },
 {
  "CATALOG_KEY": "81.1",
  "PRO_NOMBRE": "Artrodesis y artroereisis de pie y tobillo"
 },
 {
  "CATALOG_KEY": "81.11",
  "PRO_NOMBRE": "Fusión de tobillo"
 },
 {
  "CATALOG_KEY": "81.12",
  "PRO_NOMBRE": "Triple artrodesis"
 },
 {
  "CATALOG_KEY": "81.13",
  "PRO_NOMBRE": "Fusión subastragalina"
 },
 {
  "CATALOG_KEY": "81.14",
  "PRO_NOMBRE": "Fusión medio tarsiana"
 },
 {
  "CATALOG_KEY": "81.15",
  "PRO_NOMBRE": "Fusión tarsometatarsiana"
 },
 {
  "CATALOG_KEY": "81.16",
  "PRO_NOMBRE": "Fusión metatarso-falángica"
 },
 {
  "CATALOG_KEY": "81.17",
  "PRO_NOMBRE": "Otra fusión de pie"
 },
 {
  "CATALOG_KEY": "81.18",
  "PRO_NOMBRE": "Artroereisis de articulación subastragalina"
 },
 {
  "CATALOG_KEY": "81.2",
  "PRO_NOMBRE": "Artrodesis de otra articulación"
 },
 {
  "CATALOG_KEY": "81.20",
  "PRO_NOMBRE": "Artrodesis de articulación no especificada"
 },
 {
  "CATALOG_KEY": "81.21",
  "PRO_NOMBRE": "Artrodesis de cadera"
 },
 {
  "CATALOG_KEY": "81.22",
  "PRO_NOMBRE": "Artrodesis de rodilla"
 },
 {
  "CATALOG_KEY": "81.23",
  "PRO_NOMBRE": "Artrodesis de hombro"
 },
 {
  "CATALOG_KEY": "81.24",
  "PRO_NOMBRE": "Artrodesis de codo"
 },
 {
  "CATALOG_KEY": "81.25",
  "PRO_NOMBRE": "Fusión carporradial"
 },
 {
  "CATALOG_KEY": "81.26",
  "PRO_NOMBRE": "Fusión carpometacarpiana"
 },
 {
  "CATALOG_KEY": "81.27",
  "PRO_NOMBRE": "Fusión metacarpofalángica"
 },
 {
  "CATALOG_KEY": "81.28",
  "PRO_NOMBRE": "Fusión interfalángica"
 },
 {
  "CATALOG_KEY": "81.29",
  "PRO_NOMBRE": "Artrodesis de otras articulaciones especificadas"
 },
 {
  "CATALOG_KEY": "81.3",
  "PRO_NOMBRE": "Refusión vertebral"
 },
 {
  "CATALOG_KEY": "81.30",
  "PRO_NOMBRE": "Refusión vertebral, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "81.31",
  "PRO_NOMBRE": "Refusión espinal atlas-axis"
 },
 {
  "CATALOG_KEY": "81.32",
  "PRO_NOMBRE": "Refusión de otras vértebras cervicales, técnica anterior"
 },
 {
  "CATALOG_KEY": "81.33",
  "PRO_NOMBRE": "Refusión de otras vértebras cervicales, técnica posterior"
 },
 {
  "CATALOG_KEY": "81.34",
  "PRO_NOMBRE": "Refusión espinal dorsal y dorsolumbar, técnica anterior"
 },
 {
  "CATALOG_KEY": "81.35",
  "PRO_NOMBRE": "Refusión espinal dorsal y dorsolumbar, técnica posterior"
 },
 {
  "CATALOG_KEY": "81.36",
  "PRO_NOMBRE": "Refusión espinal lumbar y lumbosacra, técnica anterior"
 },
 {
  "CATALOG_KEY": "81.37",
  "PRO_NOMBRE": "Refusión espinal lumbar y lumbosacra, técnica de procedimiento lateral transverso"
 },
 {
  "CATALOG_KEY": "81.38",
  "PRO_NOMBRE": "Refusión espinal lumbar y lumbosacra, técnica posterior"
 },
 {
  "CATALOG_KEY": "81.39",
  "PRO_NOMBRE": "Refusión vertebral, no clasificada bajo otro concepto"
 },
 {
  "CATALOG_KEY": "81.4",
  "PRO_NOMBRE": "Otra reparación de articulación de extremidades inferiores"
 },
 {
  "CATALOG_KEY": "81.40",
  "PRO_NOMBRE": "Reparación de cadera, no especificada bajo otro concepto"
 },
 {
  "CATALOG_KEY": "81.42",
  "PRO_NOMBRE": "Reparación “cinco en uno” de rodilla"
 },
 {
  "CATALOG_KEY": "81.43",
  "PRO_NOMBRE": "Reparación de una triada de rodilla"
 },
 {
  "CATALOG_KEY": "81.44",
  "PRO_NOMBRE": "Estabilización de rótula"
 },
 {
  "CATALOG_KEY": "81.45",
  "PRO_NOMBRE": "Otra reparación de los ligamentos cruzados"
 },
 {
  "CATALOG_KEY": "81.46",
  "PRO_NOMBRE": "Otra reparación de los ligamentos colaterales"
 },
 {
  "CATALOG_KEY": "81.47",
  "PRO_NOMBRE": "Otra reparación de rodilla"
 },
 {
  "CATALOG_KEY": "81.49",
  "PRO_NOMBRE": "Otra reparación de tobillo"
 },
 {
  "CATALOG_KEY": "81.5",
  "PRO_NOMBRE": "Sustitución de las articulaciones de las extremidades inferiores"
 },
 {
  "CATALOG_KEY": "81.51",
  "PRO_NOMBRE": "Sustitución o reemplazo total de cadera"
 },
 {
  "CATALOG_KEY": "81.52",
  "PRO_NOMBRE": "Sustitución parcial de cadera"
 },
 {
  "CATALOG_KEY": "81.53",
  "PRO_NOMBRE": "Revisión de sustitución de cadera, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "81.54",
  "PRO_NOMBRE": "Sustitución total de rodilla"
 },
 {
  "CATALOG_KEY": "81.55",
  "PRO_NOMBRE": "Revisión de sustitución de rodilla, no especificada en otra parte"
 },
 {
  "CATALOG_KEY": "81.56",
  "PRO_NOMBRE": "Sustitución total de tobillo"
 },
 {
  "CATALOG_KEY": "81.57",
  "PRO_NOMBRE": "Sustitución de articulación de pie y dedos"
 },
 {
  "CATALOG_KEY": "81.59",
  "PRO_NOMBRE": "Revisión de sustitución de articulación de extremidad inferior, no clasificada en otra parte"
 },
 {
  "CATALOG_KEY": "81.6",
  "PRO_NOMBRE": "Otros procedimientos vertebrales"
 },
 {
  "CATALOG_KEY": "81.62",
  "PRO_NOMBRE": "Fusión o refusión de 2-3 vértebras"
 },
 {
  "CATALOG_KEY": "81.63",
  "PRO_NOMBRE": "Fusión o refusión de 4-8 vértebras"
 },
 {
  "CATALOG_KEY": "81.64",
  "PRO_NOMBRE": "Fusión o refusión de 9 ó más vértebras"
 },
 {
  "CATALOG_KEY": "81.65",
  "PRO_NOMBRE": "Vertebroplastía percutánea"
 },
 {
  "CATALOG_KEY": "81.66",
  "PRO_NOMBRE": "Aumento percutáneo vertebral"
 },
 {
  "CATALOG_KEY": "81.7",
  "PRO_NOMBRE": "Artroplastía y reparación de mano, dedo de mano y muñeca"
 },
 {
  "CATALOG_KEY": "81.71",
  "PRO_NOMBRE": "Artroplastía de articulaciones metacarpofalángica e interfalángica con implante"
 },
 {
  "CATALOG_KEY": "81.72",
  "PRO_NOMBRE": "Artroplastía de articulaciones metacarpofalángica e interfalángica sin implante"
 },
 {
  "CATALOG_KEY": "81.73",
  "PRO_NOMBRE": "Sustitución total de muñeca"
 },
 {
  "CATALOG_KEY": "81.74",
  "PRO_NOMBRE": "Artroplastía de articulaciones carpocarpiana o carpometacarpiana con implante"
 },
 {
  "CATALOG_KEY": "81.75",
  "PRO_NOMBRE": "Artroplastía de articulaciones carpocarpiana o carpometacarpiana sin implante"
 },
 {
  "CATALOG_KEY": "81.79",
  "PRO_NOMBRE": "Otra reparación de mano, dedo de mano y muñeca"
 },
 {
  "CATALOG_KEY": "81.8",
  "PRO_NOMBRE": "Artroplastía y reparación de hombro y codo"
 },
 {
  "CATALOG_KEY": "81.80",
  "PRO_NOMBRE": "Sustitución total de hombro"
 },
 {
  "CATALOG_KEY": "81.81",
  "PRO_NOMBRE": "Sustitución parcial de hombro"
 },
 {
  "CATALOG_KEY": "81.82",
  "PRO_NOMBRE": "Reparación de luxación recidivante de hombro"
 },
 {
  "CATALOG_KEY": "81.83",
  "PRO_NOMBRE": "Otra reparación de hombro"
 },
 {
  "CATALOG_KEY": "81.84",
  "PRO_NOMBRE": "Sustitución total de codo"
 },
 {
  "CATALOG_KEY": "81.85",
  "PRO_NOMBRE": "Otra reparación de codo"
 },
 {
  "CATALOG_KEY": "81.9",
  "PRO_NOMBRE": "Otras reparaciones sobre estructuras de articulación"
 },
 {
  "CATALOG_KEY": "81.91",
  "PRO_NOMBRE": "Artrocentesis"
 },
 {
  "CATALOG_KEY": "81.92",
  "PRO_NOMBRE": "Inyección de sustancia terapéutica en articulación o ligamento"
 },
 {
  "CATALOG_KEY": "81.93",
  "PRO_NOMBRE": "Sutura de cápsula o ligamento de extremidad superior"
 },
 {
  "CATALOG_KEY": "81.94",
  "PRO_NOMBRE": "Sutura de cápsula o ligamento de tobillo y pie"
 },
 {
  "CATALOG_KEY": "81.95",
  "PRO_NOMBRE": "Sutura de cápsula o ligamento de otra extremidad inferior"
 },
 {
  "CATALOG_KEY": "81.96",
  "PRO_NOMBRE": "Otra reparación de articulación"
 },
 {
  "CATALOG_KEY": "81.97",
  "PRO_NOMBRE": "Revisión de sustitución de articulación de extremidad superior"
 },
 {
  "CATALOG_KEY": "81.98",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre estructuras de articulación"
 },
 {
  "CATALOG_KEY": "81.99",
  "PRO_NOMBRE": "Otra reparación sobre estructuras de articulación"
 },
 {
  "CATALOG_KEY": "82",
  "PRO_NOMBRE": "Operaciones sobre músculo, tendón y fascia de mano"
 },
 {
  "CATALOG_KEY": "82.0",
  "PRO_NOMBRE": "Incisión de músculo, tendón, fascia y bolsa sinovial de mano"
 },
 {
  "CATALOG_KEY": "82.01",
  "PRO_NOMBRE": "Exploración de vaina de tendón de mano"
 },
 {
  "CATALOG_KEY": "82.02",
  "PRO_NOMBRE": "Miotomía de mano"
 },
 {
  "CATALOG_KEY": "82.03",
  "PRO_NOMBRE": "Bursotomía de mano"
 },
 {
  "CATALOG_KEY": "82.04",
  "PRO_NOMBRE": "Incisión y drenaje de espacio palmar y tenar"
 },
 {
  "CATALOG_KEY": "82.09",
  "PRO_NOMBRE": "Otra incisión de tejido blando de mano"
 },
 {
  "CATALOG_KEY": "82.1",
  "PRO_NOMBRE": "División de músculo, tendón y fascia de mano"
 },
 {
  "CATALOG_KEY": "82.11",
  "PRO_NOMBRE": "Tenotomía de mano"
 },
 {
  "CATALOG_KEY": "82.12",
  "PRO_NOMBRE": "Fasciotomía de mano"
 },
 {
  "CATALOG_KEY": "82.19",
  "PRO_NOMBRE": "Otra división de tejido blando de mano"
 },
 {
  "CATALOG_KEY": "82.2",
  "PRO_NOMBRE": "Excisión de lesión de músculo, tendón y fascia de mano"
 },
 {
  "CATALOG_KEY": "82.21",
  "PRO_NOMBRE": "Excisión de lesión de vaina de tendón de mano"
 },
 {
  "CATALOG_KEY": "82.22",
  "PRO_NOMBRE": "Excisión de lesión de músculo de mano"
 },
 {
  "CATALOG_KEY": "82.29",
  "PRO_NOMBRE": "Excisión de otra lesión de tejido de mano"
 },
 {
  "CATALOG_KEY": "82.3",
  "PRO_NOMBRE": "Otra excisión de tejido blando de mano"
 },
 {
  "CATALOG_KEY": "82.31",
  "PRO_NOMBRE": "Bursectomía de mano"
 },
 {
  "CATALOG_KEY": "82.32",
  "PRO_NOMBRE": "Excisión de tendón de mano para injerto"
 },
 {
  "CATALOG_KEY": "82.33",
  "PRO_NOMBRE": "Otra tendonectomía de mano"
 },
 {
  "CATALOG_KEY": "82.34",
  "PRO_NOMBRE": "Excisión de músculo o fascia de mano para injerto"
 },
 {
  "CATALOG_KEY": "82.35",
  "PRO_NOMBRE": "Otra fasciectomía de mano"
 },
 {
  "CATALOG_KEY": "82.36",
  "PRO_NOMBRE": "Otra miectomía de mano"
 },
 {
  "CATALOG_KEY": "82.39",
  "PRO_NOMBRE": "Otra excisión de tejido blando de mano"
 },
 {
  "CATALOG_KEY": "82.4",
  "PRO_NOMBRE": "Sutura de músculo, tendón y fascia de mano"
 },
 {
  "CATALOG_KEY": "82.41",
  "PRO_NOMBRE": "Sutura de vaina de tendón de mano"
 },
 {
  "CATALOG_KEY": "82.42",
  "PRO_NOMBRE": "Sutura retardada del tendón flexor de mano"
 },
 {
  "CATALOG_KEY": "82.43",
  "PRO_NOMBRE": "Sutura retardada de otro tendón de mano"
 },
 {
  "CATALOG_KEY": "82.44",
  "PRO_NOMBRE": "Otra sutura de tendón flexor de mano"
 },
 {
  "CATALOG_KEY": "82.45",
  "PRO_NOMBRE": "Otra sutura de otro tendón de mano"
 },
 {
  "CATALOG_KEY": "82.46",
  "PRO_NOMBRE": "Sutura de músculo o fascia de mano"
 },
 {
  "CATALOG_KEY": "82.5",
  "PRO_NOMBRE": "Trasplante de músculo y tendón de mano"
 },
 {
  "CATALOG_KEY": "82.51",
  "PRO_NOMBRE": "Adelantamiento de tendón de mano"
 },
 {
  "CATALOG_KEY": "82.52",
  "PRO_NOMBRE": "Resección de tendón de mano"
 },
 {
  "CATALOG_KEY": "82.53",
  "PRO_NOMBRE": "Refijación de tendón de mano"
 },
 {
  "CATALOG_KEY": "82.54",
  "PRO_NOMBRE": "Refijación de músculo de mano"
 },
 {
  "CATALOG_KEY": "82.55",
  "PRO_NOMBRE": "Otro cambio de longitud de músculo o tendón de mano"
 },
 {
  "CATALOG_KEY": "82.56",
  "PRO_NOMBRE": "Otra transferencia o trasplante de tendón de mano"
 },
 {
  "CATALOG_KEY": "82.57",
  "PRO_NOMBRE": "Otra transposición de tendón de mano"
 },
 {
  "CATALOG_KEY": "82.58",
  "PRO_NOMBRE": "Otra transferencia o trasplante de músculo de mano"
 },
 {
  "CATALOG_KEY": "82.59",
  "PRO_NOMBRE": "Otra trasposición de músculo de mano"
 },
 {
  "CATALOG_KEY": "82.6",
  "PRO_NOMBRE": "Reconstrucción de dedo pulgar"
 },
 {
  "CATALOG_KEY": "82.61",
  "PRO_NOMBRE": "Operación de policización con transferencia de nervios y aporte vascular"
 },
 {
  "CATALOG_KEY": "82.69",
  "PRO_NOMBRE": "Otra reconstrucción de dedo pulgar"
 },
 {
  "CATALOG_KEY": "82.7",
  "PRO_NOMBRE": "Operación plástica sobre mano con injerto o implante"
 },
 {
  "CATALOG_KEY": "82.71",
  "PRO_NOMBRE": "Reconstrucción de polea de tendón"
 },
 {
  "CATALOG_KEY": "82.72",
  "PRO_NOMBRE": "Operación plástica sobre mano con injerto de músculo o fascia"
 },
 {
  "CATALOG_KEY": "82.79",
  "PRO_NOMBRE": "Operación plástica sobre mano con injerto o implantación"
 },
 {
  "CATALOG_KEY": "82.8",
  "PRO_NOMBRE": "Otras operaciones plásticas sobre mano"
 },
 {
  "CATALOG_KEY": "82.81",
  "PRO_NOMBRE": "Transferencia de dedo, salvo pulgar"
 },
 {
  "CATALOG_KEY": "82.82",
  "PRO_NOMBRE": "Reparación de mano hendida"
 },
 {
  "CATALOG_KEY": "82.83",
  "PRO_NOMBRE": "Reparación de macrodactilia"
 },
 {
  "CATALOG_KEY": "82.84",
  "PRO_NOMBRE": "Reparación de dedo en martillo de la mano"
 },
 {
  "CATALOG_KEY": "82.85",
  "PRO_NOMBRE": "Otra tenodesis de mano"
 },
 {
  "CATALOG_KEY": "82.86",
  "PRO_NOMBRE": "Otra tenoplastía de mano"
 },
 {
  "CATALOG_KEY": "82.89",
  "PRO_NOMBRE": "Otras operaciones plásticas sobre mano"
 },
 {
  "CATALOG_KEY": "82.9",
  "PRO_NOMBRE": "Otras operaciones sobre músculos, tendón y fascia de mano"
 },
 {
  "CATALOG_KEY": "82.91",
  "PRO_NOMBRE": "Lisis de adherencias de mano"
 },
 {
  "CATALOG_KEY": "82.92",
  "PRO_NOMBRE": "Aspiración de bolsa sinovial de mano"
 },
 {
  "CATALOG_KEY": "82.93",
  "PRO_NOMBRE": "Aspiración de otro tejido blando de mano"
 },
 {
  "CATALOG_KEY": "82.94",
  "PRO_NOMBRE": "Inyección de sustancia terapéutica en bolsa sinovial de mano"
 },
 {
  "CATALOG_KEY": "82.95",
  "PRO_NOMBRE": "Inyección de sustancia terapéutica en tendón de mano"
 },
 {
  "CATALOG_KEY": "82.96",
  "PRO_NOMBRE": "Otra inyección de sustancia terapéutica de acción local en tejido blando de mano"
 },
 {
  "CATALOG_KEY": "82.99",
  "PRO_NOMBRE": "Otras operaciones sobre músculo, tendón y fascia de mano"
 },
 {
  "CATALOG_KEY": "83",
  "PRO_NOMBRE": "Operaciones sobre músculo, tendón, fascia y bolsa sinovial salvo de la mano"
 },
 {
  "CATALOG_KEY": "83.0",
  "PRO_NOMBRE": "Incisión de músculo, tendón, fascia y bolsa sinovial"
 },
 {
  "CATALOG_KEY": "83.01",
  "PRO_NOMBRE": "Exploración de vaina de tendón"
 },
 {
  "CATALOG_KEY": "83.02",
  "PRO_NOMBRE": "Miotomía"
 },
 {
  "CATALOG_KEY": "83.03",
  "PRO_NOMBRE": "Bursotomía"
 },
 {
  "CATALOG_KEY": "83.09",
  "PRO_NOMBRE": "Otra incisión de tejido blando"
 },
 {
  "CATALOG_KEY": "83.1",
  "PRO_NOMBRE": "División de músculo, tendón y fascia"
 },
 {
  "CATALOG_KEY": "83.11",
  "PRO_NOMBRE": "Tenotomia de Aquiles"
 },
 {
  "CATALOG_KEY": "83.12",
  "PRO_NOMBRE": "Tenotomía de aductor de cadera"
 },
 {
  "CATALOG_KEY": "83.13",
  "PRO_NOMBRE": "Otra tenotomía"
 },
 {
  "CATALOG_KEY": "83.14",
  "PRO_NOMBRE": "Fasciotomía"
 },
 {
  "CATALOG_KEY": "83.19",
  "PRO_NOMBRE": "Otra división de tejido blando"
 },
 {
  "CATALOG_KEY": "83.2",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre músculo, tendón, fascia y bolsa sinovial, incluso aquel de mano"
 },
 {
  "CATALOG_KEY": "83.21",
  "PRO_NOMBRE": "Biopsia de tejido blando"
 },
 {
  "CATALOG_KEY": "83.29",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre músculo, tendón, fascia y bolsa sinovial, incluso aquel de mano"
 },
 {
  "CATALOG_KEY": "83.3",
  "PRO_NOMBRE": "Excisión de lesión de músculo, tendón, fascia y bolsa sinovial"
 },
 {
  "CATALOG_KEY": "83.31",
  "PRO_NOMBRE": "Excisión de lesión de vaina de tendón"
 },
 {
  "CATALOG_KEY": "83.32",
  "PRO_NOMBRE": "Excisión de lesión de músculo"
 },
 {
  "CATALOG_KEY": "83.39",
  "PRO_NOMBRE": "Excisión de lesión de otro tejido blando"
 },
 {
  "CATALOG_KEY": "83.4",
  "PRO_NOMBRE": "Otra excisión de músculo, tendón y fascia"
 },
 {
  "CATALOG_KEY": "83.41",
  "PRO_NOMBRE": "Excisión de tendón para injerto"
 },
 {
  "CATALOG_KEY": "83.42",
  "PRO_NOMBRE": "Otra tendonectomía"
 },
 {
  "CATALOG_KEY": "83.43",
  "PRO_NOMBRE": "Excisión de músculo o fascia para injerto"
 },
 {
  "CATALOG_KEY": "83.44",
  "PRO_NOMBRE": "Otra fasciectomía"
 },
 {
  "CATALOG_KEY": "83.45",
  "PRO_NOMBRE": "Otra miectomía"
 },
 {
  "CATALOG_KEY": "83.49",
  "PRO_NOMBRE": "Otra excisión de tejido blando"
 },
 {
  "CATALOG_KEY": "83.5",
  "PRO_NOMBRE": "Bursectomía"
 },
 {
  "CATALOG_KEY": "83.6",
  "PRO_NOMBRE": "Sutura de músculo, tendón y fascia"
 },
 {
  "CATALOG_KEY": "83.61",
  "PRO_NOMBRE": "Sutura de vaina de tendón"
 },
 {
  "CATALOG_KEY": "83.62",
  "PRO_NOMBRE": "Sutura retardada de tendón"
 },
 {
  "CATALOG_KEY": "83.63",
  "PRO_NOMBRE": "Reparación de manguito de los rotadores"
 },
 {
  "CATALOG_KEY": "83.64",
  "PRO_NOMBRE": "Otra sutura de tendón"
 },
 {
  "CATALOG_KEY": "83.65",
  "PRO_NOMBRE": "Otra sutura de músculo o fascia"
 },
 {
  "CATALOG_KEY": "83.7",
  "PRO_NOMBRE": "Reconstrucción de músculos y tendón"
 },
 {
  "CATALOG_KEY": "83.71",
  "PRO_NOMBRE": "Adelantamiento de tendón"
 },
 {
  "CATALOG_KEY": "83.72",
  "PRO_NOMBRE": "Resección de tendón"
 },
 {
  "CATALOG_KEY": "83.73",
  "PRO_NOMBRE": "Reanclaje de tendón"
 },
 {
  "CATALOG_KEY": "83.74",
  "PRO_NOMBRE": "Reanclaje de músculo"
 },
 {
  "CATALOG_KEY": "83.75",
  "PRO_NOMBRE": "Transferencia o trasplante de tendón"
 },
 {
  "CATALOG_KEY": "83.76",
  "PRO_NOMBRE": "Otra trasposición de tendón"
 },
 {
  "CATALOG_KEY": "83.77",
  "PRO_NOMBRE": "Transferencia o trasplante de músculo"
 },
 {
  "CATALOG_KEY": "83.79",
  "PRO_NOMBRE": "Otra trasposición de músculo"
 },
 {
  "CATALOG_KEY": "83.8",
  "PRO_NOMBRE": "Otras operaciones plásticas sobre músculo, tendón y fascia"
 },
 {
  "CATALOG_KEY": "83.81",
  "PRO_NOMBRE": "Injerto de tendón"
 },
 {
  "CATALOG_KEY": "83.82",
  "PRO_NOMBRE": "Injerto de músculo o fascia"
 },
 {
  "CATALOG_KEY": "83.83",
  "PRO_NOMBRE": "Reconstrucción de polea de tendón"
 },
 {
  "CATALOG_KEY": "83.84",
  "PRO_NOMBRE": "Liberación de pie talo no clasificada bajo otro concepto"
 },
 {
  "CATALOG_KEY": "83.85",
  "PRO_NOMBRE": "Otro cambio en longitud de músculo o tendón"
 },
 {
  "CATALOG_KEY": "83.86",
  "PRO_NOMBRE": "Plastía de cuadríceps"
 },
 {
  "CATALOG_KEY": "83.87",
  "PRO_NOMBRE": "Otras operaciones plásticas sobre músculo"
 },
 {
  "CATALOG_KEY": "83.88",
  "PRO_NOMBRE": "Otras operaciones plásticas sobre tendón"
 },
 {
  "CATALOG_KEY": "83.89",
  "PRO_NOMBRE": "Otras operaciones plásticas sobre fascia"
 },
 {
  "CATALOG_KEY": "83.9",
  "PRO_NOMBRE": "Otras operaciones sobre músculo, tendón fascia y bolsa sinovial"
 },
 {
  "CATALOG_KEY": "83.91",
  "PRO_NOMBRE": "Lisis de adherencias de músculo, tendón, fascia y bolsa sinovial"
 },
 {
  "CATALOG_KEY": "83.92",
  "PRO_NOMBRE": "Inserción o sustitución de estimulador de músculo esquelético"
 },
 {
  "CATALOG_KEY": "83.93",
  "PRO_NOMBRE": "Extracción de estimulador de músculo esquelético"
 },
 {
  "CATALOG_KEY": "83.94",
  "PRO_NOMBRE": "Aspiración de bolsa sinovial"
 },
 {
  "CATALOG_KEY": "83.95",
  "PRO_NOMBRE": "Aspiración de otro tejido blando"
 },
 {
  "CATALOG_KEY": "83.96",
  "PRO_NOMBRE": "Inyección de sustancia terapéutica en bolsa sinovial"
 },
 {
  "CATALOG_KEY": "83.97",
  "PRO_NOMBRE": "Inyección de sustancia terapéutica en tendón"
 },
 {
  "CATALOG_KEY": "83.98",
  "PRO_NOMBRE": "Inyección de sustancia terapéutica de acción local en otro tejido blando"
 },
 {
  "CATALOG_KEY": "83.99",
  "PRO_NOMBRE": "Otras operaciones sobre músculo, tendón, fascia y bolsa sinovial"
 },
 {
  "CATALOG_KEY": "84",
  "PRO_NOMBRE": "Otros procedimientos sobre aparato musculoesquelético"
 },
 {
  "CATALOG_KEY": "84.0",
  "PRO_NOMBRE": "Amputación de miembro superior"
 },
 {
  "CATALOG_KEY": "84.00",
  "PRO_NOMBRE": "Amputación de miembro superior, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "84.01",
  "PRO_NOMBRE": "Amputación y desarticulación de dedo de mano"
 },
 {
  "CATALOG_KEY": "84.02",
  "PRO_NOMBRE": "Amputación y desarticulación de dedo pulgar"
 },
 {
  "CATALOG_KEY": "84.03",
  "PRO_NOMBRE": "Amputación a través de mano"
 },
 {
  "CATALOG_KEY": "84.04",
  "PRO_NOMBRE": "Desarticulación de muñeca"
 },
 {
  "CATALOG_KEY": "84.05",
  "PRO_NOMBRE": "Amputación a través de antebrazo"
 },
 {
  "CATALOG_KEY": "84.06",
  "PRO_NOMBRE": "Desarticulación de codo"
 },
 {
  "CATALOG_KEY": "84.07",
  "PRO_NOMBRE": "Amputación a través de húmero"
 },
 {
  "CATALOG_KEY": "84.08",
  "PRO_NOMBRE": "Desarticulación de hombro"
 },
 {
  "CATALOG_KEY": "84.09",
  "PRO_NOMBRE": "Amputación intertoracoescapular"
 },
 {
  "CATALOG_KEY": "84.1",
  "PRO_NOMBRE": "Amputación de miembro inferior"
 },
 {
  "CATALOG_KEY": "84.10",
  "PRO_NOMBRE": "Amputación de miembro inferior, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "84.11",
  "PRO_NOMBRE": "Amputación de dedo de pie"
 },
 {
  "CATALOG_KEY": "84.12",
  "PRO_NOMBRE": "Amputación a través de pie"
 },
 {
  "CATALOG_KEY": "84.13",
  "PRO_NOMBRE": "Desarticulación de tobillo"
 },
 {
  "CATALOG_KEY": "84.14",
  "PRO_NOMBRE": "Amputación de tobillo a través de maléolos de tibia y peroné"
 },
 {
  "CATALOG_KEY": "84.15",
  "PRO_NOMBRE": "Otra amputación debajo de la rodilla"
 },
 {
  "CATALOG_KEY": "84.16",
  "PRO_NOMBRE": "Desarticulación de rodilla"
 },
 {
  "CATALOG_KEY": "84.17",
  "PRO_NOMBRE": "Amputación por encima de la rodilla"
 },
 {
  "CATALOG_KEY": "84.18",
  "PRO_NOMBRE": "Desarticulación de cadera"
 },
 {
  "CATALOG_KEY": "84.19",
  "PRO_NOMBRE": "Amputación abdominopélvica"
 },
 {
  "CATALOG_KEY": "84.2",
  "PRO_NOMBRE": "Reimplante de extremidad"
 },
 {
  "CATALOG_KEY": "84.21",
  "PRO_NOMBRE": "Reimplante de dedo pulgar"
 },
 {
  "CATALOG_KEY": "84.22",
  "PRO_NOMBRE": "Reimplante de dedo de mano"
 },
 {
  "CATALOG_KEY": "84.23",
  "PRO_NOMBRE": "Reimplante de antebrazo, muñeca o mano"
 },
 {
  "CATALOG_KEY": "84.24",
  "PRO_NOMBRE": "Reimplante de brazo superior"
 },
 {
  "CATALOG_KEY": "84.25",
  "PRO_NOMBRE": "Reimplante de dedo de pie"
 },
 {
  "CATALOG_KEY": "84.26",
  "PRO_NOMBRE": "Reimplante de pie"
 },
 {
  "CATALOG_KEY": "84.27",
  "PRO_NOMBRE": "Reimplante de pierna inferior y tobillo"
 },
 {
  "CATALOG_KEY": "84.28",
  "PRO_NOMBRE": "Reimplante de muslo"
 },
 {
  "CATALOG_KEY": "84.29",
  "PRO_NOMBRE": "Otro reimplante"
 },
 {
  "CATALOG_KEY": "84.3",
  "PRO_NOMBRE": "Revisión de muñón de amputación"
 },
 {
  "CATALOG_KEY": "84.4",
  "PRO_NOMBRE": "Implantación o colocación de dispositivo de miembro protésico"
 },
 {
  "CATALOG_KEY": "84.40",
  "PRO_NOMBRE": "Implantación o colocación de dispositivo de miembro protésico, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "84.41",
  "PRO_NOMBRE": "Colocación de prótesis de brazo superior y hombro"
 },
 {
  "CATALOG_KEY": "84.42",
  "PRO_NOMBRE": "Colocación de prótesis de brazo inferior y mano"
 },
 {
  "CATALOG_KEY": "84.43",
  "PRO_NOMBRE": "Colocación de prótesis de brazo, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "84.44",
  "PRO_NOMBRE": "Implantación de dispositivo protésico de brazo"
 },
 {
  "CATALOG_KEY": "84.45",
  "PRO_NOMBRE": "Colocación de prótesis encima de la rodilla"
 },
 {
  "CATALOG_KEY": "84.46",
  "PRO_NOMBRE": "Colocación de prótesis debajo de la rodilla"
 },
 {
  "CATALOG_KEY": "84.47",
  "PRO_NOMBRE": "Colocación de prótesis de pierna, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "84.48",
  "PRO_NOMBRE": "Implantación de dispositivo protésico de pierna"
 },
 {
  "CATALOG_KEY": "84.5",
  "PRO_NOMBRE": "Implantación de otras sustancias y dispositivos musculoesqueléticos"
 },
 {
  "CATALOG_KEY": "84.51",
  "PRO_NOMBRE": "Inserción de dispositivo de fusión vertebral intersomático"
 },
 {
  "CATALOG_KEY": "84.52",
  "PRO_NOMBRE": "Inserción de proteína morfogenética ósea recombinante"
 },
 {
  "CATALOG_KEY": "84.53",
  "PRO_NOMBRE": "Implantación de dispositivo interno de alargamiento de miembro con tracción cinética"
 },
 {
  "CATALOG_KEY": "84.54",
  "PRO_NOMBRE": "Implantación de otro dispositivo interno de alargamiento de miembro"
 },
 {
  "CATALOG_KEY": "84.55",
  "PRO_NOMBRE": "Inserción de rellenador de hueso"
 },
 {
  "CATALOG_KEY": "84.56",
  "PRO_NOMBRE": "Inserción o reemplazo de espaciador (cemento)"
 },
 {
  "CATALOG_KEY": "84.57",
  "PRO_NOMBRE": "Retiro de espaciador (cemento)"
 },
 {
  "CATALOG_KEY": "84.59",
  "PRO_NOMBRE": "Inserción de otros dispositivos vertebrales"
 },
 {
  "CATALOG_KEY": "84.6",
  "PRO_NOMBRE": "Sustitución de disco intervertebral"
 },
 {
  "CATALOG_KEY": "84.60",
  "PRO_NOMBRE": "Inserción de prótesis de disco intervertebral, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "84.61",
  "PRO_NOMBRE": "Inserción de prótesis parcial de disco intervertebral, cervical"
 },
 {
  "CATALOG_KEY": "84.62",
  "PRO_NOMBRE": "Inserción de prótesis total de disco intervertebral, cervical"
 },
 {
  "CATALOG_KEY": "84.63",
  "PRO_NOMBRE": "Inserción de prótesis de disco intervertebral, torácico"
 },
 {
  "CATALOG_KEY": "84.64",
  "PRO_NOMBRE": "Inserción de prótesis parcial de disco intervertebral, lumbosacra"
 },
 {
  "CATALOG_KEY": "84.65",
  "PRO_NOMBRE": "Inserción de prótesis total de disco intervertebral, lumbosacra"
 },
 {
  "CATALOG_KEY": "84.66",
  "PRO_NOMBRE": "Revisión o sustitución de prótesis artificial de disco intervertebral, cervical"
 },
 {
  "CATALOG_KEY": "84.67",
  "PRO_NOMBRE": "Revisión o sustitución de prótesis artificial de disco intervertebral, torácico"
 },
 {
  "CATALOG_KEY": "84.68",
  "PRO_NOMBRE": "Revisión o sustitución de prótesis artificial de disco intervertebral, lumbosacra"
 },
 {
  "CATALOG_KEY": "84.69",
  "PRO_NOMBRE": "Revisión o sustitución de prótesis artificial de disco intervertebral, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "84.7",
  "PRO_NOMBRE": "Códigos auxiliares para dispositivos fijadores externos"
 },
 {
  "CATALOG_KEY": "84.71",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo, sistema monoplano"
 },
 {
  "CATALOG_KEY": "84.72",
  "PRO_NOMBRE": "Aplicación de dispositivo fijador externo, sistema en anillo"
 },
 {
  "CATALOG_KEY": "84.73",
  "PRO_NOMBRE": "Aplicación de dispositivo híbrido de fijación externa"
 },
 {
  "CATALOG_KEY": "84.8",
  "PRO_NOMBRE": "Inserción, reemplazo y revisión del dispositivo (s) de conservación del movimiento vertebral posterior"
 },
 {
  "CATALOG_KEY": "84.80",
  "PRO_NOMBRE": "Inserción o reemplazo de dispositivo (s) de proceso interespinoso"
 },
 {
  "CATALOG_KEY": "84.81",
  "PRO_NOMBRE": "Revisión de dispositivo(s) de proceso interespinoso"
 },
 {
  "CATALOG_KEY": "84.82",
  "PRO_NOMBRE": "Inserción o reemplazo de dispositivo (s) de estabilización de movimiento basado en pedículo"
 },
 {
  "CATALOG_KEY": "84.83",
  "PRO_NOMBRE": "Revisión de dispositivo (s) de estabilización dinámico basado en pedículo"
 },
 {
  "CATALOG_KEY": "84.84",
  "PRO_NOMBRE": "Inserción o reemplazo de dispositivo (s) de reemplazo de faceta"
 },
 {
  "CATALOG_KEY": "84.85",
  "PRO_NOMBRE": "Revisión de dispositivo (s) de reemplazo de faceta"
 },
 {
  "CATALOG_KEY": "84.9",
  "PRO_NOMBRE": "Otras operaciones sobre el aparato musculoesquelético"
 },
 {
  "CATALOG_KEY": "84.91",
  "PRO_NOMBRE": "Amputación no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "84.92",
  "PRO_NOMBRE": "Separación de gemelos unidos iguales"
 },
 {
  "CATALOG_KEY": "84.93",
  "PRO_NOMBRE": "Separación de gemelos unidos desiguales"
 },
 {
  "CATALOG_KEY": "84.99",
  "PRO_NOMBRE": "Otras operaciones sobre el aparato musculoesquelético"
 },
 {
  "CATALOG_KEY": "85",
  "PRO_NOMBRE": "Operaciones sobre la mama"
 },
 {
  "CATALOG_KEY": "85.0",
  "PRO_NOMBRE": "Mastotomía"
 },
 {
  "CATALOG_KEY": "85.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre mama"
 },
 {
  "CATALOG_KEY": "85.11",
  "PRO_NOMBRE": "Biopsia cerrada [aguja] [percutánea] de mama"
 },
 {
  "CATALOG_KEY": "85.12",
  "PRO_NOMBRE": "Biopsia abierta de mama"
 },
 {
  "CATALOG_KEY": "85.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre mama"
 },
 {
  "CATALOG_KEY": "85.2",
  "PRO_NOMBRE": "Extirpación o destrucción de tejido de la mama"
 },
 {
  "CATALOG_KEY": "85.20",
  "PRO_NOMBRE": "Extirpación o destrucción de tejido de mama, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "85.21",
  "PRO_NOMBRE": "Extirpación local de lesión de mama"
 },
 {
  "CATALOG_KEY": "85.22",
  "PRO_NOMBRE": "Resección de cuadrante de mama"
 },
 {
  "CATALOG_KEY": "85.23",
  "PRO_NOMBRE": "Mastectomía subtotal"
 },
 {
  "CATALOG_KEY": "85.24",
  "PRO_NOMBRE": "Extirpación de tejido mamario ectópico"
 },
 {
  "CATALOG_KEY": "85.25",
  "PRO_NOMBRE": "Extirpación de pezón"
 },
 {
  "CATALOG_KEY": "85.3",
  "PRO_NOMBRE": "Mamoplastía de reducción y mastectomía subcutánea"
 },
 {
  "CATALOG_KEY": "85.31",
  "PRO_NOMBRE": "Mamoplastía de reducción unilateral"
 },
 {
  "CATALOG_KEY": "85.32",
  "PRO_NOMBRE": "Mamoplastía de reducción bilateral"
 },
 {
  "CATALOG_KEY": "85.33",
  "PRO_NOMBRE": "Mastectomía subcutánea unilateral con implantación simultánea"
 },
 {
  "CATALOG_KEY": "85.34",
  "PRO_NOMBRE": "Otra mastectomía subcutánea unilateral"
 },
 {
  "CATALOG_KEY": "85.35",
  "PRO_NOMBRE": "Mastectomía subcutánea bilateral con implantación simultánea"
 },
 {
  "CATALOG_KEY": "85.36",
  "PRO_NOMBRE": "Otra mastectomía subcutánea bilateral"
 },
 {
  "CATALOG_KEY": "85.4",
  "PRO_NOMBRE": "Mastectomía"
 },
 {
  "CATALOG_KEY": "85.41",
  "PRO_NOMBRE": "Mastectomía simple unilateral"
 },
 {
  "CATALOG_KEY": "85.42",
  "PRO_NOMBRE": "Mastectomía simple bilateral"
 },
 {
  "CATALOG_KEY": "85.43",
  "PRO_NOMBRE": "Mastectomía simple ampliada unilateral"
 },
 {
  "CATALOG_KEY": "85.44",
  "PRO_NOMBRE": "Mastectomía simple ampliada bilateral"
 },
 {
  "CATALOG_KEY": "85.45",
  "PRO_NOMBRE": "Mastectomía radical unilateral"
 },
 {
  "CATALOG_KEY": "85.46",
  "PRO_NOMBRE": "Mastectomía radical bilateral"
 },
 {
  "CATALOG_KEY": "85.47",
  "PRO_NOMBRE": "Mastectomía radical ampliada unilateral"
 },
 {
  "CATALOG_KEY": "85.48",
  "PRO_NOMBRE": "Mastectomía radical ampliada bilateral"
 },
 {
  "CATALOG_KEY": "85.5",
  "PRO_NOMBRE": "Mamoplastía de aumento"
 },
 {
  "CATALOG_KEY": "85.50",
  "PRO_NOMBRE": "Mamoplastía de aumento, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "85.51",
  "PRO_NOMBRE": "Inyección en la mama unilateral para aumento"
 },
 {
  "CATALOG_KEY": "85.52",
  "PRO_NOMBRE": "Inyección en el interior de la mama bilateral para aumento"
 },
 {
  "CATALOG_KEY": "85.53",
  "PRO_NOMBRE": "Implante mamario unilateral"
 },
 {
  "CATALOG_KEY": "85.54",
  "PRO_NOMBRE": "Implante mamario bilateral"
 },
 {
  "CATALOG_KEY": "85.6",
  "PRO_NOMBRE": "Mastopexia"
 },
 {
  "CATALOG_KEY": "85.7",
  "PRO_NOMBRE": "Reconstrucción total de mama"
 },
 {
  "CATALOG_KEY": "85.70",
  "PRO_NOMBRE": "Reconstrucción total de mama, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "85.71",
  "PRO_NOMBRE": "Reconstrucción total de mama con colgajo miocutáneo dorsal ancho"
 },
 {
  "CATALOG_KEY": "85.72",
  "PRO_NOMBRE": "Reconstrucción total de mama con colgajo TRAM pediculado"
 },
 {
  "CATALOG_KEY": "85.73",
  "PRO_NOMBRE": "Reconstrucción total de mama con colgajo TRAM libre (miocutáneo de recto transverso abdominal)"
 },
 {
  "CATALOG_KEY": "85.74",
  "PRO_NOMBRE": "Reconstrucción total de mama con colgajo DIEP (de arteria epigástrica inferior profunda perforante)"
 },
 {
  "CATALOG_KEY": "85.75",
  "PRO_NOMBRE": "Reconstrucción total de mama con colgajo libre SIEA (de arteria epigástrica superficial inferior)"
 },
 {
  "CATALOG_KEY": "85.76",
  "PRO_NOMBRE": "Reconstrucción total de mama con colgajo libre GAP (de arteria glútea perforante)"
 },
 {
  "CATALOG_KEY": "85.8",
  "PRO_NOMBRE": "Otras operaciones de reparación y plásticas sobre mama"
 },
 {
  "CATALOG_KEY": "85.81",
  "PRO_NOMBRE": "Sutura de desgarro de la mama"
 },
 {
  "CATALOG_KEY": "85.82",
  "PRO_NOMBRE": "Injerto de grosor parcial en la piel de la mama"
 },
 {
  "CATALOG_KEY": "85.83",
  "PRO_NOMBRE": "Injerto de grosor total en la piel de la mama"
 },
 {
  "CATALOG_KEY": "85.84",
  "PRO_NOMBRE": "Colgajo sobre la mama"
 },
 {
  "CATALOG_KEY": "85.85",
  "PRO_NOMBRE": "Colgajo muscular sobre región mamaria"
 },
 {
  "CATALOG_KEY": "85.86",
  "PRO_NOMBRE": "Transposición de pezón"
 },
 {
  "CATALOG_KEY": "85.87",
  "PRO_NOMBRE": "Otra reparación o reconstrucción de pezón"
 },
 {
  "CATALOG_KEY": "85.89",
  "PRO_NOMBRE": "Otra mamoplastía"
 },
 {
  "CATALOG_KEY": "85.9",
  "PRO_NOMBRE": "Otras operaciones sobre la mama"
 },
 {
  "CATALOG_KEY": "85.91",
  "PRO_NOMBRE": "Aspiración de mama"
 },
 {
  "CATALOG_KEY": "85.92",
  "PRO_NOMBRE": "Inyección de agente terapéutico en mama"
 },
 {
  "CATALOG_KEY": "85.93",
  "PRO_NOMBRE": "Revisión de implante de mama"
 },
 {
  "CATALOG_KEY": "85.94",
  "PRO_NOMBRE": "Extracción de implante de mama"
 },
 {
  "CATALOG_KEY": "85.95",
  "PRO_NOMBRE": "Inserción de expansores del tejido mamario"
 },
 {
  "CATALOG_KEY": "85.96",
  "PRO_NOMBRE": "Extracción de expansores de tejido mamario"
 },
 {
  "CATALOG_KEY": "85.99",
  "PRO_NOMBRE": "Otras operaciones sobre la mama"
 },
 {
  "CATALOG_KEY": "86",
  "PRO_NOMBRE": "Operaciones sobre piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.0",
  "PRO_NOMBRE": "Incisión de piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.01",
  "PRO_NOMBRE": "Aspiración de piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.02",
  "PRO_NOMBRE": "Inyección o tatuaje de lesión o defecto de piel"
 },
 {
  "CATALOG_KEY": "86.03",
  "PRO_NOMBRE": "Incisión de seno o quiste pilonidal"
 },
 {
  "CATALOG_KEY": "86.04",
  "PRO_NOMBRE": "Otra incisión con drenaje de piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.05",
  "PRO_NOMBRE": "Incisión con extracción de cuerpo extraño o dispositivo de piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.06",
  "PRO_NOMBRE": "Inserción de bomba de infusión totalmente implantable"
 },
 {
  "CATALOG_KEY": "86.07",
  "PRO_NOMBRE": "Inserción de dispositivo de acceso vascular [DAV] totalmente implantable"
 },
 {
  "CATALOG_KEY": "86.09",
  "PRO_NOMBRE": "Otra incisión de piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.1",
  "PRO_NOMBRE": "Procedimientos diagnósticos sobre piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.11",
  "PRO_NOMBRE": "Biopsia de piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.19",
  "PRO_NOMBRE": "Otros procedimientos diagnósticos sobre piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.2",
  "PRO_NOMBRE": "Extirpación o destrucción de lesión o tejido de piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.21",
  "PRO_NOMBRE": "Extirpación de quiste o seno pilonidal"
 },
 {
  "CATALOG_KEY": "86.22",
  "PRO_NOMBRE": "Desbridamiento excisional de herida, infección o quemadura"
 },
 {
  "CATALOG_KEY": "86.23",
  "PRO_NOMBRE": "Extracción de uña, lecho de uña o pliegue de uña"
 },
 {
  "CATALOG_KEY": "86.24",
  "PRO_NOMBRE": "Quimiocirugía de piel"
 },
 {
  "CATALOG_KEY": "86.25",
  "PRO_NOMBRE": "Abrasión dérmica"
 },
 {
  "CATALOG_KEY": "86.26",
  "PRO_NOMBRE": "Ligadura de apéndice dérmico"
 },
 {
  "CATALOG_KEY": "86.27",
  "PRO_NOMBRE": "Desbridamiento de uña, base de uña o pliegue de uña"
 },
 {
  "CATALOG_KEY": "86.28",
  "PRO_NOMBRE": "Desbridamiento no excisional de herida, infección o quemadura"
 },
 {
  "CATALOG_KEY": "86.3",
  "PRO_NOMBRE": "Otra extirpación local o destrucción de lesión o tejido de piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.4",
  "PRO_NOMBRE": "Extirpación radical de lesión cutánea"
 },
 {
  "CATALOG_KEY": "86.5",
  "PRO_NOMBRE": "Sutura u otro cierre de piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.51",
  "PRO_NOMBRE": "Reimplantación de cuero cabelludo"
 },
 {
  "CATALOG_KEY": "86.59",
  "PRO_NOMBRE": "Cierre de piel y tejido subcutáneo de otros sitios"
 },
 {
  "CATALOG_KEY": "86.6",
  "PRO_NOMBRE": "Injerto cutáneo libre"
 },
 {
  "CATALOG_KEY": "86.60",
  "PRO_NOMBRE": "Injerto cutáneo libre. no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "86.61",
  "PRO_NOMBRE": "Injerto cutáneo de espesor total a mano"
 },
 {
  "CATALOG_KEY": "86.62",
  "PRO_NOMBRE": "Otro injerto cutáneo a mano"
 },
 {
  "CATALOG_KEY": "86.63",
  "PRO_NOMBRE": "Injerto cutáneo de grosor total a otros sitios"
 },
 {
  "CATALOG_KEY": "86.64",
  "PRO_NOMBRE": "Trasplante de pelo"
 },
 {
  "CATALOG_KEY": "86.65",
  "PRO_NOMBRE": "Heteroinjerto de piel"
 },
 {
  "CATALOG_KEY": "86.66",
  "PRO_NOMBRE": "Homoinjerto de piel"
 },
 {
  "CATALOG_KEY": "86.67",
  "PRO_NOMBRE": "Injerto regenerativo de piel"
 },
 {
  "CATALOG_KEY": "86.69",
  "PRO_NOMBRE": "Otro injerto cutáneo a otros sitios"
 },
 {
  "CATALOG_KEY": "86.7",
  "PRO_NOMBRE": "Injertos de pedículos o colgajos"
 },
 {
  "CATALOG_KEY": "86.70",
  "PRO_NOMBRE": "Injerto de pedículo o colgajo, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "86.71",
  "PRO_NOMBRE": "Corte y preparación de injertos de pedículos o colgajos"
 },
 {
  "CATALOG_KEY": "86.72",
  "PRO_NOMBRE": "Avance de pedículo o colgajo"
 },
 {
  "CATALOG_KEY": "86.73",
  "PRO_NOMBRE": "Fijación de injerto de pedículo o colgajo a mano"
 },
 {
  "CATALOG_KEY": "86.74",
  "PRO_NOMBRE": "Fijación de injerto de pedículo o colgajo a otros sitios"
 },
 {
  "CATALOG_KEY": "86.75",
  "PRO_NOMBRE": "Revisión de injerto o colgajo"
 },
 {
  "CATALOG_KEY": "86.8",
  "PRO_NOMBRE": "Otra reparación y reconstrucción de piel de tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.81",
  "PRO_NOMBRE": "Reparación de debilidad facial"
 },
 {
  "CATALOG_KEY": "86.82",
  "PRO_NOMBRE": "Ritidectomía facial"
 },
 {
  "CATALOG_KEY": "86.83",
  "PRO_NOMBRE": "Operación plástica de reducción de tamaño"
 },
 {
  "CATALOG_KEY": "86.84",
  "PRO_NOMBRE": "Relajación de cicatriz o de contractura reticulada de piel"
 },
 {
  "CATALOG_KEY": "86.85",
  "PRO_NOMBRE": "Corrección de sindactilia"
 },
 {
  "CATALOG_KEY": "86.86",
  "PRO_NOMBRE": "Onicoplastía"
 },
 {
  "CATALOG_KEY": "86.89",
  "PRO_NOMBRE": "Otra reparación y reconstrucción de piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.9",
  "PRO_NOMBRE": "Otras operaciones sobre piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "86.91",
  "PRO_NOMBRE": "Excisión de piel para injerto"
 },
 {
  "CATALOG_KEY": "86.92",
  "PRO_NOMBRE": "Electrolisis y otra depilación de piel"
 },
 {
  "CATALOG_KEY": "86.93",
  "PRO_NOMBRE": "Inserción de expansor de tejidos"
 },
 {
  "CATALOG_KEY": "86.94",
  "PRO_NOMBRE": "Inserción o sustitución de neuroestimulador generador de pulsos de un solo electrodo, no especificado como recargable"
 },
 {
  "CATALOG_KEY": "86.95",
  "PRO_NOMBRE": "Inserción o sustitución de neuroestimulador generador de pulsos de disposición dual"
 },
 {
  "CATALOG_KEY": "86.96",
  "PRO_NOMBRE": "Inserción o sustitución de otro neuroestimulador generador de pulsos"
 },
 {
  "CATALOG_KEY": "86.97",
  "PRO_NOMBRE": "Inserción o sustitución de neuroestimulador generador de pulsos recargable de electrodo único"
 },
 {
  "CATALOG_KEY": "86.98",
  "PRO_NOMBRE": "Inserción o sustitución de neuroestimulador generador de pulsos recargable de doble electrodo"
 },
 {
  "CATALOG_KEY": "86.99",
  "PRO_NOMBRE": "Otras operaciones sobre piel y tejido subcutáneo"
 },
 {
  "CATALOG_KEY": "87.5",
  "PRO_NOMBRE": "Radiografía de las vías biliares"
 },
 {
  "CATALOG_KEY": "87.51",
  "PRO_NOMBRE": "Colangiografía hepática percutánea"
 },
 {
  "CATALOG_KEY": "87.52",
  "PRO_NOMBRE": "Colangiografía intravenosa"
 },
 {
  "CATALOG_KEY": "87.53",
  "PRO_NOMBRE": "Colangiografía intraoperatoria"
 },
 {
  "CATALOG_KEY": "87.54",
  "PRO_NOMBRE": "Otras colangiografías"
 },
 {
  "CATALOG_KEY": "87.59",
  "PRO_NOMBRE": "Otras radiografías de vías biliares"
 },
 {
  "CATALOG_KEY": "87.6",
  "PRO_NOMBRE": "Otras radiografías del aparato digestivo"
 },
 {
  "CATALOG_KEY": "87.61",
  "PRO_NOMBRE": "Deglución de la papilla"
 },
 {
  "CATALOG_KEY": "87.62",
  "PRO_NOMBRE": "Serie gastrointestinal superior"
 },
 {
  "CATALOG_KEY": "87.63",
  "PRO_NOMBRE": "Serie de intestino delgado"
 },
 {
  "CATALOG_KEY": "87.64",
  "PRO_NOMBRE": "Serie gastrointestinal inferior"
 },
 {
  "CATALOG_KEY": "87.65",
  "PRO_NOMBRE": "Otras radiografías del intestino"
 },
 {
  "CATALOG_KEY": "87.66",
  "PRO_NOMBRE": "Pancreatografía con contraste"
 },
 {
  "CATALOG_KEY": "87.69",
  "PRO_NOMBRE": "Otras radiografías del tubo digestivo"
 },
 {
  "CATALOG_KEY": "87.7",
  "PRO_NOMBRE": "Radiografía del aparato urinario"
 },
 {
  "CATALOG_KEY": "87.71",
  "PRO_NOMBRE": "Tomografía axial computarizada de riñón"
 },
 {
  "CATALOG_KEY": "87.72",
  "PRO_NOMBRE": "Otra nefrotomografía"
 },
 {
  "CATALOG_KEY": "87.73",
  "PRO_NOMBRE": "Pielografía intravenosa"
 },
 {
  "CATALOG_KEY": "87.74",
  "PRO_NOMBRE": "Pielografía retrógrada"
 },
 {
  "CATALOG_KEY": "87.75",
  "PRO_NOMBRE": "Pielografía percutánea"
 },
 {
  "CATALOG_KEY": "87.76",
  "PRO_NOMBRE": "Cistouretrografía retrógrada"
 },
 {
  "CATALOG_KEY": "87.77",
  "PRO_NOMBRE": "Otra cistografía"
 },
 {
  "CATALOG_KEY": "87.78",
  "PRO_NOMBRE": "Conductografía ileal"
 },
 {
  "CATALOG_KEY": "87.79",
  "PRO_NOMBRE": "Otra radiografía del aparato urinario"
 },
 {
  "CATALOG_KEY": "87.8",
  "PRO_NOMBRE": "Radiografía de órganos genitales femeninos"
 },
 {
  "CATALOG_KEY": "87.81",
  "PRO_NOMBRE": "Radiografía de útero grávido"
 },
 {
  "CATALOG_KEY": "87.82",
  "PRO_NOMBRE": "Histerosalpingografía con contraste por gas"
 },
 {
  "CATALOG_KEY": "87.83",
  "PRO_NOMBRE": "Histerosalpingografía con contraste radiopaco"
 },
 {
  "CATALOG_KEY": "87.84",
  "PRO_NOMBRE": "Histerografía percutánea"
 },
 {
  "CATALOG_KEY": "87.85",
  "PRO_NOMBRE": "Otra radiografía de trompas de Falopio y útero"
 },
 {
  "CATALOG_KEY": "87.89",
  "PRO_NOMBRE": "Otras radiografías de órganos genitales femeninos"
 },
 {
  "CATALOG_KEY": "87.9",
  "PRO_NOMBRE": "Radiografía de órganos genitales masculinos"
 },
 {
  "CATALOG_KEY": "87.91",
  "PRO_NOMBRE": "Radiografía con contraste de vesículas seminales (vesiculografía)"
 },
 {
  "CATALOG_KEY": "87.92",
  "PRO_NOMBRE": "Otras radiografías de la próstata y las vesículas seminales"
 },
 {
  "CATALOG_KEY": "87.93",
  "PRO_NOMBRE": "Epididimograma de contraste"
 },
 {
  "CATALOG_KEY": "87.94",
  "PRO_NOMBRE": "Deferentografía con contraste"
 },
 {
  "CATALOG_KEY": "87.95",
  "PRO_NOMBRE": "Otras radiografías del epidídimo y los conductos deferentes"
 },
 {
  "CATALOG_KEY": "87.99",
  "PRO_NOMBRE": "Otras radiografías de los órganos genitales masculinos"
 },
 {
  "CATALOG_KEY": "88",
  "PRO_NOMBRE": "Otras radiografías diagnósticas y técnicas conexas"
 },
 {
  "CATALOG_KEY": "88.0",
  "PRO_NOMBRE": "Radiografía de tejidos blandos del abdomen"
 },
 {
  "CATALOG_KEY": "88.01",
  "PRO_NOMBRE": "Tomografía axial computarizada del abdomen"
 },
 {
  "CATALOG_KEY": "88.02",
  "PRO_NOMBRE": "Otras tomografías de abdomen"
 },
 {
  "CATALOG_KEY": "88.03",
  "PRO_NOMBRE": "Sinografía de pared abdominal"
 },
 {
  "CATALOG_KEY": "88.04",
  "PRO_NOMBRE": "Linfangiografía abdominal"
 },
 {
  "CATALOG_KEY": "88.09",
  "PRO_NOMBRE": "Otras radiografías de los tejidos blandos de la pared abdominal"
 },
 {
  "CATALOG_KEY": "88.4",
  "PRO_NOMBRE": "Arteriografía utilizando medios de contraste"
 },
 {
  "CATALOG_KEY": "88.40",
  "PRO_NOMBRE": "Arteriografía con contraste, área no especificada"
 },
 {
  "CATALOG_KEY": "88.41",
  "PRO_NOMBRE": "Arteriografía de las arterias cerebrales"
 },
 {
  "CATALOG_KEY": "88.42",
  "PRO_NOMBRE": "Aortografía"
 },
 {
  "CATALOG_KEY": "88.43",
  "PRO_NOMBRE": "Arteriografía de las arterias pulmonares"
 },
 {
  "CATALOG_KEY": "88.44",
  "PRO_NOMBRE": "Arteriografía de otros vasos intratorácicos"
 },
 {
  "CATALOG_KEY": "88.45",
  "PRO_NOMBRE": "Arteriografía de arterias renales"
 },
 {
  "CATALOG_KEY": "88.46",
  "PRO_NOMBRE": "Arteriografía de la placenta"
 },
 {
  "CATALOG_KEY": "88.47",
  "PRO_NOMBRE": "Arteriografía de otras arterias intra-abdominales"
 },
 {
  "CATALOG_KEY": "88.48",
  "PRO_NOMBRE": "Arteriografía de arterias femorales y otras arterias de las extremidades inferiores"
 },
 {
  "CATALOG_KEY": "88.49",
  "PRO_NOMBRE": "Arteriografía de otras áreas especificadas"
 },
 {
  "CATALOG_KEY": "88.5",
  "PRO_NOMBRE": "Angiocardiografía utilizando medios de contraste"
 },
 {
  "CATALOG_KEY": "88.50",
  "PRO_NOMBRE": "Angiocardiografía, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "88.51",
  "PRO_NOMBRE": "Angiocardiografía de las venas cavas"
 },
 {
  "CATALOG_KEY": "88.52",
  "PRO_NOMBRE": "Angiocardiografía de estructuras cardiacas derechas"
 },
 {
  "CATALOG_KEY": "88.53",
  "PRO_NOMBRE": "Angiocardiografía de estructuras cardiacas izquierdas"
 },
 {
  "CATALOG_KEY": "88.54",
  "PRO_NOMBRE": "Angiocardiografía combinada de las cavidades derechas e izquierdas"
 },
 {
  "CATALOG_KEY": "88.55",
  "PRO_NOMBRE": "Arteriografía coronaria con empleo de un solo catéter"
 },
 {
  "CATALOG_KEY": "88.56",
  "PRO_NOMBRE": "Arteriografía coronaria con empleo de dos catéteres"
 },
 {
  "CATALOG_KEY": "88.57",
  "PRO_NOMBRE": "Otra arteriografía coronaria y arteriografía coronaria, no especificada"
 },
 {
  "CATALOG_KEY": "88.58",
  "PRO_NOMBRE": "Radiografía cardiaca de contraste negativo"
 },
 {
  "CATALOG_KEY": "88.59",
  "PRO_NOMBRE": "Angiografía vascular fluorescente intra-operatoria"
 },
 {
  "CATALOG_KEY": "88.6",
  "PRO_NOMBRE": "Flebografía"
 },
 {
  "CATALOG_KEY": "88.60",
  "PRO_NOMBRE": "Flebografía con contraste, área no especificada"
 },
 {
  "CATALOG_KEY": "88.61",
  "PRO_NOMBRE": "Flebografía de las venas de la cabeza y el cuello utilizando contraste"
 },
 {
  "CATALOG_KEY": "88.62",
  "PRO_NOMBRE": "Flebografía de las venas pulmonares utilizando un medio de contraste"
 },
 {
  "CATALOG_KEY": "88.63",
  "PRO_NOMBRE": "Flebografía de otras venas intratorácicas utilizando un medio de contraste"
 },
 {
  "CATALOG_KEY": "88.64",
  "PRO_NOMBRE": "Flebografía del sistema venoso portal utilizando un medio de contraste"
 },
 {
  "CATALOG_KEY": "88.65",
  "PRO_NOMBRE": "Flebografía de otras venas intraabdominales utilizando un medio de contraste"
 },
 {
  "CATALOG_KEY": "88.66",
  "PRO_NOMBRE": "Flebografía de venas femorales y otras venas de los miembros inferiores utilizando un medio de contraste"
 },
 {
  "CATALOG_KEY": "88.67",
  "PRO_NOMBRE": "Flebografía de otras áreas especificadas utilizando un medio de contraste"
 },
 {
  "CATALOG_KEY": "88.68",
  "PRO_NOMBRE": "Flebografía de impedancia"
 },
 {
  "CATALOG_KEY": "88.7",
  "PRO_NOMBRE": "Ecografía diagnóstica"
 },
 {
  "CATALOG_KEY": "88.71",
  "PRO_NOMBRE": "Ultrasonografía diagnóstica de la cabeza y el cuello"
 },
 {
  "CATALOG_KEY": "88.72",
  "PRO_NOMBRE": "Ultrasonografía diagnóstica del corazón"
 },
 {
  "CATALOG_KEY": "88.73",
  "PRO_NOMBRE": "Ultrasonografía diagnóstica de otras áreas del tórax"
 },
 {
  "CATALOG_KEY": "88.74",
  "PRO_NOMBRE": "Ultrasonografía diagnóstica del aparato digestivo"
 },
 {
  "CATALOG_KEY": "88.75",
  "PRO_NOMBRE": "Ultrasonografía diagnóstica del aparato urinario"
 },
 {
  "CATALOG_KEY": "88.76",
  "PRO_NOMBRE": "Ultrasonografía diagnóstica del abdomen y el retroperitoneo"
 },
 {
  "CATALOG_KEY": "88.77",
  "PRO_NOMBRE": "Ultrasonografía diagnóstica del sistema vascular periférico"
 },
 {
  "CATALOG_KEY": "88.78",
  "PRO_NOMBRE": "Ultrasonografía diagnóstica del útero grávido"
 },
 {
  "CATALOG_KEY": "88.79",
  "PRO_NOMBRE": "Otras ultrasonografías diagnósticas"
 },
 {
  "CATALOG_KEY": "92.3",
  "PRO_NOMBRE": "Radiocirugía estereotáxica"
 },
 {
  "CATALOG_KEY": "92.30",
  "PRO_NOMBRE": "Radiocirugía estereotáxica, no especificada de otra manera"
 },
 {
  "CATALOG_KEY": "92.31",
  "PRO_NOMBRE": "Radiocirugía de fuente única de fotones"
 },
 {
  "CATALOG_KEY": "92.32",
  "PRO_NOMBRE": "Radiocirugía de múltiples fuentes de fotones"
 },
 {
  "CATALOG_KEY": "92.33",
  "PRO_NOMBRE": "Radiocirugía de partículas"
 },
 {
  "CATALOG_KEY": "92.39",
  "PRO_NOMBRE": "Radiocirugía estereotáxica, no clasificada bajo otros conceptos"
 },
 {
  "CATALOG_KEY": "92.4",
  "PRO_NOMBRE": "Procedimientos intra-operatorios de radiación"
 },
 {
  "CATALOG_KEY": "92.41",
  "PRO_NOMBRE": "Radioterapia intra-operatoria con electrones (IOERT)"
 },
 {
  "CATALOG_KEY": "96",
  "PRO_NOMBRE": "Intubación e irrigación no quirúrgicas"
 },
 {
  "CATALOG_KEY": "96.0",
  "PRO_NOMBRE": "Intubación no operatoria de los tractos gastrointestinal y respiratorio"
 },
 {
  "CATALOG_KEY": "96.01",
  "PRO_NOMBRE": "Inserción de vía aérea nasofaríngea"
 },
 {
  "CATALOG_KEY": "96.02",
  "PRO_NOMBRE": "Inserción de vía aérea orofaríngea"
 },
 {
  "CATALOG_KEY": "96.03",
  "PRO_NOMBRE": "Inserción de vía aérea obturada esofágica"
 },
 {
  "CATALOG_KEY": "96.04",
  "PRO_NOMBRE": "Inserción de tubo endotraqueal"
 },
 {
  "CATALOG_KEY": "96.05",
  "PRO_NOMBRE": "Otra intubación del tracto respiratorio"
 },
 {
  "CATALOG_KEY": "96.06",
  "PRO_NOMBRE": "Inserción de tubo de Sengstaken"
 },
 {
  "CATALOG_KEY": "96.07",
  "PRO_NOMBRE": "Inserción de otro tubo (naso-)gástrico"
 },
 {
  "CATALOG_KEY": "96.08",
  "PRO_NOMBRE": "Inserción de tubo (naso-)intestinal"
 },
 {
  "CATALOG_KEY": "96.09",
  "PRO_NOMBRE": "Inserción de tubo rectal"
 },
 {
  "CATALOG_KEY": "96.1",
  "PRO_NOMBRE": "Otra inserción no quirúrgica"
 },
 {
  "CATALOG_KEY": "96.11",
  "PRO_NOMBRE": "Taponamiento del canal auditivo externo"
 },
 {
  "CATALOG_KEY": "96.14",
  "PRO_NOMBRE": "Taponamiento vaginal"
 },
 {
  "CATALOG_KEY": "96.15",
  "PRO_NOMBRE": "Inserción de molde vaginal"
 },
 {
  "CATALOG_KEY": "96.16",
  "PRO_NOMBRE": "Otra dilatación vaginal"
 },
 {
  "CATALOG_KEY": "96.17",
  "PRO_NOMBRE": "Inserción de diafragma vaginal"
 },
 {
  "CATALOG_KEY": "96.18",
  "PRO_NOMBRE": "Inserción de otro pesario vaginal"
 },
 {
  "CATALOG_KEY": "96.19",
  "PRO_NOMBRE": "Taponamiento rectal"
 },
 {
  "CATALOG_KEY": "96.2",
  "PRO_NOMBRE": "Dilatación y manipulación no quirúrgica"
 },
 {
  "CATALOG_KEY": "96.21",
  "PRO_NOMBRE": "Dilatación del conducto frontonasal"
 },
 {
  "CATALOG_KEY": "96.22",
  "PRO_NOMBRE": "Dilatación del recto"
 },
 {
  "CATALOG_KEY": "96.23",
  "PRO_NOMBRE": "Dilatación del esfínter anal"
 },
 {
  "CATALOG_KEY": "96.24",
  "PRO_NOMBRE": "Dilatación y manipulación de estoma de esterostomía"
 },
 {
  "CATALOG_KEY": "96.25",
  "PRO_NOMBRE": "Distensión terapéutica de vejiga"
 },
 {
  "CATALOG_KEY": "96.26",
  "PRO_NOMBRE": "Reducción manual de prolapso rectal"
 },
 {
  "CATALOG_KEY": "96.27",
  "PRO_NOMBRE": "Reducción manual de hernia"
 },
 {
  "CATALOG_KEY": "96.28",
  "PRO_NOMBRE": "Reducción manual de prolapso de enterostomía"
 },
 {
  "CATALOG_KEY": "96.29",
  "PRO_NOMBRE": "Reducción de intususcepción del tracto alimentario"
 },
 {
  "CATALOG_KEY": "96.3",
  "PRO_NOMBRE": "Irrigación, limpieza e instalación local del tracto digestivo no quirúrgico"
 },
 {
  "CATALOG_KEY": "96.31",
  "PRO_NOMBRE": "Enfriamiento gástrico"
 },
 {
  "CATALOG_KEY": "96.32",
  "PRO_NOMBRE": "Congelación gástrica"
 },
 {
  "CATALOG_KEY": "96.33",
  "PRO_NOMBRE": "Lavado gástrico"
 },
 {
  "CATALOG_KEY": "96.34",
  "PRO_NOMBRE": "Otra irrigación de tubo (naso-)gástrico"
 },
 {
  "CATALOG_KEY": "96.35",
  "PRO_NOMBRE": "Alimentación gástrica por sonda"
 },
 {
  "CATALOG_KEY": "96.36",
  "PRO_NOMBRE": "Irrigación de gastrostomía o de enterostomía"
 },
 {
  "CATALOG_KEY": "96.37",
  "PRO_NOMBRE": "Proctoclisis"
 },
 {
  "CATALOG_KEY": "96.38",
  "PRO_NOMBRE": "Extracción de heces impactadas"
 },
 {
  "CATALOG_KEY": "96.39",
  "PRO_NOMBRE": "Otro enema transanal"
 },
 {
  "CATALOG_KEY": "96.4",
  "PRO_NOMBRE": "Irrigación, limpieza e instilación local no quirúrgica de otros órganos digestivos y genitourinarios"
 },
 {
  "CATALOG_KEY": "96.41",
  "PRO_NOMBRE": "Irrigación de colecistostomía y otro tubo biliar"
 },
 {
  "CATALOG_KEY": "96.42",
  "PRO_NOMBRE": "Irrigación de tubo pancreático"
 },
 {
  "CATALOG_KEY": "96.43",
  "PRO_NOMBRE": "Instalación del tracto digestivo, salvo alimentación gástrica por sonda"
 },
 {
  "CATALOG_KEY": "96.44",
  "PRO_NOMBRE": "Ducha vaginal"
 },
 {
  "CATALOG_KEY": "96.45",
  "PRO_NOMBRE": "Irrigación de nefrostomía y pielostomía"
 },
 {
  "CATALOG_KEY": "96.46",
  "PRO_NOMBRE": "Irrigación de ureterostomía y catéter ureteral"
 },
 {
  "CATALOG_KEY": "96.47",
  "PRO_NOMBRE": "Irrigación de cistostomía"
 },
 {
  "CATALOG_KEY": "96.48",
  "PRO_NOMBRE": "Irrigación de otro catéter urinario permanente"
 },
 {
  "CATALOG_KEY": "96.49",
  "PRO_NOMBRE": "Otra instilación genitourinaria"
 },
 {
  "CATALOG_KEY": "96.5",
  "PRO_NOMBRE": "Otra irrigación y limpieza no quirúrgica"
 },
 {
  "CATALOG_KEY": "96.51",
  "PRO_NOMBRE": "Irrigación del ojo"
 },
 {
  "CATALOG_KEY": "96.52",
  "PRO_NOMBRE": "Irrigación del oído"
 },
 {
  "CATALOG_KEY": "96.53",
  "PRO_NOMBRE": "Irrigación de conductos nasales"
 },
 {
  "CATALOG_KEY": "96.54",
  "PRO_NOMBRE": "Eliminación de sarro, pulido y desbridamiento de dientes"
 },
 {
  "CATALOG_KEY": "96.55",
  "PRO_NOMBRE": "Limpieza de traqueostomía"
 },
 {
  "CATALOG_KEY": "96.56",
  "PRO_NOMBRE": "Otro lavado de bronquio y tráquea"
 },
 {
  "CATALOG_KEY": "96.57",
  "PRO_NOMBRE": "Irrigación de catéter vascular"
 },
 {
  "CATALOG_KEY": "96.58",
  "PRO_NOMBRE": "Irrigación de catéter de herida"
 },
 {
  "CATALOG_KEY": "96.59",
  "PRO_NOMBRE": "Otra irrigación de herida"
 },
 {
  "CATALOG_KEY": "96.6",
  "PRO_NOMBRE": "Infusión enteral de sustancias nutritivas concentradas"
 },
 {
  "CATALOG_KEY": "96.7",
  "PRO_NOMBRE": "Otra ventilación mecánica continua invasiva"
 },
 {
  "CATALOG_KEY": "96.70",
  "PRO_NOMBRE": "Ventilación mecánica invasiva continua de duración no especificada"
 },
 {
  "CATALOG_KEY": "96.71",
  "PRO_NOMBRE": "Ventilación mecánica invasiva continua inferior a 96 horas consecutivas"
 },
 {
  "CATALOG_KEY": "96.72",
  "PRO_NOMBRE": "Ventilación mecánica invasiva continua durante 96 horas consecutivas o más"
 },
 {
  "CATALOG_KEY": "97",
  "PRO_NOMBRE": "Sustitución y extracción de dispositivos terapéuticos"
 },
 {
  "CATALOG_KEY": "97.0",
  "PRO_NOMBRE": "Sustitución no quirúrgica de dispositivo gastrointestinal"
 },
 {
  "CATALOG_KEY": "97.01",
  "PRO_NOMBRE": "Sustitución de tubo (naso-)gástrico o de esofagostomía"
 },
 {
  "CATALOG_KEY": "97.02",
  "PRO_NOMBRE": "Sustitución de tubo de gastrostomía"
 },
 {
  "CATALOG_KEY": "97.03",
  "PRO_NOMBRE": "Sustitución de tubo o dispositivo de enterostomía del intestino delgado"
 },
 {
  "CATALOG_KEY": "97.04",
  "PRO_NOMBRE": "Sustitución de tubo o dispositivo de enterostomía del intestino grueso"
 },
 {
  "CATALOG_KEY": "97.05",
  "PRO_NOMBRE": "Sustitución de stent (tubo tutor) en vías biliares o conducto pancreático"
 },
 {
  "CATALOG_KEY": "97.1",
  "PRO_NOMBRE": "Sustitución no quirúrgica de dispositivo de los sistemas músculo esqueléticos o tegumentario"
 },
 {
  "CATALOG_KEY": "97.11",
  "PRO_NOMBRE": "Sustitución de escayola en miembro superior"
 },
 {
  "CATALOG_KEY": "97.12",
  "PRO_NOMBRE": "Sustitución de escayola en miembro inferior"
 },
 {
  "CATALOG_KEY": "97.13",
  "PRO_NOMBRE": "Sustitución de otra escayola"
 },
 {
  "CATALOG_KEY": "97.14",
  "PRO_NOMBRE": "Sustitución de otro dispositivo para inmovilización músculo esquelético"
 },
 {
  "CATALOG_KEY": "97.15",
  "PRO_NOMBRE": "Sustitución de catéter de herida"
 },
 {
  "CATALOG_KEY": "97.16",
  "PRO_NOMBRE": "Sustitución de tapón o drenaje de herida"
 },
 {
  "CATALOG_KEY": "97.2",
  "PRO_NOMBRE": "Otra sustitución, no quirúrgica"
 },
 {
  "CATALOG_KEY": "97.21",
  "PRO_NOMBRE": "Sustitución de tapón nasal"
 },
 {
  "CATALOG_KEY": "97.22",
  "PRO_NOMBRE": "Sustitución de tapón dental"
 },
 {
  "CATALOG_KEY": "97.23",
  "PRO_NOMBRE": "Sustitución de tubo de traqueostomía"
 },
 {
  "CATALOG_KEY": "97.24",
  "PRO_NOMBRE": "Sustitución y ajuste de diafragma vaginal"
 },
 {
  "CATALOG_KEY": "97.25",
  "PRO_NOMBRE": "Sustitución de otro pesario vaginal"
 },
 {
  "CATALOG_KEY": "97.26",
  "PRO_NOMBRE": "Sustitución de otro tapón o drenaje vaginal o vulvar"
 },
 {
  "CATALOG_KEY": "97.29",
  "PRO_NOMBRE": "Otras sustituciones no quirúrgicas"
 },
 {
  "CATALOG_KEY": "97.3",
  "PRO_NOMBRE": "Extracción no quirúrgica de dispositivo terapéutico de cabeza y cuello"
 },
 {
  "CATALOG_KEY": "97.31",
  "PRO_NOMBRE": "Extracción de prótesis ocular"
 },
 {
  "CATALOG_KEY": "97.32",
  "PRO_NOMBRE": "Extracción de tapón nasal"
 },
 {
  "CATALOG_KEY": "97.33",
  "PRO_NOMBRE": "Extracción de férulas dentales"
 },
 {
  "CATALOG_KEY": "97.34",
  "PRO_NOMBRE": "Extracción de tapón dental"
 },
 {
  "CATALOG_KEY": "97.35",
  "PRO_NOMBRE": "Extracción de prótesis dental"
 },
 {
  "CATALOG_KEY": "97.36",
  "PRO_NOMBRE": "Extracción de otro dispositivo de fijación mandibular externa"
 },
 {
  "CATALOG_KEY": "97.37",
  "PRO_NOMBRE": "Extracción de tubo de traqueostomía"
 },
 {
  "CATALOG_KEY": "97.38",
  "PRO_NOMBRE": "Retiro de suturas de cabeza y cuello (Retiro de puntos)"
 },
 {
  "CATALOG_KEY": "97.39",
  "PRO_NOMBRE": "Extracción de otro dispositivo terapéutico de cabeza y cuello"
 },
 {
  "CATALOG_KEY": "97.4",
  "PRO_NOMBRE": "Extracción no quirúrgica de dispositivo terapéutico de tórax"
 },
 {
  "CATALOG_KEY": "97.41",
  "PRO_NOMBRE": "Extracción de tubo de toracotomía o de drenaje de la cavidad pleural"
 },
 {
  "CATALOG_KEY": "97.42",
  "PRO_NOMBRE": "Extracción de drenaje mediastínico"
 },
 {
  "CATALOG_KEY": "97.43",
  "PRO_NOMBRE": "Retiro de suturas de tórax (Retiro de puntos)"
 },
 {
  "CATALOG_KEY": "97.44",
  "PRO_NOMBRE": "Extracción no quirúrgica de sistema de asistencia cardíaca"
 },
 {
  "CATALOG_KEY": "97.49",
  "PRO_NOMBRE": "Extracción de otro dispositivo de tórax"
 },
 {
  "CATALOG_KEY": "97.5",
  "PRO_NOMBRE": "Extracción no quirúrgica de dispositivo terapéutico del aparato digestivo"
 },
 {
  "CATALOG_KEY": "97.51",
  "PRO_NOMBRE": "Extracción de tubo de gastrostomía"
 },
 {
  "CATALOG_KEY": "97.52",
  "PRO_NOMBRE": "Extracción de tubo de intestino delgado"
 },
 {
  "CATALOG_KEY": "97.53",
  "PRO_NOMBRE": "Extracción de tubo de intestino grueso o apéndice"
 },
 {
  "CATALOG_KEY": "97.54",
  "PRO_NOMBRE": "Extracción de tubo de colecistostomía"
 },
 {
  "CATALOG_KEY": "97.55",
  "PRO_NOMBRE": "Extracción de tubo en T, otro tubo de vía biliar o tubo hepático"
 },
 {
  "CATALOG_KEY": "97.56",
  "PRO_NOMBRE": "Extracción de tubo o drenaje pancreático"
 },
 {
  "CATALOG_KEY": "97.59",
  "PRO_NOMBRE": "Extracción de otro dispositivo del aparato digestivo"
 },
 {
  "CATALOG_KEY": "97.6",
  "PRO_NOMBRE": "Extracción no quirúrgica de dispositivo terapéutico del aparato urinario"
 },
 {
  "CATALOG_KEY": "97.61",
  "PRO_NOMBRE": "Extracción de tubo de pielostomía y nefrostomía"
 },
 {
  "CATALOG_KEY": "97.62",
  "PRO_NOMBRE": "Extracción de tubo de ureterostomía y de catéter ureteral"
 },
 {
  "CATALOG_KEY": "97.63",
  "PRO_NOMBRE": "Extracción de tubo de cistostomía"
 },
 {
  "CATALOG_KEY": "97.64",
  "PRO_NOMBRE": "Extracción de otro dispositivo de drenaje urinario"
 },
 {
  "CATALOG_KEY": "97.65",
  "PRO_NOMBRE": "Extracción de sonda uretral"
 },
 {
  "CATALOG_KEY": "97.69",
  "PRO_NOMBRE": "Extracción de otro dispositivo del aparato urinario"
 },
 {
  "CATALOG_KEY": "97.7",
  "PRO_NOMBRE": "Extracción no quirúrgica de dispositivo terapéutico del aparato genital"
 },
 {
  "CATALOG_KEY": "97.71",
  "PRO_NOMBRE": "Extracción de dispositivo anticonceptivo intrauterino"
 },
 {
  "CATALOG_KEY": "97.72",
  "PRO_NOMBRE": "Extracción de tapón intrauterino"
 },
 {
  "CATALOG_KEY": "97.73",
  "PRO_NOMBRE": "Extracción de diafragma vaginal"
 },
 {
  "CATALOG_KEY": "97.74",
  "PRO_NOMBRE": "Extracción de otro pesario vaginal"
 },
 {
  "CATALOG_KEY": "97.75",
  "PRO_NOMBRE": "Extracción de tapón vaginal o vulvar"
 },
 {
  "CATALOG_KEY": "97.79",
  "PRO_NOMBRE": "Extracción de otro dispositivo del tracto genital"
 },
 {
  "CATALOG_KEY": "97.8",
  "PRO_NOMBRE": "Otra extracción no quirúrgica de dispositivo terapéutico"
 },
 {
  "CATALOG_KEY": "97.81",
  "PRO_NOMBRE": "Extracción de dispositivo de drenaje retroperitoneal"
 },
 {
  "CATALOG_KEY": "97.82",
  "PRO_NOMBRE": "Extracción de dispositivo de drenaje peritoneal"
 },
 {
  "CATALOG_KEY": "97.83",
  "PRO_NOMBRE": "Extracción de suturas de la pared abdominal"
 },
 {
  "CATALOG_KEY": "97.84",
  "PRO_NOMBRE": "Extracción de suturas del tronco, no clasificadas bajo otro concepto"
 },
 {
  "CATALOG_KEY": "97.85",
  "PRO_NOMBRE": "Extracción de tapón de tronco, no clasificado bajo otro concepto"
 },
 {
  "CATALOG_KEY": "97.86",
  "PRO_NOMBRE": "Extracción de otro dispositivo de abdomen"
 },
 {
  "CATALOG_KEY": "97.87",
  "PRO_NOMBRE": "Extracción de otro dispositivo de tronco"
 },
 {
  "CATALOG_KEY": "97.88",
  "PRO_NOMBRE": "Extracción de dispositivo de inmovilización externo"
 },
 {
  "CATALOG_KEY": "97.89",
  "PRO_NOMBRE": "Extracción de otro dispositivo terapéutico"
 },
 {
  "CATALOG_KEY": "98",
  "PRO_NOMBRE": "Extracción de cuerpo extraño y cálculo no operatorio"
 },
 {
  "CATALOG_KEY": "98.0",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño intraluminal del aparato digestivo"
 },
 {
  "CATALOG_KEY": "98.01",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño intraluminal de la boca"
 },
 {
  "CATALOG_KEY": "98.02",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño intraluminal del esófago"
 },
 {
  "CATALOG_KEY": "98.03",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño intraluminal del estómago e intestino delgado"
 },
 {
  "CATALOG_KEY": "98.04",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño intraluminal del intestino grueso"
 },
 {
  "CATALOG_KEY": "98.05",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño intraluminal del recto y ano"
 },
 {
  "CATALOG_KEY": "98.1",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño intraluminal de otros sitios"
 },
 {
  "CATALOG_KEY": "98.11",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño intraluminal del oído"
 },
 {
  "CATALOG_KEY": "98.12",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño intraluminal de la nariz"
 },
 {
  "CATALOG_KEY": "98.13",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño intraluminal de la faringe"
 },
 {
  "CATALOG_KEY": "98.14",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño intraluminal de la laringe"
 },
 {
  "CATALOG_KEY": "98.15",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño intraluminal de tráquea y bronquio"
 },
 {
  "CATALOG_KEY": "98.16",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño en útero"
 },
 {
  "CATALOG_KEY": "98.17",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño en vagina"
 },
 {
  "CATALOG_KEY": "98.18",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño en estoma artificial"
 },
 {
  "CATALOG_KEY": "98.19",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño en uretra"
 },
 {
  "CATALOG_KEY": "98.2",
  "PRO_NOMBRE": "Extracción sin incisión de otro cuerpo extraño"
 },
 {
  "CATALOG_KEY": "98.20",
  "PRO_NOMBRE": "Extracción de cuerpo extraño, no especificado de otra manera"
 },
 {
  "CATALOG_KEY": "98.21",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño superficial en ojo"
 },
 {
  "CATALOG_KEY": "98.22",
  "PRO_NOMBRE": "Extracción sin incisión de otro cuerpo extraño en cuello y cabeza"
 },
 {
  "CATALOG_KEY": "98.23",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño en vulva"
 },
 {
  "CATALOG_KEY": "98.24",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño en pene o escroto"
 },
 {
  "CATALOG_KEY": "98.25",
  "PRO_NOMBRE": "Extracción sin incisión de otro cuerpo extraño en otro conducto salvo de escroto, pene o vulva"
 },
 {
  "CATALOG_KEY": "98.26",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño en mano"
 },
 {
  "CATALOG_KEY": "98.27",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño en miembro superior, salvo de la mano"
 },
 {
  "CATALOG_KEY": "98.28",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño de pie"
 },
 {
  "CATALOG_KEY": "98.29",
  "PRO_NOMBRE": "Extracción sin incisión de cuerpo extraño de miembro inferior, salvo del pie"
 },
 {
  "CATALOG_KEY": "98.5",
  "PRO_NOMBRE": "Litotricia extracorpórea por ondas de choque [ESWL]"
 },
 {
  "CATALOG_KEY": "98.51",
  "PRO_NOMBRE": "Litotricia por ondas de choque extracorporales del riñón, del uréter y de la vejiga"
 },
 {
  "CATALOG_KEY": "98.52",
  "PRO_NOMBRE": "Litotricia por ondas de choque extracorporales de vesícula o conducto biliar"
 },
 {
  "CATALOG_KEY": "98.59",
  "PRO_NOMBRE": "Litotricia por ondas de choque extracorporales en otros sitios"
 }
]
